import * as Types from './operations'

import gql from 'graphql-tag'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@sketch/graphql-apollo'
const defaultOptions = {} as const
export const AnnotationPageInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationPageInfo on Page {
    identifier
    pageUUID: uuid
    hasUnreadComments @include(if: $includeHasUnreadComments)
  }
`
export const DeletedAnnotationSubjectCountersFragmentDoc = /*#__PURE__*/ gql`
  fragment DeletedAnnotationSubjectCounters on AnnotationDeletedEvent {
    identifier
    page: currentPage {
      identifier
      uuid
      ...AnnotationPageInfo
    }
  }
  ${AnnotationPageInfoFragmentDoc}
`
export const AnnotationSubjectFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationSubject on Annotation {
    identifier
    currentSubject {
      ... on Artboard {
        documentVersionShortId
        permanentArtboardShortId
        uuid
        page {
          identifier
          uuid
        }
      }
      ... on Page {
        identifier
        pageUUID: uuid
      }
      ... on Component {
        identifier
        uuid
      }
    }
  }
`
export const AnnotationSubjectSubscriptionStatusFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationSubjectSubscriptionStatus on Annotation {
    identifier
    subscriptionStatus
    share {
      identifier
      subscriptionStatus
    }
    ...AnnotationSubject
    currentSubject {
      ... on Artboard {
        documentVersionShortId
        permanentArtboardShortId
        uuid
        subscriptionStatus
      }
    }
  }
  ${AnnotationSubjectFragmentDoc}
`
export const CommentUserFragmentDoc = /*#__PURE__*/ gql`
  fragment CommentUser on PublicUser {
    avatar {
      small
    }
    identifier
    name
  }
`
export const BaseCommentFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseComment on Comment {
    identifier
    userIsCreator
    userCanDelete
    isRead
  }
`
export const CommentFragmentDoc = /*#__PURE__*/ gql`
  fragment Comment on Comment {
    identifier
    body
    createdAt
    isRead
    isEdited
    user {
      ...CommentUser
    }
    ...BaseComment
  }
  ${CommentUserFragmentDoc}
  ${BaseCommentFragmentDoc}
`
export const AnnotationCoordinatesFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationCoordinates on Annotation {
    identifier
    coordinates {
      identifier @client
      x
      y
    }
  }
`
export const AnnotationResolutionInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationResolutionInfo on Annotation {
    identifier
    resolution {
      resolvedAt
      user {
        ...CommentUser
      }
    }
  }
  ${CommentUserFragmentDoc}
`
export const AnnotationDotFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationDot on Annotation {
    identifier
    hasNewComments
    isOptimistic @client
    ...AnnotationSubject
    ...AnnotationCoordinates
    ...AnnotationResolutionInfo
  }
  ${AnnotationSubjectFragmentDoc}
  ${AnnotationCoordinatesFragmentDoc}
  ${AnnotationResolutionInfoFragmentDoc}
`
export const AnnotationLastCommentFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationLastComment on Annotation {
    identifier
    latestCommentCreatedAt
  }
`
export const AnnotationCommentCountFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationCommentCount on Annotation {
    comments {
      meta {
        totalCount
      }
    }
  }
`
export const BaseAnnotationFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseAnnotation on Annotation {
    identifier
    isNew
    subscriptionStatus
    firstComment {
      ...Comment
    }
    share {
      identifier
      subscriptionStatus
    }
    ...AnnotationDot
    ...AnnotationLastComment
    ...AnnotationCommentCount
  }
  ${CommentFragmentDoc}
  ${AnnotationDotFragmentDoc}
  ${AnnotationLastCommentFragmentDoc}
  ${AnnotationCommentCountFragmentDoc}
`
export const AnnotationSubjectCountersFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationSubjectCounters on Annotation {
    identifier
    page {
      ... on Page {
        identifier
        uuid
        ...AnnotationPageInfo
      }
    }
  }
  ${AnnotationPageInfoFragmentDoc}
`
export const AnnotationCoordinatesAndCountersFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationCoordinatesAndCounters on Annotation {
    identifier
    share {
      identifier
    }
    ...AnnotationCoordinates
    ...AnnotationSubjectCounters
  }
  ${AnnotationCoordinatesFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`
export const CredentialsFragmentDoc = /*#__PURE__*/ gql`
  fragment Credentials on OAuthCredentials {
    authToken
    refreshToken
    expirationDateTime
  }
`
export const ShareListItemBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareListItemBase on Share {
    identifier
    name
    shareType
    userCanUpdateSettings
    createdAt
    updatedAt
    deletedAt
    archivedAt
    sharePrivacyIcon
    publicAccessLevel
    pinnedByCurrentUserAt
  }
`
export const ShareThumbnailsFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareThumbnails on File {
    identifier
    thumbnails {
      identifier
      url
      url2x
      type
    }
  }
`
export const SharesListVersionItemFragmentDoc = /*#__PURE__*/ gql`
  fragment SharesListVersionItem on Version {
    identifier
    shortId
    kind
    createdAt
    updatedAt
    userIsCreator
    creator {
      identifier
      name
      avatar {
        small
      }
    }
    document {
      identifier
      renderStatus
      previewFile {
        identifier
        url
        ...ShareThumbnails
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const ProjectFragmentDoc = /*#__PURE__*/ gql`
  fragment Project on Project {
    name
    description
    identifier
    projectType
    projectPrivacyIcon
    workspaceAccessLevel
    userCanLeave
    deletedAt
    archivedAt
    pinnedByCurrentUserAt
    parentProjectIdentifier
    topLevelProject {
      identifier
      name
      workspaceAccessLevel
    }
  }
`
export const ShareListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareListItem on Share {
    ...ShareListItemBase
    version(preferredState: PROCESSED) {
      ...SharesListVersionItem
    }
    project {
      ...Project
    }
    collection {
      identifier
      name
    }
  }
  ${ShareListItemBaseFragmentDoc}
  ${SharesListVersionItemFragmentDoc}
  ${ProjectFragmentDoc}
`
export const ShareMetaFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareMeta on PaginationMeta {
    after
    limit
    totalCount
  }
`
export const CollectionSharesFragmentDoc = /*#__PURE__*/ gql`
  fragment CollectionShares on Collection {
    shares(after: $after) {
      entries {
        ...ShareListItem
      }
      meta {
        ...ShareMeta
      }
    }
  }
  ${ShareListItemFragmentDoc}
  ${ShareMetaFragmentDoc}
`
export const UnpaginatedCollectionShareFragmentDoc = /*#__PURE__*/ gql`
  fragment UnpaginatedCollectionShare on UnpaginatedCollectionShare {
    identifier
    name
    updatedAt
    file {
      ...ShareThumbnails
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const CollectionFragmentDoc = /*#__PURE__*/ gql`
  fragment Collection on Collection {
    identifier
    name
    description
  }
`
export const CollectionSharePreviewFragmentDoc = /*#__PURE__*/ gql`
  fragment CollectionSharePreview on CollectionSharePreview {
    shareIdentifier
    name
    file {
      ...ShareThumbnails
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const CollectionPreviewsFragmentDoc = /*#__PURE__*/ gql`
  fragment CollectionPreviews on Collection {
    ...Collection
    previews {
      ...CollectionSharePreview
    }
    shareCount
  }
  ${CollectionFragmentDoc}
  ${CollectionSharePreviewFragmentDoc}
`
export const CollectionForSelectFragmentDoc = /*#__PURE__*/ gql`
  fragment CollectionForSelect on Collection {
    identifier
    name
  }
`
export const UserErrorFragmentDoc = /*#__PURE__*/ gql`
  fragment UserError on UserError {
    message
    code
  }
`
export const SizeFragmentDoc = /*#__PURE__*/ gql`
  fragment Size on Size {
    xs
    sm
    md
    lg
    xl
  }
`
export const LinkFragmentDoc = /*#__PURE__*/ gql`
  fragment Link on Link {
    text
    url
    icon
    variant
  }
`
export const PublicationQueryPreferencesFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationQueryPreferences on PublicationQueryPreferences {
    search
    limit
    sort
    period
    include
    exclude
    allowPagination
    documentType
  }
`
export const CommunityPublicationQueryFragmentDoc = /*#__PURE__*/ gql`
  fragment CommunityPublicationQuery on CommunityPublicationQuery {
    id
    title
    subTitle
    link {
      ...Link
    }
    preferences {
      ...PublicationQueryPreferences
    }
    ... on CommunityGrid {
      modifiers
    }
  }
  ${LinkFragmentDoc}
  ${PublicationQueryPreferencesFragmentDoc}
`
export const SingleImageFragmentDoc = /*#__PURE__*/ gql`
  fragment SingleImage on SingleImage {
    alt
    src
  }
`
export const ResponsiveImageFragmentDoc = /*#__PURE__*/ gql`
  fragment ResponsiveImage on ResponsiveImage {
    alt
    source {
      xs
      sm
      md
      lg
      xl
    }
  }
`
export const VideoSourceFragmentDoc = /*#__PURE__*/ gql`
  fragment VideoSource on VideoSource {
    backgroundColor
    poster
    src
  }
`
export const VideoFragmentDoc = /*#__PURE__*/ gql`
  fragment Video on Video {
    standard {
      ...VideoSource
    }
    retina {
      ...VideoSource
    }
  }
  ${VideoSourceFragmentDoc}
`
export const CommunityHeroFragmentDoc = /*#__PURE__*/ gql`
  fragment CommunityHero on CommunityHero {
    id
    image {
      ...SingleImage
      ...ResponsiveImage
    }
    video {
      ...Video
    }
    backgroundColor
    title
    content
    contentPosition
    icon
    links {
      ...Link
    }
    size {
      ...Size
    }
  }
  ${SingleImageFragmentDoc}
  ${ResponsiveImageFragmentDoc}
  ${VideoFragmentDoc}
  ${LinkFragmentDoc}
  ${SizeFragmentDoc}
`
export const CommunityItemFragmentDoc = /*#__PURE__*/ gql`
  fragment CommunityItem on CommunityItem {
    ... on CommunityPublicationQuery {
      ...CommunityPublicationQuery
    }
    ... on CommunityHero {
      ...CommunityHero
    }
  }
  ${CommunityPublicationQueryFragmentDoc}
  ${CommunityHeroFragmentDoc}
`
export const CommunitySectionFragmentDoc = /*#__PURE__*/ gql`
  fragment CommunitySection on CommunitySection {
    id
    size {
      ...Size
    }
    items {
      ...CommunityItem
    }
  }
  ${SizeFragmentDoc}
  ${CommunityItemFragmentDoc}
`
export const VisibilityFragmentDoc = /*#__PURE__*/ gql`
  fragment Visibility on Visibility {
    hideOnBreakpoint
    hiddenForFF
  }
`
export const PermissionsFragmentDoc = /*#__PURE__*/ gql`
  fragment Permissions on Permissions {
    roles
    audience
    categories
  }
`
export const EventDateFragmentDoc = /*#__PURE__*/ gql`
  fragment EventDate on EventDate {
    day
    time
  }
`
export const SpeakerFragmentDoc = /*#__PURE__*/ gql`
  fragment Speaker on Speaker {
    name
    role
    image
  }
`
export const DiscoverItemFragmentDoc = /*#__PURE__*/ gql`
  fragment DiscoverItem on DiscoverItem {
    id
    type
    image {
      ...SingleImage
      ...ResponsiveImage
    }
    video {
      ...Video
    }
    title
    content
    url
    featured
    size {
      ...Size
    }
    permissions {
      ...Permissions
    }
    categories
    mobile {
      description
      icon
    }
    links {
      ...Link
    }
    contentPosition
    source
    length
    author
    icon
    note
    place
    backgroundColor
    date {
      ...EventDate
    }
    speakers {
      ...Speaker
    }
    dismissable
  }
  ${SingleImageFragmentDoc}
  ${ResponsiveImageFragmentDoc}
  ${VideoFragmentDoc}
  ${SizeFragmentDoc}
  ${PermissionsFragmentDoc}
  ${LinkFragmentDoc}
  ${EventDateFragmentDoc}
  ${SpeakerFragmentDoc}
`
export const DiscoverSectionFragmentDoc = /*#__PURE__*/ gql`
  fragment DiscoverSection on DiscoverSection {
    id
    type
    title
    subTitle {
      text
      visibility {
        ...Visibility
      }
    }
    stretchedContent
    permissions {
      ...Permissions
    }
    limit
    size {
      ...Size
    }
    categories {
      id
      name
    }
    links {
      ...Link
    }
    items {
      ... on DiscoverItem {
        ...DiscoverItem
      }
    }
    visibility {
      ...Visibility
    }
  }
  ${VisibilityFragmentDoc}
  ${PermissionsFragmentDoc}
  ${SizeFragmentDoc}
  ${LinkFragmentDoc}
  ${DiscoverItemFragmentDoc}
`
export const ProjectSearchDestinationFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectSearchDestination on Project {
    ...Project
    workspace {
      identifier
      name
    }
  }
  ${ProjectFragmentDoc}
`
export const ProjectListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectListItem on Project {
    ...Project
    collections {
      meta {
        totalCount
      }
    }
    parentProject {
      identifier
      name
    }
    shares(limit: 4) {
      entries {
        identifier
        name
        version {
          shortId
          document {
            identifier
            previewFile {
              url
              ...ShareThumbnails
            }
          }
        }
      }
      meta {
        totalCount
      }
    }
  }
  ${ProjectFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
`
export const WorkspaceMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceMembership on WorkspaceMembership {
    identifier
    acceptedAt
    isEditor
    isOwner
    activityStatus {
      lastSeenInDays
      status
    }
    user {
      identifier
      email
      avatar {
        small
        large
      }
      name
    }
    invite {
      identifier
      email
    }
    role
  }
`
export const ProjectMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectMembership on ProjectMembership {
    identifier
    inviteStatus
    privateAccessLevel
    guestCommentsEnabled
    guestInspectEnabled
    workspaceMembership {
      ...WorkspaceMembership
    }
  }
  ${WorkspaceMembershipFragmentDoc}
`
export const UserAccessProjectMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment UserAccessProjectMembership on ProjectMembership {
    ...ProjectMembership
    project {
      ...Project
      projectPrivacyIcon
    }
  }
  ${ProjectMembershipFragmentDoc}
  ${ProjectFragmentDoc}
`
export const WorkspacePermissionGroupFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspacePermissionGroup on PermissionGroup {
    identifier
    name
    members {
      meta {
        totalCount
      }
    }
  }
`
export const ProjectGroupMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectGroupMembership on PermissionGroupRelationProject {
    identifier
    permissionGroup {
      ...WorkspacePermissionGroup
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`
export const TrashedProjectFragmentDoc = /*#__PURE__*/ gql`
  fragment TrashedProject on TrashedProject {
    identifier
    shortId
    deletedAt
    name
    shares(limit: 4) {
      entries {
        identifier
        name
        version {
          shortId
          document {
            identifier
            previewFile {
              url
              ...ShareThumbnails
            }
          }
        }
      }
      meta {
        totalCount
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const WorkspaceProfileFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceProfile on WorkspaceProfile {
    identifier
    description
    websiteUrl
    isPublic
    isOfficial
    shortUrlName
    workspace {
      identifier
      name
      userRole
      avatar {
        large
        small
      }
    }
  }
`
export const PresentationFileFragmentDoc = /*#__PURE__*/ gql`
  fragment PresentationFile on Page {
    identifier
    uuid
    presentationFile {
      downloadUrl
      imageToken
      manifestUrl
    }
  }
`
export const PublicationPageFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationPage on Page {
    identifier
    uuid
    name
    ...PresentationFile
  }
  ${PresentationFileFragmentDoc}
`
export const PublicWorkspaceMinimalFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicWorkspaceMinimal on PublicWorkspace {
    identifier
    name
    userRole
    type
    avatar {
      small
      large
    }
    customer {
      identifier
      ssoStartUrl
      ssoEnabled
    }
    profile {
      identifier
      shortUrlName
    }
  }
`
export const PublicWorkspaceProfileFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicWorkspaceProfile on PublicWorkspaceProfile {
    identifier
    description
    isPublic
    shortUrlName
    websiteUrl
  }
`
export const PublicationThumbnailFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationThumbnail on Publication {
    identifier
    previewFile {
      identifier
      ...ShareThumbnails
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const PublicationReactionsFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationReactions on Publication {
    identifier
    totalHearts
    userReaction
  }
`
export const PublicationFragmentDoc = /*#__PURE__*/ gql`
  fragment Publication on Publication {
    identifier
    updatedAt
    workspaceProfile {
      identifier
      isOfficial
      ...WorkspaceProfile
    }
    share {
      identifier
      name
      description
      shareType
      publicAccessLevel
      userCanInspect
      publicCommentsEnabled
      publicInspectEnabled
      userCanEdit
      userCanUpdateSettings
      version(preferredState: PROCESSED_AND_PUBLISHED) {
        identifier
        shortId
        description
        kind
        updatedAt
        document {
          identifier
          downloadAvailable
          url
          renderStatus
          updatedAt
          previewFile {
            ...ShareThumbnails
          }
          pages(limit: 1) {
            entries {
              ...PublicationPage
            }
          }
        }
      }
      workspace {
        identifier
        ...PublicWorkspaceMinimal
        profile {
          identifier
          ...PublicWorkspaceProfile
        }
      }
    }
    ...PublicationThumbnail
    ...PublicationReactions
  }
  ${WorkspaceProfileFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
  ${PublicationPageFragmentDoc}
  ${PublicWorkspaceMinimalFragmentDoc}
  ${PublicWorkspaceProfileFragmentDoc}
  ${PublicationThumbnailFragmentDoc}
  ${PublicationReactionsFragmentDoc}
`
export const PublicationItemDownloadFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationItemDownload on Document {
    url
    downloadAvailable
    downloadUnavailableError
    userCanOpenInApp
  }
`
export const PublicationItemFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationItem on Publication {
    identifier
    updatedAt
    workspaceProfile {
      identifier
      shortUrlName
      isOfficial
      workspace {
        identifier
        ...PublicWorkspaceMinimal
      }
    }
    share {
      name
      identifier
      shareType
      publicAccessLevel
      userCanInspect
      publicCommentsEnabled
      publicInspectEnabled
      workspace {
        identifier
        ...PublicWorkspaceMinimal
      }
      version {
        identifier
        shortId
        updatedAt
        document {
          identifier
          ...PublicationItemDownload
        }
      }
    }
    ...PublicationReactions
    ...PublicationThumbnail
  }
  ${PublicWorkspaceMinimalFragmentDoc}
  ${PublicationItemDownloadFragmentDoc}
  ${PublicationReactionsFragmentDoc}
  ${PublicationThumbnailFragmentDoc}
`
export const PublicationListingFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationListing on PublicationListing {
    title
    preferences {
      ...PublicationQueryPreferences
    }
    modifiers
  }
  ${PublicationQueryPreferencesFragmentDoc}
`
export const ArtboardCacheInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardCacheInfo on Artboard {
    identifier
    shortId
    documentVersionShortId
    permanentArtboardShortId
    uuid
  }
`
export const ArtboardDetailInfoCwvFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardDetailInfoCWV on Artboard {
    identifier
    permanentArtboardShortId
    uuid
    files(type: FULL) {
      identifier
      url
      scale
      thumbnails {
        type
        url
      }
    }
  }
`
export const FrameDetailInfoCwvFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameDetailInfoCWV on Frame {
    identifier
    uuid
    width
    height
    files(type: FULL) {
      identifier
      url
      scale
      thumbnails {
        type
        url
      }
    }
  }
`
export const SymbolFragmentDoc = /*#__PURE__*/ gql`
  fragment Symbol on Symbol {
    artboard {
      ...ArtboardDetailInfoCWV
    }
    frame {
      ... on Frame {
        ...FrameDetailInfoCWV
      }
      ... on Artboard {
        ...ArtboardDetailInfoCWV
      }
    }
  }
  ${ArtboardDetailInfoCwvFragmentDoc}
  ${FrameDetailInfoCwvFragmentDoc}
`
export const ComponentInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ComponentInfo on Component {
    identifier
    uuid
    name
    description
    path
    depth
    ... on Symbol {
      ...Symbol
    }
    ... on ColorVariable {
      rgbaValue {
        blue
        green
        red
        alpha
      }
    }
    ... on TextStyle {
      needsContrastingBackground
      horizontalAlignment
      font {
        size
        name
        weight
      }
      files {
        identifier
        url
        scale
        thumbnails {
          type
          url
        }
      }
    }
    ... on LayerStyle {
      needsContrastingBackground
      files {
        identifier
        url
        scale
        thumbnails {
          type
          url
        }
      }
    }
  }
  ${SymbolFragmentDoc}
`
export const FrameGroupThumbnailsFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameGroupThumbnails on File {
    thumbnails {
      type
      url
    }
  }
`
export const AnnotationFrameGroupInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationFrameGroupInfo on FrameGroup {
    documentVersionShortId
    subscriptionStatus
    unreadCount
    annotationCount
  }
`
export const FrameGroupDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameGroupDetails on FrameGroup {
    uuid
    identifier
    documentVersionShortId
    name
    documentOrder
    isFlowHome
    subscriptionStatus
    hasMissingFonts
    page {
      uuid
      identifier
      name
      artboardCount
      ...PresentationFile
    }
    component {
      identifier
      uuid
      name
      description
      path
      depth
      ... on Symbol {
        ...Symbol
      }
    }
    files(type: FULL) {
      identifier
      url
      scale
      ...FrameGroupThumbnails
    }
    ...AnnotationFrameGroupInfo
  }
  ${PresentationFileFragmentDoc}
  ${SymbolFragmentDoc}
  ${FrameGroupThumbnailsFragmentDoc}
  ${AnnotationFrameGroupInfoFragmentDoc}
`
export const FrameDetailInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameDetailInfo on Frame {
    ...FrameGroupDetails
  }
  ${FrameGroupDetailsFragmentDoc}
`
export const PageDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PageDetails on Page {
    identifier
    uuid
    name
  }
`
export const ShareSettingsFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareSettings on Share {
    description
    shareType
    commentsEnabled
    userCanInspect
    updatedAt
  }
`
export const ShareLibraryListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareLibraryListItem on Share {
    ...ShareListItem
    designSystems {
      name
      preview
    }
  }
  ${ShareListItemFragmentDoc}
`
export const ShareViewerHasUnacceptedMembershipInviteFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareViewerHasUnacceptedMembershipInvite on Share {
    userHasUnacceptedInvitationToView
  }
`
export const SubscriptionShareFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionShare on Share {
    identifier
    workspace {
      identifier
    }
    ...ShareListItemBase
    project {
      ...Project
    }
    collection {
      identifier
      name
    }
  }
  ${ShareListItemBaseFragmentDoc}
  ${ProjectFragmentDoc}
`
export const ShareDropdownOptionsBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareDropdownOptionsBase on Share {
    userCanEdit
    userCanInspect
    userCanLeaveShare
    userAccessLevel
    userCanPublish
    commentsEnabled
    publicAccessLevel
    pinnedByCurrentUserAt
    workspace {
      identifier
    }
    subscriptionStatus
    publicCommentsEnabled
    publicInspectEnabled
    publication {
      identifier
    }
  }
`
export const DocumentDownloadFragmentDoc = /*#__PURE__*/ gql`
  fragment DocumentDownload on Document {
    url
    downloadAvailable
    downloadUnavailableError
    userCanOpenInApp
  }
`
export const ShareDropdownOptionsFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareDropdownOptions on Share {
    identifier
    ...ShareDropdownOptionsBase
    version(shortId: $versionShortId) {
      shortId
      identifier
      document {
        identifier
        sketchVersion
        ...DocumentDownload
      }
    }
  }
  ${ShareDropdownOptionsBaseFragmentDoc}
  ${DocumentDownloadFragmentDoc}
`
export const ShareWorkspaceFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareWorkspace on Share {
    identifier
    workspace {
      identifier
      userRole
    }
  }
`
export const ArtboardThumbnailsFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardThumbnails on File {
    thumbnails {
      type
      url
    }
  }
`
export const ArtboardDetailInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardDetailInfo on Artboard {
    shortId
    documentVersionShortId
    permanentArtboardShortId
    revisionIdentifier
    files(type: FULL) {
      identifier
      url
      scale
      ...ArtboardThumbnails
    }
    ...FrameGroupDetails
    ...AnnotationFrameGroupInfo
  }
  ${ArtboardThumbnailsFragmentDoc}
  ${FrameGroupDetailsFragmentDoc}
  ${AnnotationFrameGroupInfoFragmentDoc}
`
export const ShareAboutFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareAbout on Share {
    identifier
    description
    name
    commentsEnabled
    shareType
    userIsMember
    userCanInspect
    userCanUpdateSettings
    userAccessLevel
    updatedAt
    subscriptionStatus
    publication {
      identifier
    }
    workspace {
      identifier
      userIsMember
    }
    version(shortId: $versionShortId) {
      identifier
      shortId
      kind
      userIsCreator
      creator {
        identifier
        name
        avatar {
          small
        }
      }
      document {
        identifier
        pages(limit: 1) {
          entries {
            uuid
          }
          meta {
            totalCount
          }
        }
        prototypes: artboards(limit: 3, filter: PROTOTYPE) {
          entries {
            ...ArtboardDetailInfo
          }
          meta {
            totalCount
          }
        }
        componentCount {
          colorVar
          layerStyle
          symbol
          textStyle
        }
      }
    }
  }
  ${ArtboardDetailInfoFragmentDoc}
`
export const SharePublicationFragmentDoc = /*#__PURE__*/ gql`
  fragment SharePublication on Share {
    identifier
    name
    version {
      shortId
      identifier
      document {
        identifier
        previewFile {
          ...ShareThumbnails
        }
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const ShareSubscriptionStatusFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareSubscriptionStatus on Share {
    subscriptionStatus
  }
`
export const ShareUserAccessLevelFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareUserAccessLevel on Share {
    userAccessLevel
  }
`
export const SharePublicPermissionsFragmentDoc = /*#__PURE__*/ gql`
  fragment SharePublicPermissions on Share {
    identifier
    name
    publicAccessLevel
    publicCommentsEnabled
    publicInspectEnabled
    userCanUpdateCommentsEnabled
    sharePrivacyIcon
    userCanPublish
    publication {
      identifier
    }
  }
`
export const ShareDropdownOptionsPreloadFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareDropdownOptionsPreload on Share {
    identifier
    ...ShareDropdownOptionsBase
    version(preferredState: PROCESSED) {
      shortId
      identifier
      document {
        identifier
        sketchVersion
        ...DocumentDownload
      }
    }
  }
  ${ShareDropdownOptionsBaseFragmentDoc}
  ${DocumentDownloadFragmentDoc}
`
export const SharePermissionsFragmentDoc = /*#__PURE__*/ gql`
  fragment SharePermissions on Share {
    ...ShareDropdownOptionsPreload
    parentAccessLevel
    updatedAt
    userCanInspect
    userCanUpdateParentPermissions
    userCanUpdateSettings
    versionTypeAvailableToUser
  }
  ${ShareDropdownOptionsPreloadFragmentDoc}
`
export const ShareBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareBase on Share {
    ...ShareListItemBase
    ...ShareSubscriptionStatus
    ...ShareUserAccessLevel
    ...SharePublicPermissions
    ...ShareDropdownOptionsBase
    ...SharePermissions
    shareType
    userCanUpdateCommentsEnabled
    userCanLeaveShare
    createdAt
    updatedAt
    deletedAt
    sharePrivacyIcon
    publicUrl
    allowedParentAccessLevels
    parentAccessLevel
    userCanUpdateParentPermissions
    isShared
    isDraft
    userIsMember
    isSharedWithGuests
    memberships {
      meta {
        totalCount
      }
    }
    description
    commentsEnabled
    userIsWatching
    userHasUnacceptedInvitationToView
    unreadCount
    versionTypeAvailableToUser
  }
  ${ShareListItemBaseFragmentDoc}
  ${ShareSubscriptionStatusFragmentDoc}
  ${ShareUserAccessLevelFragmentDoc}
  ${SharePublicPermissionsFragmentDoc}
  ${ShareDropdownOptionsBaseFragmentDoc}
  ${SharePermissionsFragmentDoc}
`
export const PublicWorkspaceSsoIdentityFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicWorkspaceSSOIdentity on PublicWorkspace {
    identifier
    name
    userRole
    customer {
      identifier
      ssoEnabled
      ssoStartUrl
    }
  }
`
export const PublicWorkspaceFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicWorkspace on PublicWorkspace {
    ...PublicWorkspaceSSOIdentity
    identifier
    name
    userIsMember
    userRole
    userIsOwner
    type
    avatar {
      small
      large
    }
  }
  ${PublicWorkspaceSsoIdentityFragmentDoc}
`
export const VersionListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionListItem on Version {
    identifier
    shortId
    kind
    createdAt
    userIsCreator
    createdAfterVersioning
    updatedAt
    description
    hasComponentManifest
    presentationStatus
    creator {
      identifier
      name
      avatar {
        small
      }
    }
    document {
      identifier
      ...DocumentDownload
      renderStatus
      colorspace
      size
      sketchVersion
      previewFile {
        identifier
        width
        height
        url
        ...ShareThumbnails
      }
    }
  }
  ${DocumentDownloadFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
`
export const DownloadableAssetFragmentDoc = /*#__PURE__*/ gql`
  fragment DownloadableAsset on DownloadableAsset {
    __typename
    identifier
    status
    fileName
    fileSizeInBytes
    path
    layerUuids
  }
`
export const DocumentDownloadableAssetsFragmentDoc = /*#__PURE__*/ gql`
  fragment DocumentDownloadableAssets on Document {
    __typename
    identifier
    assetStatus
    downloadableAssets {
      ...DownloadableAsset
    }
  }
  ${DownloadableAssetFragmentDoc}
`
export const VersionDocumentFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionDocument on Document {
    identifier
    ...DocumentDownload
    renderStatus
    colorspace
    size
    sketchVersion
    downloadUnavailableError
    name
    isPresent
    pageCount
    artboardCount
    documentVersion
    coeditCompatibilityVersion
    canEditDescriptions
    uuid
    ...DocumentDownloadableAssets
    pages(limit: 1) {
      entries {
        uuid
      }
    }
  }
  ${DocumentDownloadFragmentDoc}
  ${DocumentDownloadableAssetsFragmentDoc}
`
export const VersionFragmentDoc = /*#__PURE__*/ gql`
  fragment Version on Version {
    ...VersionListItem
    document {
      ...VersionDocument
      previewFile {
        identifier
        width
        height
        url
        ...ShareThumbnails
      }
    }
  }
  ${VersionListItemFragmentDoc}
  ${VersionDocumentFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
`
export const ProjectListCountsFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectListCounts on Project {
    identifier
    sharesCount
    nestedProjectsCount
  }
`
export const ProjectSharePreviewFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectSharePreview on ProjectSharePreview {
    shareIdentifier
    name
    file {
      ...ShareThumbnails
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const ProjectPreviewFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectPreview on Project {
    ...ProjectListCounts
    previews {
      ...ProjectSharePreview
    }
  }
  ${ProjectListCountsFragmentDoc}
  ${ProjectSharePreviewFragmentDoc}
`
export const NestedProjectFragmentDoc = /*#__PURE__*/ gql`
  fragment NestedProject on Project {
    ...Project
    ...ProjectPreview
  }
  ${ProjectFragmentDoc}
  ${ProjectPreviewFragmentDoc}
`
export const ProjectDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectDetails on Project {
    ...NestedProject
    workspace {
      identifier
      name
    }
    parentProjects {
      ...Project
      nestedProjectsCount
    }
    parentProject {
      ...NestedProject
    }
  }
  ${NestedProjectFragmentDoc}
  ${ProjectFragmentDoc}
`
export const ShareInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareInfo on Share {
    ...ShareBase
    workspace {
      ...PublicWorkspace
      customer {
        ssoEnabled
      }
    }
    version(preferredState: PROCESSED) {
      ...Version
      document {
        previewFile {
          ...ShareThumbnails
        }
      }
    }
    project {
      ...ProjectDetails
    }
    collection {
      identifier
      name
    }
  }
  ${ShareBaseFragmentDoc}
  ${PublicWorkspaceFragmentDoc}
  ${VersionFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
  ${ProjectDetailsFragmentDoc}
`
export const ShareWithSizeFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareWithSize on ShareWithSize {
    size
    share {
      ...ShareInfo
      versions {
        meta {
          totalCount
        }
      }
    }
  }
  ${ShareInfoFragmentDoc}
`
export const ShareUserRelatedFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareUserRelatedFields on Share {
    identifier
    commentsEnabled
    userCanEdit
    userCanInspect
    userCanUpdateSettings
    userAccessLevel
  }
`
export const ShareWithPublicationFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareWithPublication on Share {
    identifier
    name
    publication {
      identifier
    }
    version(preferredState: PROCESSED) {
      identifier
      shortId
      document {
        identifier
        previewFile {
          ...ShareThumbnails
        }
      }
      updatedAt
    }
    updatedAt
  }
  ${ShareThumbnailsFragmentDoc}
`
export const ShareMembershipInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareMembershipInfo on ShareMembership {
    identifier
    email
    acceptedAt
    inviteStatus
    privateAccessLevel
    guestCommentsEnabled
    guestInspectEnabled
    userCanUpdateCommentsEnabled
    workspaceMembership {
      role
      user {
        identifier
        name
        email
        avatar {
          small
        }
      }
    }
  }
`
export const UserAccessShareMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment UserAccessShareMembership on ShareMembership {
    ...ShareMembershipInfo
    share {
      ...ShareInfo
    }
  }
  ${ShareMembershipInfoFragmentDoc}
  ${ShareInfoFragmentDoc}
`
export const ShareGroupMembershipInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareGroupMembershipInfo on PermissionGroupRelationShare {
    identifier
    accessLevel
    permissionGroup {
      ...WorkspacePermissionGroup
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`
export const TrashedShareFragmentDoc = /*#__PURE__*/ gql`
  fragment TrashedShare on TrashedShare {
    identifier
    deletedAt
    updatedAt
    name
    userAccessLevel
    shareType
    sharePrivacyIcon
    userAccessLevel
    version {
      identifier
      userIsCreator
      shortId
      kind
      createdAt
      updatedAt
      document {
        identifier
        downloadAvailable
        url
        renderStatus
        previewFile {
          identifier
          width
          height
          url
          ...ShareThumbnails
        }
      }
      creator {
        identifier
        name
        avatar {
          small
        }
      }
    }
    workspace {
      identifier
      userRole
    }
    project {
      ...Project
    }
  }
  ${ShareThumbnailsFragmentDoc}
  ${ProjectFragmentDoc}
`
export const IdentityProviderConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment IdentityProviderConfig on IdentityProviderConfig {
    binding
    certificate
    entityId
    ssoUrl
  }
`
export const AttributeMappingEntryFragmentDoc = /*#__PURE__*/ gql`
  fragment AttributeMappingEntry on AttributeMappingEntry {
    fullName {
      firstName
      surname
      updateOnLogin
    }
    email {
      mapping
      updateOnLogin
    }
  }
`
export const WorkspaceSsoConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceSsoConfig on WorkspaceSsoConfig {
    acsUrl
    serviceProviderEntityId
    config {
      ...IdentityProviderConfig
    }
    attributeMapping {
      ...AttributeMappingEntry
    }
  }
  ${IdentityProviderConfigFragmentDoc}
  ${AttributeMappingEntryFragmentDoc}
`
export const StorageItemFragmentDoc = /*#__PURE__*/ gql`
  fragment StorageItem on StorageItem {
    ... on Project {
      ...NestedProject
    }
    ... on Share {
      ...ShareListItem
    }
  }
  ${NestedProjectFragmentDoc}
  ${ShareListItemFragmentDoc}
`
export const StorageItemDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment StorageItemDetails on StorageItem {
    ... on Project {
      ...ProjectDetails
    }
    ... on Share {
      ...ShareInfo
    }
  }
  ${ProjectDetailsFragmentDoc}
  ${ShareInfoFragmentDoc}
`
export const StorageItemsPaginationMetaFragmentDoc = /*#__PURE__*/ gql`
  fragment StorageItemsPaginationMeta on StorageItemsPaginationMeta {
    after
    totalCount
    sharesCount
    nestedProjectsCount
  }
`
export const UserNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment UserNotification on UserNotification {
    identifier
    date
    isRead
    title
    subtitle
    path
    user {
      identifier
      name
      avatar {
        small
      }
    }
  }
`
export const NotificationCommentFragmentDoc = /*#__PURE__*/ gql`
  fragment NotificationComment on Comment {
    identifier
    body
    annotation {
      identifier
      firstComment {
        identifier
      }
      currentSubject {
        ... on Artboard {
          permanentArtboardShortId
          documentVersionShortId
          nameArtboard: name
        }
        ... on Page {
          identifier
          uuid
          name
        }
      }
    }
  }
`
export const CommentNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment CommentNotification on CommentNotification {
    ...UserNotification
    comment {
      identifier
      ...NotificationComment
    }
    share {
      identifier
      name
      subscriptionStatus
      workspace {
        identifier
        name
      }
    }
    artboard {
      identifier
      shortId
      name
      documentVersionShortId
      permanentArtboardShortId
      files(type: FULL) {
        identifier
        url
        size
        thumbnails {
          type
          url
        }
      }
      ...AnnotationFrameGroupInfo
    }
  }
  ${UserNotificationFragmentDoc}
  ${NotificationCommentFragmentDoc}
  ${AnnotationFrameGroupInfoFragmentDoc}
`
export const MentionNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment MentionNotification on MentionNotification {
    ...UserNotification
    comment {
      identifier
      ...NotificationComment
    }
    share {
      identifier
      name
      subscriptionStatus
      workspace {
        identifier
        name
      }
    }
    artboard {
      identifier
      shortId
      name
      documentVersionShortId
      permanentArtboardShortId
      files(type: FULL) {
        identifier
        url
        size
        thumbnails {
          type
          url
        }
      }
    }
  }
  ${UserNotificationFragmentDoc}
  ${NotificationCommentFragmentDoc}
`
export const StarNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment StarNotification on StarNotification {
    ...UserNotification
    identifier
    share {
      identifier
      name
      subscriptionStatus
      workspace {
        identifier
        name
      }
    }
  }
  ${UserNotificationFragmentDoc}
`
export const AddShareMemberNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment AddShareMemberNotification on AddShareMemberNotification {
    ...UserNotification
    token
    share {
      identifier
      name
      userHasUnacceptedInvitationToView
      subscriptionStatus
      workspace {
        identifier
        name
      }
    }
  }
  ${UserNotificationFragmentDoc}
`
export const DownloadableAssetRenderedNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment DownloadableAssetRenderedNotification on DownloadableAssetRenderedNotification {
    ...UserNotification
    share {
      identifier
      name
      subscriptionStatus
      workspace {
        identifier
        name
      }
    }
    notifiedVersion {
      shortId
      document {
        ...DocumentDownloadableAssets
      }
    }
  }
  ${UserNotificationFragmentDoc}
  ${DocumentDownloadableAssetsFragmentDoc}
`
export const NotificationInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment NotificationInfo on UserNotification {
    ...UserNotification
    ... on CommentNotification {
      ...CommentNotification
    }
    ... on MentionNotification {
      ...MentionNotification
    }
    ... on StarNotification {
      ...StarNotification
    }
    ... on AddShareMemberNotification {
      ...AddShareMemberNotification
    }
    ... on DownloadableAssetRenderedNotification {
      ...DownloadableAssetRenderedNotification
    }
  }
  ${UserNotificationFragmentDoc}
  ${CommentNotificationFragmentDoc}
  ${MentionNotificationFragmentDoc}
  ${StarNotificationFragmentDoc}
  ${AddShareMemberNotificationFragmentDoc}
  ${DownloadableAssetRenderedNotificationFragmentDoc}
`
export const ShareMemberInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareMemberInfo on PublicUser {
    identifier
    name
    avatar {
      small
    }
  }
`
export const NotificationStatusFragmentDoc = /*#__PURE__*/ gql`
  fragment NotificationStatus on User {
    identifier
    hasUnreadNotifications
  }
`
export const UserEmailFragmentDoc = /*#__PURE__*/ gql`
  fragment UserEmail on User {
    identifier
    email
  }
`
export const UserPreferencesFragmentDoc = /*#__PURE__*/ gql`
  fragment UserPreferences on User {
    identifier
    preferences {
      showOnboardingFirstSteps
      showStorageLimitChanges
    }
  }
`
export const UserFragmentDoc = /*#__PURE__*/ gql`
  fragment User on User {
    email
    identifier
    name
    personalIdentityEmail
    isVerified
    isSuperadmin
    isPartner
    isWebSignup
    hasAvatar
    avatar {
      small
    }
    receiveEmailNotifications
    hasAcceptedAgreement
    eligibleForWorkspaceTrial
    ...UserPreferences
  }
  ${UserPreferencesFragmentDoc}
`
export const UserFeatureFlagsFragmentDoc = /*#__PURE__*/ gql`
  fragment UserFeatureFlags on User {
    identifier
    featureFlags
  }
`
export const InitialUserFragmentDoc = /*#__PURE__*/ gql`
  fragment InitialUser on User {
    identifier
    hasPersonalIdentity
    mfaState
    ...User
    ...UserFeatureFlags
  }
  ${UserFragmentDoc}
  ${UserFeatureFlagsFragmentDoc}
`
export const WorkspaceMinimalIdentityFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceMinimalIdentity on Workspace {
    identifier
    name
    avatar {
      small
    }
  }
`
export const WorkspaceSsoIdentityFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceSSOIdentity on Workspace {
    identifier
    name
    userRole
    customer {
      identifier
      ssoEnabled
      ssoStartUrl
      tosAgreed
    }
  }
`
export const WorkspaceMinimalFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceMinimal on Workspace {
    ...WorkspaceMinimalIdentity
    ...WorkspaceSSOIdentity
    type
    avatar {
      large
    }
    status
    userCanEdit
    userCanAdminister
    userRole
    userIsOwner
    status
    type
    features {
      restrictedPublicLinks
      workspaceProfileEnabled
      permissionGroupsEnabled
      archiveEnabled
      unlimitedStorageEnabled
      unlimitedTrialEnabled
    }
  }
  ${WorkspaceMinimalIdentityFragmentDoc}
  ${WorkspaceSsoIdentityFragmentDoc}
`
export const UserWorkspaceMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment UserWorkspaceMembership on WorkspaceMembership {
    identifier
    role
    isEditor
    workspace {
      ...WorkspaceMinimal
      customer {
        identifier
        source
        billing {
          status
          trialEnd
          subscriptionSetUp
        }
      }
    }
    user {
      identifier
      email
    }
  }
  ${WorkspaceMinimalFragmentDoc}
`
export const UserActiveSessionFragmentDoc = /*#__PURE__*/ gql`
  fragment UserActiveSession on Session {
    id
    lastUpdateAt
    type
    ipAddress
    countryCode
    deviceName
    userAgent
    isCurrentOne
  }
`
export const UserNotificationCountFragmentDoc = /*#__PURE__*/ gql`
  fragment UserNotificationCount on User {
    identifier
    newNotificationsCount: notifications(filter: { state: NEW }) {
      meta {
        totalCount
      }
    }
    unreadNotificationsCount: notifications(filter: { state: UNREAD }) {
      meta {
        totalCount
      }
    }
  }
`
export const ReadShareFragmentDoc = /*#__PURE__*/ gql`
  fragment ReadShare on Share {
    identifier
  }
`
export const ArtboardRevisionFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardRevision on Revision {
    identifier
    kind
    creator {
      identifier
      name
    }
    userIsCreator
    createdAt
    version {
      identifier
      shortId
      description
      kind
    }
    artboard {
      permanentArtboardShortId
      documentVersionShortId
      uuid
    }
  }
`
export const ArtboardRevisionDeletedFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardRevisionDeleted on RevisionDeleted {
    identifier
    creator {
      name
    }
    userIsCreator
    createdAt
    artboardIdentifier
  }
`
export const ArtboardRevisionUnavailableFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardRevisionUnavailable on RevisionUnavailable {
    identifier
    creator {
      name
    }
    userIsCreator
    createdAt
  }
`
export const FrameGroupRevisionFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameGroupRevision on Revision {
    identifier
    kind
    creator {
      identifier
      name
    }
    userIsCreator
    createdAt
    version {
      identifier
      shortId
      description
      kind
    }
    frame {
      identifier
      documentVersionShortId
      uuid
    }
  }
`
export const FrameGroupRevisionDeletedFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameGroupRevisionDeleted on RevisionDeleted {
    identifier
    creator {
      name
    }
    userIsCreator
    createdAt
    frameIdentifier
  }
`
export const FrameGroupRevisionUnavailableFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameGroupRevisionUnavailable on RevisionUnavailable {
    identifier
    creator {
      name
    }
    userIsCreator
    createdAt
  }
`
export const ShareLatestStarredVersionFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareLatestStarredVersion on Share {
    identifier
    lastStarredVersion: version(preferredState: PROCESSED_AND_PUBLISHED) {
      kind
      ...Version
    }
  }
  ${VersionFragmentDoc}
`
export const VersionDeletedFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionDeleted on VersionDeleted {
    identifier
    deletedAt
    createdAt
    order
    kind
    creator {
      identifier
      name
    }
    userIsCreator
  }
`
export const VersionUnavailableFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionUnavailable on VersionUnavailable {
    identifier
    createdAt
    creator {
      identifier
      name
    }
    userIsCreator
  }
`
export const VersionUnavailableWithOrderFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionUnavailableWithOrder on VersionUnavailable {
    ...VersionUnavailable
    order
  }
  ${VersionUnavailableFragmentDoc}
`
export const VersionListItemWithOrderFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionListItemWithOrder on Version {
    ...VersionListItem
    order
  }
  ${VersionListItemFragmentDoc}
`
export const ShareVersionHistoryFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareVersionHistory on Share {
    identifier
    workspace {
      identifier
    }
    availableVersions: versionHistory(include: [VERSION]) {
      meta {
        totalCount
      }
    }
    ...ShareLatestStarredVersion
    versionHistory(
      after: $after
      limit: $limit
      include: [VERSION, VERSION_UNAVAILABLE]
    ) {
      entries {
        ...VersionDeleted
        ...VersionUnavailableWithOrder
        ...VersionListItemWithOrder
      }
      meta {
        totalCount
        after
      }
    }
  }
  ${ShareLatestStarredVersionFragmentDoc}
  ${VersionDeletedFragmentDoc}
  ${VersionUnavailableWithOrderFragmentDoc}
  ${VersionListItemWithOrderFragmentDoc}
`
export const BillingMinimalFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingMinimal on Billing {
    status
    subscriptionEnd
  }
`
export const BillingWorkspaceNoticeFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingWorkspaceNotice on Billing {
    status
    subscriptionEnd
    trialEnd
    subscriptionSetUp
  }
`
export const BillingDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingDetails on BillingDetails {
    name
    email
    address {
      line1
      city
      state
      country
      postalCode
    }
    taxId {
      id
      status
    }
  }
`
export const PriceFragmentDoc = /*#__PURE__*/ gql`
  fragment Price on Price {
    amount
    currency
  }
`
export const CouponMinimalFragmentDoc = /*#__PURE__*/ gql`
  fragment CouponMinimal on CouponInfo {
    promotionCode
    percentOff
    endDate
  }
`
export const BillingHistoryEntryFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingHistoryEntry on BillingHistoryEntry {
    id
    price {
      ...Price
    }
    description
    createdAt
    ... on CustomerInvoice {
      pdf
      couponInfo {
        ...CouponMinimal
      }
    }
    ... on CreditTransaction {
      licenseRedemption {
        serial
        months
        seats
        credits
      }
    }
  }
  ${PriceFragmentDoc}
  ${CouponMinimalFragmentDoc}
`
export const BillingPlanFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingPlan on BillingPlan {
    id
    name
    type
    invoicePrice
    monthlyPrice
    product
  }
`
export const AppStoreBillingPlanFragmentDoc = /*#__PURE__*/ gql`
  fragment AppStoreBillingPlan on AppStoreBillingPlan {
    id
    type
  }
`
export const CloudBillingPlanFragmentDoc = /*#__PURE__*/ gql`
  fragment CloudBillingPlan on CloudBillingPlan {
    id
    name
    type
    product
    prices {
      invoice
      monthly
      currency
    }
  }
`
export const SubscriptionInfoPlanFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionInfoPlan on SubscriptionInfo {
    currentPlan {
      ... on AppStoreBillingPlan {
        ...AppStoreBillingPlan
      }
      ... on CloudBillingPlan {
        ...CloudBillingPlan
      }
    }
  }
  ${AppStoreBillingPlanFragmentDoc}
  ${CloudBillingPlanFragmentDoc}
`
export const BillingPriceFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingPrice on BillingPrice {
    invoice
    monthly
    currency
  }
`
export const BillingSeatsInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingSeatsInfo on BillingSeatsInfo {
    availableSeats
    usedSeats
    currentSeatsTotal
    scheduledSeatsTotal
  }
`
export const CouponFragmentDoc = /*#__PURE__*/ gql`
  fragment Coupon on CouponInfo {
    promotionCode
    percentOff
    amountOff
    errorCode
  }
`
export const CreditBalanceFragmentDoc = /*#__PURE__*/ gql`
  fragment CreditBalance on CreditBalance {
    amount
    projectedDuration
  }
`
export const PaymentDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PaymentDetails on PaymentDetails {
    type
    ... on CreditCardPaymentDetails {
      id
      last4Digits
      brand
      expiration {
        month
        year
      }
    }
  }
`
export const WorkspaceMinimalWithBillingStatusFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceMinimalWithBillingStatus on Workspace {
    ...WorkspaceMinimal
    customer {
      identifier
      billing {
        status
        subscriptionSetUp
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
`
export const DuplicationWorkspaceFragmentDoc = /*#__PURE__*/ gql`
  fragment DuplicationWorkspace on Workspace {
    ...WorkspaceMinimalIdentity
    ...WorkspaceSSOIdentity
    status
    userCanEdit
    uploadsRestrictedFor
  }
  ${WorkspaceMinimalIdentityFragmentDoc}
  ${WorkspaceSsoIdentityFragmentDoc}
`
export const DraftsWorkspaceFragmentDoc = /*#__PURE__*/ gql`
  fragment DraftsWorkspace on Workspace {
    ...WorkspaceMinimal
    status
    userCanEdit
    draftsProject: projects(limit: 1, type: PERSONAL_DRAFTS) {
      entries {
        ...Project
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
  ${ProjectFragmentDoc}
`
export const InvitableUserFragmentDoc = /*#__PURE__*/ gql`
  fragment InvitableUser on WorkspaceMembership {
    isEditor
    role
    identifier
    user {
      identifier
      avatar {
        small
        large
      }
      email
      name
    }
    invite {
      identifier
      email
    }
  }
`
export const InvitableUserEmailFragmentDoc = /*#__PURE__*/ gql`
  fragment InvitableUserEmail on WorkspaceMembership {
    identifier
    user {
      identifier
      email
    }
  }
`
export const WorkspacePermissionGroupMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspacePermissionGroupMembership on PermissionGroupMembership {
    identifier
    permissionGroup {
      identifier
      ...WorkspacePermissionGroup
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`
export const CreateAnnotationDocument = /*#__PURE__*/ gql`
  mutation createAnnotation(
    $shareIdentifier: UUID!
    $body: String!
    $subject: AnnotationSubjectInput!
    $coordinates: AnnotationCoordinatesInput
    $includeHasUnreadComments: Boolean = false
  ) {
    createAnnotation(
      body: $body
      shareIdentifier: $shareIdentifier
      subject: $subject
      coordinates: $coordinates
    ) {
      annotation {
        isOptimistic @client
        ...BaseAnnotation
        ...AnnotationCoordinatesAndCounters
      }
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationCoordinatesAndCountersFragmentDoc}
`
export type CreateAnnotationMutationFn = ApolloReactCommon.MutationFunction<
  Types.CreateAnnotationMutation,
  Types.CreateAnnotationMutationVariables
>

/**
 * __useCreateAnnotationMutation__
 *
 * To run a mutation, you first call `useCreateAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnotationMutation, { data, loading, error }] = useCreateAnnotationMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      body: // value for 'body'
 *      subject: // value for 'subject'
 *      coordinates: // value for 'coordinates'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useCreateAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateAnnotationMutation,
    Types.CreateAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateAnnotationMutation,
    Types.CreateAnnotationMutationVariables
  >(CreateAnnotationDocument, options)
}
export type CreateAnnotationMutationHookResult = ReturnType<
  typeof useCreateAnnotationMutation
>
export type CreateAnnotationMutationResult =
  ApolloReactCommon.MutationResult<Types.CreateAnnotationMutation>
export type CreateAnnotationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreateAnnotationMutation,
    Types.CreateAnnotationMutationVariables
  >
export const MoveAnnotationDocument = /*#__PURE__*/ gql`
  mutation moveAnnotation(
    $annotationIdentifier: UUID!
    $coordinates: AnnotationCoordinatesInput!
    $subject: AnnotationSubjectInput!
    $includeHasUnreadComments: Boolean = false
  ) {
    moveAnnotation(
      annotationIdentifier: $annotationIdentifier
      coordinates: $coordinates
      subject: $subject
    ) {
      annotation {
        frameUuid
        ...BaseAnnotation
        ...AnnotationCoordinatesAndCounters
      }
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationCoordinatesAndCountersFragmentDoc}
`
export type MoveAnnotationMutationFn = ApolloReactCommon.MutationFunction<
  Types.MoveAnnotationMutation,
  Types.MoveAnnotationMutationVariables
>

/**
 * __useMoveAnnotationMutation__
 *
 * To run a mutation, you first call `useMoveAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAnnotationMutation, { data, loading, error }] = useMoveAnnotationMutation({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      coordinates: // value for 'coordinates'
 *      subject: // value for 'subject'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useMoveAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.MoveAnnotationMutation,
    Types.MoveAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.MoveAnnotationMutation,
    Types.MoveAnnotationMutationVariables
  >(MoveAnnotationDocument, options)
}
export type MoveAnnotationMutationHookResult = ReturnType<
  typeof useMoveAnnotationMutation
>
export type MoveAnnotationMutationResult =
  ApolloReactCommon.MutationResult<Types.MoveAnnotationMutation>
export type MoveAnnotationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.MoveAnnotationMutation,
    Types.MoveAnnotationMutationVariables
  >
export const DeleteAnnotationDocument = /*#__PURE__*/ gql`
  mutation deleteAnnotation(
    $identifier: UUID!
    $includeHasUnreadComments: Boolean = false
  ) {
    deleteAnnotation(annotationIdentifier: $identifier) {
      annotation {
        frameUuid
        ...AnnotationCoordinatesAndCounters
      }
    }
  }
  ${AnnotationCoordinatesAndCountersFragmentDoc}
`
export type DeleteAnnotationMutationFn = ApolloReactCommon.MutationFunction<
  Types.DeleteAnnotationMutation,
  Types.DeleteAnnotationMutationVariables
>

/**
 * __useDeleteAnnotationMutation__
 *
 * To run a mutation, you first call `useDeleteAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnotationMutation, { data, loading, error }] = useDeleteAnnotationMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useDeleteAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteAnnotationMutation,
    Types.DeleteAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteAnnotationMutation,
    Types.DeleteAnnotationMutationVariables
  >(DeleteAnnotationDocument, options)
}
export type DeleteAnnotationMutationHookResult = ReturnType<
  typeof useDeleteAnnotationMutation
>
export type DeleteAnnotationMutationResult =
  ApolloReactCommon.MutationResult<Types.DeleteAnnotationMutation>
export type DeleteAnnotationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DeleteAnnotationMutation,
    Types.DeleteAnnotationMutationVariables
  >
export const ResolveAnnotationDocument = /*#__PURE__*/ gql`
  mutation resolveAnnotation($annotationIdentifier: UUID!) {
    resolveAnnotation(annotationIdentifier: $annotationIdentifier) {
      annotation {
        identifier
        ...AnnotationResolutionInfo
        ...AnnotationSubject
      }
    }
  }
  ${AnnotationResolutionInfoFragmentDoc}
  ${AnnotationSubjectFragmentDoc}
`
export type ResolveAnnotationMutationFn = ApolloReactCommon.MutationFunction<
  Types.ResolveAnnotationMutation,
  Types.ResolveAnnotationMutationVariables
>

/**
 * __useResolveAnnotationMutation__
 *
 * To run a mutation, you first call `useResolveAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveAnnotationMutation, { data, loading, error }] = useResolveAnnotationMutation({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *   },
 * });
 */
export function useResolveAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ResolveAnnotationMutation,
    Types.ResolveAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ResolveAnnotationMutation,
    Types.ResolveAnnotationMutationVariables
  >(ResolveAnnotationDocument, options)
}
export type ResolveAnnotationMutationHookResult = ReturnType<
  typeof useResolveAnnotationMutation
>
export type ResolveAnnotationMutationResult =
  ApolloReactCommon.MutationResult<Types.ResolveAnnotationMutation>
export type ResolveAnnotationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ResolveAnnotationMutation,
    Types.ResolveAnnotationMutationVariables
  >
export const UnResolveAnnotationDocument = /*#__PURE__*/ gql`
  mutation unResolveAnnotation($annotationIdentifier: UUID!) {
    unresolveAnnotation(annotationIdentifier: $annotationIdentifier) {
      annotation {
        identifier
        ...AnnotationResolutionInfo
        ...AnnotationSubject
      }
    }
  }
  ${AnnotationResolutionInfoFragmentDoc}
  ${AnnotationSubjectFragmentDoc}
`
export type UnResolveAnnotationMutationFn = ApolloReactCommon.MutationFunction<
  Types.UnResolveAnnotationMutation,
  Types.UnResolveAnnotationMutationVariables
>

/**
 * __useUnResolveAnnotationMutation__
 *
 * To run a mutation, you first call `useUnResolveAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnResolveAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unResolveAnnotationMutation, { data, loading, error }] = useUnResolveAnnotationMutation({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *   },
 * });
 */
export function useUnResolveAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnResolveAnnotationMutation,
    Types.UnResolveAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnResolveAnnotationMutation,
    Types.UnResolveAnnotationMutationVariables
  >(UnResolveAnnotationDocument, options)
}
export type UnResolveAnnotationMutationHookResult = ReturnType<
  typeof useUnResolveAnnotationMutation
>
export type UnResolveAnnotationMutationResult =
  ApolloReactCommon.MutationResult<Types.UnResolveAnnotationMutation>
export type UnResolveAnnotationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UnResolveAnnotationMutation,
    Types.UnResolveAnnotationMutationVariables
  >
export const GetAnnotationsDocument = /*#__PURE__*/ gql`
  query getAnnotations(
    $shareIdentifier: UUID!
    $versionIdentifier: UUID
    $subject: AnnotationSubjectInput
    $subjects: [AnnotationSubjectInput!]
    $after: String
    $sort: AnnotationSortOrder
    $annotationStatus: AnnotationStatusFilter
  ) {
    annotations(
      shareIdentifier: $shareIdentifier
      versionIdentifier: $versionIdentifier
      subject: $subject
      subjects: $subjects
      after: $after
      sortOrder: $sort
      status: $annotationStatus
    ) {
      entries {
        ...BaseAnnotation
      }
      meta {
        after
        totalCount
      }
    }
  }
  ${BaseAnnotationFragmentDoc}
`

/**
 * __useGetAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionIdentifier: // value for 'versionIdentifier'
 *      subject: // value for 'subject'
 *      subjects: // value for 'subjects'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      annotationStatus: // value for 'annotationStatus'
 *   },
 * });
 */
export function useGetAnnotationsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationsQuery,
    Types.GetAnnotationsQueryVariables
  > &
    (
      | { variables: Types.GetAnnotationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationsQuery,
    Types.GetAnnotationsQueryVariables
  >(GetAnnotationsDocument, options)
}
export function useGetAnnotationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationsQuery,
    Types.GetAnnotationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationsQuery,
    Types.GetAnnotationsQueryVariables
  >(GetAnnotationsDocument, options)
}

export type GetAnnotationsQueryHookResult = ReturnType<
  typeof useGetAnnotationsQuery
>
export type GetAnnotationsLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationsLazyQuery
>
export type GetAnnotationsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetAnnotationsQuery,
  Types.GetAnnotationsQueryVariables
>
export const GetAnnotationCommentsDocument = /*#__PURE__*/ gql`
  query getAnnotationComments($annotationIdentifier: UUID!, $after: String) {
    annotation(identifier: $annotationIdentifier) {
      identifier
      isNew
      share {
        identifier
      }
      ...AnnotationSubject
      subscriptionStatus
      ...AnnotationResolutionInfo
      firstComment {
        ...BaseComment
      }
      comments(after: $after) {
        entries {
          ...Comment
        }
        meta {
          after
          totalCount
        }
      }
    }
  }
  ${AnnotationSubjectFragmentDoc}
  ${AnnotationResolutionInfoFragmentDoc}
  ${BaseCommentFragmentDoc}
  ${CommentFragmentDoc}
`

/**
 * __useGetAnnotationCommentsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationCommentsQuery({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAnnotationCommentsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationCommentsQuery,
    Types.GetAnnotationCommentsQueryVariables
  > &
    (
      | { variables: Types.GetAnnotationCommentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationCommentsQuery,
    Types.GetAnnotationCommentsQueryVariables
  >(GetAnnotationCommentsDocument, options)
}
export function useGetAnnotationCommentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationCommentsQuery,
    Types.GetAnnotationCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationCommentsQuery,
    Types.GetAnnotationCommentsQueryVariables
  >(GetAnnotationCommentsDocument, options)
}

export type GetAnnotationCommentsQueryHookResult = ReturnType<
  typeof useGetAnnotationCommentsQuery
>
export type GetAnnotationCommentsLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationCommentsLazyQuery
>
export type GetAnnotationCommentsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetAnnotationCommentsQuery,
  Types.GetAnnotationCommentsQueryVariables
>
export const GetMentionableUsersDocument = /*#__PURE__*/ gql`
  query getMentionableUsers($shareIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      identifier
      mentionableUsers {
        avatar {
          small
        }
        identifier
        name
      }
    }
  }
`

/**
 * __useGetMentionableUsersQuery__
 *
 * To run a query within a React component, call `useGetMentionableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentionableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentionableUsersQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetMentionableUsersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetMentionableUsersQuery,
    Types.GetMentionableUsersQueryVariables
  > &
    (
      | { variables: Types.GetMentionableUsersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetMentionableUsersQuery,
    Types.GetMentionableUsersQueryVariables
  >(GetMentionableUsersDocument, options)
}
export function useGetMentionableUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetMentionableUsersQuery,
    Types.GetMentionableUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetMentionableUsersQuery,
    Types.GetMentionableUsersQueryVariables
  >(GetMentionableUsersDocument, options)
}

export type GetMentionableUsersQueryHookResult = ReturnType<
  typeof useGetMentionableUsersQuery
>
export type GetMentionableUsersLazyQueryHookResult = ReturnType<
  typeof useGetMentionableUsersLazyQuery
>
export type GetMentionableUsersQueryResult = ApolloReactCommon.QueryResult<
  Types.GetMentionableUsersQuery,
  Types.GetMentionableUsersQueryVariables
>
export const GetAnnotationDotsDocument = /*#__PURE__*/ gql`
  query getAnnotationDots(
    $shareIdentifier: UUID!
    $versionIdentifier: UUID
    $subject: AnnotationSubjectInput
    $subjects: [AnnotationSubjectInput!]
    $after: String
    $annotationStatus: AnnotationStatusFilter
    $sort: AnnotationSortOrder
  ) {
    annotations(
      shareIdentifier: $shareIdentifier
      versionIdentifier: $versionIdentifier
      subject: $subject
      subjects: $subjects
      limit: 100
      after: $after
      status: $annotationStatus
      sortOrder: $sort
    ) {
      entries {
        ...AnnotationDot
      }
      meta {
        after
        totalCount
      }
    }
  }
  ${AnnotationDotFragmentDoc}
`

/**
 * __useGetAnnotationDotsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationDotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationDotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationDotsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionIdentifier: // value for 'versionIdentifier'
 *      subject: // value for 'subject'
 *      subjects: // value for 'subjects'
 *      after: // value for 'after'
 *      annotationStatus: // value for 'annotationStatus'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAnnotationDotsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationDotsQuery,
    Types.GetAnnotationDotsQueryVariables
  > &
    (
      | { variables: Types.GetAnnotationDotsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationDotsQuery,
    Types.GetAnnotationDotsQueryVariables
  >(GetAnnotationDotsDocument, options)
}
export function useGetAnnotationDotsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationDotsQuery,
    Types.GetAnnotationDotsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationDotsQuery,
    Types.GetAnnotationDotsQueryVariables
  >(GetAnnotationDotsDocument, options)
}

export type GetAnnotationDotsQueryHookResult = ReturnType<
  typeof useGetAnnotationDotsQuery
>
export type GetAnnotationDotsLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationDotsLazyQuery
>
export type GetAnnotationDotsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetAnnotationDotsQuery,
  Types.GetAnnotationDotsQueryVariables
>
export const GetAnnotationSettingsDocument = /*#__PURE__*/ gql`
  query getAnnotationSettings {
    hideAnnotationsDots @client
  }
`

/**
 * __useGetAnnotationSettingsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnnotationSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationSettingsQuery,
    Types.GetAnnotationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationSettingsQuery,
    Types.GetAnnotationSettingsQueryVariables
  >(GetAnnotationSettingsDocument, options)
}
export function useGetAnnotationSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationSettingsQuery,
    Types.GetAnnotationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationSettingsQuery,
    Types.GetAnnotationSettingsQueryVariables
  >(GetAnnotationSettingsDocument, options)
}

export type GetAnnotationSettingsQueryHookResult = ReturnType<
  typeof useGetAnnotationSettingsQuery
>
export type GetAnnotationSettingsLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationSettingsLazyQuery
>
export type GetAnnotationSettingsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetAnnotationSettingsQuery,
  Types.GetAnnotationSettingsQueryVariables
>
export const GetAnnotationDotDocument = /*#__PURE__*/ gql`
  query getAnnotationDot($identifier: UUID!) {
    annotation(identifier: $identifier) {
      ...AnnotationDot
    }
  }
  ${AnnotationDotFragmentDoc}
`

/**
 * __useGetAnnotationDotQuery__
 *
 * To run a query within a React component, call `useGetAnnotationDotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationDotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationDotQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetAnnotationDotQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationDotQuery,
    Types.GetAnnotationDotQueryVariables
  > &
    (
      | { variables: Types.GetAnnotationDotQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationDotQuery,
    Types.GetAnnotationDotQueryVariables
  >(GetAnnotationDotDocument, options)
}
export function useGetAnnotationDotLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationDotQuery,
    Types.GetAnnotationDotQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationDotQuery,
    Types.GetAnnotationDotQueryVariables
  >(GetAnnotationDotDocument, options)
}

export type GetAnnotationDotQueryHookResult = ReturnType<
  typeof useGetAnnotationDotQuery
>
export type GetAnnotationDotLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationDotLazyQuery
>
export type GetAnnotationDotQueryResult = ApolloReactCommon.QueryResult<
  Types.GetAnnotationDotQuery,
  Types.GetAnnotationDotQueryVariables
>
export const GetAnnotationLatestVisibleVersionDocument = /*#__PURE__*/ gql`
  query getAnnotationLatestVisibleVersion($identifier: UUID!) {
    annotation(identifier: $identifier) {
      latestVisibleVersion {
        isLatest
        identifier
        shortId
      }
    }
  }
`

/**
 * __useGetAnnotationLatestVisibleVersionQuery__
 *
 * To run a query within a React component, call `useGetAnnotationLatestVisibleVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationLatestVisibleVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationLatestVisibleVersionQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetAnnotationLatestVisibleVersionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationLatestVisibleVersionQuery,
    Types.GetAnnotationLatestVisibleVersionQueryVariables
  > &
    (
      | {
          variables: Types.GetAnnotationLatestVisibleVersionQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationLatestVisibleVersionQuery,
    Types.GetAnnotationLatestVisibleVersionQueryVariables
  >(GetAnnotationLatestVisibleVersionDocument, options)
}
export function useGetAnnotationLatestVisibleVersionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationLatestVisibleVersionQuery,
    Types.GetAnnotationLatestVisibleVersionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationLatestVisibleVersionQuery,
    Types.GetAnnotationLatestVisibleVersionQueryVariables
  >(GetAnnotationLatestVisibleVersionDocument, options)
}

export type GetAnnotationLatestVisibleVersionQueryHookResult = ReturnType<
  typeof useGetAnnotationLatestVisibleVersionQuery
>
export type GetAnnotationLatestVisibleVersionLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationLatestVisibleVersionLazyQuery
>
export type GetAnnotationLatestVisibleVersionQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetAnnotationLatestVisibleVersionQuery,
    Types.GetAnnotationLatestVisibleVersionQueryVariables
  >
export const AnnotationCreatedDocument = /*#__PURE__*/ gql`
  subscription annotationCreated(
    $permanentArtboardId: String
    $permanentPageId: String
    $shareIdentifier: UUID!
    $includeHasUnreadComments: Boolean = false
  ) {
    annotationCreated(
      permanentArtboardId: $permanentArtboardId
      permanentPageId: $permanentPageId
      shareIdentifier: $shareIdentifier
    ) {
      ...BaseAnnotation
      ...AnnotationSubjectCounters
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationCreatedSubscription__
 *
 * To run a query within a React component, call `useAnnotationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationCreatedSubscription({
 *   variables: {
 *      permanentArtboardId: // value for 'permanentArtboardId'
 *      permanentPageId: // value for 'permanentPageId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useAnnotationCreatedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationCreatedSubscription,
    Types.AnnotationCreatedSubscriptionVariables
  > &
    (
      | {
          variables: Types.AnnotationCreatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationCreatedSubscription,
    Types.AnnotationCreatedSubscriptionVariables
  >(AnnotationCreatedDocument, options)
}
export type AnnotationCreatedSubscriptionHookResult = ReturnType<
  typeof useAnnotationCreatedSubscription
>
export type AnnotationCreatedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.AnnotationCreatedSubscription>
export const AnnotationDeletedDocument = /*#__PURE__*/ gql`
  subscription annotationDeleted(
    $annotationIdentifier: UUID
    $permanentArtboardId: String
    $permanentPageId: String
    $shareIdentifier: UUID
    $subject: AnnotationSubjectInput
    $includeHasUnreadComments: Boolean = false
  ) {
    annotationDeleted(
      annotationIdentifier: $annotationIdentifier
      permanentArtboardId: $permanentArtboardId
      permanentPageId: $permanentPageId
      shareIdentifier: $shareIdentifier
      subject: $subject
    ) {
      identifier
      currentSubject {
        ... on Artboard {
          uuid
        }
      }
      ...DeletedAnnotationSubjectCounters
    }
  }
  ${DeletedAnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationDeletedSubscription__
 *
 * To run a query within a React component, call `useAnnotationDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationDeletedSubscription({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      permanentArtboardId: // value for 'permanentArtboardId'
 *      permanentPageId: // value for 'permanentPageId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      subject: // value for 'subject'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useAnnotationDeletedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationDeletedSubscription,
    Types.AnnotationDeletedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationDeletedSubscription,
    Types.AnnotationDeletedSubscriptionVariables
  >(AnnotationDeletedDocument, options)
}
export type AnnotationDeletedSubscriptionHookResult = ReturnType<
  typeof useAnnotationDeletedSubscription
>
export type AnnotationDeletedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.AnnotationDeletedSubscription>
export const AnnotationMovedDocument = /*#__PURE__*/ gql`
  subscription annotationMoved(
    $permanentArtboardId: String
    $permanentPageId: String
    $shareIdentifier: UUID!
    $subject: AnnotationSubjectInput
    $includeHasUnreadComments: Boolean = false
  ) {
    annotationMoved(
      permanentArtboardId: $permanentArtboardId
      permanentPageId: $permanentPageId
      shareIdentifier: $shareIdentifier
      subject: $subject
    ) {
      ...BaseAnnotation
      ...AnnotationSubjectCounters
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationMovedSubscription__
 *
 * To run a query within a React component, call `useAnnotationMovedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationMovedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationMovedSubscription({
 *   variables: {
 *      permanentArtboardId: // value for 'permanentArtboardId'
 *      permanentPageId: // value for 'permanentPageId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      subject: // value for 'subject'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useAnnotationMovedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationMovedSubscription,
    Types.AnnotationMovedSubscriptionVariables
  > &
    (
      | {
          variables: Types.AnnotationMovedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationMovedSubscription,
    Types.AnnotationMovedSubscriptionVariables
  >(AnnotationMovedDocument, options)
}
export type AnnotationMovedSubscriptionHookResult = ReturnType<
  typeof useAnnotationMovedSubscription
>
export type AnnotationMovedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.AnnotationMovedSubscription>
export const AnnotationResolvedDocument = /*#__PURE__*/ gql`
  subscription annotationResolved(
    $shareIdentifier: UUID!
    $annotationIdentifier: UUID
  ) {
    annotationResolved(
      shareIdentifier: $shareIdentifier
      annotationIdentifier: $annotationIdentifier
    ) {
      identifier
      ...BaseAnnotation
    }
  }
  ${BaseAnnotationFragmentDoc}
`

/**
 * __useAnnotationResolvedSubscription__
 *
 * To run a query within a React component, call `useAnnotationResolvedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationResolvedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationResolvedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *   },
 * });
 */
export function useAnnotationResolvedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationResolvedSubscription,
    Types.AnnotationResolvedSubscriptionVariables
  > &
    (
      | {
          variables: Types.AnnotationResolvedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationResolvedSubscription,
    Types.AnnotationResolvedSubscriptionVariables
  >(AnnotationResolvedDocument, options)
}
export type AnnotationResolvedSubscriptionHookResult = ReturnType<
  typeof useAnnotationResolvedSubscription
>
export type AnnotationResolvedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.AnnotationResolvedSubscription>
export const AnnotationUnresolvedDocument = /*#__PURE__*/ gql`
  subscription annotationUnresolved(
    $shareIdentifier: UUID!
    $annotationIdentifier: UUID
  ) {
    annotationUnresolved(
      shareIdentifier: $shareIdentifier
      annotationIdentifier: $annotationIdentifier
    ) {
      identifier
      ...BaseAnnotation
    }
  }
  ${BaseAnnotationFragmentDoc}
`

/**
 * __useAnnotationUnresolvedSubscription__
 *
 * To run a query within a React component, call `useAnnotationUnresolvedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationUnresolvedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationUnresolvedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *   },
 * });
 */
export function useAnnotationUnresolvedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationUnresolvedSubscription,
    Types.AnnotationUnresolvedSubscriptionVariables
  > &
    (
      | {
          variables: Types.AnnotationUnresolvedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationUnresolvedSubscription,
    Types.AnnotationUnresolvedSubscriptionVariables
  >(AnnotationUnresolvedDocument, options)
}
export type AnnotationUnresolvedSubscriptionHookResult = ReturnType<
  typeof useAnnotationUnresolvedSubscription
>
export type AnnotationUnresolvedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.AnnotationUnresolvedSubscription>
export const EditCommentDocument = /*#__PURE__*/ gql`
  mutation editComment($identifier: UUID!, $body: String!) {
    editComment(commentIdentifier: $identifier, body: $body) {
      comment {
        identifier
        body
        isEdited
      }
    }
  }
`
export type EditCommentMutationFn = ApolloReactCommon.MutationFunction<
  Types.EditCommentMutation,
  Types.EditCommentMutationVariables
>

/**
 * __useEditCommentMutation__
 *
 * To run a mutation, you first call `useEditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCommentMutation, { data, loading, error }] = useEditCommentMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useEditCommentMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EditCommentMutation,
    Types.EditCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EditCommentMutation,
    Types.EditCommentMutationVariables
  >(EditCommentDocument, options)
}
export type EditCommentMutationHookResult = ReturnType<
  typeof useEditCommentMutation
>
export type EditCommentMutationResult =
  ApolloReactCommon.MutationResult<Types.EditCommentMutation>
export type EditCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.EditCommentMutation,
  Types.EditCommentMutationVariables
>
export const CreateAnnotationCommentDocument = /*#__PURE__*/ gql`
  mutation createAnnotationComment(
    $identifier: UUID!
    $body: String!
    $includeHasUnreadComments: Boolean = false
  ) {
    createAnnotationReply(annotationIdentifier: $identifier, body: $body) {
      comment {
        ...Comment
        annotation {
          ...AnnotationSubjectCounters
          ...AnnotationLastComment
          share {
            identifier
          }
          frameUuid
          subscriptionStatus
        }
      }
    }
  }
  ${CommentFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
  ${AnnotationLastCommentFragmentDoc}
`
export type CreateAnnotationCommentMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.CreateAnnotationCommentMutation,
    Types.CreateAnnotationCommentMutationVariables
  >

/**
 * __useCreateAnnotationCommentMutation__
 *
 * To run a mutation, you first call `useCreateAnnotationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnotationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnotationCommentMutation, { data, loading, error }] = useCreateAnnotationCommentMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      body: // value for 'body'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useCreateAnnotationCommentMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateAnnotationCommentMutation,
    Types.CreateAnnotationCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateAnnotationCommentMutation,
    Types.CreateAnnotationCommentMutationVariables
  >(CreateAnnotationCommentDocument, options)
}
export type CreateAnnotationCommentMutationHookResult = ReturnType<
  typeof useCreateAnnotationCommentMutation
>
export type CreateAnnotationCommentMutationResult =
  ApolloReactCommon.MutationResult<Types.CreateAnnotationCommentMutation>
export type CreateAnnotationCommentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreateAnnotationCommentMutation,
    Types.CreateAnnotationCommentMutationVariables
  >
export const DeleteAnnotationReplyDocument = /*#__PURE__*/ gql`
  mutation deleteAnnotationReply($identifier: UUID!) {
    deleteAnnotationReply(commentIdentifier: $identifier) {
      comment {
        identifier
        annotation {
          identifier
          ...AnnotationCommentCount
        }
      }
    }
  }
  ${AnnotationCommentCountFragmentDoc}
`
export type DeleteAnnotationReplyMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.DeleteAnnotationReplyMutation,
    Types.DeleteAnnotationReplyMutationVariables
  >

/**
 * __useDeleteAnnotationReplyMutation__
 *
 * To run a mutation, you first call `useDeleteAnnotationReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnotationReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnotationReplyMutation, { data, loading, error }] = useDeleteAnnotationReplyMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDeleteAnnotationReplyMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteAnnotationReplyMutation,
    Types.DeleteAnnotationReplyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteAnnotationReplyMutation,
    Types.DeleteAnnotationReplyMutationVariables
  >(DeleteAnnotationReplyDocument, options)
}
export type DeleteAnnotationReplyMutationHookResult = ReturnType<
  typeof useDeleteAnnotationReplyMutation
>
export type DeleteAnnotationReplyMutationResult =
  ApolloReactCommon.MutationResult<Types.DeleteAnnotationReplyMutation>
export type DeleteAnnotationReplyMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DeleteAnnotationReplyMutation,
    Types.DeleteAnnotationReplyMutationVariables
  >
export const MarkCommentsAsReadDocument = /*#__PURE__*/ gql`
  mutation markCommentsAsRead(
    $commentIdentifiers: [UUID!]!
    $includeHasUnreadComments: Boolean = false
  ) {
    markCommentsAsRead(commentIdentifiers: $commentIdentifiers) {
      comments {
        identifier
        isRead
        annotation {
          identifier
          hasNewComments
          isNew
          ...AnnotationSubjectCounters
        }
      }
    }
  }
  ${AnnotationSubjectCountersFragmentDoc}
`
export type MarkCommentsAsReadMutationFn = ApolloReactCommon.MutationFunction<
  Types.MarkCommentsAsReadMutation,
  Types.MarkCommentsAsReadMutationVariables
>

/**
 * __useMarkCommentsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkCommentsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommentsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCommentsAsReadMutation, { data, loading, error }] = useMarkCommentsAsReadMutation({
 *   variables: {
 *      commentIdentifiers: // value for 'commentIdentifiers'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useMarkCommentsAsReadMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.MarkCommentsAsReadMutation,
    Types.MarkCommentsAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.MarkCommentsAsReadMutation,
    Types.MarkCommentsAsReadMutationVariables
  >(MarkCommentsAsReadDocument, options)
}
export type MarkCommentsAsReadMutationHookResult = ReturnType<
  typeof useMarkCommentsAsReadMutation
>
export type MarkCommentsAsReadMutationResult =
  ApolloReactCommon.MutationResult<Types.MarkCommentsAsReadMutation>
export type MarkCommentsAsReadMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.MarkCommentsAsReadMutation,
    Types.MarkCommentsAsReadMutationVariables
  >
export const GetBaseCommentDocument = /*#__PURE__*/ gql`
  query getBaseComment($identifier: UUID!) {
    comment(identifier: $identifier) @client {
      identifier
      ...BaseComment
    }
  }
  ${BaseCommentFragmentDoc}
`

/**
 * __useGetBaseCommentQuery__
 *
 * To run a query within a React component, call `useGetBaseCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaseCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaseCommentQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetBaseCommentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetBaseCommentQuery,
    Types.GetBaseCommentQueryVariables
  > &
    (
      | { variables: Types.GetBaseCommentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetBaseCommentQuery,
    Types.GetBaseCommentQueryVariables
  >(GetBaseCommentDocument, options)
}
export function useGetBaseCommentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetBaseCommentQuery,
    Types.GetBaseCommentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetBaseCommentQuery,
    Types.GetBaseCommentQueryVariables
  >(GetBaseCommentDocument, options)
}

export type GetBaseCommentQueryHookResult = ReturnType<
  typeof useGetBaseCommentQuery
>
export type GetBaseCommentLazyQueryHookResult = ReturnType<
  typeof useGetBaseCommentLazyQuery
>
export type GetBaseCommentQueryResult = ApolloReactCommon.QueryResult<
  Types.GetBaseCommentQuery,
  Types.GetBaseCommentQueryVariables
>
export const AnnotationReplyCreatedDocument = /*#__PURE__*/ gql`
  subscription annotationReplyCreated(
    $shareIdentifier: UUID!
    $includeHasUnreadComments: Boolean = false
  ) {
    annotationReplyCreated(shareIdentifier: $shareIdentifier) {
      identifier
      ...Comment
      annotation {
        ...BaseAnnotation
        ...AnnotationSubjectCounters
      }
    }
  }
  ${CommentFragmentDoc}
  ${BaseAnnotationFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationReplyCreatedSubscription__
 *
 * To run a query within a React component, call `useAnnotationReplyCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationReplyCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationReplyCreatedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useAnnotationReplyCreatedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationReplyCreatedSubscription,
    Types.AnnotationReplyCreatedSubscriptionVariables
  > &
    (
      | {
          variables: Types.AnnotationReplyCreatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationReplyCreatedSubscription,
    Types.AnnotationReplyCreatedSubscriptionVariables
  >(AnnotationReplyCreatedDocument, options)
}
export type AnnotationReplyCreatedSubscriptionHookResult = ReturnType<
  typeof useAnnotationReplyCreatedSubscription
>
export type AnnotationReplyCreatedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.AnnotationReplyCreatedSubscription>
export const AnnotationReplyDeletedDocument = /*#__PURE__*/ gql`
  subscription annotationReplyDeleted(
    $shareIdentifier: UUID!
    $includeHasUnreadComments: Boolean = false
  ) {
    annotationReplyDeleted(shareIdentifier: $shareIdentifier) {
      identifier
      annotation {
        ...BaseAnnotation
        ...AnnotationSubjectCounters
      }
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationReplyDeletedSubscription__
 *
 * To run a query within a React component, call `useAnnotationReplyDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationReplyDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationReplyDeletedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useAnnotationReplyDeletedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationReplyDeletedSubscription,
    Types.AnnotationReplyDeletedSubscriptionVariables
  > &
    (
      | {
          variables: Types.AnnotationReplyDeletedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationReplyDeletedSubscription,
    Types.AnnotationReplyDeletedSubscriptionVariables
  >(AnnotationReplyDeletedDocument, options)
}
export type AnnotationReplyDeletedSubscriptionHookResult = ReturnType<
  typeof useAnnotationReplyDeletedSubscription
>
export type AnnotationReplyDeletedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.AnnotationReplyDeletedSubscription>
export const AnnotationReplyEditedDocument = /*#__PURE__*/ gql`
  subscription annotationReplyEdited($shareIdentifier: UUID!) {
    commentEdited(shareIdentifier: $shareIdentifier) {
      identifier
      body
      isEdited
    }
  }
`

/**
 * __useAnnotationReplyEditedSubscription__
 *
 * To run a query within a React component, call `useAnnotationReplyEditedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationReplyEditedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationReplyEditedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useAnnotationReplyEditedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationReplyEditedSubscription,
    Types.AnnotationReplyEditedSubscriptionVariables
  > &
    (
      | {
          variables: Types.AnnotationReplyEditedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationReplyEditedSubscription,
    Types.AnnotationReplyEditedSubscriptionVariables
  >(AnnotationReplyEditedDocument, options)
}
export type AnnotationReplyEditedSubscriptionHookResult = ReturnType<
  typeof useAnnotationReplyEditedSubscription
>
export type AnnotationReplyEditedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.AnnotationReplyEditedSubscription>
export const AnnotationReplyReadDocument = /*#__PURE__*/ gql`
  subscription annotationReplyRead(
    $shareIdentifier: UUID!
    $includeHasUnreadComments: Boolean = false
  ) {
    commentsMarkedAsRead(shareIdentifier: $shareIdentifier) {
      identifier
      body
      isRead
      annotation {
        ...BaseAnnotation
        ...AnnotationSubjectCounters
      }
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationReplyReadSubscription__
 *
 * To run a query within a React component, call `useAnnotationReplyReadSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationReplyReadSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationReplyReadSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useAnnotationReplyReadSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationReplyReadSubscription,
    Types.AnnotationReplyReadSubscriptionVariables
  > &
    (
      | {
          variables: Types.AnnotationReplyReadSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationReplyReadSubscription,
    Types.AnnotationReplyReadSubscriptionVariables
  >(AnnotationReplyReadDocument, options)
}
export type AnnotationReplyReadSubscriptionHookResult = ReturnType<
  typeof useAnnotationReplyReadSubscription
>
export type AnnotationReplyReadSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.AnnotationReplyReadSubscription>
export const SetNotificationSubscriptionDocument = /*#__PURE__*/ gql`
  mutation setNotificationSubscription(
    $shareIdentifier: UUID
    $frameUUID: String
    $annotationIdentifier: UUID
    $state: NotificationSubscriptionState!
  ) {
    setNotificationSubscription(
      shareIdentifier: $shareIdentifier
      annotationIdentifier: $annotationIdentifier
      frameUuid: $frameUUID
      state: $state
    ) {
      share {
        identifier
        subscriptionStatus
      }
      annotation {
        identifier
        subscriptionStatus
      }
      artboard {
        permanentArtboardShortId
        documentVersionShortId
        subscriptionStatus
      }
      frame {
        identifier
        documentVersionShortId
        subscriptionStatus
      }
    }
  }
`
export type SetNotificationSubscriptionMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.SetNotificationSubscriptionMutation,
    Types.SetNotificationSubscriptionMutationVariables
  >

/**
 * __useSetNotificationSubscriptionMutation__
 *
 * To run a mutation, you first call `useSetNotificationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationSubscriptionMutation, { data, loading, error }] = useSetNotificationSubscriptionMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      frameUUID: // value for 'frameUUID'
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSetNotificationSubscriptionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SetNotificationSubscriptionMutation,
    Types.SetNotificationSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SetNotificationSubscriptionMutation,
    Types.SetNotificationSubscriptionMutationVariables
  >(SetNotificationSubscriptionDocument, options)
}
export type SetNotificationSubscriptionMutationHookResult = ReturnType<
  typeof useSetNotificationSubscriptionMutation
>
export type SetNotificationSubscriptionMutationResult =
  ApolloReactCommon.MutationResult<Types.SetNotificationSubscriptionMutation>
export type SetNotificationSubscriptionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.SetNotificationSubscriptionMutation,
    Types.SetNotificationSubscriptionMutationVariables
  >
export const SignInDocument = /*#__PURE__*/ gql`
  mutation signIn(
    $email: String!
    $password: String!
    $createWorkspace: Boolean
  ) {
    signIn(
      email: $email
      password: $password
      createWorkspace: $createWorkspace
    ) @client {
      ... on MFACredentials {
        mfaToken
      }
      ... on SignInCredentials {
        credentials {
          ...Credentials
        }
        createdWorkspace
      }
    }
  }
  ${CredentialsFragmentDoc}
`
export type SignInMutationFn = ApolloReactCommon.MutationFunction<
  Types.SignInMutation,
  Types.SignInMutationVariables
>

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      createWorkspace: // value for 'createWorkspace'
 *   },
 * });
 */
export function useSignInMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SignInMutation,
    Types.SignInMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SignInMutation,
    Types.SignInMutationVariables
  >(SignInDocument, options)
}
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>
export type SignInMutationResult =
  ApolloReactCommon.MutationResult<Types.SignInMutation>
export type SignInMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SignInMutation,
  Types.SignInMutationVariables
>
export const SignUpDocument = /*#__PURE__*/ gql`
  mutation signUp($input: SignUpInput!) {
    signUp(input: $input) {
      errors {
        ...UserError
      }
      successful
      credentials {
        ...Credentials
      }
      user {
        identifier
        ...InitialUser
        workspaces {
          identifier
        }
      }
    }
  }
  ${UserErrorFragmentDoc}
  ${CredentialsFragmentDoc}
  ${InitialUserFragmentDoc}
`
export type SignUpMutationFn = ApolloReactCommon.MutationFunction<
  Types.SignUpMutation,
  Types.SignUpMutationVariables
>

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SignUpMutation,
    Types.SignUpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SignUpMutation,
    Types.SignUpMutationVariables
  >(SignUpDocument, options)
}
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>
export type SignUpMutationResult =
  ApolloReactCommon.MutationResult<Types.SignUpMutation>
export type SignUpMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SignUpMutation,
  Types.SignUpMutationVariables
>
export const SignInWithSsoDocument = /*#__PURE__*/ gql`
  mutation signInWithSso($exchangeToken: String!) {
    signInWithSso(exchangeToken: $exchangeToken) @client {
      credentials {
        ...Credentials
      }
      workspaceId
    }
  }
  ${CredentialsFragmentDoc}
`
export type SignInWithSsoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SignInWithSsoMutation,
  Types.SignInWithSsoMutationVariables
>

/**
 * __useSignInWithSsoMutation__
 *
 * To run a mutation, you first call `useSignInWithSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithSsoMutation, { data, loading, error }] = useSignInWithSsoMutation({
 *   variables: {
 *      exchangeToken: // value for 'exchangeToken'
 *   },
 * });
 */
export function useSignInWithSsoMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SignInWithSsoMutation,
    Types.SignInWithSsoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SignInWithSsoMutation,
    Types.SignInWithSsoMutationVariables
  >(SignInWithSsoDocument, options)
}
export type SignInWithSsoMutationHookResult = ReturnType<
  typeof useSignInWithSsoMutation
>
export type SignInWithSsoMutationResult =
  ApolloReactCommon.MutationResult<Types.SignInWithSsoMutation>
export type SignInWithSsoMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.SignInWithSsoMutation,
    Types.SignInWithSsoMutationVariables
  >
export const RevokeOAuthDocument = /*#__PURE__*/ gql`
  mutation revokeOAuth($token: String!) {
    revokeOAuth(token: $token) @client {
      successful
    }
  }
`
export type RevokeOAuthMutationFn = ApolloReactCommon.MutationFunction<
  Types.RevokeOAuthMutation,
  Types.RevokeOAuthMutationVariables
>

/**
 * __useRevokeOAuthMutation__
 *
 * To run a mutation, you first call `useRevokeOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOAuthMutation, { data, loading, error }] = useRevokeOAuthMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRevokeOAuthMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RevokeOAuthMutation,
    Types.RevokeOAuthMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RevokeOAuthMutation,
    Types.RevokeOAuthMutationVariables
  >(RevokeOAuthDocument, options)
}
export type RevokeOAuthMutationHookResult = ReturnType<
  typeof useRevokeOAuthMutation
>
export type RevokeOAuthMutationResult =
  ApolloReactCommon.MutationResult<Types.RevokeOAuthMutation>
export type RevokeOAuthMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.RevokeOAuthMutation,
  Types.RevokeOAuthMutationVariables
>
export const ValidateMfaTotpDocument = /*#__PURE__*/ gql`
  mutation validateMfaTotp(
    $token: String!
    $totp: String!
    $createWorkspace: Boolean
  ) {
    validateMfaTotp(
      token: $token
      totp: $totp
      createWorkspace: $createWorkspace
    ) @client {
      createdWorkspace
      credentials {
        ...Credentials
      }
    }
  }
  ${CredentialsFragmentDoc}
`
export type ValidateMfaTotpMutationFn = ApolloReactCommon.MutationFunction<
  Types.ValidateMfaTotpMutation,
  Types.ValidateMfaTotpMutationVariables
>

/**
 * __useValidateMfaTotpMutation__
 *
 * To run a mutation, you first call `useValidateMfaTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateMfaTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateMfaTotpMutation, { data, loading, error }] = useValidateMfaTotpMutation({
 *   variables: {
 *      token: // value for 'token'
 *      totp: // value for 'totp'
 *      createWorkspace: // value for 'createWorkspace'
 *   },
 * });
 */
export function useValidateMfaTotpMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ValidateMfaTotpMutation,
    Types.ValidateMfaTotpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ValidateMfaTotpMutation,
    Types.ValidateMfaTotpMutationVariables
  >(ValidateMfaTotpDocument, options)
}
export type ValidateMfaTotpMutationHookResult = ReturnType<
  typeof useValidateMfaTotpMutation
>
export type ValidateMfaTotpMutationResult =
  ApolloReactCommon.MutationResult<Types.ValidateMfaTotpMutation>
export type ValidateMfaTotpMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ValidateMfaTotpMutation,
    Types.ValidateMfaTotpMutationVariables
  >
export const ValidateMfaRecoveryCodeDocument = /*#__PURE__*/ gql`
  mutation validateMfaRecoveryCode(
    $token: String!
    $recoveryCode: String!
    $createWorkspace: Boolean
  ) {
    validateMfaRecoveryCode(
      token: $token
      recoveryCode: $recoveryCode
      createWorkspace: $createWorkspace
    ) @client {
      createdWorkspace
      credentials {
        ...Credentials
      }
    }
  }
  ${CredentialsFragmentDoc}
`
export type ValidateMfaRecoveryCodeMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.ValidateMfaRecoveryCodeMutation,
    Types.ValidateMfaRecoveryCodeMutationVariables
  >

/**
 * __useValidateMfaRecoveryCodeMutation__
 *
 * To run a mutation, you first call `useValidateMfaRecoveryCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateMfaRecoveryCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateMfaRecoveryCodeMutation, { data, loading, error }] = useValidateMfaRecoveryCodeMutation({
 *   variables: {
 *      token: // value for 'token'
 *      recoveryCode: // value for 'recoveryCode'
 *      createWorkspace: // value for 'createWorkspace'
 *   },
 * });
 */
export function useValidateMfaRecoveryCodeMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ValidateMfaRecoveryCodeMutation,
    Types.ValidateMfaRecoveryCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ValidateMfaRecoveryCodeMutation,
    Types.ValidateMfaRecoveryCodeMutationVariables
  >(ValidateMfaRecoveryCodeDocument, options)
}
export type ValidateMfaRecoveryCodeMutationHookResult = ReturnType<
  typeof useValidateMfaRecoveryCodeMutation
>
export type ValidateMfaRecoveryCodeMutationResult =
  ApolloReactCommon.MutationResult<Types.ValidateMfaRecoveryCodeMutation>
export type ValidateMfaRecoveryCodeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ValidateMfaRecoveryCodeMutation,
    Types.ValidateMfaRecoveryCodeMutationVariables
  >
export const RevokeActiveSessionsDocument = /*#__PURE__*/ gql`
  mutation revokeActiveSessions($exceptCurrentOne: Boolean!) {
    revokeActiveSessions(exceptCurrentOne: $exceptCurrentOne) {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type RevokeActiveSessionsMutationFn = ApolloReactCommon.MutationFunction<
  Types.RevokeActiveSessionsMutation,
  Types.RevokeActiveSessionsMutationVariables
>

/**
 * __useRevokeActiveSessionsMutation__
 *
 * To run a mutation, you first call `useRevokeActiveSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeActiveSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeActiveSessionsMutation, { data, loading, error }] = useRevokeActiveSessionsMutation({
 *   variables: {
 *      exceptCurrentOne: // value for 'exceptCurrentOne'
 *   },
 * });
 */
export function useRevokeActiveSessionsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RevokeActiveSessionsMutation,
    Types.RevokeActiveSessionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RevokeActiveSessionsMutation,
    Types.RevokeActiveSessionsMutationVariables
  >(RevokeActiveSessionsDocument, options)
}
export type RevokeActiveSessionsMutationHookResult = ReturnType<
  typeof useRevokeActiveSessionsMutation
>
export type RevokeActiveSessionsMutationResult =
  ApolloReactCommon.MutationResult<Types.RevokeActiveSessionsMutation>
export type RevokeActiveSessionsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RevokeActiveSessionsMutation,
    Types.RevokeActiveSessionsMutationVariables
  >
export const RevokeSessionDocument = /*#__PURE__*/ gql`
  mutation revokeSession($id: UUID!) {
    revokeSession(id: $id) {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type RevokeSessionMutationFn = ApolloReactCommon.MutationFunction<
  Types.RevokeSessionMutation,
  Types.RevokeSessionMutationVariables
>

/**
 * __useRevokeSessionMutation__
 *
 * To run a mutation, you first call `useRevokeSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeSessionMutation, { data, loading, error }] = useRevokeSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeSessionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RevokeSessionMutation,
    Types.RevokeSessionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RevokeSessionMutation,
    Types.RevokeSessionMutationVariables
  >(RevokeSessionDocument, options)
}
export type RevokeSessionMutationHookResult = ReturnType<
  typeof useRevokeSessionMutation
>
export type RevokeSessionMutationResult =
  ApolloReactCommon.MutationResult<Types.RevokeSessionMutation>
export type RevokeSessionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RevokeSessionMutation,
    Types.RevokeSessionMutationVariables
  >
export const GetUserCredentialsDocument = /*#__PURE__*/ gql`
  query getUserCredentials {
    userCredentials @client {
      ...Credentials
    }
  }
  ${CredentialsFragmentDoc}
`

/**
 * __useGetUserCredentialsQuery__
 *
 * To run a query within a React component, call `useGetUserCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCredentialsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetUserCredentialsQuery,
    Types.GetUserCredentialsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetUserCredentialsQuery,
    Types.GetUserCredentialsQueryVariables
  >(GetUserCredentialsDocument, options)
}
export function useGetUserCredentialsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetUserCredentialsQuery,
    Types.GetUserCredentialsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetUserCredentialsQuery,
    Types.GetUserCredentialsQueryVariables
  >(GetUserCredentialsDocument, options)
}

export type GetUserCredentialsQueryHookResult = ReturnType<
  typeof useGetUserCredentialsQuery
>
export type GetUserCredentialsLazyQueryHookResult = ReturnType<
  typeof useGetUserCredentialsLazyQuery
>
export type GetUserCredentialsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetUserCredentialsQuery,
  Types.GetUserCredentialsQueryVariables
>
export const SetupMfaDocument = /*#__PURE__*/ gql`
  mutation setupMfa {
    setupMfa {
      otpAuthUri
    }
  }
`
export type SetupMfaMutationFn = ApolloReactCommon.MutationFunction<
  Types.SetupMfaMutation,
  Types.SetupMfaMutationVariables
>

/**
 * __useSetupMfaMutation__
 *
 * To run a mutation, you first call `useSetupMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupMfaMutation, { data, loading, error }] = useSetupMfaMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetupMfaMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SetupMfaMutation,
    Types.SetupMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SetupMfaMutation,
    Types.SetupMfaMutationVariables
  >(SetupMfaDocument, options)
}
export type SetupMfaMutationHookResult = ReturnType<typeof useSetupMfaMutation>
export type SetupMfaMutationResult =
  ApolloReactCommon.MutationResult<Types.SetupMfaMutation>
export type SetupMfaMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SetupMfaMutation,
  Types.SetupMfaMutationVariables
>
export const ConfirmMfaSetupDocument = /*#__PURE__*/ gql`
  mutation confirmMfaSetup($totp: String!) {
    confirmMfaSetup(totp: $totp) {
      recoveryCodes {
        entries
      }
    }
  }
`
export type ConfirmMfaSetupMutationFn = ApolloReactCommon.MutationFunction<
  Types.ConfirmMfaSetupMutation,
  Types.ConfirmMfaSetupMutationVariables
>

/**
 * __useConfirmMfaSetupMutation__
 *
 * To run a mutation, you first call `useConfirmMfaSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMfaSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMfaSetupMutation, { data, loading, error }] = useConfirmMfaSetupMutation({
 *   variables: {
 *      totp: // value for 'totp'
 *   },
 * });
 */
export function useConfirmMfaSetupMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ConfirmMfaSetupMutation,
    Types.ConfirmMfaSetupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ConfirmMfaSetupMutation,
    Types.ConfirmMfaSetupMutationVariables
  >(ConfirmMfaSetupDocument, options)
}
export type ConfirmMfaSetupMutationHookResult = ReturnType<
  typeof useConfirmMfaSetupMutation
>
export type ConfirmMfaSetupMutationResult =
  ApolloReactCommon.MutationResult<Types.ConfirmMfaSetupMutation>
export type ConfirmMfaSetupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ConfirmMfaSetupMutation,
    Types.ConfirmMfaSetupMutationVariables
  >
export const DisableMfaDocument = /*#__PURE__*/ gql`
  mutation disableMfa($password: String!) {
    disableMfa(password: $password) {
      user {
        identifier
        mfaState
      }
    }
  }
`
export type DisableMfaMutationFn = ApolloReactCommon.MutationFunction<
  Types.DisableMfaMutation,
  Types.DisableMfaMutationVariables
>

/**
 * __useDisableMfaMutation__
 *
 * To run a mutation, you first call `useDisableMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMfaMutation, { data, loading, error }] = useDisableMfaMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useDisableMfaMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DisableMfaMutation,
    Types.DisableMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DisableMfaMutation,
    Types.DisableMfaMutationVariables
  >(DisableMfaDocument, options)
}
export type DisableMfaMutationHookResult = ReturnType<
  typeof useDisableMfaMutation
>
export type DisableMfaMutationResult =
  ApolloReactCommon.MutationResult<Types.DisableMfaMutation>
export type DisableMfaMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.DisableMfaMutation,
  Types.DisableMfaMutationVariables
>
export const GenerateMfaRecoveryCodesDocument = /*#__PURE__*/ gql`
  mutation generateMfaRecoveryCodes($password: String!) {
    generateMfaRecoveryCodes(password: $password) {
      recoveryCodes {
        entries
      }
    }
  }
`
export type GenerateMfaRecoveryCodesMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.GenerateMfaRecoveryCodesMutation,
    Types.GenerateMfaRecoveryCodesMutationVariables
  >

/**
 * __useGenerateMfaRecoveryCodesMutation__
 *
 * To run a mutation, you first call `useGenerateMfaRecoveryCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMfaRecoveryCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMfaRecoveryCodesMutation, { data, loading, error }] = useGenerateMfaRecoveryCodesMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGenerateMfaRecoveryCodesMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.GenerateMfaRecoveryCodesMutation,
    Types.GenerateMfaRecoveryCodesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.GenerateMfaRecoveryCodesMutation,
    Types.GenerateMfaRecoveryCodesMutationVariables
  >(GenerateMfaRecoveryCodesDocument, options)
}
export type GenerateMfaRecoveryCodesMutationHookResult = ReturnType<
  typeof useGenerateMfaRecoveryCodesMutation
>
export type GenerateMfaRecoveryCodesMutationResult =
  ApolloReactCommon.MutationResult<Types.GenerateMfaRecoveryCodesMutation>
export type GenerateMfaRecoveryCodesMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.GenerateMfaRecoveryCodesMutation,
    Types.GenerateMfaRecoveryCodesMutationVariables
  >
export const SignInAndDisableMfaDocument = /*#__PURE__*/ gql`
  mutation signInAndDisableMfa(
    $email: String!
    $password: String!
    $disableMfaToken: UUID!
  ) {
    signInAndDisableMfa(
      email: $email
      password: $password
      disableMfaToken: $disableMfaToken
    ) @client {
      credentials {
        ...Credentials
      }
    }
  }
  ${CredentialsFragmentDoc}
`
export type SignInAndDisableMfaMutationFn = ApolloReactCommon.MutationFunction<
  Types.SignInAndDisableMfaMutation,
  Types.SignInAndDisableMfaMutationVariables
>

/**
 * __useSignInAndDisableMfaMutation__
 *
 * To run a mutation, you first call `useSignInAndDisableMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInAndDisableMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInAndDisableMfaMutation, { data, loading, error }] = useSignInAndDisableMfaMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      disableMfaToken: // value for 'disableMfaToken'
 *   },
 * });
 */
export function useSignInAndDisableMfaMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SignInAndDisableMfaMutation,
    Types.SignInAndDisableMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SignInAndDisableMfaMutation,
    Types.SignInAndDisableMfaMutationVariables
  >(SignInAndDisableMfaDocument, options)
}
export type SignInAndDisableMfaMutationHookResult = ReturnType<
  typeof useSignInAndDisableMfaMutation
>
export type SignInAndDisableMfaMutationResult =
  ApolloReactCommon.MutationResult<Types.SignInAndDisableMfaMutation>
export type SignInAndDisableMfaMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.SignInAndDisableMfaMutation,
    Types.SignInAndDisableMfaMutationVariables
  >
export const GetBrowserSettingsDocument = /*#__PURE__*/ gql`
  query getBrowserSettings {
    sidebarRightOpen @client
  }
`

/**
 * __useGetBrowserSettingsQuery__
 *
 * To run a query within a React component, call `useGetBrowserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrowserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrowserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrowserSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetBrowserSettingsQuery,
    Types.GetBrowserSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetBrowserSettingsQuery,
    Types.GetBrowserSettingsQueryVariables
  >(GetBrowserSettingsDocument, options)
}
export function useGetBrowserSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetBrowserSettingsQuery,
    Types.GetBrowserSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetBrowserSettingsQuery,
    Types.GetBrowserSettingsQueryVariables
  >(GetBrowserSettingsDocument, options)
}

export type GetBrowserSettingsQueryHookResult = ReturnType<
  typeof useGetBrowserSettingsQuery
>
export type GetBrowserSettingsLazyQueryHookResult = ReturnType<
  typeof useGetBrowserSettingsLazyQuery
>
export type GetBrowserSettingsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetBrowserSettingsQuery,
  Types.GetBrowserSettingsQueryVariables
>
export const AddSharesToCollectionDocument = /*#__PURE__*/ gql`
  mutation addSharesToCollection(
    $identifier: UUID!
    $shareIdentifiers: [UUID!]!
    $search: SharesSearchParams
  ) {
    addSharesToCollection(
      identifier: $identifier
      shareIdentifiers: $shareIdentifiers
    ) {
      collection {
        ...Collection
        previews(search: $search) {
          ...CollectionSharePreview
        }
        shareCount(search: $search)
      }
    }
  }
  ${CollectionFragmentDoc}
  ${CollectionSharePreviewFragmentDoc}
`
export type AddSharesToCollectionMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AddSharesToCollectionMutation,
    Types.AddSharesToCollectionMutationVariables
  >

/**
 * __useAddSharesToCollectionMutation__
 *
 * To run a mutation, you first call `useAddSharesToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSharesToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSharesToCollectionMutation, { data, loading, error }] = useAddSharesToCollectionMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      shareIdentifiers: // value for 'shareIdentifiers'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAddSharesToCollectionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddSharesToCollectionMutation,
    Types.AddSharesToCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddSharesToCollectionMutation,
    Types.AddSharesToCollectionMutationVariables
  >(AddSharesToCollectionDocument, options)
}
export type AddSharesToCollectionMutationHookResult = ReturnType<
  typeof useAddSharesToCollectionMutation
>
export type AddSharesToCollectionMutationResult =
  ApolloReactCommon.MutationResult<Types.AddSharesToCollectionMutation>
export type AddSharesToCollectionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AddSharesToCollectionMutation,
    Types.AddSharesToCollectionMutationVariables
  >
export const CreateCollectionDocument = /*#__PURE__*/ gql`
  mutation createCollection(
    $projectIdentifier: UUID!
    $name: String!
    $description: String
    $shareIdentifiers: [UUID!]!
    $addAllProjectShares: Boolean
  ) {
    createCollection(
      projectIdentifier: $projectIdentifier
      name: $name
      description: $description
      shareIdentifiers: $shareIdentifiers
      addAllProjectShares: $addAllProjectShares
    ) {
      collection {
        ...CollectionPreviews
      }
    }
  }
  ${CollectionPreviewsFragmentDoc}
`
export type CreateCollectionMutationFn = ApolloReactCommon.MutationFunction<
  Types.CreateCollectionMutation,
  Types.CreateCollectionMutationVariables
>

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      shareIdentifiers: // value for 'shareIdentifiers'
 *      addAllProjectShares: // value for 'addAllProjectShares'
 *   },
 * });
 */
export function useCreateCollectionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateCollectionMutation,
    Types.CreateCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateCollectionMutation,
    Types.CreateCollectionMutationVariables
  >(CreateCollectionDocument, options)
}
export type CreateCollectionMutationHookResult = ReturnType<
  typeof useCreateCollectionMutation
>
export type CreateCollectionMutationResult =
  ApolloReactCommon.MutationResult<Types.CreateCollectionMutation>
export type CreateCollectionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreateCollectionMutation,
    Types.CreateCollectionMutationVariables
  >
export const RemoveSharesFromCollectionDocument = /*#__PURE__*/ gql`
  mutation removeSharesFromCollection(
    $identifier: UUID!
    $shareIdentifiers: [UUID!]!
  ) {
    removeSharesFromCollection(
      identifier: $identifier
      shareIdentifiers: $shareIdentifiers
    ) {
      collection {
        ...CollectionPreviews
      }
    }
  }
  ${CollectionPreviewsFragmentDoc}
`
export type RemoveSharesFromCollectionMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.RemoveSharesFromCollectionMutation,
    Types.RemoveSharesFromCollectionMutationVariables
  >

/**
 * __useRemoveSharesFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveSharesFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSharesFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSharesFromCollectionMutation, { data, loading, error }] = useRemoveSharesFromCollectionMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      shareIdentifiers: // value for 'shareIdentifiers'
 *   },
 * });
 */
export function useRemoveSharesFromCollectionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemoveSharesFromCollectionMutation,
    Types.RemoveSharesFromCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemoveSharesFromCollectionMutation,
    Types.RemoveSharesFromCollectionMutationVariables
  >(RemoveSharesFromCollectionDocument, options)
}
export type RemoveSharesFromCollectionMutationHookResult = ReturnType<
  typeof useRemoveSharesFromCollectionMutation
>
export type RemoveSharesFromCollectionMutationResult =
  ApolloReactCommon.MutationResult<Types.RemoveSharesFromCollectionMutation>
export type RemoveSharesFromCollectionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RemoveSharesFromCollectionMutation,
    Types.RemoveSharesFromCollectionMutationVariables
  >
export const RenameCollectionDocument = /*#__PURE__*/ gql`
  mutation renameCollection($identifier: UUID!, $name: String!) {
    renameCollection(identifier: $identifier, name: $name) {
      collection {
        ...CollectionPreviews
      }
    }
  }
  ${CollectionPreviewsFragmentDoc}
`
export type RenameCollectionMutationFn = ApolloReactCommon.MutationFunction<
  Types.RenameCollectionMutation,
  Types.RenameCollectionMutationVariables
>

/**
 * __useRenameCollectionMutation__
 *
 * To run a mutation, you first call `useRenameCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameCollectionMutation, { data, loading, error }] = useRenameCollectionMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameCollectionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RenameCollectionMutation,
    Types.RenameCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RenameCollectionMutation,
    Types.RenameCollectionMutationVariables
  >(RenameCollectionDocument, options)
}
export type RenameCollectionMutationHookResult = ReturnType<
  typeof useRenameCollectionMutation
>
export type RenameCollectionMutationResult =
  ApolloReactCommon.MutationResult<Types.RenameCollectionMutation>
export type RenameCollectionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RenameCollectionMutation,
    Types.RenameCollectionMutationVariables
  >
export const EditCollectionDescriptionDocument = /*#__PURE__*/ gql`
  mutation editCollectionDescription($identifier: UUID!, $description: String) {
    editCollectionDescription(
      identifier: $identifier
      description: $description
    ) {
      collection {
        ...CollectionPreviews
      }
    }
  }
  ${CollectionPreviewsFragmentDoc}
`
export type EditCollectionDescriptionMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.EditCollectionDescriptionMutation,
    Types.EditCollectionDescriptionMutationVariables
  >

/**
 * __useEditCollectionDescriptionMutation__
 *
 * To run a mutation, you first call `useEditCollectionDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCollectionDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCollectionDescriptionMutation, { data, loading, error }] = useEditCollectionDescriptionMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useEditCollectionDescriptionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EditCollectionDescriptionMutation,
    Types.EditCollectionDescriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EditCollectionDescriptionMutation,
    Types.EditCollectionDescriptionMutationVariables
  >(EditCollectionDescriptionDocument, options)
}
export type EditCollectionDescriptionMutationHookResult = ReturnType<
  typeof useEditCollectionDescriptionMutation
>
export type EditCollectionDescriptionMutationResult =
  ApolloReactCommon.MutationResult<Types.EditCollectionDescriptionMutation>
export type EditCollectionDescriptionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.EditCollectionDescriptionMutation,
    Types.EditCollectionDescriptionMutationVariables
  >
export const DeleteCollectionDocument = /*#__PURE__*/ gql`
  mutation deleteCollection($identifier: UUID!) {
    deleteCollection(identifier: $identifier) {
      collection {
        identifier
      }
    }
  }
`
export type DeleteCollectionMutationFn = ApolloReactCommon.MutationFunction<
  Types.DeleteCollectionMutation,
  Types.DeleteCollectionMutationVariables
>

/**
 * __useDeleteCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionMutation, { data, loading, error }] = useDeleteCollectionMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDeleteCollectionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteCollectionMutation,
    Types.DeleteCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteCollectionMutation,
    Types.DeleteCollectionMutationVariables
  >(DeleteCollectionDocument, options)
}
export type DeleteCollectionMutationHookResult = ReturnType<
  typeof useDeleteCollectionMutation
>
export type DeleteCollectionMutationResult =
  ApolloReactCommon.MutationResult<Types.DeleteCollectionMutation>
export type DeleteCollectionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DeleteCollectionMutation,
    Types.DeleteCollectionMutationVariables
  >
export const EditCollectionDocument = /*#__PURE__*/ gql`
  mutation editCollection(
    $identifier: UUID!
    $name: String!
    $description: String
    $shareIdentifiers: [UUID!]!
    $addAllProjectShares: Boolean
  ) {
    editCollection(
      identifier: $identifier
      name: $name
      description: $description
      shareIdentifiers: $shareIdentifiers
      addAllProjectShares: $addAllProjectShares
    ) {
      collection {
        ...CollectionPreviews
      }
    }
  }
  ${CollectionPreviewsFragmentDoc}
`
export type EditCollectionMutationFn = ApolloReactCommon.MutationFunction<
  Types.EditCollectionMutation,
  Types.EditCollectionMutationVariables
>

/**
 * __useEditCollectionMutation__
 *
 * To run a mutation, you first call `useEditCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCollectionMutation, { data, loading, error }] = useEditCollectionMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      shareIdentifiers: // value for 'shareIdentifiers'
 *      addAllProjectShares: // value for 'addAllProjectShares'
 *   },
 * });
 */
export function useEditCollectionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EditCollectionMutation,
    Types.EditCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EditCollectionMutation,
    Types.EditCollectionMutationVariables
  >(EditCollectionDocument, options)
}
export type EditCollectionMutationHookResult = ReturnType<
  typeof useEditCollectionMutation
>
export type EditCollectionMutationResult =
  ApolloReactCommon.MutationResult<Types.EditCollectionMutation>
export type EditCollectionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.EditCollectionMutation,
    Types.EditCollectionMutationVariables
  >
export const MoveAllCollectionSharesDocument = /*#__PURE__*/ gql`
  mutation moveAllCollectionShares(
    $originIdentifier: UUID!
    $targetIdentifier: UUID!
    $removeCollection: Boolean!
    $search: SharesSearchParams
  ) {
    moveAllCollectionShares(
      originIdentifier: $originIdentifier
      targetIdentifier: $targetIdentifier
      removeCollection: $removeCollection
    ) {
      targetCollection {
        identifier
        previews(search: $search) {
          ...CollectionSharePreview
        }
        shareCount(search: $search)
      }
      projectIdentifier
    }
  }
  ${CollectionSharePreviewFragmentDoc}
`
export type MoveAllCollectionSharesMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.MoveAllCollectionSharesMutation,
    Types.MoveAllCollectionSharesMutationVariables
  >

/**
 * __useMoveAllCollectionSharesMutation__
 *
 * To run a mutation, you first call `useMoveAllCollectionSharesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAllCollectionSharesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAllCollectionSharesMutation, { data, loading, error }] = useMoveAllCollectionSharesMutation({
 *   variables: {
 *      originIdentifier: // value for 'originIdentifier'
 *      targetIdentifier: // value for 'targetIdentifier'
 *      removeCollection: // value for 'removeCollection'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMoveAllCollectionSharesMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.MoveAllCollectionSharesMutation,
    Types.MoveAllCollectionSharesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.MoveAllCollectionSharesMutation,
    Types.MoveAllCollectionSharesMutationVariables
  >(MoveAllCollectionSharesDocument, options)
}
export type MoveAllCollectionSharesMutationHookResult = ReturnType<
  typeof useMoveAllCollectionSharesMutation
>
export type MoveAllCollectionSharesMutationResult =
  ApolloReactCommon.MutationResult<Types.MoveAllCollectionSharesMutation>
export type MoveAllCollectionSharesMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.MoveAllCollectionSharesMutation,
    Types.MoveAllCollectionSharesMutationVariables
  >
export const GetCollectionSharesDocument = /*#__PURE__*/ gql`
  query getCollectionShares(
    $projectIdentifier: UUID!
    $collectionIdentifier: UUID!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
  ) {
    project(identifier: $projectIdentifier) {
      ...Project
      collection(identifier: $collectionIdentifier) {
        ...CollectionPreviews
        shares(after: $after, search: $search, sortOrder: $sortOrder) {
          entries {
            ...ShareListItem
          }
          meta {
            ...ShareMeta
          }
        }
      }
    }
  }
  ${ProjectFragmentDoc}
  ${CollectionPreviewsFragmentDoc}
  ${ShareListItemFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetCollectionSharesQuery__
 *
 * To run a query within a React component, call `useGetCollectionSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionSharesQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      collectionIdentifier: // value for 'collectionIdentifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetCollectionSharesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetCollectionSharesQuery,
    Types.GetCollectionSharesQueryVariables
  > &
    (
      | { variables: Types.GetCollectionSharesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCollectionSharesQuery,
    Types.GetCollectionSharesQueryVariables
  >(GetCollectionSharesDocument, options)
}
export function useGetCollectionSharesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCollectionSharesQuery,
    Types.GetCollectionSharesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCollectionSharesQuery,
    Types.GetCollectionSharesQueryVariables
  >(GetCollectionSharesDocument, options)
}

export type GetCollectionSharesQueryHookResult = ReturnType<
  typeof useGetCollectionSharesQuery
>
export type GetCollectionSharesLazyQueryHookResult = ReturnType<
  typeof useGetCollectionSharesLazyQuery
>
export type GetCollectionSharesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetCollectionSharesQuery,
  Types.GetCollectionSharesQueryVariables
>
export const GetCollectionSharesUnpaginatedDocument = /*#__PURE__*/ gql`
  query getCollectionSharesUnpaginated(
    $projectIdentifier: UUID!
    $collectionIdentifier: UUID!
  ) {
    project(identifier: $projectIdentifier) {
      identifier
      collection(identifier: $collectionIdentifier) {
        identifier
        sharesUnpaginated {
          ...UnpaginatedCollectionShare
        }
      }
    }
  }
  ${UnpaginatedCollectionShareFragmentDoc}
`

/**
 * __useGetCollectionSharesUnpaginatedQuery__
 *
 * To run a query within a React component, call `useGetCollectionSharesUnpaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionSharesUnpaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionSharesUnpaginatedQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      collectionIdentifier: // value for 'collectionIdentifier'
 *   },
 * });
 */
export function useGetCollectionSharesUnpaginatedQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetCollectionSharesUnpaginatedQuery,
    Types.GetCollectionSharesUnpaginatedQueryVariables
  > &
    (
      | {
          variables: Types.GetCollectionSharesUnpaginatedQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCollectionSharesUnpaginatedQuery,
    Types.GetCollectionSharesUnpaginatedQueryVariables
  >(GetCollectionSharesUnpaginatedDocument, options)
}
export function useGetCollectionSharesUnpaginatedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCollectionSharesUnpaginatedQuery,
    Types.GetCollectionSharesUnpaginatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCollectionSharesUnpaginatedQuery,
    Types.GetCollectionSharesUnpaginatedQueryVariables
  >(GetCollectionSharesUnpaginatedDocument, options)
}

export type GetCollectionSharesUnpaginatedQueryHookResult = ReturnType<
  typeof useGetCollectionSharesUnpaginatedQuery
>
export type GetCollectionSharesUnpaginatedLazyQueryHookResult = ReturnType<
  typeof useGetCollectionSharesUnpaginatedLazyQuery
>
export type GetCollectionSharesUnpaginatedQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetCollectionSharesUnpaginatedQuery,
    Types.GetCollectionSharesUnpaginatedQueryVariables
  >
export const GetProjectCollectionsDocument = /*#__PURE__*/ gql`
  query getProjectCollections(
    $projectIdentifier: UUID!
    $after: String
    $search: SharesSearchParams
  ) {
    project(identifier: $projectIdentifier) {
      identifier
      collections(shareSearch: $search, after: $after) {
        entries {
          ...Collection
          previews(search: $search) {
            ...CollectionSharePreview
          }
          shareCount(search: $search)
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${CollectionFragmentDoc}
  ${CollectionSharePreviewFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetProjectCollectionsQuery__
 *
 * To run a query within a React component, call `useGetProjectCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCollectionsQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetProjectCollectionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectCollectionsQuery,
    Types.GetProjectCollectionsQueryVariables
  > &
    (
      | { variables: Types.GetProjectCollectionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectCollectionsQuery,
    Types.GetProjectCollectionsQueryVariables
  >(GetProjectCollectionsDocument, options)
}
export function useGetProjectCollectionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectCollectionsQuery,
    Types.GetProjectCollectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectCollectionsQuery,
    Types.GetProjectCollectionsQueryVariables
  >(GetProjectCollectionsDocument, options)
}

export type GetProjectCollectionsQueryHookResult = ReturnType<
  typeof useGetProjectCollectionsQuery
>
export type GetProjectCollectionsLazyQueryHookResult = ReturnType<
  typeof useGetProjectCollectionsLazyQuery
>
export type GetProjectCollectionsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetProjectCollectionsQuery,
  Types.GetProjectCollectionsQueryVariables
>
export const GetShareCollectionDocument = /*#__PURE__*/ gql`
  query getShareCollection($shareIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      identifier
      collection {
        ...CollectionForSelect
      }
    }
  }
  ${CollectionForSelectFragmentDoc}
`

/**
 * __useGetShareCollectionQuery__
 *
 * To run a query within a React component, call `useGetShareCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareCollectionQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetShareCollectionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareCollectionQuery,
    Types.GetShareCollectionQueryVariables
  > &
    (
      | { variables: Types.GetShareCollectionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareCollectionQuery,
    Types.GetShareCollectionQueryVariables
  >(GetShareCollectionDocument, options)
}
export function useGetShareCollectionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareCollectionQuery,
    Types.GetShareCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareCollectionQuery,
    Types.GetShareCollectionQueryVariables
  >(GetShareCollectionDocument, options)
}

export type GetShareCollectionQueryHookResult = ReturnType<
  typeof useGetShareCollectionQuery
>
export type GetShareCollectionLazyQueryHookResult = ReturnType<
  typeof useGetShareCollectionLazyQuery
>
export type GetShareCollectionQueryResult = ApolloReactCommon.QueryResult<
  Types.GetShareCollectionQuery,
  Types.GetShareCollectionQueryVariables
>
export const GetProjectCollectionsForSelectDocument = /*#__PURE__*/ gql`
  query getProjectCollectionsForSelect($projectIdentifier: UUID!) {
    project(identifier: $projectIdentifier) {
      identifier
      collectionsUnpaginated {
        identifier
        name
      }
    }
  }
`

/**
 * __useGetProjectCollectionsForSelectQuery__
 *
 * To run a query within a React component, call `useGetProjectCollectionsForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCollectionsForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCollectionsForSelectQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useGetProjectCollectionsForSelectQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectCollectionsForSelectQuery,
    Types.GetProjectCollectionsForSelectQueryVariables
  > &
    (
      | {
          variables: Types.GetProjectCollectionsForSelectQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectCollectionsForSelectQuery,
    Types.GetProjectCollectionsForSelectQueryVariables
  >(GetProjectCollectionsForSelectDocument, options)
}
export function useGetProjectCollectionsForSelectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectCollectionsForSelectQuery,
    Types.GetProjectCollectionsForSelectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectCollectionsForSelectQuery,
    Types.GetProjectCollectionsForSelectQueryVariables
  >(GetProjectCollectionsForSelectDocument, options)
}

export type GetProjectCollectionsForSelectQueryHookResult = ReturnType<
  typeof useGetProjectCollectionsForSelectQuery
>
export type GetProjectCollectionsForSelectLazyQueryHookResult = ReturnType<
  typeof useGetProjectCollectionsForSelectLazyQuery
>
export type GetProjectCollectionsForSelectQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetProjectCollectionsForSelectQuery,
    Types.GetProjectCollectionsForSelectQueryVariables
  >
export const ShareCollectionChangedDocument = /*#__PURE__*/ gql`
  subscription shareCollectionChanged($projectIdentifier: UUID!) {
    shareCollectionChanged(projectIdentifier: $projectIdentifier) {
      ... on ShareAddedToCollectionEvent {
        share {
          ...ShareListItem
        }
        collection {
          ...CollectionForSelect
        }
        projectIdentifier
      }
      ... on ShareRemovedFromCollectionEvent {
        share {
          ...ShareListItem
        }
        collection {
          ...CollectionForSelect
        }
        destinationProjectIdentifier
      }
    }
  }
  ${ShareListItemFragmentDoc}
  ${CollectionForSelectFragmentDoc}
`

/**
 * __useShareCollectionChangedSubscription__
 *
 * To run a query within a React component, call `useShareCollectionChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShareCollectionChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareCollectionChangedSubscription({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useShareCollectionChangedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.ShareCollectionChangedSubscription,
    Types.ShareCollectionChangedSubscriptionVariables
  > &
    (
      | {
          variables: Types.ShareCollectionChangedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ShareCollectionChangedSubscription,
    Types.ShareCollectionChangedSubscriptionVariables
  >(ShareCollectionChangedDocument, options)
}
export type ShareCollectionChangedSubscriptionHookResult = ReturnType<
  typeof useShareCollectionChangedSubscription
>
export type ShareCollectionChangedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.ShareCollectionChangedSubscription>
export const CollectionDeletedDocument = /*#__PURE__*/ gql`
  subscription collectionDeleted($projectIdentifier: UUID!) {
    collectionDeleted(projectIdentifier: $projectIdentifier) {
      identifier
    }
  }
`

/**
 * __useCollectionDeletedSubscription__
 *
 * To run a query within a React component, call `useCollectionDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCollectionDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionDeletedSubscription({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useCollectionDeletedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.CollectionDeletedSubscription,
    Types.CollectionDeletedSubscriptionVariables
  > &
    (
      | {
          variables: Types.CollectionDeletedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.CollectionDeletedSubscription,
    Types.CollectionDeletedSubscriptionVariables
  >(CollectionDeletedDocument, options)
}
export type CollectionDeletedSubscriptionHookResult = ReturnType<
  typeof useCollectionDeletedSubscription
>
export type CollectionDeletedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.CollectionDeletedSubscription>
export const CollectionChangedDocument = /*#__PURE__*/ gql`
  subscription collectionChanged($projectIdentifier: UUID!) {
    collectionChanged(projectIdentifier: $projectIdentifier) {
      collection {
        identifier
        name
        description
      }
    }
  }
`

/**
 * __useCollectionChangedSubscription__
 *
 * To run a query within a React component, call `useCollectionChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCollectionChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionChangedSubscription({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useCollectionChangedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.CollectionChangedSubscription,
    Types.CollectionChangedSubscriptionVariables
  > &
    (
      | {
          variables: Types.CollectionChangedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.CollectionChangedSubscription,
    Types.CollectionChangedSubscriptionVariables
  >(CollectionChangedDocument, options)
}
export type CollectionChangedSubscriptionHookResult = ReturnType<
  typeof useCollectionChangedSubscription
>
export type CollectionChangedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.CollectionChangedSubscription>
export const CollectionCreatedDocument = /*#__PURE__*/ gql`
  subscription collectionCreated($projectIdentifier: UUID!) {
    collectionCreated(projectIdentifier: $projectIdentifier) {
      collection {
        ...CollectionPreviews
      }
    }
  }
  ${CollectionPreviewsFragmentDoc}
`

/**
 * __useCollectionCreatedSubscription__
 *
 * To run a query within a React component, call `useCollectionCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCollectionCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionCreatedSubscription({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useCollectionCreatedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.CollectionCreatedSubscription,
    Types.CollectionCreatedSubscriptionVariables
  > &
    (
      | {
          variables: Types.CollectionCreatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.CollectionCreatedSubscription,
    Types.CollectionCreatedSubscriptionVariables
  >(CollectionCreatedDocument, options)
}
export type CollectionCreatedSubscriptionHookResult = ReturnType<
  typeof useCollectionCreatedSubscription
>
export type CollectionCreatedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.CollectionCreatedSubscription>
export const GetCommunityPageItemsDocument = /*#__PURE__*/ gql`
  query getCommunityPageItems {
    community @client {
      sections {
        ...CommunitySection
      }
    }
  }
  ${CommunitySectionFragmentDoc}
`

/**
 * __useGetCommunityPageItemsQuery__
 *
 * To run a query within a React component, call `useGetCommunityPageItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityPageItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityPageItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommunityPageItemsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetCommunityPageItemsQuery,
    Types.GetCommunityPageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCommunityPageItemsQuery,
    Types.GetCommunityPageItemsQueryVariables
  >(GetCommunityPageItemsDocument, options)
}
export function useGetCommunityPageItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCommunityPageItemsQuery,
    Types.GetCommunityPageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCommunityPageItemsQuery,
    Types.GetCommunityPageItemsQueryVariables
  >(GetCommunityPageItemsDocument, options)
}

export type GetCommunityPageItemsQueryHookResult = ReturnType<
  typeof useGetCommunityPageItemsQuery
>
export type GetCommunityPageItemsLazyQueryHookResult = ReturnType<
  typeof useGetCommunityPageItemsLazyQuery
>
export type GetCommunityPageItemsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetCommunityPageItemsQuery,
  Types.GetCommunityPageItemsQueryVariables
>
export const CreateDesignSystemDocument = /*#__PURE__*/ gql`
  mutation createDesignSystem(
    $workspaceIdentifier: UUID!
    $input: CreateDesignSystemInput!
  ) {
    createDesignSystem(
      workspaceIdentifier: $workspaceIdentifier
      input: $input
    ) {
      identifier
      description
      preview
      header
      shares {
        meta {
          totalCount
        }
        entries {
          name
          identifier
        }
      }
    }
  }
`
export type CreateDesignSystemMutationFn = ApolloReactCommon.MutationFunction<
  Types.CreateDesignSystemMutation,
  Types.CreateDesignSystemMutationVariables
>

/**
 * __useCreateDesignSystemMutation__
 *
 * To run a mutation, you first call `useCreateDesignSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDesignSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDesignSystemMutation, { data, loading, error }] = useCreateDesignSystemMutation({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDesignSystemMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateDesignSystemMutation,
    Types.CreateDesignSystemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateDesignSystemMutation,
    Types.CreateDesignSystemMutationVariables
  >(CreateDesignSystemDocument, options)
}
export type CreateDesignSystemMutationHookResult = ReturnType<
  typeof useCreateDesignSystemMutation
>
export type CreateDesignSystemMutationResult =
  ApolloReactCommon.MutationResult<Types.CreateDesignSystemMutation>
export type CreateDesignSystemMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreateDesignSystemMutation,
    Types.CreateDesignSystemMutationVariables
  >
export const DeleteDesignSystemDocument = /*#__PURE__*/ gql`
  mutation deleteDesignSystem($identifier: UUID!) {
    deleteDesignSystem(identifier: $identifier) {
      name
    }
  }
`
export type DeleteDesignSystemMutationFn = ApolloReactCommon.MutationFunction<
  Types.DeleteDesignSystemMutation,
  Types.DeleteDesignSystemMutationVariables
>

/**
 * __useDeleteDesignSystemMutation__
 *
 * To run a mutation, you first call `useDeleteDesignSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDesignSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDesignSystemMutation, { data, loading, error }] = useDeleteDesignSystemMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDeleteDesignSystemMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteDesignSystemMutation,
    Types.DeleteDesignSystemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteDesignSystemMutation,
    Types.DeleteDesignSystemMutationVariables
  >(DeleteDesignSystemDocument, options)
}
export type DeleteDesignSystemMutationHookResult = ReturnType<
  typeof useDeleteDesignSystemMutation
>
export type DeleteDesignSystemMutationResult =
  ApolloReactCommon.MutationResult<Types.DeleteDesignSystemMutation>
export type DeleteDesignSystemMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DeleteDesignSystemMutation,
    Types.DeleteDesignSystemMutationVariables
  >
export const UpdateDesignSystemDocument = /*#__PURE__*/ gql`
  mutation updateDesignSystem(
    $identifier: UUID!
    $input: UpdateDesignSystemInput!
  ) {
    updateDesignSystem(identifier: $identifier, input: $input) {
      identifier
      header
    }
  }
`
export type UpdateDesignSystemMutationFn = ApolloReactCommon.MutationFunction<
  Types.UpdateDesignSystemMutation,
  Types.UpdateDesignSystemMutationVariables
>

/**
 * __useUpdateDesignSystemMutation__
 *
 * To run a mutation, you first call `useUpdateDesignSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDesignSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDesignSystemMutation, { data, loading, error }] = useUpdateDesignSystemMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDesignSystemMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateDesignSystemMutation,
    Types.UpdateDesignSystemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateDesignSystemMutation,
    Types.UpdateDesignSystemMutationVariables
  >(UpdateDesignSystemDocument, options)
}
export type UpdateDesignSystemMutationHookResult = ReturnType<
  typeof useUpdateDesignSystemMutation
>
export type UpdateDesignSystemMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateDesignSystemMutation>
export type UpdateDesignSystemMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateDesignSystemMutation,
    Types.UpdateDesignSystemMutationVariables
  >
export const UpdateDesignSystemContentDocument = /*#__PURE__*/ gql`
  mutation updateDesignSystemContent(
    $identifier: UUID!
    $input: UpdateDesignSystemInput!
  ) {
    updateDesignSystem(identifier: $identifier, input: $input) {
      identifier
      content
    }
  }
`
export type UpdateDesignSystemContentMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateDesignSystemContentMutation,
    Types.UpdateDesignSystemContentMutationVariables
  >

/**
 * __useUpdateDesignSystemContentMutation__
 *
 * To run a mutation, you first call `useUpdateDesignSystemContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDesignSystemContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDesignSystemContentMutation, { data, loading, error }] = useUpdateDesignSystemContentMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDesignSystemContentMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateDesignSystemContentMutation,
    Types.UpdateDesignSystemContentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateDesignSystemContentMutation,
    Types.UpdateDesignSystemContentMutationVariables
  >(UpdateDesignSystemContentDocument, options)
}
export type UpdateDesignSystemContentMutationHookResult = ReturnType<
  typeof useUpdateDesignSystemContentMutation
>
export type UpdateDesignSystemContentMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateDesignSystemContentMutation>
export type UpdateDesignSystemContentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateDesignSystemContentMutation,
    Types.UpdateDesignSystemContentMutationVariables
  >
export const CreateDesignSystemDocsDocument = /*#__PURE__*/ gql`
  mutation createDesignSystemDocs($designSystemId: UUID!) {
    createDesignSystemDocs(identifier: $designSystemId) {
      identifier
      description
    }
  }
`
export type CreateDesignSystemDocsMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.CreateDesignSystemDocsMutation,
    Types.CreateDesignSystemDocsMutationVariables
  >

/**
 * __useCreateDesignSystemDocsMutation__
 *
 * To run a mutation, you first call `useCreateDesignSystemDocsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDesignSystemDocsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDesignSystemDocsMutation, { data, loading, error }] = useCreateDesignSystemDocsMutation({
 *   variables: {
 *      designSystemId: // value for 'designSystemId'
 *   },
 * });
 */
export function useCreateDesignSystemDocsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateDesignSystemDocsMutation,
    Types.CreateDesignSystemDocsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateDesignSystemDocsMutation,
    Types.CreateDesignSystemDocsMutationVariables
  >(CreateDesignSystemDocsDocument, options)
}
export type CreateDesignSystemDocsMutationHookResult = ReturnType<
  typeof useCreateDesignSystemDocsMutation
>
export type CreateDesignSystemDocsMutationResult =
  ApolloReactCommon.MutationResult<Types.CreateDesignSystemDocsMutation>
export type CreateDesignSystemDocsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreateDesignSystemDocsMutation,
    Types.CreateDesignSystemDocsMutationVariables
  >
export const GetWorkspaceDesignSystemsDocument = /*#__PURE__*/ gql`
  query getWorkspaceDesignSystems(
    $identifier: UUID!
    $after: String
    $limit: Int = 15
  ) {
    workspace(identifier: $identifier) {
      identifier
      userRole
      designSystems(limit: $limit, after: $after) {
        entries {
          identifier
          preview
          header
          name
          description
          shareCount
          previewShares {
            ...ShareListItem
          }
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ShareListItemFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetWorkspaceDesignSystemsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceDesignSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceDesignSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceDesignSystemsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetWorkspaceDesignSystemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceDesignSystemsQuery,
    Types.GetWorkspaceDesignSystemsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceDesignSystemsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceDesignSystemsQuery,
    Types.GetWorkspaceDesignSystemsQueryVariables
  >(GetWorkspaceDesignSystemsDocument, options)
}
export function useGetWorkspaceDesignSystemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceDesignSystemsQuery,
    Types.GetWorkspaceDesignSystemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceDesignSystemsQuery,
    Types.GetWorkspaceDesignSystemsQueryVariables
  >(GetWorkspaceDesignSystemsDocument, options)
}

export type GetWorkspaceDesignSystemsQueryHookResult = ReturnType<
  typeof useGetWorkspaceDesignSystemsQuery
>
export type GetWorkspaceDesignSystemsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceDesignSystemsLazyQuery
>
export type GetWorkspaceDesignSystemsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspaceDesignSystemsQuery,
    Types.GetWorkspaceDesignSystemsQueryVariables
  >
export const GetDesignSystemDocument = /*#__PURE__*/ gql`
  query getDesignSystem(
    $identifier: UUID!
    $after: String
    $limit: Int = 10
    $search: String
  ) {
    designSystem(identifier: $identifier) {
      identifier
      name
      description
      content
      createdAt
      updatedAt
      preview
      header
      sections {
        identifier
        name
      }
      shares(after: $after, limit: $limit, search: { name: $search }) {
        entries {
          ...ShareListItem
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ShareListItemFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetDesignSystemQuery__
 *
 * To run a query within a React component, call `useGetDesignSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignSystemQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetDesignSystemQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetDesignSystemQuery,
    Types.GetDesignSystemQueryVariables
  > &
    (
      | { variables: Types.GetDesignSystemQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDesignSystemQuery,
    Types.GetDesignSystemQueryVariables
  >(GetDesignSystemDocument, options)
}
export function useGetDesignSystemLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDesignSystemQuery,
    Types.GetDesignSystemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDesignSystemQuery,
    Types.GetDesignSystemQueryVariables
  >(GetDesignSystemDocument, options)
}

export type GetDesignSystemQueryHookResult = ReturnType<
  typeof useGetDesignSystemQuery
>
export type GetDesignSystemLazyQueryHookResult = ReturnType<
  typeof useGetDesignSystemLazyQuery
>
export type GetDesignSystemQueryResult = ApolloReactCommon.QueryResult<
  Types.GetDesignSystemQuery,
  Types.GetDesignSystemQueryVariables
>
export const GetEligibleSharesDocument = /*#__PURE__*/ gql`
  query getEligibleShares(
    $identifier: UUID!
    $after: String
    $limit: Int = 10
    $search: String
  ) {
    designSystemEligibleShares(
      workspaceIdentifier: $identifier
      limit: $limit
      after: $after
      search: { name: $search }
    ) {
      entries {
        ...SharePublication
      }
      meta {
        ...ShareMeta
      }
    }
  }
  ${SharePublicationFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetEligibleSharesQuery__
 *
 * To run a query within a React component, call `useGetEligibleSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibleSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligibleSharesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEligibleSharesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetEligibleSharesQuery,
    Types.GetEligibleSharesQueryVariables
  > &
    (
      | { variables: Types.GetEligibleSharesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetEligibleSharesQuery,
    Types.GetEligibleSharesQueryVariables
  >(GetEligibleSharesDocument, options)
}
export function useGetEligibleSharesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetEligibleSharesQuery,
    Types.GetEligibleSharesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetEligibleSharesQuery,
    Types.GetEligibleSharesQueryVariables
  >(GetEligibleSharesDocument, options)
}

export type GetEligibleSharesQueryHookResult = ReturnType<
  typeof useGetEligibleSharesQuery
>
export type GetEligibleSharesLazyQueryHookResult = ReturnType<
  typeof useGetEligibleSharesLazyQuery
>
export type GetEligibleSharesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetEligibleSharesQuery,
  Types.GetEligibleSharesQueryVariables
>
export const CanUseDesignSystemManagerDocument = /*#__PURE__*/ gql`
  query canUseDesignSystemManager($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      features {
        designSystemsEnabled
      }
    }
  }
`

/**
 * __useCanUseDesignSystemManagerQuery__
 *
 * To run a query within a React component, call `useCanUseDesignSystemManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanUseDesignSystemManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanUseDesignSystemManagerQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useCanUseDesignSystemManagerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.CanUseDesignSystemManagerQuery,
    Types.CanUseDesignSystemManagerQueryVariables
  > &
    (
      | {
          variables: Types.CanUseDesignSystemManagerQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.CanUseDesignSystemManagerQuery,
    Types.CanUseDesignSystemManagerQueryVariables
  >(CanUseDesignSystemManagerDocument, options)
}
export function useCanUseDesignSystemManagerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.CanUseDesignSystemManagerQuery,
    Types.CanUseDesignSystemManagerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.CanUseDesignSystemManagerQuery,
    Types.CanUseDesignSystemManagerQueryVariables
  >(CanUseDesignSystemManagerDocument, options)
}

export type CanUseDesignSystemManagerQueryHookResult = ReturnType<
  typeof useCanUseDesignSystemManagerQuery
>
export type CanUseDesignSystemManagerLazyQueryHookResult = ReturnType<
  typeof useCanUseDesignSystemManagerLazyQuery
>
export type CanUseDesignSystemManagerQueryResult =
  ApolloReactCommon.QueryResult<
    Types.CanUseDesignSystemManagerQuery,
    Types.CanUseDesignSystemManagerQueryVariables
  >
export const GetDesignSystemSectionsDocument = /*#__PURE__*/ gql`
  query getDesignSystemSections($identifier: UUID!) {
    designSystem(identifier: $identifier) {
      identifier
      sections {
        identifier
        name
        pages {
          identifier
          name
        }
      }
    }
  }
`

/**
 * __useGetDesignSystemSectionsQuery__
 *
 * To run a query within a React component, call `useGetDesignSystemSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignSystemSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignSystemSectionsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetDesignSystemSectionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetDesignSystemSectionsQuery,
    Types.GetDesignSystemSectionsQueryVariables
  > &
    (
      | {
          variables: Types.GetDesignSystemSectionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDesignSystemSectionsQuery,
    Types.GetDesignSystemSectionsQueryVariables
  >(GetDesignSystemSectionsDocument, options)
}
export function useGetDesignSystemSectionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDesignSystemSectionsQuery,
    Types.GetDesignSystemSectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDesignSystemSectionsQuery,
    Types.GetDesignSystemSectionsQueryVariables
  >(GetDesignSystemSectionsDocument, options)
}

export type GetDesignSystemSectionsQueryHookResult = ReturnType<
  typeof useGetDesignSystemSectionsQuery
>
export type GetDesignSystemSectionsLazyQueryHookResult = ReturnType<
  typeof useGetDesignSystemSectionsLazyQuery
>
export type GetDesignSystemSectionsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetDesignSystemSectionsQuery,
  Types.GetDesignSystemSectionsQueryVariables
>
export const GetDiscoverDocument = /*#__PURE__*/ gql`
  query getDiscover {
    discover @client {
      sections @client {
        ...DiscoverSection
      }
    }
  }
  ${DiscoverSectionFragmentDoc}
`

/**
 * __useGetDiscoverQuery__
 *
 * To run a query within a React component, call `useGetDiscoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoverQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDiscoverQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetDiscoverQuery,
    Types.GetDiscoverQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDiscoverQuery,
    Types.GetDiscoverQueryVariables
  >(GetDiscoverDocument, options)
}
export function useGetDiscoverLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDiscoverQuery,
    Types.GetDiscoverQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDiscoverQuery,
    Types.GetDiscoverQueryVariables
  >(GetDiscoverDocument, options)
}

export type GetDiscoverQueryHookResult = ReturnType<typeof useGetDiscoverQuery>
export type GetDiscoverLazyQueryHookResult = ReturnType<
  typeof useGetDiscoverLazyQuery
>
export type GetDiscoverQueryResult = ApolloReactCommon.QueryResult<
  Types.GetDiscoverQuery,
  Types.GetDiscoverQueryVariables
>
export const GetDiscoverResourcesDocument = /*#__PURE__*/ gql`
  query getDiscoverResources($type: DiscoveryResourceType!) {
    discoverResources(type: $type) @client {
      ...DiscoverSection
    }
  }
  ${DiscoverSectionFragmentDoc}
`

/**
 * __useGetDiscoverResourcesQuery__
 *
 * To run a query within a React component, call `useGetDiscoverResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoverResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoverResourcesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDiscoverResourcesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetDiscoverResourcesQuery,
    Types.GetDiscoverResourcesQueryVariables
  > &
    (
      | { variables: Types.GetDiscoverResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDiscoverResourcesQuery,
    Types.GetDiscoverResourcesQueryVariables
  >(GetDiscoverResourcesDocument, options)
}
export function useGetDiscoverResourcesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDiscoverResourcesQuery,
    Types.GetDiscoverResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDiscoverResourcesQuery,
    Types.GetDiscoverResourcesQueryVariables
  >(GetDiscoverResourcesDocument, options)
}

export type GetDiscoverResourcesQueryHookResult = ReturnType<
  typeof useGetDiscoverResourcesQuery
>
export type GetDiscoverResourcesLazyQueryHookResult = ReturnType<
  typeof useGetDiscoverResourcesLazyQuery
>
export type GetDiscoverResourcesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetDiscoverResourcesQuery,
  Types.GetDiscoverResourcesQueryVariables
>
export const RenameProjectDocument = /*#__PURE__*/ gql`
  mutation renameProject($projectId: ShortId!, $name: String!) {
    renameProject(name: $name, projectId: $projectId) {
      successful
      errors {
        ...UserError
      }
      project {
        ...Project
      }
    }
  }
  ${UserErrorFragmentDoc}
  ${ProjectFragmentDoc}
`
export type RenameProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.RenameProjectMutation,
  Types.RenameProjectMutationVariables
>

/**
 * __useRenameProjectMutation__
 *
 * To run a mutation, you first call `useRenameProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameProjectMutation, { data, loading, error }] = useRenameProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RenameProjectMutation,
    Types.RenameProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RenameProjectMutation,
    Types.RenameProjectMutationVariables
  >(RenameProjectDocument, options)
}
export type RenameProjectMutationHookResult = ReturnType<
  typeof useRenameProjectMutation
>
export type RenameProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.RenameProjectMutation>
export type RenameProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RenameProjectMutation,
    Types.RenameProjectMutationVariables
  >
export const UpdateProjectDocument = /*#__PURE__*/ gql`
  mutation updateProject(
    $identifier: UUID!
    $name: String
    $description: String
  ) {
    updateProject(
      identifier: $identifier
      name: $name
      description: $description
    ) {
      project {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type UpdateProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.UpdateProjectMutation,
  Types.UpdateProjectMutationVariables
>

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateProjectMutation,
    Types.UpdateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateProjectMutation,
    Types.UpdateProjectMutationVariables
  >(UpdateProjectDocument, options)
}
export type UpdateProjectMutationHookResult = ReturnType<
  typeof useUpdateProjectMutation
>
export type UpdateProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateProjectMutation>
export type UpdateProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateProjectMutation,
    Types.UpdateProjectMutationVariables
  >
export const DeleteProjectDocument = /*#__PURE__*/ gql`
  mutation deleteProject($projectId: ShortId!) {
    deleteProject(projectId: $projectId) {
      successful
      errors {
        ...UserError
      }
      project {
        identifier
        deletedAt
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type DeleteProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.DeleteProjectMutation,
  Types.DeleteProjectMutationVariables
>

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteProjectMutation,
    Types.DeleteProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteProjectMutation,
    Types.DeleteProjectMutationVariables
  >(DeleteProjectDocument, options)
}
export type DeleteProjectMutationHookResult = ReturnType<
  typeof useDeleteProjectMutation
>
export type DeleteProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.DeleteProjectMutation>
export type DeleteProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DeleteProjectMutation,
    Types.DeleteProjectMutationVariables
  >
export const RemoveShareFromProjectDocument = /*#__PURE__*/ gql`
  mutation removeShareFromProject($shareId: ShortId!, $projectId: ShortId!) {
    removeShareFromProject(shareId: $shareId, projectId: $projectId) {
      errors {
        ...UserError
      }
      project {
        ...ProjectPreview
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
  ${ProjectPreviewFragmentDoc}
`
export type RemoveShareFromProjectMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.RemoveShareFromProjectMutation,
    Types.RemoveShareFromProjectMutationVariables
  >

/**
 * __useRemoveShareFromProjectMutation__
 *
 * To run a mutation, you first call `useRemoveShareFromProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveShareFromProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeShareFromProjectMutation, { data, loading, error }] = useRemoveShareFromProjectMutation({
 *   variables: {
 *      shareId: // value for 'shareId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRemoveShareFromProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemoveShareFromProjectMutation,
    Types.RemoveShareFromProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemoveShareFromProjectMutation,
    Types.RemoveShareFromProjectMutationVariables
  >(RemoveShareFromProjectDocument, options)
}
export type RemoveShareFromProjectMutationHookResult = ReturnType<
  typeof useRemoveShareFromProjectMutation
>
export type RemoveShareFromProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.RemoveShareFromProjectMutation>
export type RemoveShareFromProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RemoveShareFromProjectMutation,
    Types.RemoveShareFromProjectMutationVariables
  >
export const MoveShareToProjectDocument = /*#__PURE__*/ gql`
  mutation moveShareToProject($projectId: UUID!, $shareId: UUID!) {
    moveShareToProject(
      projectIdentifier: $projectId
      shareIdentifier: $shareId
    ) {
      errors {
        ...UserError
      }
      successful
      project {
        ...Project
        ...ProjectPreview
      }
      share {
        ...ShareListItem
        isDraft
      }
    }
  }
  ${UserErrorFragmentDoc}
  ${ProjectFragmentDoc}
  ${ProjectPreviewFragmentDoc}
  ${ShareListItemFragmentDoc}
`
export type MoveShareToProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.MoveShareToProjectMutation,
  Types.MoveShareToProjectMutationVariables
>

/**
 * __useMoveShareToProjectMutation__
 *
 * To run a mutation, you first call `useMoveShareToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveShareToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveShareToProjectMutation, { data, loading, error }] = useMoveShareToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      shareId: // value for 'shareId'
 *   },
 * });
 */
export function useMoveShareToProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.MoveShareToProjectMutation,
    Types.MoveShareToProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.MoveShareToProjectMutation,
    Types.MoveShareToProjectMutationVariables
  >(MoveShareToProjectDocument, options)
}
export type MoveShareToProjectMutationHookResult = ReturnType<
  typeof useMoveShareToProjectMutation
>
export type MoveShareToProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.MoveShareToProjectMutation>
export type MoveShareToProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.MoveShareToProjectMutation,
    Types.MoveShareToProjectMutationVariables
  >
export const RestoreProjectDocument = /*#__PURE__*/ gql`
  mutation restoreProject($projectIdentifier: UUID!) {
    restoreProject(identifier: $projectIdentifier) {
      project {
        identifier
        deletedAt
        archivedAt
      }
    }
  }
`
export type RestoreProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.RestoreProjectMutation,
  Types.RestoreProjectMutationVariables
>

/**
 * __useRestoreProjectMutation__
 *
 * To run a mutation, you first call `useRestoreProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreProjectMutation, { data, loading, error }] = useRestoreProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useRestoreProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RestoreProjectMutation,
    Types.RestoreProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RestoreProjectMutation,
    Types.RestoreProjectMutationVariables
  >(RestoreProjectDocument, options)
}
export type RestoreProjectMutationHookResult = ReturnType<
  typeof useRestoreProjectMutation
>
export type RestoreProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.RestoreProjectMutation>
export type RestoreProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RestoreProjectMutation,
    Types.RestoreProjectMutationVariables
  >
export const DeleteProjectPermanentlyDocument = /*#__PURE__*/ gql`
  mutation deleteProjectPermanently($projectIdentifier: UUID!) {
    deleteProjectPermanently(identifier: $projectIdentifier) {
      projectIdentifier
    }
  }
`
export type DeleteProjectPermanentlyMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.DeleteProjectPermanentlyMutation,
    Types.DeleteProjectPermanentlyMutationVariables
  >

/**
 * __useDeleteProjectPermanentlyMutation__
 *
 * To run a mutation, you first call `useDeleteProjectPermanentlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectPermanentlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectPermanentlyMutation, { data, loading, error }] = useDeleteProjectPermanentlyMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useDeleteProjectPermanentlyMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteProjectPermanentlyMutation,
    Types.DeleteProjectPermanentlyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteProjectPermanentlyMutation,
    Types.DeleteProjectPermanentlyMutationVariables
  >(DeleteProjectPermanentlyDocument, options)
}
export type DeleteProjectPermanentlyMutationHookResult = ReturnType<
  typeof useDeleteProjectPermanentlyMutation
>
export type DeleteProjectPermanentlyMutationResult =
  ApolloReactCommon.MutationResult<Types.DeleteProjectPermanentlyMutation>
export type DeleteProjectPermanentlyMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DeleteProjectPermanentlyMutation,
    Types.DeleteProjectPermanentlyMutationVariables
  >
export const RequestAccessToProjectDocument = /*#__PURE__*/ gql`
  mutation requestAccessToProject(
    $projectShortId: ShortId
    $projectIdentifier: UUID
  ) {
    requestAccessToProject(
      projectShortId: $projectShortId
      projectIdentifier: $projectIdentifier
    ) {
      __typename
    }
  }
`
export type RequestAccessToProjectMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.RequestAccessToProjectMutation,
    Types.RequestAccessToProjectMutationVariables
  >

/**
 * __useRequestAccessToProjectMutation__
 *
 * To run a mutation, you first call `useRequestAccessToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccessToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccessToProjectMutation, { data, loading, error }] = useRequestAccessToProjectMutation({
 *   variables: {
 *      projectShortId: // value for 'projectShortId'
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useRequestAccessToProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RequestAccessToProjectMutation,
    Types.RequestAccessToProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RequestAccessToProjectMutation,
    Types.RequestAccessToProjectMutationVariables
  >(RequestAccessToProjectDocument, options)
}
export type RequestAccessToProjectMutationHookResult = ReturnType<
  typeof useRequestAccessToProjectMutation
>
export type RequestAccessToProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.RequestAccessToProjectMutation>
export type RequestAccessToProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RequestAccessToProjectMutation,
    Types.RequestAccessToProjectMutationVariables
  >
export const UpdateProjectPermissionDocument = /*#__PURE__*/ gql`
  mutation updateProjectPermission(
    $projectIdentifier: UUID!
    $workspaceAccessLevel: ProjectWorkspaceAccessLevel!
  ) {
    updateProjectPermission(
      projectIdentifier: $projectIdentifier
      workspaceAccessLevel: $workspaceAccessLevel
    ) {
      project {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type UpdateProjectPermissionMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateProjectPermissionMutation,
    Types.UpdateProjectPermissionMutationVariables
  >

/**
 * __useUpdateProjectPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateProjectPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectPermissionMutation, { data, loading, error }] = useUpdateProjectPermissionMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      workspaceAccessLevel: // value for 'workspaceAccessLevel'
 *   },
 * });
 */
export function useUpdateProjectPermissionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateProjectPermissionMutation,
    Types.UpdateProjectPermissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateProjectPermissionMutation,
    Types.UpdateProjectPermissionMutationVariables
  >(UpdateProjectPermissionDocument, options)
}
export type UpdateProjectPermissionMutationHookResult = ReturnType<
  typeof useUpdateProjectPermissionMutation
>
export type UpdateProjectPermissionMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateProjectPermissionMutation>
export type UpdateProjectPermissionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateProjectPermissionMutation,
    Types.UpdateProjectPermissionMutationVariables
  >
export const CreateProjectDocument = /*#__PURE__*/ gql`
  mutation createProject(
    $workspaceId: UUID!
    $name: String!
    $workspaceAccessLevel: ProjectWorkspaceAccessLevel
    $workspaceMembershipIdentifiers: [UUID!]
    $guestsToInvite: [CreateWorkspaceProjectGuestToInvite!]
    $permissionGroups: [PermissionGroupParam!]
    $description: String
    $parentProjectIdentifier: UUID
    $storageItems: [MinimalStorageItem!]
  ) {
    createWorkspaceProject(
      workspaceIdentifier: $workspaceId
      name: $name
      workspaceAccessLevel: $workspaceAccessLevel
      workspaceMembershipIdentifiers: $workspaceMembershipIdentifiers
      guestsToInvite: $guestsToInvite
      permissionGroups: $permissionGroups
      description: $description
      parentProjectIdentifier: $parentProjectIdentifier
      storageItems: $storageItems
    ) {
      project {
        ...Project
        parentProject {
          identifier
          name
          nestedProjectsCount
          sharesCount
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type CreateProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.CreateProjectMutation,
  Types.CreateProjectMutationVariables
>

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      workspaceAccessLevel: // value for 'workspaceAccessLevel'
 *      workspaceMembershipIdentifiers: // value for 'workspaceMembershipIdentifiers'
 *      guestsToInvite: // value for 'guestsToInvite'
 *      permissionGroups: // value for 'permissionGroups'
 *      description: // value for 'description'
 *      parentProjectIdentifier: // value for 'parentProjectIdentifier'
 *      storageItems: // value for 'storageItems'
 *   },
 * });
 */
export function useCreateProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateProjectMutation,
    Types.CreateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateProjectMutation,
    Types.CreateProjectMutationVariables
  >(CreateProjectDocument, options)
}
export type CreateProjectMutationHookResult = ReturnType<
  typeof useCreateProjectMutation
>
export type CreateProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.CreateProjectMutation>
export type CreateProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreateProjectMutation,
    Types.CreateProjectMutationVariables
  >
export const RemoveProjectMemberDocument = /*#__PURE__*/ gql`
  mutation removeProjectMember(
    $membershipIdentifier: UUID!
    $confirmed: Boolean! = false
    $removeShareMemberships: Boolean
  ) {
    removeProjectMember(
      membershipIdentifier: $membershipIdentifier
      confirmed: $confirmed
      removeShareMemberships: $removeShareMemberships
    ) {
      project {
        identifier
        projectPrivacyIcon
      }
    }
  }
`
export type RemoveProjectMemberMutationFn = ApolloReactCommon.MutationFunction<
  Types.RemoveProjectMemberMutation,
  Types.RemoveProjectMemberMutationVariables
>

/**
 * __useRemoveProjectMemberMutation__
 *
 * To run a mutation, you first call `useRemoveProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectMemberMutation, { data, loading, error }] = useRemoveProjectMemberMutation({
 *   variables: {
 *      membershipIdentifier: // value for 'membershipIdentifier'
 *      confirmed: // value for 'confirmed'
 *      removeShareMemberships: // value for 'removeShareMemberships'
 *   },
 * });
 */
export function useRemoveProjectMemberMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemoveProjectMemberMutation,
    Types.RemoveProjectMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemoveProjectMemberMutation,
    Types.RemoveProjectMemberMutationVariables
  >(RemoveProjectMemberDocument, options)
}
export type RemoveProjectMemberMutationHookResult = ReturnType<
  typeof useRemoveProjectMemberMutation
>
export type RemoveProjectMemberMutationResult =
  ApolloReactCommon.MutationResult<Types.RemoveProjectMemberMutation>
export type RemoveProjectMemberMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RemoveProjectMemberMutation,
    Types.RemoveProjectMemberMutationVariables
  >
export const LeaveProjectDocument = /*#__PURE__*/ gql`
  mutation leaveProject($projectIdentifier: UUID!) {
    leaveProject(projectIdentifier: $projectIdentifier) {
      project {
        identifier
      }
    }
  }
`
export type LeaveProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.LeaveProjectMutation,
  Types.LeaveProjectMutationVariables
>

/**
 * __useLeaveProjectMutation__
 *
 * To run a mutation, you first call `useLeaveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveProjectMutation, { data, loading, error }] = useLeaveProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useLeaveProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.LeaveProjectMutation,
    Types.LeaveProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.LeaveProjectMutation,
    Types.LeaveProjectMutationVariables
  >(LeaveProjectDocument, options)
}
export type LeaveProjectMutationHookResult = ReturnType<
  typeof useLeaveProjectMutation
>
export type LeaveProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.LeaveProjectMutation>
export type LeaveProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.LeaveProjectMutation,
  Types.LeaveProjectMutationVariables
>
export const PinProjectDocument = /*#__PURE__*/ gql`
  mutation pinProject($projectIdentifier: UUID!) {
    pinProject(input: { projectIdentifier: $projectIdentifier }) {
      project {
        identifier
      }
    }
  }
`
export type PinProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.PinProjectMutation,
  Types.PinProjectMutationVariables
>

/**
 * __usePinProjectMutation__
 *
 * To run a mutation, you first call `usePinProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinProjectMutation, { data, loading, error }] = usePinProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function usePinProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.PinProjectMutation,
    Types.PinProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.PinProjectMutation,
    Types.PinProjectMutationVariables
  >(PinProjectDocument, options)
}
export type PinProjectMutationHookResult = ReturnType<
  typeof usePinProjectMutation
>
export type PinProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.PinProjectMutation>
export type PinProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.PinProjectMutation,
  Types.PinProjectMutationVariables
>
export const UnpinProjectDocument = /*#__PURE__*/ gql`
  mutation unpinProject($projectIdentifier: UUID!) {
    unpinProject(input: { projectIdentifier: $projectIdentifier }) {
      project {
        identifier
      }
    }
  }
`
export type UnpinProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.UnpinProjectMutation,
  Types.UnpinProjectMutationVariables
>

/**
 * __useUnpinProjectMutation__
 *
 * To run a mutation, you first call `useUnpinProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinProjectMutation, { data, loading, error }] = useUnpinProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useUnpinProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnpinProjectMutation,
    Types.UnpinProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnpinProjectMutation,
    Types.UnpinProjectMutationVariables
  >(UnpinProjectDocument, options)
}
export type UnpinProjectMutationHookResult = ReturnType<
  typeof useUnpinProjectMutation
>
export type UnpinProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.UnpinProjectMutation>
export type UnpinProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.UnpinProjectMutation,
  Types.UnpinProjectMutationVariables
>
export const ArchiveProjectDocument = /*#__PURE__*/ gql`
  mutation archiveProject($projectIdentifier: UUID!) {
    archiveProject(identifier: $projectIdentifier) {
      project {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type ArchiveProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.ArchiveProjectMutation,
  Types.ArchiveProjectMutationVariables
>

/**
 * __useArchiveProjectMutation__
 *
 * To run a mutation, you first call `useArchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProjectMutation, { data, loading, error }] = useArchiveProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useArchiveProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ArchiveProjectMutation,
    Types.ArchiveProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ArchiveProjectMutation,
    Types.ArchiveProjectMutationVariables
  >(ArchiveProjectDocument, options)
}
export type ArchiveProjectMutationHookResult = ReturnType<
  typeof useArchiveProjectMutation
>
export type ArchiveProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.ArchiveProjectMutation>
export type ArchiveProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ArchiveProjectMutation,
    Types.ArchiveProjectMutationVariables
  >
export const UnarchiveProjectDocument = /*#__PURE__*/ gql`
  mutation unarchiveProject($projectIdentifier: UUID!) {
    unarchiveProject(identifier: $projectIdentifier) {
      project {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type UnarchiveProjectMutationFn = ApolloReactCommon.MutationFunction<
  Types.UnarchiveProjectMutation,
  Types.UnarchiveProjectMutationVariables
>

/**
 * __useUnarchiveProjectMutation__
 *
 * To run a mutation, you first call `useUnarchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveProjectMutation, { data, loading, error }] = useUnarchiveProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useUnarchiveProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnarchiveProjectMutation,
    Types.UnarchiveProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnarchiveProjectMutation,
    Types.UnarchiveProjectMutationVariables
  >(UnarchiveProjectDocument, options)
}
export type UnarchiveProjectMutationHookResult = ReturnType<
  typeof useUnarchiveProjectMutation
>
export type UnarchiveProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.UnarchiveProjectMutation>
export type UnarchiveProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UnarchiveProjectMutation,
    Types.UnarchiveProjectMutationVariables
  >
export const GetProjectsDocument = /*#__PURE__*/ gql`
  query getProjects($workspaceId: UUID!, $after: String) {
    workspace(identifier: $workspaceId) {
      identifier
      projects(after: $after, type: STANDARD) {
        entries {
          ...Project
        }
        meta {
          after
          limit
          totalCount
        }
      }
      draftsProject: projects(type: PERSONAL_DRAFTS) {
        entries {
          ...Project
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetProjectsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectsQuery,
    Types.GetProjectsQueryVariables
  > &
    (
      | { variables: Types.GetProjectsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectsQuery,
    Types.GetProjectsQueryVariables
  >(GetProjectsDocument, options)
}
export function useGetProjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectsQuery,
    Types.GetProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectsQuery,
    Types.GetProjectsQueryVariables
  >(GetProjectsDocument, options)
}

export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>
export type GetProjectsLazyQueryHookResult = ReturnType<
  typeof useGetProjectsLazyQuery
>
export type GetProjectsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetProjectsQuery,
  Types.GetProjectsQueryVariables
>
export const GetNestedProjectsDocument = /*#__PURE__*/ gql`
  query getNestedProjects($projectIdentifier: UUID!, $after: String) {
    project(identifier: $projectIdentifier) {
      identifier
      projects(after: $after, limit: 40) {
        entries {
          ...NestedProject
        }
        meta {
          after
          limit
          totalCount
        }
      }
    }
  }
  ${NestedProjectFragmentDoc}
`

/**
 * __useGetNestedProjectsQuery__
 *
 * To run a query within a React component, call `useGetNestedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNestedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNestedProjectsQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNestedProjectsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetNestedProjectsQuery,
    Types.GetNestedProjectsQueryVariables
  > &
    (
      | { variables: Types.GetNestedProjectsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNestedProjectsQuery,
    Types.GetNestedProjectsQueryVariables
  >(GetNestedProjectsDocument, options)
}
export function useGetNestedProjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNestedProjectsQuery,
    Types.GetNestedProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNestedProjectsQuery,
    Types.GetNestedProjectsQueryVariables
  >(GetNestedProjectsDocument, options)
}

export type GetNestedProjectsQueryHookResult = ReturnType<
  typeof useGetNestedProjectsQuery
>
export type GetNestedProjectsLazyQueryHookResult = ReturnType<
  typeof useGetNestedProjectsLazyQuery
>
export type GetNestedProjectsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetNestedProjectsQuery,
  Types.GetNestedProjectsQueryVariables
>
export const GetWorkspacesDraftsProjectsDocument = /*#__PURE__*/ gql`
  query getWorkspacesDraftsProjects {
    me {
      identifier
      workspaces {
        ...DraftsWorkspace
      }
    }
  }
  ${DraftsWorkspaceFragmentDoc}
`

/**
 * __useGetWorkspacesDraftsProjectsQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesDraftsProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesDraftsProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesDraftsProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspacesDraftsProjectsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacesDraftsProjectsQuery,
    Types.GetWorkspacesDraftsProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacesDraftsProjectsQuery,
    Types.GetWorkspacesDraftsProjectsQueryVariables
  >(GetWorkspacesDraftsProjectsDocument, options)
}
export function useGetWorkspacesDraftsProjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacesDraftsProjectsQuery,
    Types.GetWorkspacesDraftsProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacesDraftsProjectsQuery,
    Types.GetWorkspacesDraftsProjectsQueryVariables
  >(GetWorkspacesDraftsProjectsDocument, options)
}

export type GetWorkspacesDraftsProjectsQueryHookResult = ReturnType<
  typeof useGetWorkspacesDraftsProjectsQuery
>
export type GetWorkspacesDraftsProjectsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacesDraftsProjectsLazyQuery
>
export type GetWorkspacesDraftsProjectsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspacesDraftsProjectsQuery,
    Types.GetWorkspacesDraftsProjectsQueryVariables
  >
export const GetProjectDetailsDocument = /*#__PURE__*/ gql`
  query getProjectDetails($projectIdentifier: UUID!) {
    project(identifier: $projectIdentifier) {
      ...ProjectDetails
    }
  }
  ${ProjectDetailsFragmentDoc}
`

/**
 * __useGetProjectDetailsQuery__
 *
 * To run a query within a React component, call `useGetProjectDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDetailsQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useGetProjectDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectDetailsQuery,
    Types.GetProjectDetailsQueryVariables
  > &
    (
      | { variables: Types.GetProjectDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectDetailsQuery,
    Types.GetProjectDetailsQueryVariables
  >(GetProjectDetailsDocument, options)
}
export function useGetProjectDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectDetailsQuery,
    Types.GetProjectDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectDetailsQuery,
    Types.GetProjectDetailsQueryVariables
  >(GetProjectDetailsDocument, options)
}

export type GetProjectDetailsQueryHookResult = ReturnType<
  typeof useGetProjectDetailsQuery
>
export type GetProjectDetailsLazyQueryHookResult = ReturnType<
  typeof useGetProjectDetailsLazyQuery
>
export type GetProjectDetailsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetProjectDetailsQuery,
  Types.GetProjectDetailsQueryVariables
>
export const GetProjectsListDocument = /*#__PURE__*/ gql`
  query getProjectsList(
    $workspaceId: UUID!
    $after: String
    $archived: ProjectArchivedStatus = UNARCHIVED
    $searchTerm: String
  ) {
    workspace(identifier: $workspaceId) {
      identifier
      projects(
        after: $after
        limit: 20
        type: STANDARD
        archived: $archived
        search: { name: $searchTerm }
      ) {
        entries {
          ...ProjectListItem
        }
        meta {
          after
          limit
          totalCount
        }
      }
    }
  }
  ${ProjectListItemFragmentDoc}
`

/**
 * __useGetProjectsListQuery__
 *
 * To run a query within a React component, call `useGetProjectsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsListQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      after: // value for 'after'
 *      archived: // value for 'archived'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetProjectsListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectsListQuery,
    Types.GetProjectsListQueryVariables
  > &
    (
      | { variables: Types.GetProjectsListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectsListQuery,
    Types.GetProjectsListQueryVariables
  >(GetProjectsListDocument, options)
}
export function useGetProjectsListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectsListQuery,
    Types.GetProjectsListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectsListQuery,
    Types.GetProjectsListQueryVariables
  >(GetProjectsListDocument, options)
}

export type GetProjectsListQueryHookResult = ReturnType<
  typeof useGetProjectsListQuery
>
export type GetProjectsListLazyQueryHookResult = ReturnType<
  typeof useGetProjectsListLazyQuery
>
export type GetProjectsListQueryResult = ApolloReactCommon.QueryResult<
  Types.GetProjectsListQuery,
  Types.GetProjectsListQueryVariables
>
export const GetShowDocumentsInProjectsDocument = /*#__PURE__*/ gql`
  query getShowDocumentsInProjects {
    showDocumentsInProjects @client
  }
`

/**
 * __useGetShowDocumentsInProjectsQuery__
 *
 * To run a query within a React component, call `useGetShowDocumentsInProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShowDocumentsInProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShowDocumentsInProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShowDocumentsInProjectsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetShowDocumentsInProjectsQuery,
    Types.GetShowDocumentsInProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShowDocumentsInProjectsQuery,
    Types.GetShowDocumentsInProjectsQueryVariables
  >(GetShowDocumentsInProjectsDocument, options)
}
export function useGetShowDocumentsInProjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShowDocumentsInProjectsQuery,
    Types.GetShowDocumentsInProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShowDocumentsInProjectsQuery,
    Types.GetShowDocumentsInProjectsQueryVariables
  >(GetShowDocumentsInProjectsDocument, options)
}

export type GetShowDocumentsInProjectsQueryHookResult = ReturnType<
  typeof useGetShowDocumentsInProjectsQuery
>
export type GetShowDocumentsInProjectsLazyQueryHookResult = ReturnType<
  typeof useGetShowDocumentsInProjectsLazyQuery
>
export type GetShowDocumentsInProjectsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetShowDocumentsInProjectsQuery,
    Types.GetShowDocumentsInProjectsQueryVariables
  >
export const GetProjectSearchSettingsDocument = /*#__PURE__*/ gql`
  query getProjectSearchSettings {
    hideCollections @client
  }
`

/**
 * __useGetProjectSearchSettingsQuery__
 *
 * To run a query within a React component, call `useGetProjectSearchSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSearchSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSearchSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectSearchSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectSearchSettingsQuery,
    Types.GetProjectSearchSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectSearchSettingsQuery,
    Types.GetProjectSearchSettingsQueryVariables
  >(GetProjectSearchSettingsDocument, options)
}
export function useGetProjectSearchSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectSearchSettingsQuery,
    Types.GetProjectSearchSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectSearchSettingsQuery,
    Types.GetProjectSearchSettingsQueryVariables
  >(GetProjectSearchSettingsDocument, options)
}

export type GetProjectSearchSettingsQueryHookResult = ReturnType<
  typeof useGetProjectSearchSettingsQuery
>
export type GetProjectSearchSettingsLazyQueryHookResult = ReturnType<
  typeof useGetProjectSearchSettingsLazyQuery
>
export type GetProjectSearchSettingsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetProjectSearchSettingsQuery,
  Types.GetProjectSearchSettingsQueryVariables
>
export const GetProjectDocument = /*#__PURE__*/ gql`
  query getProject($shortId: ShortId!) {
    project(shortId: $shortId) {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      shortId: // value for 'shortId'
 *   },
 * });
 */
export function useGetProjectQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectQuery,
    Types.GetProjectQueryVariables
  > &
    (
      | { variables: Types.GetProjectQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectQuery,
    Types.GetProjectQueryVariables
  >(GetProjectDocument, options)
}
export function useGetProjectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectQuery,
    Types.GetProjectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectQuery,
    Types.GetProjectQueryVariables
  >(GetProjectDocument, options)
}

export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>
export type GetProjectLazyQueryHookResult = ReturnType<
  typeof useGetProjectLazyQuery
>
export type GetProjectQueryResult = ApolloReactCommon.QueryResult<
  Types.GetProjectQuery,
  Types.GetProjectQueryVariables
>
export const GetWorkspaceTransferDestinationsDocument = /*#__PURE__*/ gql`
  query getWorkspaceTransferDestinations(
    $workspaceIdentifier: UUID!
    $after: String
    $search: TransferDestinationSearchParams
  ) {
    workspaceTransferDestinations(
      workspaceIdentifier: $workspaceIdentifier
      after: $after
      search: $search
    ) {
      entries {
        ... on Project {
          ...ProjectSearchDestination
        }
        ... on Workspace {
          identifier
          name
        }
      }
      meta {
        after
        limit
        totalCount
      }
    }
  }
  ${ProjectSearchDestinationFragmentDoc}
`

/**
 * __useGetWorkspaceTransferDestinationsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceTransferDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceTransferDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceTransferDestinationsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkspaceTransferDestinationsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceTransferDestinationsQuery,
    Types.GetWorkspaceTransferDestinationsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceTransferDestinationsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceTransferDestinationsQuery,
    Types.GetWorkspaceTransferDestinationsQueryVariables
  >(GetWorkspaceTransferDestinationsDocument, options)
}
export function useGetWorkspaceTransferDestinationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceTransferDestinationsQuery,
    Types.GetWorkspaceTransferDestinationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceTransferDestinationsQuery,
    Types.GetWorkspaceTransferDestinationsQueryVariables
  >(GetWorkspaceTransferDestinationsDocument, options)
}

export type GetWorkspaceTransferDestinationsQueryHookResult = ReturnType<
  typeof useGetWorkspaceTransferDestinationsQuery
>
export type GetWorkspaceTransferDestinationsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceTransferDestinationsLazyQuery
>
export type GetWorkspaceTransferDestinationsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspaceTransferDestinationsQuery,
    Types.GetWorkspaceTransferDestinationsQueryVariables
  >
export const ProjectChangedDocument = /*#__PURE__*/ gql`
  subscription projectChanged {
    projectChanged {
      __typename
      workspaceIdentifier
      ... on ProjectCreatedEvent {
        project {
          ...Project
        }
      }
      ... on ProjectRestoredEvent {
        project {
          ...Project
        }
      }
      ... on ProjectChangedEvent {
        project {
          ...Project
        }
      }
      ... on ProjectDeletedEvent {
        project {
          ...Project
        }
      }
      ... on ProjectTransferredEvent {
        oldParentProjectIdentifier
        oldWorkspaceIdentifier
        workspaceIdentifier
        project {
          name
          identifier
        }
      }
      ... on ProjectPermanentlyDeletedEvent {
        projectIdentifier
      }
      ... on ProjectWorkspaceAccessLevelChangedEvent {
        workspaceIdentifier
        project {
          identifier
          workspaceAccessLevel
          userMembership {
            identifier
          }
          projectPrivacyIcon
        }
      }
      ... on ProjectArchivedEvent {
        project {
          ...Project
        }
      }
      ... on ProjectUnarchivedEvent {
        project {
          ...Project
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useProjectChangedSubscription__
 *
 * To run a query within a React component, call `useProjectChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectChangedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ProjectChangedSubscription,
    Types.ProjectChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ProjectChangedSubscription,
    Types.ProjectChangedSubscriptionVariables
  >(ProjectChangedDocument, options)
}
export type ProjectChangedSubscriptionHookResult = ReturnType<
  typeof useProjectChangedSubscription
>
export type ProjectChangedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.ProjectChangedSubscription>
export const AddProjectMemberDocument = /*#__PURE__*/ gql`
  mutation addProjectMember(
    $projectIdentifier: UUID!
    $workspaceMembershipIdentifier: UUID
    $email: String
    $guestCommentsEnabled: Boolean = true
    $guestInspectEnabled: Boolean = true
  ) {
    addProjectMember(
      projectIdentifier: $projectIdentifier
      workspaceMembershipIdentifier: $workspaceMembershipIdentifier
      email: $email
      guestCommentsEnabled: $guestCommentsEnabled
      guestInspectEnabled: $guestInspectEnabled
    ) {
      project {
        identifier
        projectPrivacyIcon
      }
      projectMembership {
        ...ProjectMembership
      }
    }
  }
  ${ProjectMembershipFragmentDoc}
`
export type AddProjectMemberMutationFn = ApolloReactCommon.MutationFunction<
  Types.AddProjectMemberMutation,
  Types.AddProjectMemberMutationVariables
>

/**
 * __useAddProjectMemberMutation__
 *
 * To run a mutation, you first call `useAddProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectMemberMutation, { data, loading, error }] = useAddProjectMemberMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      workspaceMembershipIdentifier: // value for 'workspaceMembershipIdentifier'
 *      email: // value for 'email'
 *      guestCommentsEnabled: // value for 'guestCommentsEnabled'
 *      guestInspectEnabled: // value for 'guestInspectEnabled'
 *   },
 * });
 */
export function useAddProjectMemberMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddProjectMemberMutation,
    Types.AddProjectMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddProjectMemberMutation,
    Types.AddProjectMemberMutationVariables
  >(AddProjectMemberDocument, options)
}
export type AddProjectMemberMutationHookResult = ReturnType<
  typeof useAddProjectMemberMutation
>
export type AddProjectMemberMutationResult =
  ApolloReactCommon.MutationResult<Types.AddProjectMemberMutation>
export type AddProjectMemberMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AddProjectMemberMutation,
    Types.AddProjectMemberMutationVariables
  >
export const AcceptProjectAccessRequestDocument = /*#__PURE__*/ gql`
  mutation acceptProjectAccessRequest($membershipIdentifier: UUID!) {
    acceptProjectAccessRequest(membershipIdentifier: $membershipIdentifier) {
      project {
        identifier
      }
      projectMembership {
        ...ProjectMembership
        workspaceMembership {
          identifier
          workspace {
            identifier
          }
        }
      }
    }
  }
  ${ProjectMembershipFragmentDoc}
`
export type AcceptProjectAccessRequestMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AcceptProjectAccessRequestMutation,
    Types.AcceptProjectAccessRequestMutationVariables
  >

/**
 * __useAcceptProjectAccessRequestMutation__
 *
 * To run a mutation, you first call `useAcceptProjectAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptProjectAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptProjectAccessRequestMutation, { data, loading, error }] = useAcceptProjectAccessRequestMutation({
 *   variables: {
 *      membershipIdentifier: // value for 'membershipIdentifier'
 *   },
 * });
 */
export function useAcceptProjectAccessRequestMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AcceptProjectAccessRequestMutation,
    Types.AcceptProjectAccessRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AcceptProjectAccessRequestMutation,
    Types.AcceptProjectAccessRequestMutationVariables
  >(AcceptProjectAccessRequestDocument, options)
}
export type AcceptProjectAccessRequestMutationHookResult = ReturnType<
  typeof useAcceptProjectAccessRequestMutation
>
export type AcceptProjectAccessRequestMutationResult =
  ApolloReactCommon.MutationResult<Types.AcceptProjectAccessRequestMutation>
export type AcceptProjectAccessRequestMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AcceptProjectAccessRequestMutation,
    Types.AcceptProjectAccessRequestMutationVariables
  >
export const UpdateProjectMembershipDocument = /*#__PURE__*/ gql`
  mutation updateProjectMembership(
    $membershipIdentifier: UUID!
    $guestCommentsEnabled: Boolean
    $guestInspectEnabled: Boolean
  ) {
    updateProjectMembership(
      identifier: $membershipIdentifier
      guestCommentsEnabled: $guestCommentsEnabled
      guestInspectEnabled: $guestInspectEnabled
    ) {
      projectMembership {
        ...ProjectMembership
      }
    }
  }
  ${ProjectMembershipFragmentDoc}
`
export type UpdateProjectMembershipMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateProjectMembershipMutation,
    Types.UpdateProjectMembershipMutationVariables
  >

/**
 * __useUpdateProjectMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMembershipMutation, { data, loading, error }] = useUpdateProjectMembershipMutation({
 *   variables: {
 *      membershipIdentifier: // value for 'membershipIdentifier'
 *      guestCommentsEnabled: // value for 'guestCommentsEnabled'
 *      guestInspectEnabled: // value for 'guestInspectEnabled'
 *   },
 * });
 */
export function useUpdateProjectMembershipMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateProjectMembershipMutation,
    Types.UpdateProjectMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateProjectMembershipMutation,
    Types.UpdateProjectMembershipMutationVariables
  >(UpdateProjectMembershipDocument, options)
}
export type UpdateProjectMembershipMutationHookResult = ReturnType<
  typeof useUpdateProjectMembershipMutation
>
export type UpdateProjectMembershipMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateProjectMembershipMutation>
export type UpdateProjectMembershipMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateProjectMembershipMutation,
    Types.UpdateProjectMembershipMutationVariables
  >
export const AcceptProjectMembershipInvitationDocument = /*#__PURE__*/ gql`
  mutation acceptProjectMembershipInvitation(
    $input: AcceptProjectMembershipInvitationParams!
  ) {
    acceptProjectMembershipInvitation(input: $input) {
      projectMembership {
        identifier
        inviteStatus
        project {
          identifier
        }
      }
    }
  }
`
export type AcceptProjectMembershipInvitationMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AcceptProjectMembershipInvitationMutation,
    Types.AcceptProjectMembershipInvitationMutationVariables
  >

/**
 * __useAcceptProjectMembershipInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptProjectMembershipInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptProjectMembershipInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptProjectMembershipInvitationMutation, { data, loading, error }] = useAcceptProjectMembershipInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptProjectMembershipInvitationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AcceptProjectMembershipInvitationMutation,
    Types.AcceptProjectMembershipInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AcceptProjectMembershipInvitationMutation,
    Types.AcceptProjectMembershipInvitationMutationVariables
  >(AcceptProjectMembershipInvitationDocument, options)
}
export type AcceptProjectMembershipInvitationMutationHookResult = ReturnType<
  typeof useAcceptProjectMembershipInvitationMutation
>
export type AcceptProjectMembershipInvitationMutationResult =
  ApolloReactCommon.MutationResult<Types.AcceptProjectMembershipInvitationMutation>
export type AcceptProjectMembershipInvitationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AcceptProjectMembershipInvitationMutation,
    Types.AcceptProjectMembershipInvitationMutationVariables
  >
export const GetProjectMembershipsDocument = /*#__PURE__*/ gql`
  query getProjectMemberships($projectIdentifier: UUID!, $after: String) {
    project(identifier: $projectIdentifier) {
      identifier
      members(after: $after) {
        entries {
          ... on ProjectMembership {
            ...ProjectMembership
          }
          ... on PermissionGroupRelationProject {
            ...ProjectGroupMembership
          }
        }
        meta {
          after
          limit
          totalCount
        }
      }
    }
  }
  ${ProjectMembershipFragmentDoc}
  ${ProjectGroupMembershipFragmentDoc}
`

/**
 * __useGetProjectMembershipsQuery__
 *
 * To run a query within a React component, call `useGetProjectMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMembershipsQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetProjectMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectMembershipsQuery,
    Types.GetProjectMembershipsQueryVariables
  > &
    (
      | { variables: Types.GetProjectMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectMembershipsQuery,
    Types.GetProjectMembershipsQueryVariables
  >(GetProjectMembershipsDocument, options)
}
export function useGetProjectMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectMembershipsQuery,
    Types.GetProjectMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectMembershipsQuery,
    Types.GetProjectMembershipsQueryVariables
  >(GetProjectMembershipsDocument, options)
}

export type GetProjectMembershipsQueryHookResult = ReturnType<
  typeof useGetProjectMembershipsQuery
>
export type GetProjectMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetProjectMembershipsLazyQuery
>
export type GetProjectMembershipsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetProjectMembershipsQuery,
  Types.GetProjectMembershipsQueryVariables
>
export const GetProjectMembershipsCountDocument = /*#__PURE__*/ gql`
  query getProjectMembershipsCount($projectIdentifier: UUID!) {
    project(identifier: $projectIdentifier) {
      identifier
      membershipCount {
        admin
        member
        guest
        group
      }
    }
  }
`

/**
 * __useGetProjectMembershipsCountQuery__
 *
 * To run a query within a React component, call `useGetProjectMembershipsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMembershipsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMembershipsCountQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useGetProjectMembershipsCountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectMembershipsCountQuery,
    Types.GetProjectMembershipsCountQueryVariables
  > &
    (
      | {
          variables: Types.GetProjectMembershipsCountQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectMembershipsCountQuery,
    Types.GetProjectMembershipsCountQueryVariables
  >(GetProjectMembershipsCountDocument, options)
}
export function useGetProjectMembershipsCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectMembershipsCountQuery,
    Types.GetProjectMembershipsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectMembershipsCountQuery,
    Types.GetProjectMembershipsCountQueryVariables
  >(GetProjectMembershipsCountDocument, options)
}

export type GetProjectMembershipsCountQueryHookResult = ReturnType<
  typeof useGetProjectMembershipsCountQuery
>
export type GetProjectMembershipsCountLazyQueryHookResult = ReturnType<
  typeof useGetProjectMembershipsCountLazyQuery
>
export type GetProjectMembershipsCountQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetProjectMembershipsCountQuery,
    Types.GetProjectMembershipsCountQueryVariables
  >
export const GetProjectMembershipByTokenDocument = /*#__PURE__*/ gql`
  query getProjectMembershipByToken($token: String!) {
    projectMembership(token: $token) {
      identifier
      email
      inviteStatus
      project {
        identifier
        name
        workspace {
          identifier
        }
      }
      inviter {
        name
        avatar {
          large
        }
      }
    }
  }
`

/**
 * __useGetProjectMembershipByTokenQuery__
 *
 * To run a query within a React component, call `useGetProjectMembershipByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMembershipByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMembershipByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetProjectMembershipByTokenQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectMembershipByTokenQuery,
    Types.GetProjectMembershipByTokenQueryVariables
  > &
    (
      | {
          variables: Types.GetProjectMembershipByTokenQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectMembershipByTokenQuery,
    Types.GetProjectMembershipByTokenQueryVariables
  >(GetProjectMembershipByTokenDocument, options)
}
export function useGetProjectMembershipByTokenLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectMembershipByTokenQuery,
    Types.GetProjectMembershipByTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectMembershipByTokenQuery,
    Types.GetProjectMembershipByTokenQueryVariables
  >(GetProjectMembershipByTokenDocument, options)
}

export type GetProjectMembershipByTokenQueryHookResult = ReturnType<
  typeof useGetProjectMembershipByTokenQuery
>
export type GetProjectMembershipByTokenLazyQueryHookResult = ReturnType<
  typeof useGetProjectMembershipByTokenLazyQuery
>
export type GetProjectMembershipByTokenQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetProjectMembershipByTokenQuery,
    Types.GetProjectMembershipByTokenQueryVariables
  >
export const ProjectAccessChangedDocument = /*#__PURE__*/ gql`
  subscription projectAccessChanged {
    projectAccessChanged {
      workspaceIdentifier
      ... on ProjectAccessRevokedEvent {
        project {
          __typename
          identifier
          name
        }
      }
    }
  }
`

/**
 * __useProjectAccessChangedSubscription__
 *
 * To run a query within a React component, call `useProjectAccessChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectAccessChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAccessChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectAccessChangedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ProjectAccessChangedSubscription,
    Types.ProjectAccessChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ProjectAccessChangedSubscription,
    Types.ProjectAccessChangedSubscriptionVariables
  >(ProjectAccessChangedDocument, options)
}
export type ProjectAccessChangedSubscriptionHookResult = ReturnType<
  typeof useProjectAccessChangedSubscription
>
export type ProjectAccessChangedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.ProjectAccessChangedSubscription>
export const ProjectMembershipChangedDocument = /*#__PURE__*/ gql`
  subscription projectMembershipChanged {
    projectChanged {
      __typename
      workspaceIdentifier
      ... on ProjectMemberAddedEvent {
        membership {
          ...ProjectMembership
        }
        project {
          identifier
          projectPrivacyIcon
        }
      }
      ... on ProjectMemberChangedEvent {
        membership {
          ...ProjectMembership
        }
        project {
          identifier
        }
      }
      ... on ProjectMemberRemovedEvent {
        membershipIdentifier
        project {
          identifier
          projectPrivacyIcon
        }
      }
    }
  }
  ${ProjectMembershipFragmentDoc}
`

/**
 * __useProjectMembershipChangedSubscription__
 *
 * To run a query within a React component, call `useProjectMembershipChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectMembershipChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMembershipChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectMembershipChangedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ProjectMembershipChangedSubscription,
    Types.ProjectMembershipChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ProjectMembershipChangedSubscription,
    Types.ProjectMembershipChangedSubscriptionVariables
  >(ProjectMembershipChangedDocument, options)
}
export type ProjectMembershipChangedSubscriptionHookResult = ReturnType<
  typeof useProjectMembershipChangedSubscription
>
export type ProjectMembershipChangedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.ProjectMembershipChangedSubscription>
export const AddReactionToPublicationDocument = /*#__PURE__*/ gql`
  mutation addReactionToPublication(
    $publicationIdentifier: UUID!
    $reaction: PublicationReactionType!
  ) {
    addReactionToPublication(
      publicationIdentifier: $publicationIdentifier
      reaction: $reaction
    ) {
      publication {
        ...PublicationReactions
      }
    }
  }
  ${PublicationReactionsFragmentDoc}
`
export type AddReactionToPublicationMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AddReactionToPublicationMutation,
    Types.AddReactionToPublicationMutationVariables
  >

/**
 * __useAddReactionToPublicationMutation__
 *
 * To run a mutation, you first call `useAddReactionToPublicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionToPublicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionToPublicationMutation, { data, loading, error }] = useAddReactionToPublicationMutation({
 *   variables: {
 *      publicationIdentifier: // value for 'publicationIdentifier'
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useAddReactionToPublicationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddReactionToPublicationMutation,
    Types.AddReactionToPublicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddReactionToPublicationMutation,
    Types.AddReactionToPublicationMutationVariables
  >(AddReactionToPublicationDocument, options)
}
export type AddReactionToPublicationMutationHookResult = ReturnType<
  typeof useAddReactionToPublicationMutation
>
export type AddReactionToPublicationMutationResult =
  ApolloReactCommon.MutationResult<Types.AddReactionToPublicationMutation>
export type AddReactionToPublicationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AddReactionToPublicationMutation,
    Types.AddReactionToPublicationMutationVariables
  >
export const GetPublicationDocument = /*#__PURE__*/ gql`
  query getPublication($identifier: UUID!) {
    publication(identifier: $identifier) {
      ...Publication
    }
  }
  ${PublicationFragmentDoc}
`

/**
 * __useGetPublicationQuery__
 *
 * To run a query within a React component, call `useGetPublicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicationQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetPublicationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicationQuery,
    Types.GetPublicationQueryVariables
  > &
    (
      | { variables: Types.GetPublicationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicationQuery,
    Types.GetPublicationQueryVariables
  >(GetPublicationDocument, options)
}
export function useGetPublicationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicationQuery,
    Types.GetPublicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicationQuery,
    Types.GetPublicationQueryVariables
  >(GetPublicationDocument, options)
}

export type GetPublicationQueryHookResult = ReturnType<
  typeof useGetPublicationQuery
>
export type GetPublicationLazyQueryHookResult = ReturnType<
  typeof useGetPublicationLazyQuery
>
export type GetPublicationQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPublicationQuery,
  Types.GetPublicationQueryVariables
>
export const GetSharePagesDocument = /*#__PURE__*/ gql`
  query getSharePages($identifier: UUID!, $after: String, $limit: Int) {
    share(id: $identifier) {
      identifier
      version(preferredState: PROCESSED_AND_PUBLISHED) {
        identifier
        shortId
        document {
          identifier
          pages(after: $after, limit: $limit) {
            entries {
              ...PublicationPage
            }
            meta {
              after
              totalCount
            }
          }
        }
      }
    }
  }
  ${PublicationPageFragmentDoc}
`

/**
 * __useGetSharePagesQuery__
 *
 * To run a query within a React component, call `useGetSharePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharePagesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSharePagesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharePagesQuery,
    Types.GetSharePagesQueryVariables
  > &
    (
      | { variables: Types.GetSharePagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharePagesQuery,
    Types.GetSharePagesQueryVariables
  >(GetSharePagesDocument, options)
}
export function useGetSharePagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharePagesQuery,
    Types.GetSharePagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharePagesQuery,
    Types.GetSharePagesQueryVariables
  >(GetSharePagesDocument, options)
}

export type GetSharePagesQueryHookResult = ReturnType<
  typeof useGetSharePagesQuery
>
export type GetSharePagesLazyQueryHookResult = ReturnType<
  typeof useGetSharePagesLazyQuery
>
export type GetSharePagesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetSharePagesQuery,
  Types.GetSharePagesQueryVariables
>
export const GetPublicationsDocument = /*#__PURE__*/ gql`
  query getPublications(
    $after: String
    $exclude: [UUID!]
    $include: [UUID!]
    $limit: Int
    $sort: PublicationSortOrder
    $search: PublicationsSearchParams
  ) {
    publications(
      after: $after
      limit: $limit
      sortOrder: $sort
      include: $include
      exclude: $exclude
      search: $search
    ) {
      entries {
        ...PublicationItem
      }
      meta {
        after
        totalCount
      }
    }
  }
  ${PublicationItemFragmentDoc}
`

/**
 * __useGetPublicationsQuery__
 *
 * To run a query within a React component, call `useGetPublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      exclude: // value for 'exclude'
 *      include: // value for 'include'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPublicationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicationsQuery,
    Types.GetPublicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicationsQuery,
    Types.GetPublicationsQueryVariables
  >(GetPublicationsDocument, options)
}
export function useGetPublicationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicationsQuery,
    Types.GetPublicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicationsQuery,
    Types.GetPublicationsQueryVariables
  >(GetPublicationsDocument, options)
}

export type GetPublicationsQueryHookResult = ReturnType<
  typeof useGetPublicationsQuery
>
export type GetPublicationsLazyQueryHookResult = ReturnType<
  typeof useGetPublicationsLazyQuery
>
export type GetPublicationsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPublicationsQuery,
  Types.GetPublicationsQueryVariables
>
export const PublicationReactionsUpdatedDocument = /*#__PURE__*/ gql`
  subscription publicationReactionsUpdated($publicationIdentifier: UUID!) {
    publicationReactionsUpdated(publicationIdentifier: $publicationIdentifier) {
      publication {
        ...PublicationReactions
      }
    }
  }
  ${PublicationReactionsFragmentDoc}
`

/**
 * __usePublicationReactionsUpdatedSubscription__
 *
 * To run a query within a React component, call `usePublicationReactionsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePublicationReactionsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicationReactionsUpdatedSubscription({
 *   variables: {
 *      publicationIdentifier: // value for 'publicationIdentifier'
 *   },
 * });
 */
export function usePublicationReactionsUpdatedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.PublicationReactionsUpdatedSubscription,
    Types.PublicationReactionsUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types.PublicationReactionsUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.PublicationReactionsUpdatedSubscription,
    Types.PublicationReactionsUpdatedSubscriptionVariables
  >(PublicationReactionsUpdatedDocument, options)
}
export type PublicationReactionsUpdatedSubscriptionHookResult = ReturnType<
  typeof usePublicationReactionsUpdatedSubscription
>
export type PublicationReactionsUpdatedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.PublicationReactionsUpdatedSubscription>
export const GetPublicationListingDocument = /*#__PURE__*/ gql`
  query getPublicationListing($identifier: String!) {
    publicationListing(identifier: $identifier) @client {
      ...PublicationListing
    }
  }
  ${PublicationListingFragmentDoc}
`

/**
 * __useGetPublicationListingQuery__
 *
 * To run a query within a React component, call `useGetPublicationListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicationListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicationListingQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetPublicationListingQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicationListingQuery,
    Types.GetPublicationListingQueryVariables
  > &
    (
      | { variables: Types.GetPublicationListingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicationListingQuery,
    Types.GetPublicationListingQueryVariables
  >(GetPublicationListingDocument, options)
}
export function useGetPublicationListingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicationListingQuery,
    Types.GetPublicationListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicationListingQuery,
    Types.GetPublicationListingQueryVariables
  >(GetPublicationListingDocument, options)
}

export type GetPublicationListingQueryHookResult = ReturnType<
  typeof useGetPublicationListingQuery
>
export type GetPublicationListingLazyQueryHookResult = ReturnType<
  typeof useGetPublicationListingLazyQuery
>
export type GetPublicationListingQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPublicationListingQuery,
  Types.GetPublicationListingQueryVariables
>
export const GetDetailViewArtboardDocument = /*#__PURE__*/ gql`
  query getDetailViewArtboard(
    $permanentArtboardShortId: ShortId!
    $documentVersionShortId: ShortId
    $shareIdentifier: UUID!
  ) {
    artboard(
      permanentArtboardShortId: $permanentArtboardShortId
      documentVersionShortId: $documentVersionShortId
      shareIdentifier: $shareIdentifier
    ) {
      ...ArtboardCacheInfo
    }
  }
  ${ArtboardCacheInfoFragmentDoc}
`

/**
 * __useGetDetailViewArtboardQuery__
 *
 * To run a query within a React component, call `useGetDetailViewArtboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailViewArtboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailViewArtboardQuery({
 *   variables: {
 *      permanentArtboardShortId: // value for 'permanentArtboardShortId'
 *      documentVersionShortId: // value for 'documentVersionShortId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetDetailViewArtboardQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetDetailViewArtboardQuery,
    Types.GetDetailViewArtboardQueryVariables
  > &
    (
      | { variables: Types.GetDetailViewArtboardQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDetailViewArtboardQuery,
    Types.GetDetailViewArtboardQueryVariables
  >(GetDetailViewArtboardDocument, options)
}
export function useGetDetailViewArtboardLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDetailViewArtboardQuery,
    Types.GetDetailViewArtboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDetailViewArtboardQuery,
    Types.GetDetailViewArtboardQueryVariables
  >(GetDetailViewArtboardDocument, options)
}

export type GetDetailViewArtboardQueryHookResult = ReturnType<
  typeof useGetDetailViewArtboardQuery
>
export type GetDetailViewArtboardLazyQueryHookResult = ReturnType<
  typeof useGetDetailViewArtboardLazyQuery
>
export type GetDetailViewArtboardQueryResult = ApolloReactCommon.QueryResult<
  Types.GetDetailViewArtboardQuery,
  Types.GetDetailViewArtboardQueryVariables
>
export const GetArtboardInDocumentWithUuidDocument = /*#__PURE__*/ gql`
  query getArtboardInDocumentWithUuid(
    $documentId: String!
    $artboardUuid: String!
  ) {
    artboardInDocumentWithUuid(documentId: $documentId, uuid: $artboardUuid) {
      permanentArtboardShortId
    }
  }
`

/**
 * __useGetArtboardInDocumentWithUuidQuery__
 *
 * To run a query within a React component, call `useGetArtboardInDocumentWithUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtboardInDocumentWithUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtboardInDocumentWithUuidQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      artboardUuid: // value for 'artboardUuid'
 *   },
 * });
 */
export function useGetArtboardInDocumentWithUuidQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetArtboardInDocumentWithUuidQuery,
    Types.GetArtboardInDocumentWithUuidQueryVariables
  > &
    (
      | {
          variables: Types.GetArtboardInDocumentWithUuidQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetArtboardInDocumentWithUuidQuery,
    Types.GetArtboardInDocumentWithUuidQueryVariables
  >(GetArtboardInDocumentWithUuidDocument, options)
}
export function useGetArtboardInDocumentWithUuidLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetArtboardInDocumentWithUuidQuery,
    Types.GetArtboardInDocumentWithUuidQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetArtboardInDocumentWithUuidQuery,
    Types.GetArtboardInDocumentWithUuidQueryVariables
  >(GetArtboardInDocumentWithUuidDocument, options)
}

export type GetArtboardInDocumentWithUuidQueryHookResult = ReturnType<
  typeof useGetArtboardInDocumentWithUuidQuery
>
export type GetArtboardInDocumentWithUuidLazyQueryHookResult = ReturnType<
  typeof useGetArtboardInDocumentWithUuidLazyQuery
>
export type GetArtboardInDocumentWithUuidQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetArtboardInDocumentWithUuidQuery,
    Types.GetArtboardInDocumentWithUuidQueryVariables
  >
export const GetArtboardByPermanentArtboardShortIdDocument = /*#__PURE__*/ gql`
  query getArtboardByPermanentArtboardShortId(
    $permanentArtboardShortId: ShortId!
    $shareIdentifier: UUID!
    $documentVersionShortId: ShortId
  ) {
    artboard(
      permanentArtboardShortId: $permanentArtboardShortId
      shareIdentifier: $shareIdentifier
      documentVersionShortId: $documentVersionShortId
    ) {
      uuid
      isFlowHome
    }
  }
`

/**
 * __useGetArtboardByPermanentArtboardShortIdQuery__
 *
 * To run a query within a React component, call `useGetArtboardByPermanentArtboardShortIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtboardByPermanentArtboardShortIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtboardByPermanentArtboardShortIdQuery({
 *   variables: {
 *      permanentArtboardShortId: // value for 'permanentArtboardShortId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      documentVersionShortId: // value for 'documentVersionShortId'
 *   },
 * });
 */
export function useGetArtboardByPermanentArtboardShortIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetArtboardByPermanentArtboardShortIdQuery,
    Types.GetArtboardByPermanentArtboardShortIdQueryVariables
  > &
    (
      | {
          variables: Types.GetArtboardByPermanentArtboardShortIdQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetArtboardByPermanentArtboardShortIdQuery,
    Types.GetArtboardByPermanentArtboardShortIdQueryVariables
  >(GetArtboardByPermanentArtboardShortIdDocument, options)
}
export function useGetArtboardByPermanentArtboardShortIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetArtboardByPermanentArtboardShortIdQuery,
    Types.GetArtboardByPermanentArtboardShortIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetArtboardByPermanentArtboardShortIdQuery,
    Types.GetArtboardByPermanentArtboardShortIdQueryVariables
  >(GetArtboardByPermanentArtboardShortIdDocument, options)
}

export type GetArtboardByPermanentArtboardShortIdQueryHookResult = ReturnType<
  typeof useGetArtboardByPermanentArtboardShortIdQuery
>
export type GetArtboardByPermanentArtboardShortIdLazyQueryHookResult =
  ReturnType<typeof useGetArtboardByPermanentArtboardShortIdLazyQuery>
export type GetArtboardByPermanentArtboardShortIdQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetArtboardByPermanentArtboardShortIdQuery,
    Types.GetArtboardByPermanentArtboardShortIdQueryVariables
  >
export const GetComponentsDocument = /*#__PURE__*/ gql`
  query getComponents(
    $shareIdentifier: ShortId
    $versionShortId: ShortId
    $after: String = null
    $type: ComponentFilterType = SYMBOL
    $search: String = null
    $path: String = null
    $limit: Int = 40
  ) {
    share(shortId: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        shortId
        hasComponentManifest
        document {
          identifier
          documentVersion
          coeditCompatibilityVersion
          canEditDescriptions
          components(
            type: $type
            after: $after
            search: $search
            path: $path
            limit: $limit
          ) {
            entries {
              ...ComponentInfo
            }
            meta {
              after
              limit
              totalCount
            }
          }
        }
      }
      latestVersionOfAnyState: version {
        identifier
        document {
          identifier
          renderStatus
        }
      }
    }
  }
  ${ComponentInfoFragmentDoc}
`

/**
 * __useGetComponentsQuery__
 *
 * To run a query within a React component, call `useGetComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *      after: // value for 'after'
 *      type: // value for 'type'
 *      search: // value for 'search'
 *      path: // value for 'path'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetComponentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetComponentsQuery,
    Types.GetComponentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetComponentsQuery,
    Types.GetComponentsQueryVariables
  >(GetComponentsDocument, options)
}
export function useGetComponentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetComponentsQuery,
    Types.GetComponentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetComponentsQuery,
    Types.GetComponentsQueryVariables
  >(GetComponentsDocument, options)
}

export type GetComponentsQueryHookResult = ReturnType<
  typeof useGetComponentsQuery
>
export type GetComponentsLazyQueryHookResult = ReturnType<
  typeof useGetComponentsLazyQuery
>
export type GetComponentsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetComponentsQuery,
  Types.GetComponentsQueryVariables
>
export const GetComponentsCountDocument = /*#__PURE__*/ gql`
  query getComponentsCount(
    $shareIdentifier: ShortId
    $versionShortId: ShortId
  ) {
    share(shortId: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        shortId
        hasComponentManifest
        document {
          identifier
          componentCount {
            layerStyle
            textStyle
            colorVar
            symbol
          }
        }
      }
    }
  }
`

/**
 * __useGetComponentsCountQuery__
 *
 * To run a query within a React component, call `useGetComponentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentsCountQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetComponentsCountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetComponentsCountQuery,
    Types.GetComponentsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetComponentsCountQuery,
    Types.GetComponentsCountQueryVariables
  >(GetComponentsCountDocument, options)
}
export function useGetComponentsCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetComponentsCountQuery,
    Types.GetComponentsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetComponentsCountQuery,
    Types.GetComponentsCountQueryVariables
  >(GetComponentsCountDocument, options)
}

export type GetComponentsCountQueryHookResult = ReturnType<
  typeof useGetComponentsCountQuery
>
export type GetComponentsCountLazyQueryHookResult = ReturnType<
  typeof useGetComponentsCountLazyQuery
>
export type GetComponentsCountQueryResult = ApolloReactCommon.QueryResult<
  Types.GetComponentsCountQuery,
  Types.GetComponentsCountQueryVariables
>
export const GetComponentGroupsDocument = /*#__PURE__*/ gql`
  query getComponentGroups(
    $uuid: UUID!
    $type: ComponentFilterType!
    $versionShortId: ShortId
  ) {
    share(id: $uuid) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        document {
          identifier
          componentGroups(type: $type) {
            data
          }
        }
      }
    }
  }
`

/**
 * __useGetComponentGroupsQuery__
 *
 * To run a query within a React component, call `useGetComponentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentGroupsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      type: // value for 'type'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetComponentGroupsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetComponentGroupsQuery,
    Types.GetComponentGroupsQueryVariables
  > &
    (
      | { variables: Types.GetComponentGroupsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetComponentGroupsQuery,
    Types.GetComponentGroupsQueryVariables
  >(GetComponentGroupsDocument, options)
}
export function useGetComponentGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetComponentGroupsQuery,
    Types.GetComponentGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetComponentGroupsQuery,
    Types.GetComponentGroupsQueryVariables
  >(GetComponentGroupsDocument, options)
}

export type GetComponentGroupsQueryHookResult = ReturnType<
  typeof useGetComponentGroupsQuery
>
export type GetComponentGroupsLazyQueryHookResult = ReturnType<
  typeof useGetComponentGroupsLazyQuery
>
export type GetComponentGroupsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetComponentGroupsQuery,
  Types.GetComponentGroupsQueryVariables
>
export const GetComponentWithUuidDocument = /*#__PURE__*/ gql`
  query getComponentWithUuid($documentId: UUID!, $uuid: String!) {
    componentInDocumentWithUuid(documentId: $documentId, uuid: $uuid) {
      ...ComponentInfo
    }
  }
  ${ComponentInfoFragmentDoc}
`

/**
 * __useGetComponentWithUuidQuery__
 *
 * To run a query within a React component, call `useGetComponentWithUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentWithUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentWithUuidQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetComponentWithUuidQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetComponentWithUuidQuery,
    Types.GetComponentWithUuidQueryVariables
  > &
    (
      | { variables: Types.GetComponentWithUuidQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetComponentWithUuidQuery,
    Types.GetComponentWithUuidQueryVariables
  >(GetComponentWithUuidDocument, options)
}
export function useGetComponentWithUuidLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetComponentWithUuidQuery,
    Types.GetComponentWithUuidQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetComponentWithUuidQuery,
    Types.GetComponentWithUuidQueryVariables
  >(GetComponentWithUuidDocument, options)
}

export type GetComponentWithUuidQueryHookResult = ReturnType<
  typeof useGetComponentWithUuidQuery
>
export type GetComponentWithUuidLazyQueryHookResult = ReturnType<
  typeof useGetComponentWithUuidLazyQuery
>
export type GetComponentWithUuidQueryResult = ApolloReactCommon.QueryResult<
  Types.GetComponentWithUuidQuery,
  Types.GetComponentWithUuidQueryVariables
>
export const GetComponentsStateDocument = /*#__PURE__*/ gql`
  query getComponentsState(
    $shareIdentifier: ShortId
    $versionShortId: ShortId
  ) {
    share(shortId: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        document {
          identifier
          componentCount {
            layerStyle
            textStyle
            colorVar
            symbol
          }
          components {
            status
          }
        }
      }
    }
  }
`

/**
 * __useGetComponentsStateQuery__
 *
 * To run a query within a React component, call `useGetComponentsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentsStateQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetComponentsStateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetComponentsStateQuery,
    Types.GetComponentsStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetComponentsStateQuery,
    Types.GetComponentsStateQueryVariables
  >(GetComponentsStateDocument, options)
}
export function useGetComponentsStateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetComponentsStateQuery,
    Types.GetComponentsStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetComponentsStateQuery,
    Types.GetComponentsStateQueryVariables
  >(GetComponentsStateDocument, options)
}

export type GetComponentsStateQueryHookResult = ReturnType<
  typeof useGetComponentsStateQuery
>
export type GetComponentsStateLazyQueryHookResult = ReturnType<
  typeof useGetComponentsStateLazyQuery
>
export type GetComponentsStateQueryResult = ApolloReactCommon.QueryResult<
  Types.GetComponentsStateQuery,
  Types.GetComponentsStateQueryVariables
>
export const EditDescriptionsDocument = /*#__PURE__*/ gql`
  mutation editDescriptions(
    $baseVersionIdentifier: UUID4!
    $compatibilityVersion: Int!
    $documentVersion: Int!
    $edits: [ComponentDescriptionEditInput!]!
    $shareIdentifier: UUID4!
  ) @capacitorapi {
    editComponents(
      baseVersionIdentifier: $baseVersionIdentifier
      compatibilityVersion: $compatibilityVersion
      documentVersion: $documentVersion
      edits: $edits
      shareIdentifier: $shareIdentifier
    ) {
      status
    }
  }
`
export type EditDescriptionsMutationFn = ApolloReactCommon.MutationFunction<
  Types.EditDescriptionsMutation,
  Types.EditDescriptionsMutationVariables
>

/**
 * __useEditDescriptionsMutation__
 *
 * To run a mutation, you first call `useEditDescriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDescriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDescriptionsMutation, { data, loading, error }] = useEditDescriptionsMutation({
 *   variables: {
 *      baseVersionIdentifier: // value for 'baseVersionIdentifier'
 *      compatibilityVersion: // value for 'compatibilityVersion'
 *      documentVersion: // value for 'documentVersion'
 *      edits: // value for 'edits'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useEditDescriptionsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EditDescriptionsMutation,
    Types.EditDescriptionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EditDescriptionsMutation,
    Types.EditDescriptionsMutationVariables
  >(EditDescriptionsDocument, options)
}
export type EditDescriptionsMutationHookResult = ReturnType<
  typeof useEditDescriptionsMutation
>
export type EditDescriptionsMutationResult =
  ApolloReactCommon.MutationResult<Types.EditDescriptionsMutation>
export type EditDescriptionsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.EditDescriptionsMutation,
    Types.EditDescriptionsMutationVariables
  >
export const GetPendingDescriptionDocument = /*#__PURE__*/ gql`
  query getPendingDescription(
    $shareIdentifier: UUID4!
    $versionIdentifier: UUID4!
  ) @capacitorapi {
    collaborativeEditingSession(shareIdentifier: $shareIdentifier) {
      baseVersionIdentifier
      shareIdentifier
      compatibilityVersion
      componentEdits(versionIdentifier: $versionIdentifier) {
        componentUuid
        description
      }
    }
  }
`

/**
 * __useGetPendingDescriptionQuery__
 *
 * To run a query within a React component, call `useGetPendingDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingDescriptionQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionIdentifier: // value for 'versionIdentifier'
 *   },
 * });
 */
export function useGetPendingDescriptionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPendingDescriptionQuery,
    Types.GetPendingDescriptionQueryVariables
  > &
    (
      | { variables: Types.GetPendingDescriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPendingDescriptionQuery,
    Types.GetPendingDescriptionQueryVariables
  >(GetPendingDescriptionDocument, options)
}
export function useGetPendingDescriptionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPendingDescriptionQuery,
    Types.GetPendingDescriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPendingDescriptionQuery,
    Types.GetPendingDescriptionQueryVariables
  >(GetPendingDescriptionDocument, options)
}

export type GetPendingDescriptionQueryHookResult = ReturnType<
  typeof useGetPendingDescriptionQuery
>
export type GetPendingDescriptionLazyQueryHookResult = ReturnType<
  typeof useGetPendingDescriptionLazyQuery
>
export type GetPendingDescriptionQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPendingDescriptionQuery,
  Types.GetPendingDescriptionQueryVariables
>
export const GetPageDocument = /*#__PURE__*/ gql`
  query getPage($share: UUID!, $version: ShortId, $pageUUID: String) {
    share(id: $share) {
      identifier
      commentsEnabled
      version(shortId: $version) {
        identifier
        shortId
        document {
          identifier
          artboardCount
          page(uuid: $pageUUID) {
            identifier
            uuid
            name
          }
        }
      }
    }
  }
`

/**
 * __useGetPageQuery__
 *
 * To run a query within a React component, call `useGetPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageQuery({
 *   variables: {
 *      share: // value for 'share'
 *      version: // value for 'version'
 *      pageUUID: // value for 'pageUUID'
 *   },
 * });
 */
export function useGetPageQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPageQuery,
    Types.GetPageQueryVariables
  > &
    (
      | { variables: Types.GetPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPageQuery,
    Types.GetPageQueryVariables
  >(GetPageDocument, options)
}
export function useGetPageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPageQuery,
    Types.GetPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPageQuery,
    Types.GetPageQueryVariables
  >(GetPageDocument, options)
}

export type GetPageQueryHookResult = ReturnType<typeof useGetPageQuery>
export type GetPageLazyQueryHookResult = ReturnType<typeof useGetPageLazyQuery>
export type GetPageQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPageQuery,
  Types.GetPageQueryVariables
>
export const GetPagesDocument = /*#__PURE__*/ gql`
  query getPages(
    $shareIdentifier: ShortId!
    $versionShortId: ShortId!
    $after: String = null
    $includeHasUnreadComments: Boolean = false
  ) {
    share(shortId: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        shortId
        document {
          identifier
          componentCount {
            symbol
            textStyle
            colorVar
            layerStyle
          }
          prototypes: artboards(filter: PROTOTYPE) {
            meta {
              totalCount
            }
          }
          pages(after: $after) {
            entries {
              name
              identifier
              uuid
              ...AnnotationPageInfo
            }
            meta {
              after
              limit
              totalCount
            }
          }
          prototypes: artboards(filter: PROTOTYPE) {
            meta {
              totalCount
            }
          }
        }
      }
    }
  }
  ${AnnotationPageInfoFragmentDoc}
`

/**
 * __useGetPagesQuery__
 *
 * To run a query within a React component, call `useGetPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagesQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *      after: // value for 'after'
 *      includeHasUnreadComments: // value for 'includeHasUnreadComments'
 *   },
 * });
 */
export function useGetPagesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPagesQuery,
    Types.GetPagesQueryVariables
  > &
    (
      | { variables: Types.GetPagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPagesQuery,
    Types.GetPagesQueryVariables
  >(GetPagesDocument, options)
}
export function useGetPagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPagesQuery,
    Types.GetPagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPagesQuery,
    Types.GetPagesQueryVariables
  >(GetPagesDocument, options)
}

export type GetPagesQueryHookResult = ReturnType<typeof useGetPagesQuery>
export type GetPagesLazyQueryHookResult = ReturnType<
  typeof useGetPagesLazyQuery
>
export type GetPagesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPagesQuery,
  Types.GetPagesQueryVariables
>
export const RenderDownloadableAssetsDocument = /*#__PURE__*/ gql`
  mutation renderDownloadableAssets(
    $documentIdentifier: String!
    $input: RenderLayerDownloadableAssetsInput
  ) {
    renderDownloadableAssets(
      input: {
        documentIdentifier: $documentIdentifier
        renderLayerDownloadableAssetsInput: $input
      }
    ) {
      downloadableAsset {
        ...DownloadableAsset
      }
      errors {
        ...UserError
      }
    }
  }
  ${DownloadableAssetFragmentDoc}
  ${UserErrorFragmentDoc}
`
export type RenderDownloadableAssetsMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.RenderDownloadableAssetsMutation,
    Types.RenderDownloadableAssetsMutationVariables
  >

/**
 * __useRenderDownloadableAssetsMutation__
 *
 * To run a mutation, you first call `useRenderDownloadableAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderDownloadableAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderDownloadableAssetsMutation, { data, loading, error }] = useRenderDownloadableAssetsMutation({
 *   variables: {
 *      documentIdentifier: // value for 'documentIdentifier'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderDownloadableAssetsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RenderDownloadableAssetsMutation,
    Types.RenderDownloadableAssetsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RenderDownloadableAssetsMutation,
    Types.RenderDownloadableAssetsMutationVariables
  >(RenderDownloadableAssetsDocument, options)
}
export type RenderDownloadableAssetsMutationHookResult = ReturnType<
  typeof useRenderDownloadableAssetsMutation
>
export type RenderDownloadableAssetsMutationResult =
  ApolloReactCommon.MutationResult<Types.RenderDownloadableAssetsMutation>
export type RenderDownloadableAssetsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RenderDownloadableAssetsMutation,
    Types.RenderDownloadableAssetsMutationVariables
  >
export const GetDownloadableAssetsDocument = /*#__PURE__*/ gql`
  query getDownloadableAssets(
    $shareIdentifier: ShortId!
    $versionShortId: ShortId
  ) {
    share(shortId: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        shortId
        document {
          identifier
          ...DocumentDownloadableAssets
        }
      }
    }
  }
  ${DocumentDownloadableAssetsFragmentDoc}
`

/**
 * __useGetDownloadableAssetsQuery__
 *
 * To run a query within a React component, call `useGetDownloadableAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadableAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadableAssetsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetDownloadableAssetsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetDownloadableAssetsQuery,
    Types.GetDownloadableAssetsQueryVariables
  > &
    (
      | { variables: Types.GetDownloadableAssetsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDownloadableAssetsQuery,
    Types.GetDownloadableAssetsQueryVariables
  >(GetDownloadableAssetsDocument, options)
}
export function useGetDownloadableAssetsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDownloadableAssetsQuery,
    Types.GetDownloadableAssetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDownloadableAssetsQuery,
    Types.GetDownloadableAssetsQueryVariables
  >(GetDownloadableAssetsDocument, options)
}

export type GetDownloadableAssetsQueryHookResult = ReturnType<
  typeof useGetDownloadableAssetsQuery
>
export type GetDownloadableAssetsLazyQueryHookResult = ReturnType<
  typeof useGetDownloadableAssetsLazyQuery
>
export type GetDownloadableAssetsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetDownloadableAssetsQuery,
  Types.GetDownloadableAssetsQueryVariables
>
export const GetFrameViewDocument = /*#__PURE__*/ gql`
  query getFrameView(
    $frameUUID: String!
    $documentVersionShortId: ShortId
    $shareIdentifier: UUID!
  ) {
    frame(
      uuid: $frameUUID
      documentVersionShortId: $documentVersionShortId
      shareIdentifier: $shareIdentifier
    ) {
      ... on Artboard {
        ...ArtboardDetailInfo
      }
      ... on Frame {
        ...FrameDetailInfo
      }
    }
  }
  ${ArtboardDetailInfoFragmentDoc}
  ${FrameDetailInfoFragmentDoc}
`

/**
 * __useGetFrameViewQuery__
 *
 * To run a query within a React component, call `useGetFrameViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrameViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrameViewQuery({
 *   variables: {
 *      frameUUID: // value for 'frameUUID'
 *      documentVersionShortId: // value for 'documentVersionShortId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetFrameViewQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFrameViewQuery,
    Types.GetFrameViewQueryVariables
  > &
    (
      | { variables: Types.GetFrameViewQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFrameViewQuery,
    Types.GetFrameViewQueryVariables
  >(GetFrameViewDocument, options)
}
export function useGetFrameViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFrameViewQuery,
    Types.GetFrameViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFrameViewQuery,
    Types.GetFrameViewQueryVariables
  >(GetFrameViewDocument, options)
}

export type GetFrameViewQueryHookResult = ReturnType<
  typeof useGetFrameViewQuery
>
export type GetFrameViewLazyQueryHookResult = ReturnType<
  typeof useGetFrameViewLazyQuery
>
export type GetFrameViewQueryResult = ApolloReactCommon.QueryResult<
  Types.GetFrameViewQuery,
  Types.GetFrameViewQueryVariables
>
export const GetSurroundingFramesDocument = /*#__PURE__*/ gql`
  query getSurroundingFrames(
    $frameUUID: String!
    $documentVersionShortId: ShortId!
    $shareIdentifier: UUID!
  ) {
    frame(
      uuid: $frameUUID
      documentVersionShortId: $documentVersionShortId
      shareIdentifier: $shareIdentifier
    ) {
      identifier
      documentOrder
      documentVersionShortId
      ... on Artboard {
        shortId
        permanentArtboardShortId
      }
      next {
        ... on Frame {
          ...FrameDetailInfo
        }
        ... on Artboard {
          ...ArtboardDetailInfo
        }
      }
      previous {
        ... on Frame {
          ...FrameDetailInfo
        }
        ... on Artboard {
          ...ArtboardDetailInfo
        }
      }
    }
  }
  ${FrameDetailInfoFragmentDoc}
  ${ArtboardDetailInfoFragmentDoc}
`

/**
 * __useGetSurroundingFramesQuery__
 *
 * To run a query within a React component, call `useGetSurroundingFramesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurroundingFramesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurroundingFramesQuery({
 *   variables: {
 *      frameUUID: // value for 'frameUUID'
 *      documentVersionShortId: // value for 'documentVersionShortId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetSurroundingFramesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSurroundingFramesQuery,
    Types.GetSurroundingFramesQueryVariables
  > &
    (
      | { variables: Types.GetSurroundingFramesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSurroundingFramesQuery,
    Types.GetSurroundingFramesQueryVariables
  >(GetSurroundingFramesDocument, options)
}
export function useGetSurroundingFramesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSurroundingFramesQuery,
    Types.GetSurroundingFramesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSurroundingFramesQuery,
    Types.GetSurroundingFramesQueryVariables
  >(GetSurroundingFramesDocument, options)
}

export type GetSurroundingFramesQueryHookResult = ReturnType<
  typeof useGetSurroundingFramesQuery
>
export type GetSurroundingFramesLazyQueryHookResult = ReturnType<
  typeof useGetSurroundingFramesLazyQuery
>
export type GetSurroundingFramesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetSurroundingFramesQuery,
  Types.GetSurroundingFramesQueryVariables
>
export const GetFramesForDocumentDocument = /*#__PURE__*/ gql`
  query getFramesForDocument(
    $identifier: UUID!
    $versionShortId: ShortId
    $after: String
    $filter: FrameFilterType = ALL
    $search: String
  ) {
    share(id: $identifier) {
      identifier
      commentsEnabled
      userCanEdit
      version(shortId: $versionShortId) {
        identifier
        shortId
        document {
          identifier
          frames(after: $after, filter: $filter, search: $search) {
            entries {
              ... on Frame {
                ...FrameDetailInfo
              }
              ... on Artboard {
                ...ArtboardDetailInfo
              }
            }
            meta {
              after
              totalCount
            }
          }
        }
      }
    }
  }
  ${FrameDetailInfoFragmentDoc}
  ${ArtboardDetailInfoFragmentDoc}
`

/**
 * __useGetFramesForDocumentQuery__
 *
 * To run a query within a React component, call `useGetFramesForDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFramesForDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFramesForDocumentQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      versionShortId: // value for 'versionShortId'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFramesForDocumentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFramesForDocumentQuery,
    Types.GetFramesForDocumentQueryVariables
  > &
    (
      | { variables: Types.GetFramesForDocumentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFramesForDocumentQuery,
    Types.GetFramesForDocumentQueryVariables
  >(GetFramesForDocumentDocument, options)
}
export function useGetFramesForDocumentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFramesForDocumentQuery,
    Types.GetFramesForDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFramesForDocumentQuery,
    Types.GetFramesForDocumentQueryVariables
  >(GetFramesForDocumentDocument, options)
}

export type GetFramesForDocumentQueryHookResult = ReturnType<
  typeof useGetFramesForDocumentQuery
>
export type GetFramesForDocumentLazyQueryHookResult = ReturnType<
  typeof useGetFramesForDocumentLazyQuery
>
export type GetFramesForDocumentQueryResult = ApolloReactCommon.QueryResult<
  Types.GetFramesForDocumentQuery,
  Types.GetFramesForDocumentQueryVariables
>
export const GetFramesForPageDocument = /*#__PURE__*/ gql`
  query getFramesForPage(
    $identifier: UUID!
    $versionShortId: ShortId
    $pageUUID: String
    $after: String
    $search: String
  ) {
    share(id: $identifier) {
      identifier
      commentsEnabled
      version(shortId: $versionShortId) {
        identifier
        shortId
        document {
          identifier
          artboardCount
          page(uuid: $pageUUID) {
            identifier
            frames(after: $after, search: $search) {
              entries {
                ... on Frame {
                  ...FrameDetailInfo
                }
                ... on Artboard {
                  ...ArtboardDetailInfo
                }
              }
              meta {
                after
              }
            }
          }
        }
      }
    }
  }
  ${FrameDetailInfoFragmentDoc}
  ${ArtboardDetailInfoFragmentDoc}
`

/**
 * __useGetFramesForPageQuery__
 *
 * To run a query within a React component, call `useGetFramesForPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFramesForPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFramesForPageQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      versionShortId: // value for 'versionShortId'
 *      pageUUID: // value for 'pageUUID'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFramesForPageQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFramesForPageQuery,
    Types.GetFramesForPageQueryVariables
  > &
    (
      | { variables: Types.GetFramesForPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFramesForPageQuery,
    Types.GetFramesForPageQueryVariables
  >(GetFramesForPageDocument, options)
}
export function useGetFramesForPageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFramesForPageQuery,
    Types.GetFramesForPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFramesForPageQuery,
    Types.GetFramesForPageQueryVariables
  >(GetFramesForPageDocument, options)
}

export type GetFramesForPageQueryHookResult = ReturnType<
  typeof useGetFramesForPageQuery
>
export type GetFramesForPageLazyQueryHookResult = ReturnType<
  typeof useGetFramesForPageLazyQuery
>
export type GetFramesForPageQueryResult = ApolloReactCommon.QueryResult<
  Types.GetFramesForPageQuery,
  Types.GetFramesForPageQueryVariables
>
export const GetFrameDescriptionDocument = /*#__PURE__*/ gql`
  query getFrameDescription(
    $frameUUID: String!
    $shareIdentifier: UUID!
    $documentVersionShortId: ShortId
  ) {
    frame(
      uuid: $frameUUID
      shareIdentifier: $shareIdentifier
      documentVersionShortId: $documentVersionShortId
    ) {
      uuid
      identifier
      documentVersionShortId
      component {
        identifier
        description
      }
    }
  }
`

/**
 * __useGetFrameDescriptionQuery__
 *
 * To run a query within a React component, call `useGetFrameDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrameDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrameDescriptionQuery({
 *   variables: {
 *      frameUUID: // value for 'frameUUID'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      documentVersionShortId: // value for 'documentVersionShortId'
 *   },
 * });
 */
export function useGetFrameDescriptionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFrameDescriptionQuery,
    Types.GetFrameDescriptionQueryVariables
  > &
    (
      | { variables: Types.GetFrameDescriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFrameDescriptionQuery,
    Types.GetFrameDescriptionQueryVariables
  >(GetFrameDescriptionDocument, options)
}
export function useGetFrameDescriptionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFrameDescriptionQuery,
    Types.GetFrameDescriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFrameDescriptionQuery,
    Types.GetFrameDescriptionQueryVariables
  >(GetFrameDescriptionDocument, options)
}

export type GetFrameDescriptionQueryHookResult = ReturnType<
  typeof useGetFrameDescriptionQuery
>
export type GetFrameDescriptionLazyQueryHookResult = ReturnType<
  typeof useGetFrameDescriptionLazyQuery
>
export type GetFrameDescriptionQueryResult = ApolloReactCommon.QueryResult<
  Types.GetFrameDescriptionQuery,
  Types.GetFrameDescriptionQueryVariables
>
export const GetFrameAnnotationInfoDocument = /*#__PURE__*/ gql`
  query getFrameAnnotationInfo($frameUUID: String!, $shareIdentifier: UUID!) {
    frame(uuid: $frameUUID, shareIdentifier: $shareIdentifier) {
      uuid
      identifier
      ...AnnotationFrameGroupInfo
    }
  }
  ${AnnotationFrameGroupInfoFragmentDoc}
`

/**
 * __useGetFrameAnnotationInfoQuery__
 *
 * To run a query within a React component, call `useGetFrameAnnotationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrameAnnotationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrameAnnotationInfoQuery({
 *   variables: {
 *      frameUUID: // value for 'frameUUID'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetFrameAnnotationInfoQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFrameAnnotationInfoQuery,
    Types.GetFrameAnnotationInfoQueryVariables
  > &
    (
      | {
          variables: Types.GetFrameAnnotationInfoQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFrameAnnotationInfoQuery,
    Types.GetFrameAnnotationInfoQueryVariables
  >(GetFrameAnnotationInfoDocument, options)
}
export function useGetFrameAnnotationInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFrameAnnotationInfoQuery,
    Types.GetFrameAnnotationInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFrameAnnotationInfoQuery,
    Types.GetFrameAnnotationInfoQueryVariables
  >(GetFrameAnnotationInfoDocument, options)
}

export type GetFrameAnnotationInfoQueryHookResult = ReturnType<
  typeof useGetFrameAnnotationInfoQuery
>
export type GetFrameAnnotationInfoLazyQueryHookResult = ReturnType<
  typeof useGetFrameAnnotationInfoLazyQuery
>
export type GetFrameAnnotationInfoQueryResult = ApolloReactCommon.QueryResult<
  Types.GetFrameAnnotationInfoQuery,
  Types.GetFrameAnnotationInfoQueryVariables
>
export const GetInspectorComponentDataDocument = /*#__PURE__*/ gql`
  query getInspectorComponentData($componentId: UUID) {
    inspectorData(componentId: $componentId) {
      inspector {
        status
        data
      }
    }
  }
`

/**
 * __useGetInspectorComponentDataQuery__
 *
 * To run a query within a React component, call `useGetInspectorComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectorComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectorComponentDataQuery({
 *   variables: {
 *      componentId: // value for 'componentId'
 *   },
 * });
 */
export function useGetInspectorComponentDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetInspectorComponentDataQuery,
    Types.GetInspectorComponentDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetInspectorComponentDataQuery,
    Types.GetInspectorComponentDataQueryVariables
  >(GetInspectorComponentDataDocument, options)
}
export function useGetInspectorComponentDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetInspectorComponentDataQuery,
    Types.GetInspectorComponentDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetInspectorComponentDataQuery,
    Types.GetInspectorComponentDataQueryVariables
  >(GetInspectorComponentDataDocument, options)
}

export type GetInspectorComponentDataQueryHookResult = ReturnType<
  typeof useGetInspectorComponentDataQuery
>
export type GetInspectorComponentDataLazyQueryHookResult = ReturnType<
  typeof useGetInspectorComponentDataLazyQuery
>
export type GetInspectorComponentDataQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetInspectorComponentDataQuery,
    Types.GetInspectorComponentDataQueryVariables
  >
export const RenderPresentationDocument = /*#__PURE__*/ gql`
  mutation renderPresentation($versionIdentifier: UUID!) {
    renderPresentation(versionIdentifier: $versionIdentifier) {
      presentationStatus
    }
  }
`
export type RenderPresentationMutationFn = ApolloReactCommon.MutationFunction<
  Types.RenderPresentationMutation,
  Types.RenderPresentationMutationVariables
>

/**
 * __useRenderPresentationMutation__
 *
 * To run a mutation, you first call `useRenderPresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderPresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderPresentationMutation, { data, loading, error }] = useRenderPresentationMutation({
 *   variables: {
 *      versionIdentifier: // value for 'versionIdentifier'
 *   },
 * });
 */
export function useRenderPresentationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RenderPresentationMutation,
    Types.RenderPresentationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RenderPresentationMutation,
    Types.RenderPresentationMutationVariables
  >(RenderPresentationDocument, options)
}
export type RenderPresentationMutationHookResult = ReturnType<
  typeof useRenderPresentationMutation
>
export type RenderPresentationMutationResult =
  ApolloReactCommon.MutationResult<Types.RenderPresentationMutation>
export type RenderPresentationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RenderPresentationMutation,
    Types.RenderPresentationMutationVariables
  >
export const GetPagePresentationFileDocument = /*#__PURE__*/ gql`
  query getPagePresentationFile(
    $shareIdentifier: UUID!
    $versionShortId: ShortId
    $pageUUID: String
  ) {
    share(id: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        shortId
        document {
          identifier
          page(uuid: $pageUUID) {
            name
            identifier
            uuid
            ...PresentationFile
          }
        }
      }
    }
  }
  ${PresentationFileFragmentDoc}
`

/**
 * __useGetPagePresentationFileQuery__
 *
 * To run a query within a React component, call `useGetPagePresentationFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagePresentationFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagePresentationFileQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *      pageUUID: // value for 'pageUUID'
 *   },
 * });
 */
export function useGetPagePresentationFileQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPagePresentationFileQuery,
    Types.GetPagePresentationFileQueryVariables
  > &
    (
      | {
          variables: Types.GetPagePresentationFileQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPagePresentationFileQuery,
    Types.GetPagePresentationFileQueryVariables
  >(GetPagePresentationFileDocument, options)
}
export function useGetPagePresentationFileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPagePresentationFileQuery,
    Types.GetPagePresentationFileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPagePresentationFileQuery,
    Types.GetPagePresentationFileQueryVariables
  >(GetPagePresentationFileDocument, options)
}

export type GetPagePresentationFileQueryHookResult = ReturnType<
  typeof useGetPagePresentationFileQuery
>
export type GetPagePresentationFileLazyQueryHookResult = ReturnType<
  typeof useGetPagePresentationFileLazyQuery
>
export type GetPagePresentationFileQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPagePresentationFileQuery,
  Types.GetPagePresentationFileQueryVariables
>
export const GetPresentationAssetsByArtboardDocument = /*#__PURE__*/ gql`
  query getPresentationAssetsByArtboard(
    $documentId: String!
    $artboardUuid: String!
  ) {
    artboardInDocumentWithUuid(documentId: $documentId, uuid: $artboardUuid) {
      uuid
      page {
        identifier
        uuid
        ...PresentationFile
      }
    }
  }
  ${PresentationFileFragmentDoc}
`

/**
 * __useGetPresentationAssetsByArtboardQuery__
 *
 * To run a query within a React component, call `useGetPresentationAssetsByArtboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresentationAssetsByArtboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresentationAssetsByArtboardQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      artboardUuid: // value for 'artboardUuid'
 *   },
 * });
 */
export function useGetPresentationAssetsByArtboardQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPresentationAssetsByArtboardQuery,
    Types.GetPresentationAssetsByArtboardQueryVariables
  > &
    (
      | {
          variables: Types.GetPresentationAssetsByArtboardQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPresentationAssetsByArtboardQuery,
    Types.GetPresentationAssetsByArtboardQueryVariables
  >(GetPresentationAssetsByArtboardDocument, options)
}
export function useGetPresentationAssetsByArtboardLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPresentationAssetsByArtboardQuery,
    Types.GetPresentationAssetsByArtboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPresentationAssetsByArtboardQuery,
    Types.GetPresentationAssetsByArtboardQueryVariables
  >(GetPresentationAssetsByArtboardDocument, options)
}

export type GetPresentationAssetsByArtboardQueryHookResult = ReturnType<
  typeof useGetPresentationAssetsByArtboardQuery
>
export type GetPresentationAssetsByArtboardLazyQueryHookResult = ReturnType<
  typeof useGetPresentationAssetsByArtboardLazyQuery
>
export type GetPresentationAssetsByArtboardQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetPresentationAssetsByArtboardQuery,
    Types.GetPresentationAssetsByArtboardQueryVariables
  >
export const GetPageImageTokensDocument = /*#__PURE__*/ gql`
  query getPageImageTokens(
    $shareIdentifier: ShortId!
    $versionShortId: ShortId!
    $after: String = null
  ) {
    share(shortId: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        document {
          identifier
          pages(after: $after) {
            entries {
              uuid
              presentationFile {
                imageToken
              }
            }
            meta {
              after
              limit
              totalCount
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetPageImageTokensQuery__
 *
 * To run a query within a React component, call `useGetPageImageTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageImageTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageImageTokensQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPageImageTokensQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPageImageTokensQuery,
    Types.GetPageImageTokensQueryVariables
  > &
    (
      | { variables: Types.GetPageImageTokensQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPageImageTokensQuery,
    Types.GetPageImageTokensQueryVariables
  >(GetPageImageTokensDocument, options)
}
export function useGetPageImageTokensLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPageImageTokensQuery,
    Types.GetPageImageTokensQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPageImageTokensQuery,
    Types.GetPageImageTokensQueryVariables
  >(GetPageImageTokensDocument, options)
}

export type GetPageImageTokensQueryHookResult = ReturnType<
  typeof useGetPageImageTokensQuery
>
export type GetPageImageTokensLazyQueryHookResult = ReturnType<
  typeof useGetPageImageTokensLazyQuery
>
export type GetPageImageTokensQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPageImageTokensQuery,
  Types.GetPageImageTokensQueryVariables
>
export const ShareDeleteDocument = /*#__PURE__*/ gql`
  mutation shareDelete($identifier: UUID!) {
    shareDelete(identifier: $identifier) {
      errors {
        ...UserError
      }
      successful
      share {
        identifier
        name
        deletedAt
        workspace {
          identifier
        }
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type ShareDeleteMutationFn = ApolloReactCommon.MutationFunction<
  Types.ShareDeleteMutation,
  Types.ShareDeleteMutationVariables
>

/**
 * __useShareDeleteMutation__
 *
 * To run a mutation, you first call `useShareDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDeleteMutation, { data, loading, error }] = useShareDeleteMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useShareDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareDeleteMutation,
    Types.ShareDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareDeleteMutation,
    Types.ShareDeleteMutationVariables
  >(ShareDeleteDocument, options)
}
export type ShareDeleteMutationHookResult = ReturnType<
  typeof useShareDeleteMutation
>
export type ShareDeleteMutationResult =
  ApolloReactCommon.MutationResult<Types.ShareDeleteMutation>
export type ShareDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ShareDeleteMutation,
  Types.ShareDeleteMutationVariables
>
export const SharesDeleteDocument = /*#__PURE__*/ gql`
  mutation sharesDelete($identifiers: [UUID!]!) {
    sharesDelete(identifiers: $identifiers) {
      shares {
        identifier
      }
    }
  }
`
export type SharesDeleteMutationFn = ApolloReactCommon.MutationFunction<
  Types.SharesDeleteMutation,
  Types.SharesDeleteMutationVariables
>

/**
 * __useSharesDeleteMutation__
 *
 * To run a mutation, you first call `useSharesDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharesDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharesDeleteMutation, { data, loading, error }] = useSharesDeleteMutation({
 *   variables: {
 *      identifiers: // value for 'identifiers'
 *   },
 * });
 */
export function useSharesDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SharesDeleteMutation,
    Types.SharesDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SharesDeleteMutation,
    Types.SharesDeleteMutationVariables
  >(SharesDeleteDocument, options)
}
export type SharesDeleteMutationHookResult = ReturnType<
  typeof useSharesDeleteMutation
>
export type SharesDeleteMutationResult =
  ApolloReactCommon.MutationResult<Types.SharesDeleteMutation>
export type SharesDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SharesDeleteMutation,
  Types.SharesDeleteMutationVariables
>
export const RestoreShareDocument = /*#__PURE__*/ gql`
  mutation restoreShare($identifier: UUID!) {
    restoreShare(identifier: $identifier) {
      share {
        ...ShareInfo
      }
    }
  }
  ${ShareInfoFragmentDoc}
`
export type RestoreShareMutationFn = ApolloReactCommon.MutationFunction<
  Types.RestoreShareMutation,
  Types.RestoreShareMutationVariables
>

/**
 * __useRestoreShareMutation__
 *
 * To run a mutation, you first call `useRestoreShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreShareMutation, { data, loading, error }] = useRestoreShareMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useRestoreShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RestoreShareMutation,
    Types.RestoreShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RestoreShareMutation,
    Types.RestoreShareMutationVariables
  >(RestoreShareDocument, options)
}
export type RestoreShareMutationHookResult = ReturnType<
  typeof useRestoreShareMutation
>
export type RestoreShareMutationResult =
  ApolloReactCommon.MutationResult<Types.RestoreShareMutation>
export type RestoreShareMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.RestoreShareMutation,
  Types.RestoreShareMutationVariables
>
export const ShareUpdateDocument = /*#__PURE__*/ gql`
  mutation shareUpdate($identifier: UUID!, $share: ShareParams!) {
    shareUpdate(identifier: $identifier, share: $share) {
      errors {
        ...UserError
      }
      share {
        name
        identifier
        ...ShareSettings
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
  ${ShareSettingsFragmentDoc}
`
export type ShareUpdateMutationFn = ApolloReactCommon.MutationFunction<
  Types.ShareUpdateMutation,
  Types.ShareUpdateMutationVariables
>

/**
 * __useShareUpdateMutation__
 *
 * To run a mutation, you first call `useShareUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareUpdateMutation, { data, loading, error }] = useShareUpdateMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      share: // value for 'share'
 *   },
 * });
 */
export function useShareUpdateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareUpdateMutation,
    Types.ShareUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareUpdateMutation,
    Types.ShareUpdateMutationVariables
  >(ShareUpdateDocument, options)
}
export type ShareUpdateMutationHookResult = ReturnType<
  typeof useShareUpdateMutation
>
export type ShareUpdateMutationResult =
  ApolloReactCommon.MutationResult<Types.ShareUpdateMutation>
export type ShareUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ShareUpdateMutation,
  Types.ShareUpdateMutationVariables
>
export const ShareLeaveDocument = /*#__PURE__*/ gql`
  mutation shareLeave($identifier: UUID!) {
    shareLeave(identifier: $identifier) {
      errors {
        ...UserError
      }
      successful
      share {
        identifier
        workspace {
          identifier
          userIsMember
        }
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type ShareLeaveMutationFn = ApolloReactCommon.MutationFunction<
  Types.ShareLeaveMutation,
  Types.ShareLeaveMutationVariables
>

/**
 * __useShareLeaveMutation__
 *
 * To run a mutation, you first call `useShareLeaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareLeaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareLeaveMutation, { data, loading, error }] = useShareLeaveMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useShareLeaveMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareLeaveMutation,
    Types.ShareLeaveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareLeaveMutation,
    Types.ShareLeaveMutationVariables
  >(ShareLeaveDocument, options)
}
export type ShareLeaveMutationHookResult = ReturnType<
  typeof useShareLeaveMutation
>
export type ShareLeaveMutationResult =
  ApolloReactCommon.MutationResult<Types.ShareLeaveMutation>
export type ShareLeaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ShareLeaveMutation,
  Types.ShareLeaveMutationVariables
>
export const DeleteSharePermanentlyDocument = /*#__PURE__*/ gql`
  mutation deleteSharePermanently(
    $workspaceId: UUID!
    $shareIdentifier: UUID!
  ) {
    deleteSharePermanently(
      workspaceIdentifier: $workspaceId
      shareIdentifier: $shareIdentifier
    ) {
      shareIdentifier
      workspace {
        identifier
      }
    }
  }
`
export type DeleteSharePermanentlyMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.DeleteSharePermanentlyMutation,
    Types.DeleteSharePermanentlyMutationVariables
  >

/**
 * __useDeleteSharePermanentlyMutation__
 *
 * To run a mutation, you first call `useDeleteSharePermanentlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSharePermanentlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSharePermanentlyMutation, { data, loading, error }] = useDeleteSharePermanentlyMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useDeleteSharePermanentlyMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteSharePermanentlyMutation,
    Types.DeleteSharePermanentlyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteSharePermanentlyMutation,
    Types.DeleteSharePermanentlyMutationVariables
  >(DeleteSharePermanentlyDocument, options)
}
export type DeleteSharePermanentlyMutationHookResult = ReturnType<
  typeof useDeleteSharePermanentlyMutation
>
export type DeleteSharePermanentlyMutationResult =
  ApolloReactCommon.MutationResult<Types.DeleteSharePermanentlyMutation>
export type DeleteSharePermanentlyMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DeleteSharePermanentlyMutation,
    Types.DeleteSharePermanentlyMutationVariables
  >
export const EmptyWorkspaceTrashDocument = /*#__PURE__*/ gql`
  mutation emptyWorkspaceTrash($identifier: UUID!) {
    emptyWorkspaceTrash(identifier: $identifier) {
      workspace {
        identifier
      }
    }
  }
`
export type EmptyWorkspaceTrashMutationFn = ApolloReactCommon.MutationFunction<
  Types.EmptyWorkspaceTrashMutation,
  Types.EmptyWorkspaceTrashMutationVariables
>

/**
 * __useEmptyWorkspaceTrashMutation__
 *
 * To run a mutation, you first call `useEmptyWorkspaceTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyWorkspaceTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyWorkspaceTrashMutation, { data, loading, error }] = useEmptyWorkspaceTrashMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useEmptyWorkspaceTrashMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EmptyWorkspaceTrashMutation,
    Types.EmptyWorkspaceTrashMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EmptyWorkspaceTrashMutation,
    Types.EmptyWorkspaceTrashMutationVariables
  >(EmptyWorkspaceTrashDocument, options)
}
export type EmptyWorkspaceTrashMutationHookResult = ReturnType<
  typeof useEmptyWorkspaceTrashMutation
>
export type EmptyWorkspaceTrashMutationResult =
  ApolloReactCommon.MutationResult<Types.EmptyWorkspaceTrashMutation>
export type EmptyWorkspaceTrashMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.EmptyWorkspaceTrashMutation,
    Types.EmptyWorkspaceTrashMutationVariables
  >
export const UpdateSharePublicPermissionsDocument = /*#__PURE__*/ gql`
  mutation updateSharePublicPermissions(
    $input: UpdateSharePublicPermissionsParams!
  ) {
    updateSharePublicPermissions(input: $input) {
      ...SharePublicPermissions
    }
  }
  ${SharePublicPermissionsFragmentDoc}
`
export type UpdateSharePublicPermissionsMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateSharePublicPermissionsMutation,
    Types.UpdateSharePublicPermissionsMutationVariables
  >

/**
 * __useUpdateSharePublicPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateSharePublicPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharePublicPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharePublicPermissionsMutation, { data, loading, error }] = useUpdateSharePublicPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSharePublicPermissionsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateSharePublicPermissionsMutation,
    Types.UpdateSharePublicPermissionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateSharePublicPermissionsMutation,
    Types.UpdateSharePublicPermissionsMutationVariables
  >(UpdateSharePublicPermissionsDocument, options)
}
export type UpdateSharePublicPermissionsMutationHookResult = ReturnType<
  typeof useUpdateSharePublicPermissionsMutation
>
export type UpdateSharePublicPermissionsMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateSharePublicPermissionsMutation>
export type UpdateSharePublicPermissionsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateSharePublicPermissionsMutation,
    Types.UpdateSharePublicPermissionsMutationVariables
  >
export const UpdateShareParentPermissionsDocument = /*#__PURE__*/ gql`
  mutation updateShareParentPermissions(
    $input: UpdateShareParentPermissionsParams!
  ) {
    updateShareParentPermissions(input: $input) {
      identifier
      userCanUpdateSettings
      parentAccessLevel
    }
  }
`
export type UpdateShareParentPermissionsMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateShareParentPermissionsMutation,
    Types.UpdateShareParentPermissionsMutationVariables
  >

/**
 * __useUpdateShareParentPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateShareParentPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareParentPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareParentPermissionsMutation, { data, loading, error }] = useUpdateShareParentPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShareParentPermissionsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateShareParentPermissionsMutation,
    Types.UpdateShareParentPermissionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateShareParentPermissionsMutation,
    Types.UpdateShareParentPermissionsMutationVariables
  >(UpdateShareParentPermissionsDocument, options)
}
export type UpdateShareParentPermissionsMutationHookResult = ReturnType<
  typeof useUpdateShareParentPermissionsMutation
>
export type UpdateShareParentPermissionsMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateShareParentPermissionsMutation>
export type UpdateShareParentPermissionsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateShareParentPermissionsMutation,
    Types.UpdateShareParentPermissionsMutationVariables
  >
export const TransferShareDocument = /*#__PURE__*/ gql`
  mutation transferShare(
    $shareIdentifier: UUID!
    $workspaceIdentifier: UUID!
    $projectIdentifier: UUID
    $membershipsOperation: MembershipsTransferOperation!
  ) {
    transferShare(
      shareIdentifier: $shareIdentifier
      workspaceIdentifier: $workspaceIdentifier
      projectIdentifier: $projectIdentifier
      membershipsOperation: $membershipsOperation
    ) {
      share {
        identifier
        project {
          ...Project
        }
        workspace {
          identifier
          name
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type TransferShareMutationFn = ApolloReactCommon.MutationFunction<
  Types.TransferShareMutation,
  Types.TransferShareMutationVariables
>

/**
 * __useTransferShareMutation__
 *
 * To run a mutation, you first call `useTransferShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferShareMutation, { data, loading, error }] = useTransferShareMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      projectIdentifier: // value for 'projectIdentifier'
 *      membershipsOperation: // value for 'membershipsOperation'
 *   },
 * });
 */
export function useTransferShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.TransferShareMutation,
    Types.TransferShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.TransferShareMutation,
    Types.TransferShareMutationVariables
  >(TransferShareDocument, options)
}
export type TransferShareMutationHookResult = ReturnType<
  typeof useTransferShareMutation
>
export type TransferShareMutationResult =
  ApolloReactCommon.MutationResult<Types.TransferShareMutation>
export type TransferShareMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.TransferShareMutation,
    Types.TransferShareMutationVariables
  >
export const UpdateSharePublicTokenExportDocument = /*#__PURE__*/ gql`
  mutation updateSharePublicTokenExport(
    $shareIdentifier: UUID!
    $shareParams: ShareParams!
    $format: TokenExportFormat!
    $colorFormat: TokenColorFormat
    $tokenTypes: [ExportableComponentType]!
  ) {
    shareUpdate(identifier: $shareIdentifier, share: $shareParams) {
      share {
        identifier
        publicTokenExport
        publicTokenExportUrl(
          format: $format
          colorFormat: $colorFormat
          tokenTypes: $tokenTypes
        )
      }
    }
  }
`
export type UpdateSharePublicTokenExportMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateSharePublicTokenExportMutation,
    Types.UpdateSharePublicTokenExportMutationVariables
  >

/**
 * __useUpdateSharePublicTokenExportMutation__
 *
 * To run a mutation, you first call `useUpdateSharePublicTokenExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharePublicTokenExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharePublicTokenExportMutation, { data, loading, error }] = useUpdateSharePublicTokenExportMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      shareParams: // value for 'shareParams'
 *      format: // value for 'format'
 *      colorFormat: // value for 'colorFormat'
 *      tokenTypes: // value for 'tokenTypes'
 *   },
 * });
 */
export function useUpdateSharePublicTokenExportMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateSharePublicTokenExportMutation,
    Types.UpdateSharePublicTokenExportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateSharePublicTokenExportMutation,
    Types.UpdateSharePublicTokenExportMutationVariables
  >(UpdateSharePublicTokenExportDocument, options)
}
export type UpdateSharePublicTokenExportMutationHookResult = ReturnType<
  typeof useUpdateSharePublicTokenExportMutation
>
export type UpdateSharePublicTokenExportMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateSharePublicTokenExportMutation>
export type UpdateSharePublicTokenExportMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateSharePublicTokenExportMutation,
    Types.UpdateSharePublicTokenExportMutationVariables
  >
export const ShareRenameDocument = /*#__PURE__*/ gql`
  mutation shareRename($identifier: UUID!, $name: String!) {
    shareUpdate(identifier: $identifier, share: { name: $name }) {
      successful
      share {
        identifier
        name
      }
      errors {
        message
      }
    }
  }
`
export type ShareRenameMutationFn = ApolloReactCommon.MutationFunction<
  Types.ShareRenameMutation,
  Types.ShareRenameMutationVariables
>

/**
 * __useShareRenameMutation__
 *
 * To run a mutation, you first call `useShareRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareRenameMutation, { data, loading, error }] = useShareRenameMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useShareRenameMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareRenameMutation,
    Types.ShareRenameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareRenameMutation,
    Types.ShareRenameMutationVariables
  >(ShareRenameDocument, options)
}
export type ShareRenameMutationHookResult = ReturnType<
  typeof useShareRenameMutation
>
export type ShareRenameMutationResult =
  ApolloReactCommon.MutationResult<Types.ShareRenameMutation>
export type ShareRenameMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ShareRenameMutation,
  Types.ShareRenameMutationVariables
>
export const ShareDescriptionChangeDocument = /*#__PURE__*/ gql`
  mutation shareDescriptionChange($identifier: UUID!, $description: String!) {
    shareUpdate(identifier: $identifier, share: { description: $description }) {
      successful
      share {
        identifier
        description
      }
      errors {
        message
      }
    }
  }
`
export type ShareDescriptionChangeMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.ShareDescriptionChangeMutation,
    Types.ShareDescriptionChangeMutationVariables
  >

/**
 * __useShareDescriptionChangeMutation__
 *
 * To run a mutation, you first call `useShareDescriptionChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDescriptionChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDescriptionChangeMutation, { data, loading, error }] = useShareDescriptionChangeMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useShareDescriptionChangeMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareDescriptionChangeMutation,
    Types.ShareDescriptionChangeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareDescriptionChangeMutation,
    Types.ShareDescriptionChangeMutationVariables
  >(ShareDescriptionChangeDocument, options)
}
export type ShareDescriptionChangeMutationHookResult = ReturnType<
  typeof useShareDescriptionChangeMutation
>
export type ShareDescriptionChangeMutationResult =
  ApolloReactCommon.MutationResult<Types.ShareDescriptionChangeMutation>
export type ShareDescriptionChangeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ShareDescriptionChangeMutation,
    Types.ShareDescriptionChangeMutationVariables
  >
export const ShareTypeChangeDocument = /*#__PURE__*/ gql`
  mutation shareTypeChange($identifier: UUID!, $type: ShareType!) {
    shareUpdate(identifier: $identifier, share: { type: $type }) {
      successful
      share {
        identifier
        shareType
      }
      errors {
        message
      }
    }
  }
`
export type ShareTypeChangeMutationFn = ApolloReactCommon.MutationFunction<
  Types.ShareTypeChangeMutation,
  Types.ShareTypeChangeMutationVariables
>

/**
 * __useShareTypeChangeMutation__
 *
 * To run a mutation, you first call `useShareTypeChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareTypeChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareTypeChangeMutation, { data, loading, error }] = useShareTypeChangeMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useShareTypeChangeMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareTypeChangeMutation,
    Types.ShareTypeChangeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareTypeChangeMutation,
    Types.ShareTypeChangeMutationVariables
  >(ShareTypeChangeDocument, options)
}
export type ShareTypeChangeMutationHookResult = ReturnType<
  typeof useShareTypeChangeMutation
>
export type ShareTypeChangeMutationResult =
  ApolloReactCommon.MutationResult<Types.ShareTypeChangeMutation>
export type ShareTypeChangeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ShareTypeChangeMutation,
    Types.ShareTypeChangeMutationVariables
  >
export const DuplicateShareToDraftsDocument = /*#__PURE__*/ gql`
  mutation duplicateShareToDrafts($input: DuplicateShareToDraftsParams!) {
    duplicateShareToDrafts(input: $input) {
      share {
        identifier
        workspace {
          identifier
          name
        }
        project {
          identifier
        }
        collection {
          identifier
        }
      }
    }
  }
`
export type DuplicateShareToDraftsMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.DuplicateShareToDraftsMutation,
    Types.DuplicateShareToDraftsMutationVariables
  >

/**
 * __useDuplicateShareToDraftsMutation__
 *
 * To run a mutation, you first call `useDuplicateShareToDraftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateShareToDraftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateShareToDraftsMutation, { data, loading, error }] = useDuplicateShareToDraftsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateShareToDraftsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DuplicateShareToDraftsMutation,
    Types.DuplicateShareToDraftsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DuplicateShareToDraftsMutation,
    Types.DuplicateShareToDraftsMutationVariables
  >(DuplicateShareToDraftsDocument, options)
}
export type DuplicateShareToDraftsMutationHookResult = ReturnType<
  typeof useDuplicateShareToDraftsMutation
>
export type DuplicateShareToDraftsMutationResult =
  ApolloReactCommon.MutationResult<Types.DuplicateShareToDraftsMutation>
export type DuplicateShareToDraftsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DuplicateShareToDraftsMutation,
    Types.DuplicateShareToDraftsMutationVariables
  >
export const DuplicateShareToDocument = /*#__PURE__*/ gql`
  mutation duplicateShareTo(
    $sourceShareIdentifier: UUID!
    $sourceVersionIdentifier: UUID!
    $targetWorkspaceIdentifier: UUID!
    $targetProjectIdentifier: UUID
    $targetCollectionIdentifier: UUID
  ) {
    duplicateShareTo(
      sourceShareIdentifier: $sourceShareIdentifier
      sourceVersionIdentifier: $sourceVersionIdentifier
      targetWorkspaceIdentifier: $targetWorkspaceIdentifier
      targetProjectIdentifier: $targetProjectIdentifier
      targetCollectionIdentifier: $targetCollectionIdentifier
    ) {
      share {
        identifier
        project {
          identifier
        }
        collection {
          identifier
        }
      }
    }
  }
`
export type DuplicateShareToMutationFn = ApolloReactCommon.MutationFunction<
  Types.DuplicateShareToMutation,
  Types.DuplicateShareToMutationVariables
>

/**
 * __useDuplicateShareToMutation__
 *
 * To run a mutation, you first call `useDuplicateShareToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateShareToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateShareToMutation, { data, loading, error }] = useDuplicateShareToMutation({
 *   variables: {
 *      sourceShareIdentifier: // value for 'sourceShareIdentifier'
 *      sourceVersionIdentifier: // value for 'sourceVersionIdentifier'
 *      targetWorkspaceIdentifier: // value for 'targetWorkspaceIdentifier'
 *      targetProjectIdentifier: // value for 'targetProjectIdentifier'
 *      targetCollectionIdentifier: // value for 'targetCollectionIdentifier'
 *   },
 * });
 */
export function useDuplicateShareToMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DuplicateShareToMutation,
    Types.DuplicateShareToMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DuplicateShareToMutation,
    Types.DuplicateShareToMutationVariables
  >(DuplicateShareToDocument, options)
}
export type DuplicateShareToMutationHookResult = ReturnType<
  typeof useDuplicateShareToMutation
>
export type DuplicateShareToMutationResult =
  ApolloReactCommon.MutationResult<Types.DuplicateShareToMutation>
export type DuplicateShareToMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DuplicateShareToMutation,
    Types.DuplicateShareToMutationVariables
  >
export const PublishShareDocument = /*#__PURE__*/ gql`
  mutation publishShare(
    $shareIdentifier: UUID!
    $publicCommentsEnabled: Boolean!
    $publicInspectEnabled: Boolean!
  ) {
    publishShare(
      shareIdentifier: $shareIdentifier
      publicInspectEnabled: $publicInspectEnabled
      publicCommentsEnabled: $publicCommentsEnabled
    ) {
      publication {
        share {
          identifier
          ...SharePublicPermissions
        }
      }
    }
  }
  ${SharePublicPermissionsFragmentDoc}
`
export type PublishShareMutationFn = ApolloReactCommon.MutationFunction<
  Types.PublishShareMutation,
  Types.PublishShareMutationVariables
>

/**
 * __usePublishShareMutation__
 *
 * To run a mutation, you first call `usePublishShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishShareMutation, { data, loading, error }] = usePublishShareMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      publicCommentsEnabled: // value for 'publicCommentsEnabled'
 *      publicInspectEnabled: // value for 'publicInspectEnabled'
 *   },
 * });
 */
export function usePublishShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.PublishShareMutation,
    Types.PublishShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.PublishShareMutation,
    Types.PublishShareMutationVariables
  >(PublishShareDocument, options)
}
export type PublishShareMutationHookResult = ReturnType<
  typeof usePublishShareMutation
>
export type PublishShareMutationResult =
  ApolloReactCommon.MutationResult<Types.PublishShareMutation>
export type PublishShareMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.PublishShareMutation,
  Types.PublishShareMutationVariables
>
export const UnpublishShareDocument = /*#__PURE__*/ gql`
  mutation unpublishShare(
    $shareIdentifier: UUID!
    $publicAccessLevel: PublicAccessLevel!
    $publicCommentsEnabled: Boolean!
    $publicInspectEnabled: Boolean!
  ) {
    unpublishShare(
      shareIdentifier: $shareIdentifier
      publicInspectEnabled: $publicInspectEnabled
      publicCommentsEnabled: $publicCommentsEnabled
      publicAccessLevel: $publicAccessLevel
    ) {
      share {
        identifier
        ...SharePublicPermissions
      }
    }
  }
  ${SharePublicPermissionsFragmentDoc}
`
export type UnpublishShareMutationFn = ApolloReactCommon.MutationFunction<
  Types.UnpublishShareMutation,
  Types.UnpublishShareMutationVariables
>

/**
 * __useUnpublishShareMutation__
 *
 * To run a mutation, you first call `useUnpublishShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishShareMutation, { data, loading, error }] = useUnpublishShareMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      publicAccessLevel: // value for 'publicAccessLevel'
 *      publicCommentsEnabled: // value for 'publicCommentsEnabled'
 *      publicInspectEnabled: // value for 'publicInspectEnabled'
 *   },
 * });
 */
export function useUnpublishShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnpublishShareMutation,
    Types.UnpublishShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnpublishShareMutation,
    Types.UnpublishShareMutationVariables
  >(UnpublishShareDocument, options)
}
export type UnpublishShareMutationHookResult = ReturnType<
  typeof useUnpublishShareMutation
>
export type UnpublishShareMutationResult =
  ApolloReactCommon.MutationResult<Types.UnpublishShareMutation>
export type UnpublishShareMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UnpublishShareMutation,
    Types.UnpublishShareMutationVariables
  >
export const ReportShareDocument = /*#__PURE__*/ gql`
  mutation reportShare($identifier: UUID!, $reason: ShareReportReason!) {
    reportShare(identifier: $identifier, reason: $reason) {
      reported
    }
  }
`
export type ReportShareMutationFn = ApolloReactCommon.MutationFunction<
  Types.ReportShareMutation,
  Types.ReportShareMutationVariables
>

/**
 * __useReportShareMutation__
 *
 * To run a mutation, you first call `useReportShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportShareMutation, { data, loading, error }] = useReportShareMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useReportShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ReportShareMutation,
    Types.ReportShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ReportShareMutation,
    Types.ReportShareMutationVariables
  >(ReportShareDocument, options)
}
export type ReportShareMutationHookResult = ReturnType<
  typeof useReportShareMutation
>
export type ReportShareMutationResult =
  ApolloReactCommon.MutationResult<Types.ReportShareMutation>
export type ReportShareMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ReportShareMutation,
  Types.ReportShareMutationVariables
>
export const ConsolidateAutoVersionDocument = /*#__PURE__*/ gql`
  mutation consolidateAutoVersion($shareIdentifier: UUID4!) @capacitorapi {
    createCollaborativeVersion(shareIdentifier: $shareIdentifier, kind: AUTO) {
      id
      status
    }
  }
`
export type ConsolidateAutoVersionMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.ConsolidateAutoVersionMutation,
    Types.ConsolidateAutoVersionMutationVariables
  >

/**
 * __useConsolidateAutoVersionMutation__
 *
 * To run a mutation, you first call `useConsolidateAutoVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateAutoVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateAutoVersionMutation, { data, loading, error }] = useConsolidateAutoVersionMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useConsolidateAutoVersionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ConsolidateAutoVersionMutation,
    Types.ConsolidateAutoVersionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ConsolidateAutoVersionMutation,
    Types.ConsolidateAutoVersionMutationVariables
  >(ConsolidateAutoVersionDocument, options)
}
export type ConsolidateAutoVersionMutationHookResult = ReturnType<
  typeof useConsolidateAutoVersionMutation
>
export type ConsolidateAutoVersionMutationResult =
  ApolloReactCommon.MutationResult<Types.ConsolidateAutoVersionMutation>
export type ConsolidateAutoVersionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ConsolidateAutoVersionMutation,
    Types.ConsolidateAutoVersionMutationVariables
  >
export const PinShareDocument = /*#__PURE__*/ gql`
  mutation pinShare($shareIdentifier: UUID!) {
    pinShare(input: { shareIdentifier: $shareIdentifier }) {
      share {
        identifier
        pinnedByCurrentUserAt
      }
    }
  }
`
export type PinShareMutationFn = ApolloReactCommon.MutationFunction<
  Types.PinShareMutation,
  Types.PinShareMutationVariables
>

/**
 * __usePinShareMutation__
 *
 * To run a mutation, you first call `usePinShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinShareMutation, { data, loading, error }] = usePinShareMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function usePinShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.PinShareMutation,
    Types.PinShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.PinShareMutation,
    Types.PinShareMutationVariables
  >(PinShareDocument, options)
}
export type PinShareMutationHookResult = ReturnType<typeof usePinShareMutation>
export type PinShareMutationResult =
  ApolloReactCommon.MutationResult<Types.PinShareMutation>
export type PinShareMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.PinShareMutation,
  Types.PinShareMutationVariables
>
export const UnpinShareDocument = /*#__PURE__*/ gql`
  mutation unpinShare($shareIdentifier: UUID!) {
    unpinShare(input: { shareIdentifier: $shareIdentifier }) {
      share {
        identifier
        pinnedByCurrentUserAt
      }
    }
  }
`
export type UnpinShareMutationFn = ApolloReactCommon.MutationFunction<
  Types.UnpinShareMutation,
  Types.UnpinShareMutationVariables
>

/**
 * __useUnpinShareMutation__
 *
 * To run a mutation, you first call `useUnpinShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinShareMutation, { data, loading, error }] = useUnpinShareMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useUnpinShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnpinShareMutation,
    Types.UnpinShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnpinShareMutation,
    Types.UnpinShareMutationVariables
  >(UnpinShareDocument, options)
}
export type UnpinShareMutationHookResult = ReturnType<
  typeof useUnpinShareMutation
>
export type UnpinShareMutationResult =
  ApolloReactCommon.MutationResult<Types.UnpinShareMutation>
export type UnpinShareMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.UnpinShareMutation,
  Types.UnpinShareMutationVariables
>
export const GetShareDocument = /*#__PURE__*/ gql`
  query getShare($shortId: ShortId!) {
    share(shortId: $shortId) {
      ...ShareInfo
    }
  }
  ${ShareInfoFragmentDoc}
`

/**
 * __useGetShareQuery__
 *
 * To run a query within a React component, call `useGetShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareQuery({
 *   variables: {
 *      shortId: // value for 'shortId'
 *   },
 * });
 */
export function useGetShareQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareQuery,
    Types.GetShareQueryVariables
  > &
    (
      | { variables: Types.GetShareQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareQuery,
    Types.GetShareQueryVariables
  >(GetShareDocument, options)
}
export function useGetShareLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareQuery,
    Types.GetShareQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareQuery,
    Types.GetShareQueryVariables
  >(GetShareDocument, options)
}

export type GetShareQueryHookResult = ReturnType<typeof useGetShareQuery>
export type GetShareLazyQueryHookResult = ReturnType<
  typeof useGetShareLazyQuery
>
export type GetShareQueryResult = ApolloReactCommon.QueryResult<
  Types.GetShareQuery,
  Types.GetShareQueryVariables
>
export const GetShareDropdownOptionsDocument = /*#__PURE__*/ gql`
  query getShareDropdownOptions(
    $shareIdentifier: ShortId!
    $versionShortId: ShortId!
  ) {
    share(shortId: $shareIdentifier) {
      ...ShareDropdownOptions
    }
  }
  ${ShareDropdownOptionsFragmentDoc}
`

/**
 * __useGetShareDropdownOptionsQuery__
 *
 * To run a query within a React component, call `useGetShareDropdownOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareDropdownOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareDropdownOptionsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetShareDropdownOptionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareDropdownOptionsQuery,
    Types.GetShareDropdownOptionsQueryVariables
  > &
    (
      | {
          variables: Types.GetShareDropdownOptionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareDropdownOptionsQuery,
    Types.GetShareDropdownOptionsQueryVariables
  >(GetShareDropdownOptionsDocument, options)
}
export function useGetShareDropdownOptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareDropdownOptionsQuery,
    Types.GetShareDropdownOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareDropdownOptionsQuery,
    Types.GetShareDropdownOptionsQueryVariables
  >(GetShareDropdownOptionsDocument, options)
}

export type GetShareDropdownOptionsQueryHookResult = ReturnType<
  typeof useGetShareDropdownOptionsQuery
>
export type GetShareDropdownOptionsLazyQueryHookResult = ReturnType<
  typeof useGetShareDropdownOptionsLazyQuery
>
export type GetShareDropdownOptionsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetShareDropdownOptionsQuery,
  Types.GetShareDropdownOptionsQueryVariables
>
export const GetShareWorkspaceDocument = /*#__PURE__*/ gql`
  query getShareWorkspace($shareIdentifier: ShortId!) {
    share(shortId: $shareIdentifier) {
      ...ShareWorkspace
    }
  }
  ${ShareWorkspaceFragmentDoc}
`

/**
 * __useGetShareWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetShareWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareWorkspaceQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetShareWorkspaceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareWorkspaceQuery,
    Types.GetShareWorkspaceQueryVariables
  > &
    (
      | { variables: Types.GetShareWorkspaceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareWorkspaceQuery,
    Types.GetShareWorkspaceQueryVariables
  >(GetShareWorkspaceDocument, options)
}
export function useGetShareWorkspaceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareWorkspaceQuery,
    Types.GetShareWorkspaceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareWorkspaceQuery,
    Types.GetShareWorkspaceQueryVariables
  >(GetShareWorkspaceDocument, options)
}

export type GetShareWorkspaceQueryHookResult = ReturnType<
  typeof useGetShareWorkspaceQuery
>
export type GetShareWorkspaceLazyQueryHookResult = ReturnType<
  typeof useGetShareWorkspaceLazyQuery
>
export type GetShareWorkspaceQueryResult = ApolloReactCommon.QueryResult<
  Types.GetShareWorkspaceQuery,
  Types.GetShareWorkspaceQueryVariables
>
export const GetSharesDocument = /*#__PURE__*/ gql`
  query getShares(
    $identifier: UUID!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
    $archived: ShareArchivedStatus
  ) {
    workspace(identifier: $identifier) {
      identifier
      status
      shares(
        after: $after
        search: $search
        sortOrder: $sortOrder
        archived: $archived
      ) {
        entries {
          ...ShareListItem
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ShareListItemFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetSharesQuery__
 *
 * To run a query within a React component, call `useGetSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useGetSharesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharesQuery,
    Types.GetSharesQueryVariables
  > &
    (
      | { variables: Types.GetSharesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharesQuery,
    Types.GetSharesQueryVariables
  >(GetSharesDocument, options)
}
export function useGetSharesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharesQuery,
    Types.GetSharesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharesQuery,
    Types.GetSharesQueryVariables
  >(GetSharesDocument, options)
}

export type GetSharesQueryHookResult = ReturnType<typeof useGetSharesQuery>
export type GetSharesLazyQueryHookResult = ReturnType<
  typeof useGetSharesLazyQuery
>
export type GetSharesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetSharesQuery,
  Types.GetSharesQueryVariables
>
export const GetSharesLibrariesDocument = /*#__PURE__*/ gql`
  query getSharesLibraries(
    $identifier: UUID!
    $after: String
    $search: SharesSearchParams
  ) {
    workspace(identifier: $identifier) {
      identifier
      status
      shares(after: $after, search: $search) {
        entries {
          ...ShareLibraryListItem
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ShareLibraryListItemFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetSharesLibrariesQuery__
 *
 * To run a query within a React component, call `useGetSharesLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharesLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharesLibrariesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSharesLibrariesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharesLibrariesQuery,
    Types.GetSharesLibrariesQueryVariables
  > &
    (
      | { variables: Types.GetSharesLibrariesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharesLibrariesQuery,
    Types.GetSharesLibrariesQueryVariables
  >(GetSharesLibrariesDocument, options)
}
export function useGetSharesLibrariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharesLibrariesQuery,
    Types.GetSharesLibrariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharesLibrariesQuery,
    Types.GetSharesLibrariesQueryVariables
  >(GetSharesLibrariesDocument, options)
}

export type GetSharesLibrariesQueryHookResult = ReturnType<
  typeof useGetSharesLibrariesQuery
>
export type GetSharesLibrariesLazyQueryHookResult = ReturnType<
  typeof useGetSharesLibrariesLazyQuery
>
export type GetSharesLibrariesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetSharesLibrariesQuery,
  Types.GetSharesLibrariesQueryVariables
>
export const GetSharesDropdownOptionsDocument = /*#__PURE__*/ gql`
  query getSharesDropdownOptions(
    $identifier: UUID!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
  ) {
    workspace(identifier: $identifier) {
      identifier
      shares(after: $after, search: $search, sortOrder: $sortOrder) {
        entries {
          ...ShareDropdownOptionsPreload
        }
      }
    }
  }
  ${ShareDropdownOptionsPreloadFragmentDoc}
`

/**
 * __useGetSharesDropdownOptionsQuery__
 *
 * To run a query within a React component, call `useGetSharesDropdownOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharesDropdownOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharesDropdownOptionsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetSharesDropdownOptionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharesDropdownOptionsQuery,
    Types.GetSharesDropdownOptionsQueryVariables
  > &
    (
      | {
          variables: Types.GetSharesDropdownOptionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharesDropdownOptionsQuery,
    Types.GetSharesDropdownOptionsQueryVariables
  >(GetSharesDropdownOptionsDocument, options)
}
export function useGetSharesDropdownOptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharesDropdownOptionsQuery,
    Types.GetSharesDropdownOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharesDropdownOptionsQuery,
    Types.GetSharesDropdownOptionsQueryVariables
  >(GetSharesDropdownOptionsDocument, options)
}

export type GetSharesDropdownOptionsQueryHookResult = ReturnType<
  typeof useGetSharesDropdownOptionsQuery
>
export type GetSharesDropdownOptionsLazyQueryHookResult = ReturnType<
  typeof useGetSharesDropdownOptionsLazyQuery
>
export type GetSharesDropdownOptionsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetSharesDropdownOptionsQuery,
  Types.GetSharesDropdownOptionsQueryVariables
>
export const GetShareUserAccessLevelDocument = /*#__PURE__*/ gql`
  query getShareUserAccessLevel($identifier: ShortId!) {
    share(shortId: $identifier) {
      identifier
      ...ShareUserAccessLevel
    }
  }
  ${ShareUserAccessLevelFragmentDoc}
`

/**
 * __useGetShareUserAccessLevelQuery__
 *
 * To run a query within a React component, call `useGetShareUserAccessLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareUserAccessLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareUserAccessLevelQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetShareUserAccessLevelQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareUserAccessLevelQuery,
    Types.GetShareUserAccessLevelQueryVariables
  > &
    (
      | {
          variables: Types.GetShareUserAccessLevelQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareUserAccessLevelQuery,
    Types.GetShareUserAccessLevelQueryVariables
  >(GetShareUserAccessLevelDocument, options)
}
export function useGetShareUserAccessLevelLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareUserAccessLevelQuery,
    Types.GetShareUserAccessLevelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareUserAccessLevelQuery,
    Types.GetShareUserAccessLevelQueryVariables
  >(GetShareUserAccessLevelDocument, options)
}

export type GetShareUserAccessLevelQueryHookResult = ReturnType<
  typeof useGetShareUserAccessLevelQuery
>
export type GetShareUserAccessLevelLazyQueryHookResult = ReturnType<
  typeof useGetShareUserAccessLevelLazyQuery
>
export type GetShareUserAccessLevelQueryResult = ApolloReactCommon.QueryResult<
  Types.GetShareUserAccessLevelQuery,
  Types.GetShareUserAccessLevelQueryVariables
>
export const GetProjectSharesDocument = /*#__PURE__*/ gql`
  query getProjectShares(
    $shortId: ShortId!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
  ) {
    project(shortId: $shortId) {
      ...Project
      workspaceAccessLevel
      shares(after: $after, searchParams: $search, sortOrder: $sortOrder) {
        entries {
          ...ShareListItem
          collection {
            identifier
            name
          }
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ProjectFragmentDoc}
  ${ShareListItemFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetProjectSharesQuery__
 *
 * To run a query within a React component, call `useGetProjectSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSharesQuery({
 *   variables: {
 *      shortId: // value for 'shortId'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetProjectSharesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectSharesQuery,
    Types.GetProjectSharesQueryVariables
  > &
    (
      | { variables: Types.GetProjectSharesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectSharesQuery,
    Types.GetProjectSharesQueryVariables
  >(GetProjectSharesDocument, options)
}
export function useGetProjectSharesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectSharesQuery,
    Types.GetProjectSharesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectSharesQuery,
    Types.GetProjectSharesQueryVariables
  >(GetProjectSharesDocument, options)
}

export type GetProjectSharesQueryHookResult = ReturnType<
  typeof useGetProjectSharesQuery
>
export type GetProjectSharesLazyQueryHookResult = ReturnType<
  typeof useGetProjectSharesLazyQuery
>
export type GetProjectSharesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetProjectSharesQuery,
  Types.GetProjectSharesQueryVariables
>
export const GetProjectSharesDropdownOptionsDocument = /*#__PURE__*/ gql`
  query getProjectSharesDropdownOptions(
    $shortId: ShortId!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
  ) {
    project(shortId: $shortId) {
      shortId
      identifier
      shares(after: $after, searchParams: $search, sortOrder: $sortOrder) {
        entries {
          ...ShareDropdownOptionsPreload
        }
      }
    }
  }
  ${ShareDropdownOptionsPreloadFragmentDoc}
`

/**
 * __useGetProjectSharesDropdownOptionsQuery__
 *
 * To run a query within a React component, call `useGetProjectSharesDropdownOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSharesDropdownOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSharesDropdownOptionsQuery({
 *   variables: {
 *      shortId: // value for 'shortId'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetProjectSharesDropdownOptionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectSharesDropdownOptionsQuery,
    Types.GetProjectSharesDropdownOptionsQueryVariables
  > &
    (
      | {
          variables: Types.GetProjectSharesDropdownOptionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectSharesDropdownOptionsQuery,
    Types.GetProjectSharesDropdownOptionsQueryVariables
  >(GetProjectSharesDropdownOptionsDocument, options)
}
export function useGetProjectSharesDropdownOptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectSharesDropdownOptionsQuery,
    Types.GetProjectSharesDropdownOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectSharesDropdownOptionsQuery,
    Types.GetProjectSharesDropdownOptionsQueryVariables
  >(GetProjectSharesDropdownOptionsDocument, options)
}

export type GetProjectSharesDropdownOptionsQueryHookResult = ReturnType<
  typeof useGetProjectSharesDropdownOptionsQuery
>
export type GetProjectSharesDropdownOptionsLazyQueryHookResult = ReturnType<
  typeof useGetProjectSharesDropdownOptionsLazyQuery
>
export type GetProjectSharesDropdownOptionsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetProjectSharesDropdownOptionsQuery,
    Types.GetProjectSharesDropdownOptionsQueryVariables
  >
export const GetPersonalWorkspaceSharesCountDocument = /*#__PURE__*/ gql`
  query getPersonalWorkspaceSharesCount {
    me {
      identifier
      personalWorkspace {
        identifier
        allShares: shares {
          meta {
            totalCount
          }
        }
        libraries: shares(search: { filters: [LIBRARY] }) {
          meta {
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useGetPersonalWorkspaceSharesCountQuery__
 *
 * To run a query within a React component, call `useGetPersonalWorkspaceSharesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalWorkspaceSharesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalWorkspaceSharesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonalWorkspaceSharesCountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetPersonalWorkspaceSharesCountQuery,
    Types.GetPersonalWorkspaceSharesCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPersonalWorkspaceSharesCountQuery,
    Types.GetPersonalWorkspaceSharesCountQueryVariables
  >(GetPersonalWorkspaceSharesCountDocument, options)
}
export function useGetPersonalWorkspaceSharesCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPersonalWorkspaceSharesCountQuery,
    Types.GetPersonalWorkspaceSharesCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPersonalWorkspaceSharesCountQuery,
    Types.GetPersonalWorkspaceSharesCountQueryVariables
  >(GetPersonalWorkspaceSharesCountDocument, options)
}

export type GetPersonalWorkspaceSharesCountQueryHookResult = ReturnType<
  typeof useGetPersonalWorkspaceSharesCountQuery
>
export type GetPersonalWorkspaceSharesCountLazyQueryHookResult = ReturnType<
  typeof useGetPersonalWorkspaceSharesCountLazyQuery
>
export type GetPersonalWorkspaceSharesCountQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetPersonalWorkspaceSharesCountQuery,
    Types.GetPersonalWorkspaceSharesCountQueryVariables
  >
export const GetLibrariesDocument = /*#__PURE__*/ gql`
  query getLibraries($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      libraries: shares(search: { filters: [LIBRARY] }) {
        entries {
          identifier
          name
          version(preferredState: PROCESSED) {
            shortId
            document {
              previewFile {
                identifier
                url
              }
            }
          }
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetLibrariesQuery__
 *
 * To run a query within a React component, call `useGetLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibrariesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetLibrariesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetLibrariesQuery,
    Types.GetLibrariesQueryVariables
  > &
    (
      | { variables: Types.GetLibrariesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetLibrariesQuery,
    Types.GetLibrariesQueryVariables
  >(GetLibrariesDocument, options)
}
export function useGetLibrariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetLibrariesQuery,
    Types.GetLibrariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetLibrariesQuery,
    Types.GetLibrariesQueryVariables
  >(GetLibrariesDocument, options)
}

export type GetLibrariesQueryHookResult = ReturnType<
  typeof useGetLibrariesQuery
>
export type GetLibrariesLazyQueryHookResult = ReturnType<
  typeof useGetLibrariesLazyQuery
>
export type GetLibrariesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetLibrariesQuery,
  Types.GetLibrariesQueryVariables
>
export const GetWorkspaceSharesCountDocument = /*#__PURE__*/ gql`
  query getWorkspaceSharesCount($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      shares {
        meta {
          totalCount
        }
      }
    }
  }
`

/**
 * __useGetWorkspaceSharesCountQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSharesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSharesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSharesCountQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceSharesCountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSharesCountQuery,
    Types.GetWorkspaceSharesCountQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceSharesCountQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSharesCountQuery,
    Types.GetWorkspaceSharesCountQueryVariables
  >(GetWorkspaceSharesCountDocument, options)
}
export function useGetWorkspaceSharesCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSharesCountQuery,
    Types.GetWorkspaceSharesCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSharesCountQuery,
    Types.GetWorkspaceSharesCountQueryVariables
  >(GetWorkspaceSharesCountDocument, options)
}

export type GetWorkspaceSharesCountQueryHookResult = ReturnType<
  typeof useGetWorkspaceSharesCountQuery
>
export type GetWorkspaceSharesCountLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSharesCountLazyQuery
>
export type GetWorkspaceSharesCountQueryResult = ApolloReactCommon.QueryResult<
  Types.GetWorkspaceSharesCountQuery,
  Types.GetWorkspaceSharesCountQueryVariables
>
export const GetDocumentListSettingsDocument = /*#__PURE__*/ gql`
  query getDocumentListSettings {
    documentsLayout @client
    showDocumentsInProjects @client
    showArchivedDocuments @client
  }
`

/**
 * __useGetDocumentListSettingsQuery__
 *
 * To run a query within a React component, call `useGetDocumentListSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentListSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentListSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocumentListSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetDocumentListSettingsQuery,
    Types.GetDocumentListSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDocumentListSettingsQuery,
    Types.GetDocumentListSettingsQueryVariables
  >(GetDocumentListSettingsDocument, options)
}
export function useGetDocumentListSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDocumentListSettingsQuery,
    Types.GetDocumentListSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDocumentListSettingsQuery,
    Types.GetDocumentListSettingsQueryVariables
  >(GetDocumentListSettingsDocument, options)
}

export type GetDocumentListSettingsQueryHookResult = ReturnType<
  typeof useGetDocumentListSettingsQuery
>
export type GetDocumentListSettingsLazyQueryHookResult = ReturnType<
  typeof useGetDocumentListSettingsLazyQuery
>
export type GetDocumentListSettingsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetDocumentListSettingsQuery,
  Types.GetDocumentListSettingsQueryVariables
>
export const ShareForDocumentWithUuidDocument = /*#__PURE__*/ gql`
  query shareForDocumentWithUuid($name: String!, $uuid: String!) {
    shareForDocumentWithUuid(uuid: $uuid, name: $name) {
      identifier
      name
      version {
        identifier
        shortId
        document {
          identifier
        }
      }
    }
  }
`

/**
 * __useShareForDocumentWithUuidQuery__
 *
 * To run a query within a React component, call `useShareForDocumentWithUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareForDocumentWithUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareForDocumentWithUuidQuery({
 *   variables: {
 *      name: // value for 'name'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useShareForDocumentWithUuidQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.ShareForDocumentWithUuidQuery,
    Types.ShareForDocumentWithUuidQueryVariables
  > &
    (
      | {
          variables: Types.ShareForDocumentWithUuidQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.ShareForDocumentWithUuidQuery,
    Types.ShareForDocumentWithUuidQueryVariables
  >(ShareForDocumentWithUuidDocument, options)
}
export function useShareForDocumentWithUuidLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ShareForDocumentWithUuidQuery,
    Types.ShareForDocumentWithUuidQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.ShareForDocumentWithUuidQuery,
    Types.ShareForDocumentWithUuidQueryVariables
  >(ShareForDocumentWithUuidDocument, options)
}

export type ShareForDocumentWithUuidQueryHookResult = ReturnType<
  typeof useShareForDocumentWithUuidQuery
>
export type ShareForDocumentWithUuidLazyQueryHookResult = ReturnType<
  typeof useShareForDocumentWithUuidLazyQuery
>
export type ShareForDocumentWithUuidQueryResult = ApolloReactCommon.QueryResult<
  Types.ShareForDocumentWithUuidQuery,
  Types.ShareForDocumentWithUuidQueryVariables
>
export const GetSymbolMasterDocumentDocument = /*#__PURE__*/ gql`
  query getSymbolMasterDocument(
    $name: String!
    $uuid: String!
    $frameUUID: String!
  ) {
    shareForDocumentWithUuid(uuid: $uuid, name: $name) {
      identifier
      version {
        identifier
        shortId
        document {
          identifier
          frame(uuid: $frameUUID) {
            identifier
            uuid
            files(type: FULL) {
              identifier
              url
              thumbnails {
                type
                url
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetSymbolMasterDocumentQuery__
 *
 * To run a query within a React component, call `useGetSymbolMasterDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSymbolMasterDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSymbolMasterDocumentQuery({
 *   variables: {
 *      name: // value for 'name'
 *      uuid: // value for 'uuid'
 *      frameUUID: // value for 'frameUUID'
 *   },
 * });
 */
export function useGetSymbolMasterDocumentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSymbolMasterDocumentQuery,
    Types.GetSymbolMasterDocumentQueryVariables
  > &
    (
      | {
          variables: Types.GetSymbolMasterDocumentQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSymbolMasterDocumentQuery,
    Types.GetSymbolMasterDocumentQueryVariables
  >(GetSymbolMasterDocumentDocument, options)
}
export function useGetSymbolMasterDocumentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSymbolMasterDocumentQuery,
    Types.GetSymbolMasterDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSymbolMasterDocumentQuery,
    Types.GetSymbolMasterDocumentQueryVariables
  >(GetSymbolMasterDocumentDocument, options)
}

export type GetSymbolMasterDocumentQueryHookResult = ReturnType<
  typeof useGetSymbolMasterDocumentQuery
>
export type GetSymbolMasterDocumentLazyQueryHookResult = ReturnType<
  typeof useGetSymbolMasterDocumentLazyQuery
>
export type GetSymbolMasterDocumentQueryResult = ApolloReactCommon.QueryResult<
  Types.GetSymbolMasterDocumentQuery,
  Types.GetSymbolMasterDocumentQueryVariables
>
export const GetShareSidebarDocument = /*#__PURE__*/ gql`
  query getShareSidebar($identifier: UUID, $versionShortId: ShortId) {
    share(id: $identifier) {
      ...ShareAbout
    }
  }
  ${ShareAboutFragmentDoc}
`

/**
 * __useGetShareSidebarQuery__
 *
 * To run a query within a React component, call `useGetShareSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareSidebarQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetShareSidebarQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetShareSidebarQuery,
    Types.GetShareSidebarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareSidebarQuery,
    Types.GetShareSidebarQueryVariables
  >(GetShareSidebarDocument, options)
}
export function useGetShareSidebarLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareSidebarQuery,
    Types.GetShareSidebarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareSidebarQuery,
    Types.GetShareSidebarQueryVariables
  >(GetShareSidebarDocument, options)
}

export type GetShareSidebarQueryHookResult = ReturnType<
  typeof useGetShareSidebarQuery
>
export type GetShareSidebarLazyQueryHookResult = ReturnType<
  typeof useGetShareSidebarLazyQuery
>
export type GetShareSidebarQueryResult = ApolloReactCommon.QueryResult<
  Types.GetShareSidebarQuery,
  Types.GetShareSidebarQueryVariables
>
export const GetShareDesignTokenExportDocument = /*#__PURE__*/ gql`
  query getShareDesignTokenExport(
    $shareIdentifier: UUID
    $versionShortId: ShortId
    $format: TokenExportFormat!
    $colorFormat: TokenColorFormat
    $tokenTypes: [ExportableComponentType!]
  ) {
    share(id: $shareIdentifier) {
      identifier
      publicTokenExport
      publicTokenExportUrl(
        format: $format
        colorFormat: $colorFormat
        tokenTypes: $tokenTypes
      )
      version(shortId: $versionShortId) {
        identifier
        document {
          identifier
          tokenExport(
            format: $format
            colorFormat: $colorFormat
            tokenTypes: $tokenTypes
          ) {
            data
            downloadUrl
          }
        }
      }
    }
  }
`

/**
 * __useGetShareDesignTokenExportQuery__
 *
 * To run a query within a React component, call `useGetShareDesignTokenExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareDesignTokenExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareDesignTokenExportQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *      format: // value for 'format'
 *      colorFormat: // value for 'colorFormat'
 *      tokenTypes: // value for 'tokenTypes'
 *   },
 * });
 */
export function useGetShareDesignTokenExportQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareDesignTokenExportQuery,
    Types.GetShareDesignTokenExportQueryVariables
  > &
    (
      | {
          variables: Types.GetShareDesignTokenExportQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareDesignTokenExportQuery,
    Types.GetShareDesignTokenExportQueryVariables
  >(GetShareDesignTokenExportDocument, options)
}
export function useGetShareDesignTokenExportLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareDesignTokenExportQuery,
    Types.GetShareDesignTokenExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareDesignTokenExportQuery,
    Types.GetShareDesignTokenExportQueryVariables
  >(GetShareDesignTokenExportDocument, options)
}

export type GetShareDesignTokenExportQueryHookResult = ReturnType<
  typeof useGetShareDesignTokenExportQuery
>
export type GetShareDesignTokenExportLazyQueryHookResult = ReturnType<
  typeof useGetShareDesignTokenExportLazyQuery
>
export type GetShareDesignTokenExportQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetShareDesignTokenExportQuery,
    Types.GetShareDesignTokenExportQueryVariables
  >
export const GetSharePermissionsDocument = /*#__PURE__*/ gql`
  query getSharePermissions($shareIdentifier: ShortId!) {
    share(shortId: $shareIdentifier) {
      ...SharePermissions
    }
  }
  ${SharePermissionsFragmentDoc}
`

/**
 * __useGetSharePermissionsQuery__
 *
 * To run a query within a React component, call `useGetSharePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharePermissionsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetSharePermissionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharePermissionsQuery,
    Types.GetSharePermissionsQueryVariables
  > &
    (
      | { variables: Types.GetSharePermissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharePermissionsQuery,
    Types.GetSharePermissionsQueryVariables
  >(GetSharePermissionsDocument, options)
}
export function useGetSharePermissionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharePermissionsQuery,
    Types.GetSharePermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharePermissionsQuery,
    Types.GetSharePermissionsQueryVariables
  >(GetSharePermissionsDocument, options)
}

export type GetSharePermissionsQueryHookResult = ReturnType<
  typeof useGetSharePermissionsQuery
>
export type GetSharePermissionsLazyQueryHookResult = ReturnType<
  typeof useGetSharePermissionsLazyQuery
>
export type GetSharePermissionsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetSharePermissionsQuery,
  Types.GetSharePermissionsQueryVariables
>
export const GetShareListItemDocument = /*#__PURE__*/ gql`
  query getShareListItem($shareIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      identifier
      ...ShareListItem
    }
  }
  ${ShareListItemFragmentDoc}
`

/**
 * __useGetShareListItemQuery__
 *
 * To run a query within a React component, call `useGetShareListItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareListItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareListItemQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetShareListItemQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareListItemQuery,
    Types.GetShareListItemQueryVariables
  > &
    (
      | { variables: Types.GetShareListItemQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareListItemQuery,
    Types.GetShareListItemQueryVariables
  >(GetShareListItemDocument, options)
}
export function useGetShareListItemLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareListItemQuery,
    Types.GetShareListItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareListItemQuery,
    Types.GetShareListItemQueryVariables
  >(GetShareListItemDocument, options)
}

export type GetShareListItemQueryHookResult = ReturnType<
  typeof useGetShareListItemQuery
>
export type GetShareListItemLazyQueryHookResult = ReturnType<
  typeof useGetShareListItemLazyQuery
>
export type GetShareListItemQueryResult = ApolloReactCommon.QueryResult<
  Types.GetShareListItemQuery,
  Types.GetShareListItemQueryVariables
>
export const GetHasPendingPatchesDocument = /*#__PURE__*/ gql`
  query getHasPendingPatches($shareIdentifier: UUID4!) @capacitorapi {
    collaborativeEditingSession(shareIdentifier: $shareIdentifier) {
      hasPendingPatches
    }
  }
`

/**
 * __useGetHasPendingPatchesQuery__
 *
 * To run a query within a React component, call `useGetHasPendingPatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasPendingPatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasPendingPatchesQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetHasPendingPatchesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetHasPendingPatchesQuery,
    Types.GetHasPendingPatchesQueryVariables
  > &
    (
      | { variables: Types.GetHasPendingPatchesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetHasPendingPatchesQuery,
    Types.GetHasPendingPatchesQueryVariables
  >(GetHasPendingPatchesDocument, options)
}
export function useGetHasPendingPatchesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetHasPendingPatchesQuery,
    Types.GetHasPendingPatchesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetHasPendingPatchesQuery,
    Types.GetHasPendingPatchesQueryVariables
  >(GetHasPendingPatchesDocument, options)
}

export type GetHasPendingPatchesQueryHookResult = ReturnType<
  typeof useGetHasPendingPatchesQuery
>
export type GetHasPendingPatchesLazyQueryHookResult = ReturnType<
  typeof useGetHasPendingPatchesLazyQuery
>
export type GetHasPendingPatchesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetHasPendingPatchesQuery,
  Types.GetHasPendingPatchesQueryVariables
>
export const GetLicenseAgreementDocument = /*#__PURE__*/ gql`
  query getLicenseAgreement($shareIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      identifier
      licenseAgreement {
        body
      }
    }
  }
`

/**
 * __useGetLicenseAgreementQuery__
 *
 * To run a query within a React component, call `useGetLicenseAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLicenseAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLicenseAgreementQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetLicenseAgreementQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetLicenseAgreementQuery,
    Types.GetLicenseAgreementQueryVariables
  > &
    (
      | { variables: Types.GetLicenseAgreementQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetLicenseAgreementQuery,
    Types.GetLicenseAgreementQueryVariables
  >(GetLicenseAgreementDocument, options)
}
export function useGetLicenseAgreementLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetLicenseAgreementQuery,
    Types.GetLicenseAgreementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetLicenseAgreementQuery,
    Types.GetLicenseAgreementQueryVariables
  >(GetLicenseAgreementDocument, options)
}

export type GetLicenseAgreementQueryHookResult = ReturnType<
  typeof useGetLicenseAgreementQuery
>
export type GetLicenseAgreementLazyQueryHookResult = ReturnType<
  typeof useGetLicenseAgreementLazyQuery
>
export type GetLicenseAgreementQueryResult = ApolloReactCommon.QueryResult<
  Types.GetLicenseAgreementQuery,
  Types.GetLicenseAgreementQueryVariables
>
export const GetSharesForDocumentSelectionDocument = /*#__PURE__*/ gql`
  query getSharesForDocumentSelection(
    $identifier: UUID!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
  ) {
    workspace(identifier: $identifier) {
      identifier
      status
      shares(after: $after, search: $search, sortOrder: $sortOrder) {
        entries {
          ...ShareWithPublication
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ShareWithPublicationFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetSharesForDocumentSelectionQuery__
 *
 * To run a query within a React component, call `useGetSharesForDocumentSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharesForDocumentSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharesForDocumentSelectionQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetSharesForDocumentSelectionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharesForDocumentSelectionQuery,
    Types.GetSharesForDocumentSelectionQueryVariables
  > &
    (
      | {
          variables: Types.GetSharesForDocumentSelectionQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharesForDocumentSelectionQuery,
    Types.GetSharesForDocumentSelectionQueryVariables
  >(GetSharesForDocumentSelectionDocument, options)
}
export function useGetSharesForDocumentSelectionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharesForDocumentSelectionQuery,
    Types.GetSharesForDocumentSelectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharesForDocumentSelectionQuery,
    Types.GetSharesForDocumentSelectionQueryVariables
  >(GetSharesForDocumentSelectionDocument, options)
}

export type GetSharesForDocumentSelectionQueryHookResult = ReturnType<
  typeof useGetSharesForDocumentSelectionQuery
>
export type GetSharesForDocumentSelectionLazyQueryHookResult = ReturnType<
  typeof useGetSharesForDocumentSelectionLazyQuery
>
export type GetSharesForDocumentSelectionQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetSharesForDocumentSelectionQuery,
    Types.GetSharesForDocumentSelectionQueryVariables
  >
export const EmptiedWorkspaceTrashDocument = /*#__PURE__*/ gql`
  subscription emptiedWorkspaceTrash {
    emptiedWorkspaceTrash {
      workspaceIdentifier
    }
  }
`

/**
 * __useEmptiedWorkspaceTrashSubscription__
 *
 * To run a query within a React component, call `useEmptiedWorkspaceTrashSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEmptiedWorkspaceTrashSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmptiedWorkspaceTrashSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEmptiedWorkspaceTrashSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.EmptiedWorkspaceTrashSubscription,
    Types.EmptiedWorkspaceTrashSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.EmptiedWorkspaceTrashSubscription,
    Types.EmptiedWorkspaceTrashSubscriptionVariables
  >(EmptiedWorkspaceTrashDocument, options)
}
export type EmptiedWorkspaceTrashSubscriptionHookResult = ReturnType<
  typeof useEmptiedWorkspaceTrashSubscription
>
export type EmptiedWorkspaceTrashSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.EmptiedWorkspaceTrashSubscription>
export const ShareChangedDocument = /*#__PURE__*/ gql`
  subscription shareChanged {
    shareChanged {
      shareIdentifier
      workspace {
        identifier
      }
      ... on ShareDeletedEvent {
        share {
          ...SubscriptionShare
        }
      }
      ... on ShareRestoredEvent {
        share {
          ...SubscriptionShare
        }
      }
      ... on ShareProjectChangedEvent {
        share {
          ...SubscriptionShare
        }
      }
    }
  }
  ${SubscriptionShareFragmentDoc}
`

/**
 * __useShareChangedSubscription__
 *
 * To run a query within a React component, call `useShareChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShareChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useShareChangedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ShareChangedSubscription,
    Types.ShareChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ShareChangedSubscription,
    Types.ShareChangedSubscriptionVariables
  >(ShareChangedDocument, options)
}
export type ShareChangedSubscriptionHookResult = ReturnType<
  typeof useShareChangedSubscription
>
export type ShareChangedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.ShareChangedSubscription>
export const ShareMembershipChangedDocument = /*#__PURE__*/ gql`
  subscription shareMembershipChanged {
    shareMembershipChanged {
      shareMembership {
        identifier
        share {
          identifier
          ...ShareUserRelatedFields
        }
      }
    }
  }
  ${ShareUserRelatedFieldsFragmentDoc}
`

/**
 * __useShareMembershipChangedSubscription__
 *
 * To run a query within a React component, call `useShareMembershipChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShareMembershipChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareMembershipChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useShareMembershipChangedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ShareMembershipChangedSubscription,
    Types.ShareMembershipChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ShareMembershipChangedSubscription,
    Types.ShareMembershipChangedSubscriptionVariables
  >(ShareMembershipChangedDocument, options)
}
export type ShareMembershipChangedSubscriptionHookResult = ReturnType<
  typeof useShareMembershipChangedSubscription
>
export type ShareMembershipChangedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.ShareMembershipChangedSubscription>
export const ShareAcceptRequestDocument = /*#__PURE__*/ gql`
  mutation shareAcceptRequest($id: UUID!) {
    shareAcceptRequest(id: $id) {
      errors {
        ...UserError
      }
      successful
      membership {
        identifier
        share {
          identifier
        }
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type ShareAcceptRequestMutationFn = ApolloReactCommon.MutationFunction<
  Types.ShareAcceptRequestMutation,
  Types.ShareAcceptRequestMutationVariables
>

/**
 * __useShareAcceptRequestMutation__
 *
 * To run a mutation, you first call `useShareAcceptRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareAcceptRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareAcceptRequestMutation, { data, loading, error }] = useShareAcceptRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShareAcceptRequestMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareAcceptRequestMutation,
    Types.ShareAcceptRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareAcceptRequestMutation,
    Types.ShareAcceptRequestMutationVariables
  >(ShareAcceptRequestDocument, options)
}
export type ShareAcceptRequestMutationHookResult = ReturnType<
  typeof useShareAcceptRequestMutation
>
export type ShareAcceptRequestMutationResult =
  ApolloReactCommon.MutationResult<Types.ShareAcceptRequestMutation>
export type ShareAcceptRequestMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ShareAcceptRequestMutation,
    Types.ShareAcceptRequestMutationVariables
  >
export const AcceptShareMembershipInvitationDocument = /*#__PURE__*/ gql`
  mutation acceptShareMembershipInvitation(
    $shareIdentifier: UUID
    $token: String
  ) {
    acceptShareMembershipInvitation(
      shareIdentifier: $shareIdentifier
      token: $token
    ) {
      identifier
      share {
        identifier
        userHasUnacceptedInvitationToView
      }
    }
  }
`
export type AcceptShareMembershipInvitationMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AcceptShareMembershipInvitationMutation,
    Types.AcceptShareMembershipInvitationMutationVariables
  >

/**
 * __useAcceptShareMembershipInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptShareMembershipInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptShareMembershipInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptShareMembershipInvitationMutation, { data, loading, error }] = useAcceptShareMembershipInvitationMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptShareMembershipInvitationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AcceptShareMembershipInvitationMutation,
    Types.AcceptShareMembershipInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AcceptShareMembershipInvitationMutation,
    Types.AcceptShareMembershipInvitationMutationVariables
  >(AcceptShareMembershipInvitationDocument, options)
}
export type AcceptShareMembershipInvitationMutationHookResult = ReturnType<
  typeof useAcceptShareMembershipInvitationMutation
>
export type AcceptShareMembershipInvitationMutationResult =
  ApolloReactCommon.MutationResult<Types.AcceptShareMembershipInvitationMutation>
export type AcceptShareMembershipInvitationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AcceptShareMembershipInvitationMutation,
    Types.AcceptShareMembershipInvitationMutationVariables
  >
export const ShareDeleteMembershipDocument = /*#__PURE__*/ gql`
  mutation shareDeleteMembership(
    $membershipIdentifier: UUID!
    $confirmed: Boolean
  ) {
    shareDeleteMembership(
      membershipIdentifier: $membershipIdentifier
      confirmed: $confirmed
    ) {
      errors {
        ...UserError
      }
      successful
      membership {
        ...ShareMembershipInfo
        share {
          identifier
          userCanUpdateSettings
        }
      }
    }
  }
  ${UserErrorFragmentDoc}
  ${ShareMembershipInfoFragmentDoc}
`
export type ShareDeleteMembershipMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.ShareDeleteMembershipMutation,
    Types.ShareDeleteMembershipMutationVariables
  >

/**
 * __useShareDeleteMembershipMutation__
 *
 * To run a mutation, you first call `useShareDeleteMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDeleteMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDeleteMembershipMutation, { data, loading, error }] = useShareDeleteMembershipMutation({
 *   variables: {
 *      membershipIdentifier: // value for 'membershipIdentifier'
 *      confirmed: // value for 'confirmed'
 *   },
 * });
 */
export function useShareDeleteMembershipMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareDeleteMembershipMutation,
    Types.ShareDeleteMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareDeleteMembershipMutation,
    Types.ShareDeleteMembershipMutationVariables
  >(ShareDeleteMembershipDocument, options)
}
export type ShareDeleteMembershipMutationHookResult = ReturnType<
  typeof useShareDeleteMembershipMutation
>
export type ShareDeleteMembershipMutationResult =
  ApolloReactCommon.MutationResult<Types.ShareDeleteMembershipMutation>
export type ShareDeleteMembershipMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ShareDeleteMembershipMutation,
    Types.ShareDeleteMembershipMutationVariables
  >
export const ShareRequestAccessDocument = /*#__PURE__*/ gql`
  mutation shareRequestAccess($shortId: ShortId!) {
    shareRequestAccess(shortId: $shortId) {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type ShareRequestAccessMutationFn = ApolloReactCommon.MutationFunction<
  Types.ShareRequestAccessMutation,
  Types.ShareRequestAccessMutationVariables
>

/**
 * __useShareRequestAccessMutation__
 *
 * To run a mutation, you first call `useShareRequestAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareRequestAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareRequestAccessMutation, { data, loading, error }] = useShareRequestAccessMutation({
 *   variables: {
 *      shortId: // value for 'shortId'
 *   },
 * });
 */
export function useShareRequestAccessMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareRequestAccessMutation,
    Types.ShareRequestAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareRequestAccessMutation,
    Types.ShareRequestAccessMutationVariables
  >(ShareRequestAccessDocument, options)
}
export type ShareRequestAccessMutationHookResult = ReturnType<
  typeof useShareRequestAccessMutation
>
export type ShareRequestAccessMutationResult =
  ApolloReactCommon.MutationResult<Types.ShareRequestAccessMutation>
export type ShareRequestAccessMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ShareRequestAccessMutation,
    Types.ShareRequestAccessMutationVariables
  >
export const AddShareMembershipDocument = /*#__PURE__*/ gql`
  mutation addShareMembership($input: AddShareMembershipParams!) {
    addShareMembership(input: $input) {
      shareMembership {
        ...ShareMembershipInfo
        share {
          identifier
          userCanUpdateSettings
          workspace {
            identifier
          }
        }
      }
    }
  }
  ${ShareMembershipInfoFragmentDoc}
`
export type AddShareMembershipMutationFn = ApolloReactCommon.MutationFunction<
  Types.AddShareMembershipMutation,
  Types.AddShareMembershipMutationVariables
>

/**
 * __useAddShareMembershipMutation__
 *
 * To run a mutation, you first call `useAddShareMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShareMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShareMembershipMutation, { data, loading, error }] = useAddShareMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddShareMembershipMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddShareMembershipMutation,
    Types.AddShareMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddShareMembershipMutation,
    Types.AddShareMembershipMutationVariables
  >(AddShareMembershipDocument, options)
}
export type AddShareMembershipMutationHookResult = ReturnType<
  typeof useAddShareMembershipMutation
>
export type AddShareMembershipMutationResult =
  ApolloReactCommon.MutationResult<Types.AddShareMembershipMutation>
export type AddShareMembershipMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AddShareMembershipMutation,
    Types.AddShareMembershipMutationVariables
  >
export const UpdateShareMembershipDocument = /*#__PURE__*/ gql`
  mutation updateShareMembership($input: UpdateShareMembershipParams!) {
    updateShareMembership(input: $input) {
      shareMembership {
        ...ShareMembershipInfo
        share {
          identifier
          userCanUpdateSettings
        }
      }
    }
  }
  ${ShareMembershipInfoFragmentDoc}
`
export type UpdateShareMembershipMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateShareMembershipMutation,
    Types.UpdateShareMembershipMutationVariables
  >

/**
 * __useUpdateShareMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateShareMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareMembershipMutation, { data, loading, error }] = useUpdateShareMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShareMembershipMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateShareMembershipMutation,
    Types.UpdateShareMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateShareMembershipMutation,
    Types.UpdateShareMembershipMutationVariables
  >(UpdateShareMembershipDocument, options)
}
export type UpdateShareMembershipMutationHookResult = ReturnType<
  typeof useUpdateShareMembershipMutation
>
export type UpdateShareMembershipMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateShareMembershipMutation>
export type UpdateShareMembershipMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateShareMembershipMutation,
    Types.UpdateShareMembershipMutationVariables
  >
export const GetShareMembershipsDocument = /*#__PURE__*/ gql`
  query getShareMemberships(
    $shareIdentifier: ShortId!
    $after: String
    $limit: Int = 10
  ) {
    share(shortId: $shareIdentifier) {
      identifier
      myMembership {
        ...ShareMembershipInfo
      }
      members(limit: $limit, after: $after) {
        entries {
          ... on ShareMembership {
            ...ShareMembershipInfo
          }
          ... on PermissionGroupRelationShare {
            ...ShareGroupMembershipInfo
          }
        }
        meta {
          after
          totalCount
        }
      }
      parentAccessLevel
      workspace {
        avatar {
          small
        }
        name
        identifier
      }
    }
  }
  ${ShareMembershipInfoFragmentDoc}
  ${ShareGroupMembershipInfoFragmentDoc}
`

/**
 * __useGetShareMembershipsQuery__
 *
 * To run a query within a React component, call `useGetShareMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareMembershipsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetShareMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareMembershipsQuery,
    Types.GetShareMembershipsQueryVariables
  > &
    (
      | { variables: Types.GetShareMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareMembershipsQuery,
    Types.GetShareMembershipsQueryVariables
  >(GetShareMembershipsDocument, options)
}
export function useGetShareMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareMembershipsQuery,
    Types.GetShareMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareMembershipsQuery,
    Types.GetShareMembershipsQueryVariables
  >(GetShareMembershipsDocument, options)
}

export type GetShareMembershipsQueryHookResult = ReturnType<
  typeof useGetShareMembershipsQuery
>
export type GetShareMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetShareMembershipsLazyQuery
>
export type GetShareMembershipsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetShareMembershipsQuery,
  Types.GetShareMembershipsQueryVariables
>
export const GetShareMembershipByShareShortIdDocument = /*#__PURE__*/ gql`
  query getShareMembershipByShareShortId($shareIdentifier: ShortId) {
    share(shortId: $shareIdentifier) {
      identifier
      name
      version(preferredState: PROCESSED) {
        identifier
        shortId
        document {
          identifier
          name
        }
      }
    }
    shareMembership(shareShortId: $shareIdentifier) {
      identifier
      inviteStatus
      inviter {
        name
        avatar {
          large
        }
      }
    }
  }
`

/**
 * __useGetShareMembershipByShareShortIdQuery__
 *
 * To run a query within a React component, call `useGetShareMembershipByShareShortIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareMembershipByShareShortIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareMembershipByShareShortIdQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetShareMembershipByShareShortIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetShareMembershipByShareShortIdQuery,
    Types.GetShareMembershipByShareShortIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareMembershipByShareShortIdQuery,
    Types.GetShareMembershipByShareShortIdQueryVariables
  >(GetShareMembershipByShareShortIdDocument, options)
}
export function useGetShareMembershipByShareShortIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareMembershipByShareShortIdQuery,
    Types.GetShareMembershipByShareShortIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareMembershipByShareShortIdQuery,
    Types.GetShareMembershipByShareShortIdQueryVariables
  >(GetShareMembershipByShareShortIdDocument, options)
}

export type GetShareMembershipByShareShortIdQueryHookResult = ReturnType<
  typeof useGetShareMembershipByShareShortIdQuery
>
export type GetShareMembershipByShareShortIdLazyQueryHookResult = ReturnType<
  typeof useGetShareMembershipByShareShortIdLazyQuery
>
export type GetShareMembershipByShareShortIdQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetShareMembershipByShareShortIdQuery,
    Types.GetShareMembershipByShareShortIdQueryVariables
  >
export const GetShareMembershipDocument = /*#__PURE__*/ gql`
  query getShareMembership($token: String) {
    shareMembership(token: $token) {
      identifier
      email
      inviteStatus
      inviter {
        name
        avatar {
          large
        }
      }
    }
  }
`

/**
 * __useGetShareMembershipQuery__
 *
 * To run a query within a React component, call `useGetShareMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareMembershipQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetShareMembershipQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetShareMembershipQuery,
    Types.GetShareMembershipQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareMembershipQuery,
    Types.GetShareMembershipQueryVariables
  >(GetShareMembershipDocument, options)
}
export function useGetShareMembershipLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareMembershipQuery,
    Types.GetShareMembershipQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareMembershipQuery,
    Types.GetShareMembershipQueryVariables
  >(GetShareMembershipDocument, options)
}

export type GetShareMembershipQueryHookResult = ReturnType<
  typeof useGetShareMembershipQuery
>
export type GetShareMembershipLazyQueryHookResult = ReturnType<
  typeof useGetShareMembershipLazyQuery
>
export type GetShareMembershipQueryResult = ApolloReactCommon.QueryResult<
  Types.GetShareMembershipQuery,
  Types.GetShareMembershipQueryVariables
>
export const GetTrashDocument = /*#__PURE__*/ gql`
  query getTrash(
    $identifier: UUID!
    $after: String
    $search: TrashSearchParams
  ) {
    workspaceTrash(identifier: $identifier, after: $after, search: $search) {
      entries {
        __typename
        ... on TrashedProject {
          ...TrashedProject
        }
        ... on TrashedShare {
          ...TrashedShare
        }
      }
      meta {
        ...ShareMeta
      }
    }
  }
  ${TrashedProjectFragmentDoc}
  ${TrashedShareFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetTrashQuery__
 *
 * To run a query within a React component, call `useGetTrashQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrashQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTrashQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetTrashQuery,
    Types.GetTrashQueryVariables
  > &
    (
      | { variables: Types.GetTrashQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetTrashQuery,
    Types.GetTrashQueryVariables
  >(GetTrashDocument, options)
}
export function useGetTrashLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetTrashQuery,
    Types.GetTrashQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetTrashQuery,
    Types.GetTrashQueryVariables
  >(GetTrashDocument, options)
}

export type GetTrashQueryHookResult = ReturnType<typeof useGetTrashQuery>
export type GetTrashLazyQueryHookResult = ReturnType<
  typeof useGetTrashLazyQuery
>
export type GetTrashQueryResult = ApolloReactCommon.QueryResult<
  Types.GetTrashQuery,
  Types.GetTrashQueryVariables
>
export const UpdateWorkspaceCustomerSsoShortNameDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceCustomerSsoShortName(
    $customerId: UUID!
    $shortName: String!
  ) {
    updateWorkspaceCustomerSsoShortName(
      customerIdentifier: $customerId
      shortName: $shortName
    ) {
      customer {
        identifier
        ssoShortName
      }
    }
  }
`
export type UpdateWorkspaceCustomerSsoShortNameMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateWorkspaceCustomerSsoShortNameMutation,
    Types.UpdateWorkspaceCustomerSsoShortNameMutationVariables
  >

/**
 * __useUpdateWorkspaceCustomerSsoShortNameMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceCustomerSsoShortNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceCustomerSsoShortNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceCustomerSsoShortNameMutation, { data, loading, error }] = useUpdateWorkspaceCustomerSsoShortNameMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      shortName: // value for 'shortName'
 *   },
 * });
 */
export function useUpdateWorkspaceCustomerSsoShortNameMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceCustomerSsoShortNameMutation,
    Types.UpdateWorkspaceCustomerSsoShortNameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceCustomerSsoShortNameMutation,
    Types.UpdateWorkspaceCustomerSsoShortNameMutationVariables
  >(UpdateWorkspaceCustomerSsoShortNameDocument, options)
}
export type UpdateWorkspaceCustomerSsoShortNameMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceCustomerSsoShortNameMutation
>
export type UpdateWorkspaceCustomerSsoShortNameMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateWorkspaceCustomerSsoShortNameMutation>
export type UpdateWorkspaceCustomerSsoShortNameMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateWorkspaceCustomerSsoShortNameMutation,
    Types.UpdateWorkspaceCustomerSsoShortNameMutationVariables
  >
export const UpdateWorkspaceCustomerSsoIdentityProviderConfigDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceCustomerSsoIdentityProviderConfig(
    $config: UpdateWorkspaceCustomerSsoIdentityProviderConfigParams
    $customerId: UUID!
    $metadata: Upload
  ) {
    updateWorkspaceCustomerSsoIdentityProviderConfig(
      config: $config
      customerIdentifier: $customerId
      metadata: $metadata
    ) {
      customer {
        identifier
        ssoEnabled
        ssoConfig {
          ...WorkspaceSsoConfig
        }
      }
    }
  }
  ${WorkspaceSsoConfigFragmentDoc}
`
export type UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutation,
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationVariables
  >

/**
 * __useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceCustomerSsoIdentityProviderConfigMutation, { data, loading, error }] = useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation({
 *   variables: {
 *      config: // value for 'config'
 *      customerId: // value for 'customerId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutation,
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutation,
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationVariables
  >(UpdateWorkspaceCustomerSsoIdentityProviderConfigDocument, options)
}
export type UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationHookResult =
  ReturnType<typeof useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation>
export type UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutation>
export type UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutation,
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationVariables
  >
export const UpdateWorkspaceCustomerSsoAttributeMappingDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceCustomerSsoAttributeMapping(
    $customerIdentifier: UUID!
    $mappings: UpdateWorkspaceCustomerSsoAttributeMappingParams!
  ) {
    updateWorkspaceCustomerSsoAttributeMapping(
      customerIdentifier: $customerIdentifier
      mappings: $mappings
    ) {
      customer {
        identifier
        ssoConfig {
          ...WorkspaceSsoConfig
        }
      }
    }
  }
  ${WorkspaceSsoConfigFragmentDoc}
`
export type UpdateWorkspaceCustomerSsoAttributeMappingMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutation,
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutationVariables
  >

/**
 * __useUpdateWorkspaceCustomerSsoAttributeMappingMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceCustomerSsoAttributeMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceCustomerSsoAttributeMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceCustomerSsoAttributeMappingMutation, { data, loading, error }] = useUpdateWorkspaceCustomerSsoAttributeMappingMutation({
 *   variables: {
 *      customerIdentifier: // value for 'customerIdentifier'
 *      mappings: // value for 'mappings'
 *   },
 * });
 */
export function useUpdateWorkspaceCustomerSsoAttributeMappingMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutation,
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutation,
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutationVariables
  >(UpdateWorkspaceCustomerSsoAttributeMappingDocument, options)
}
export type UpdateWorkspaceCustomerSsoAttributeMappingMutationHookResult =
  ReturnType<typeof useUpdateWorkspaceCustomerSsoAttributeMappingMutation>
export type UpdateWorkspaceCustomerSsoAttributeMappingMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateWorkspaceCustomerSsoAttributeMappingMutation>
export type UpdateWorkspaceCustomerSsoAttributeMappingMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutation,
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutationVariables
  >
export const LinkRegularAccountDocument = /*#__PURE__*/ gql`
  mutation linkRegularAccount($email: Email!, $password: String!) {
    linkRegularAccount(email: $email, password: $password) {
      user {
        email
      }
    }
  }
`
export type LinkRegularAccountMutationFn = ApolloReactCommon.MutationFunction<
  Types.LinkRegularAccountMutation,
  Types.LinkRegularAccountMutationVariables
>

/**
 * __useLinkRegularAccountMutation__
 *
 * To run a mutation, you first call `useLinkRegularAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkRegularAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkRegularAccountMutation, { data, loading, error }] = useLinkRegularAccountMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLinkRegularAccountMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.LinkRegularAccountMutation,
    Types.LinkRegularAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.LinkRegularAccountMutation,
    Types.LinkRegularAccountMutationVariables
  >(LinkRegularAccountDocument, options)
}
export type LinkRegularAccountMutationHookResult = ReturnType<
  typeof useLinkRegularAccountMutation
>
export type LinkRegularAccountMutationResult =
  ApolloReactCommon.MutationResult<Types.LinkRegularAccountMutation>
export type LinkRegularAccountMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.LinkRegularAccountMutation,
    Types.LinkRegularAccountMutationVariables
  >
export const LinkRegularAccountWithMfaDocument = /*#__PURE__*/ gql`
  mutation linkRegularAccountWithMfa(
    $mfa_token: String!
    $totp: String
    $recovery_code: String
  ) {
    linkRegularAccountWithMfa(
      mfaToken: $mfa_token
      totp: $totp
      recoveryCode: $recovery_code
    ) {
      user {
        identifier
      }
    }
  }
`
export type LinkRegularAccountWithMfaMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.LinkRegularAccountWithMfaMutation,
    Types.LinkRegularAccountWithMfaMutationVariables
  >

/**
 * __useLinkRegularAccountWithMfaMutation__
 *
 * To run a mutation, you first call `useLinkRegularAccountWithMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkRegularAccountWithMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkRegularAccountWithMfaMutation, { data, loading, error }] = useLinkRegularAccountWithMfaMutation({
 *   variables: {
 *      mfa_token: // value for 'mfa_token'
 *      totp: // value for 'totp'
 *      recovery_code: // value for 'recovery_code'
 *   },
 * });
 */
export function useLinkRegularAccountWithMfaMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.LinkRegularAccountWithMfaMutation,
    Types.LinkRegularAccountWithMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.LinkRegularAccountWithMfaMutation,
    Types.LinkRegularAccountWithMfaMutationVariables
  >(LinkRegularAccountWithMfaDocument, options)
}
export type LinkRegularAccountWithMfaMutationHookResult = ReturnType<
  typeof useLinkRegularAccountWithMfaMutation
>
export type LinkRegularAccountWithMfaMutationResult =
  ApolloReactCommon.MutationResult<Types.LinkRegularAccountWithMfaMutation>
export type LinkRegularAccountWithMfaMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.LinkRegularAccountWithMfaMutation,
    Types.LinkRegularAccountWithMfaMutationVariables
  >
export const GetPublicWorkspaceForAccountLinkingDocument = /*#__PURE__*/ gql`
  query getPublicWorkspaceForAccountLinking($workspaceId: UUID!) {
    publicWorkspace(identifier: $workspaceId) {
      ...PublicWorkspaceMinimal
    }
    me {
      identifier
      personalWorkspace {
        ...WorkspaceMinimalIdentity
      }
      workspaces {
        ...WorkspaceMinimalIdentity
      }
      ssoLinkToken(team: $workspaceId)
    }
  }
  ${PublicWorkspaceMinimalFragmentDoc}
  ${WorkspaceMinimalIdentityFragmentDoc}
`

/**
 * __useGetPublicWorkspaceForAccountLinkingQuery__
 *
 * To run a query within a React component, call `useGetPublicWorkspaceForAccountLinkingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicWorkspaceForAccountLinkingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicWorkspaceForAccountLinkingQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetPublicWorkspaceForAccountLinkingQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicWorkspaceForAccountLinkingQuery,
    Types.GetPublicWorkspaceForAccountLinkingQueryVariables
  > &
    (
      | {
          variables: Types.GetPublicWorkspaceForAccountLinkingQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicWorkspaceForAccountLinkingQuery,
    Types.GetPublicWorkspaceForAccountLinkingQueryVariables
  >(GetPublicWorkspaceForAccountLinkingDocument, options)
}
export function useGetPublicWorkspaceForAccountLinkingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicWorkspaceForAccountLinkingQuery,
    Types.GetPublicWorkspaceForAccountLinkingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicWorkspaceForAccountLinkingQuery,
    Types.GetPublicWorkspaceForAccountLinkingQueryVariables
  >(GetPublicWorkspaceForAccountLinkingDocument, options)
}

export type GetPublicWorkspaceForAccountLinkingQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceForAccountLinkingQuery
>
export type GetPublicWorkspaceForAccountLinkingLazyQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceForAccountLinkingLazyQuery
>
export type GetPublicWorkspaceForAccountLinkingQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetPublicWorkspaceForAccountLinkingQuery,
    Types.GetPublicWorkspaceForAccountLinkingQueryVariables
  >
export const DisableScimDocument = /*#__PURE__*/ gql`
  mutation disableScim($identifier: UUID!) {
    disableScim(identifier: $identifier) {
      workspace {
        identifier
        scimEnabled
      }
    }
  }
`
export type DisableScimMutationFn = ApolloReactCommon.MutationFunction<
  Types.DisableScimMutation,
  Types.DisableScimMutationVariables
>

/**
 * __useDisableScimMutation__
 *
 * To run a mutation, you first call `useDisableScimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableScimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableScimMutation, { data, loading, error }] = useDisableScimMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDisableScimMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DisableScimMutation,
    Types.DisableScimMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DisableScimMutation,
    Types.DisableScimMutationVariables
  >(DisableScimDocument, options)
}
export type DisableScimMutationHookResult = ReturnType<
  typeof useDisableScimMutation
>
export type DisableScimMutationResult =
  ApolloReactCommon.MutationResult<Types.DisableScimMutation>
export type DisableScimMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.DisableScimMutation,
  Types.DisableScimMutationVariables
>
export const EnableScimDocument = /*#__PURE__*/ gql`
  mutation enableScim($identifier: UUID!) {
    enableScim(identifier: $identifier) {
      workspace {
        identifier
        scimEnabled
      }
      scimToken
    }
  }
`
export type EnableScimMutationFn = ApolloReactCommon.MutationFunction<
  Types.EnableScimMutation,
  Types.EnableScimMutationVariables
>

/**
 * __useEnableScimMutation__
 *
 * To run a mutation, you first call `useEnableScimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableScimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableScimMutation, { data, loading, error }] = useEnableScimMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useEnableScimMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EnableScimMutation,
    Types.EnableScimMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EnableScimMutation,
    Types.EnableScimMutationVariables
  >(EnableScimDocument, options)
}
export type EnableScimMutationHookResult = ReturnType<
  typeof useEnableScimMutation
>
export type EnableScimMutationResult =
  ApolloReactCommon.MutationResult<Types.EnableScimMutation>
export type EnableScimMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.EnableScimMutation,
  Types.EnableScimMutationVariables
>
export const ResetScimTokenDocument = /*#__PURE__*/ gql`
  mutation resetScimToken($identifier: UUID!) {
    resetScimToken(identifier: $identifier) {
      scimToken
    }
  }
`
export type ResetScimTokenMutationFn = ApolloReactCommon.MutationFunction<
  Types.ResetScimTokenMutation,
  Types.ResetScimTokenMutationVariables
>

/**
 * __useResetScimTokenMutation__
 *
 * To run a mutation, you first call `useResetScimTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetScimTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetScimTokenMutation, { data, loading, error }] = useResetScimTokenMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useResetScimTokenMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ResetScimTokenMutation,
    Types.ResetScimTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ResetScimTokenMutation,
    Types.ResetScimTokenMutationVariables
  >(ResetScimTokenDocument, options)
}
export type ResetScimTokenMutationHookResult = ReturnType<
  typeof useResetScimTokenMutation
>
export type ResetScimTokenMutationResult =
  ApolloReactCommon.MutationResult<Types.ResetScimTokenMutation>
export type ResetScimTokenMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ResetScimTokenMutation,
    Types.ResetScimTokenMutationVariables
  >
export const GetSsoStartUrlDocument = /*#__PURE__*/ gql`
  query getSsoStartUrl($teamName: String!) {
    ssoStartUrl(teamName: $teamName) {
      successful
      errors {
        ...UserError
      }
      url
    }
  }
  ${UserErrorFragmentDoc}
`

/**
 * __useGetSsoStartUrlQuery__
 *
 * To run a query within a React component, call `useGetSsoStartUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoStartUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoStartUrlQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useGetSsoStartUrlQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSsoStartUrlQuery,
    Types.GetSsoStartUrlQueryVariables
  > &
    (
      | { variables: Types.GetSsoStartUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSsoStartUrlQuery,
    Types.GetSsoStartUrlQueryVariables
  >(GetSsoStartUrlDocument, options)
}
export function useGetSsoStartUrlLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSsoStartUrlQuery,
    Types.GetSsoStartUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSsoStartUrlQuery,
    Types.GetSsoStartUrlQueryVariables
  >(GetSsoStartUrlDocument, options)
}

export type GetSsoStartUrlQueryHookResult = ReturnType<
  typeof useGetSsoStartUrlQuery
>
export type GetSsoStartUrlLazyQueryHookResult = ReturnType<
  typeof useGetSsoStartUrlLazyQuery
>
export type GetSsoStartUrlQueryResult = ApolloReactCommon.QueryResult<
  Types.GetSsoStartUrlQuery,
  Types.GetSsoStartUrlQueryVariables
>
export const TransferStorageItemDocument = /*#__PURE__*/ gql`
  mutation transferStorageItem(
    $identifier: UUID!
    $parentProjectId: UUID
    $workspaceId: UUID
    $type: StorageItemType!
  ) {
    transferStorageItem(
      identifier: $identifier
      parentProjectIdentifier: $parentProjectId
      workspaceIdentifier: $workspaceId
      type: $type
    ) {
      storageItem {
        ...StorageItemDetails
      }
    }
  }
  ${StorageItemDetailsFragmentDoc}
`
export type TransferStorageItemMutationFn = ApolloReactCommon.MutationFunction<
  Types.TransferStorageItemMutation,
  Types.TransferStorageItemMutationVariables
>

/**
 * __useTransferStorageItemMutation__
 *
 * To run a mutation, you first call `useTransferStorageItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferStorageItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferStorageItemMutation, { data, loading, error }] = useTransferStorageItemMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      parentProjectId: // value for 'parentProjectId'
 *      workspaceId: // value for 'workspaceId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTransferStorageItemMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.TransferStorageItemMutation,
    Types.TransferStorageItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.TransferStorageItemMutation,
    Types.TransferStorageItemMutationVariables
  >(TransferStorageItemDocument, options)
}
export type TransferStorageItemMutationHookResult = ReturnType<
  typeof useTransferStorageItemMutation
>
export type TransferStorageItemMutationResult =
  ApolloReactCommon.MutationResult<Types.TransferStorageItemMutation>
export type TransferStorageItemMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.TransferStorageItemMutation,
    Types.TransferStorageItemMutationVariables
  >
export const ArchiveStorageItemDocument = /*#__PURE__*/ gql`
  mutation archiveStorageItem($identifier: UUID!, $type: StorageItemType!) {
    archiveStorageItem(type: $type, identifier: $identifier) {
      storageItem {
        ...StorageItemDetails
      }
    }
  }
  ${StorageItemDetailsFragmentDoc}
`
export type ArchiveStorageItemMutationFn = ApolloReactCommon.MutationFunction<
  Types.ArchiveStorageItemMutation,
  Types.ArchiveStorageItemMutationVariables
>

/**
 * __useArchiveStorageItemMutation__
 *
 * To run a mutation, you first call `useArchiveStorageItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveStorageItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveStorageItemMutation, { data, loading, error }] = useArchiveStorageItemMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useArchiveStorageItemMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ArchiveStorageItemMutation,
    Types.ArchiveStorageItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ArchiveStorageItemMutation,
    Types.ArchiveStorageItemMutationVariables
  >(ArchiveStorageItemDocument, options)
}
export type ArchiveStorageItemMutationHookResult = ReturnType<
  typeof useArchiveStorageItemMutation
>
export type ArchiveStorageItemMutationResult =
  ApolloReactCommon.MutationResult<Types.ArchiveStorageItemMutation>
export type ArchiveStorageItemMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ArchiveStorageItemMutation,
    Types.ArchiveStorageItemMutationVariables
  >
export const GetStorageItemsDocument = /*#__PURE__*/ gql`
  query getStorageItems(
    $projectIdentifier: UUID!
    $after: String
    $limit: Int
    $search: String
    $filters: [StorageItemFilterType!]
    $includeAllNestedLevels: Boolean!
    $sharesSortOrder: ShareSortOrder
  ) {
    project(identifier: $projectIdentifier) {
      ...ProjectListCounts
      storageItems(
        after: $after
        limit: $limit
        includeAllNestedLevels: $includeAllNestedLevels
        search: { name: $search, filters: $filters }
        sharesSortOrder: $sharesSortOrder
      ) {
        entries {
          ...StorageItem
        }
        meta {
          ...StorageItemsPaginationMeta
        }
      }
    }
  }
  ${ProjectListCountsFragmentDoc}
  ${StorageItemFragmentDoc}
  ${StorageItemsPaginationMetaFragmentDoc}
`

/**
 * __useGetStorageItemsQuery__
 *
 * To run a query within a React component, call `useGetStorageItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorageItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorageItemsQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      includeAllNestedLevels: // value for 'includeAllNestedLevels'
 *      sharesSortOrder: // value for 'sharesSortOrder'
 *   },
 * });
 */
export function useGetStorageItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetStorageItemsQuery,
    Types.GetStorageItemsQueryVariables
  > &
    (
      | { variables: Types.GetStorageItemsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetStorageItemsQuery,
    Types.GetStorageItemsQueryVariables
  >(GetStorageItemsDocument, options)
}
export function useGetStorageItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetStorageItemsQuery,
    Types.GetStorageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetStorageItemsQuery,
    Types.GetStorageItemsQueryVariables
  >(GetStorageItemsDocument, options)
}

export type GetStorageItemsQueryHookResult = ReturnType<
  typeof useGetStorageItemsQuery
>
export type GetStorageItemsLazyQueryHookResult = ReturnType<
  typeof useGetStorageItemsLazyQuery
>
export type GetStorageItemsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetStorageItemsQuery,
  Types.GetStorageItemsQueryVariables
>
export const GetStashedStorageItemsDocument = /*#__PURE__*/ gql`
  query getStashedStorageItems(
    $workspaceId: UUID!
    $source: StorageItemSource!
    $after: String
    $limit: Int
    $search: String
    $filters: [StorageItemFilterType!]
    $includeAllNestedLevels: Boolean!
  ) {
    workspace(identifier: $workspaceId) {
      identifier
      storageItems(
        source: $source
        after: $after
        limit: $limit
        includeAllNestedLevels: $includeAllNestedLevels
        search: { name: $search, filters: $filters }
      ) {
        entries {
          ...StorageItem
        }
        meta {
          ...StorageItemsPaginationMeta
        }
      }
    }
  }
  ${StorageItemFragmentDoc}
  ${StorageItemsPaginationMetaFragmentDoc}
`

/**
 * __useGetStashedStorageItemsQuery__
 *
 * To run a query within a React component, call `useGetStashedStorageItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStashedStorageItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStashedStorageItemsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      source: // value for 'source'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      includeAllNestedLevels: // value for 'includeAllNestedLevels'
 *   },
 * });
 */
export function useGetStashedStorageItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetStashedStorageItemsQuery,
    Types.GetStashedStorageItemsQueryVariables
  > &
    (
      | {
          variables: Types.GetStashedStorageItemsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetStashedStorageItemsQuery,
    Types.GetStashedStorageItemsQueryVariables
  >(GetStashedStorageItemsDocument, options)
}
export function useGetStashedStorageItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetStashedStorageItemsQuery,
    Types.GetStashedStorageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetStashedStorageItemsQuery,
    Types.GetStashedStorageItemsQueryVariables
  >(GetStashedStorageItemsDocument, options)
}

export type GetStashedStorageItemsQueryHookResult = ReturnType<
  typeof useGetStashedStorageItemsQuery
>
export type GetStashedStorageItemsLazyQueryHookResult = ReturnType<
  typeof useGetStashedStorageItemsLazyQuery
>
export type GetStashedStorageItemsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetStashedStorageItemsQuery,
  Types.GetStashedStorageItemsQueryVariables
>
export const NotificationMarkAllAsReadDocument = /*#__PURE__*/ gql`
  mutation notificationMarkAllAsRead {
    notificationMarkAllAsRead {
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type NotificationMarkAllAsReadMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.NotificationMarkAllAsReadMutation,
    Types.NotificationMarkAllAsReadMutationVariables
  >

/**
 * __useNotificationMarkAllAsReadMutation__
 *
 * To run a mutation, you first call `useNotificationMarkAllAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationMarkAllAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationMarkAllAsReadMutation, { data, loading, error }] = useNotificationMarkAllAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useNotificationMarkAllAsReadMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.NotificationMarkAllAsReadMutation,
    Types.NotificationMarkAllAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.NotificationMarkAllAsReadMutation,
    Types.NotificationMarkAllAsReadMutationVariables
  >(NotificationMarkAllAsReadDocument, options)
}
export type NotificationMarkAllAsReadMutationHookResult = ReturnType<
  typeof useNotificationMarkAllAsReadMutation
>
export type NotificationMarkAllAsReadMutationResult =
  ApolloReactCommon.MutationResult<Types.NotificationMarkAllAsReadMutation>
export type NotificationMarkAllAsReadMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.NotificationMarkAllAsReadMutation,
    Types.NotificationMarkAllAsReadMutationVariables
  >
export const NotificationMarkAsReadDocument = /*#__PURE__*/ gql`
  mutation notificationMarkAsRead($id: ID!) {
    notificationMarkAsRead(id: $id) {
      successful
      notification {
        identifier
        isRead
      }
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type NotificationMarkAsReadMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.NotificationMarkAsReadMutation,
    Types.NotificationMarkAsReadMutationVariables
  >

/**
 * __useNotificationMarkAsReadMutation__
 *
 * To run a mutation, you first call `useNotificationMarkAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationMarkAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationMarkAsReadMutation, { data, loading, error }] = useNotificationMarkAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotificationMarkAsReadMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.NotificationMarkAsReadMutation,
    Types.NotificationMarkAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.NotificationMarkAsReadMutation,
    Types.NotificationMarkAsReadMutationVariables
  >(NotificationMarkAsReadDocument, options)
}
export type NotificationMarkAsReadMutationHookResult = ReturnType<
  typeof useNotificationMarkAsReadMutation
>
export type NotificationMarkAsReadMutationResult =
  ApolloReactCommon.MutationResult<Types.NotificationMarkAsReadMutation>
export type NotificationMarkAsReadMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.NotificationMarkAsReadMutation,
    Types.NotificationMarkAsReadMutationVariables
  >
export const UpdateNotificationSubscriptionDocument = /*#__PURE__*/ gql`
  mutation updateNotificationSubscription(
    $annotationIdentifier: UUID
    $frameUUID: String
    $shareIdentifier: UUID
    $state: NotificationSubscriptionState!
  ) {
    setNotificationSubscription(
      annotationIdentifier: $annotationIdentifier
      frameUuid: $frameUUID
      shareIdentifier: $shareIdentifier
      state: $state
    ) {
      share {
        identifier
        subscriptionStatus
      }
    }
  }
`
export type UpdateNotificationSubscriptionMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateNotificationSubscriptionMutation,
    Types.UpdateNotificationSubscriptionMutationVariables
  >

/**
 * __useUpdateNotificationSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSubscriptionMutation, { data, loading, error }] = useUpdateNotificationSubscriptionMutation({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      frameUUID: // value for 'frameUUID'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateNotificationSubscriptionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateNotificationSubscriptionMutation,
    Types.UpdateNotificationSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateNotificationSubscriptionMutation,
    Types.UpdateNotificationSubscriptionMutationVariables
  >(UpdateNotificationSubscriptionDocument, options)
}
export type UpdateNotificationSubscriptionMutationHookResult = ReturnType<
  typeof useUpdateNotificationSubscriptionMutation
>
export type UpdateNotificationSubscriptionMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateNotificationSubscriptionMutation>
export type UpdateNotificationSubscriptionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateNotificationSubscriptionMutation,
    Types.UpdateNotificationSubscriptionMutationVariables
  >
export const GetNotificationsDocument = /*#__PURE__*/ gql`
  query getNotifications($after: String, $filter: UserNotificationFilterType) {
    me {
      identifier
      ...NotificationStatus
      notifications(after: $after, filter: $filter) {
        entries {
          ...NotificationInfo
        }
        meta {
          after
        }
      }
    }
  }
  ${NotificationStatusFragmentDoc}
  ${NotificationInfoFragmentDoc}
`

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetNotificationsQuery,
    Types.GetNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNotificationsQuery,
    Types.GetNotificationsQueryVariables
  >(GetNotificationsDocument, options)
}
export function useGetNotificationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNotificationsQuery,
    Types.GetNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNotificationsQuery,
    Types.GetNotificationsQueryVariables
  >(GetNotificationsDocument, options)
}

export type GetNotificationsQueryHookResult = ReturnType<
  typeof useGetNotificationsQuery
>
export type GetNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetNotificationsLazyQuery
>
export type GetNotificationsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetNotificationsQuery,
  Types.GetNotificationsQueryVariables
>
export const NotificationCreatedDocument = /*#__PURE__*/ gql`
  subscription notificationCreated {
    notificationCreated {
      ...NotificationInfo
    }
  }
  ${NotificationInfoFragmentDoc}
`

/**
 * __useNotificationCreatedSubscription__
 *
 * To run a query within a React component, call `useNotificationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationCreatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.NotificationCreatedSubscription,
    Types.NotificationCreatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.NotificationCreatedSubscription,
    Types.NotificationCreatedSubscriptionVariables
  >(NotificationCreatedDocument, options)
}
export type NotificationCreatedSubscriptionHookResult = ReturnType<
  typeof useNotificationCreatedSubscription
>
export type NotificationCreatedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.NotificationCreatedSubscription>
export const UserPasswordUpdateDocument = /*#__PURE__*/ gql`
  mutation userPasswordUpdate(
    $currentPassword: String!
    $newPassword: String!
  ) {
    userPasswordUpdate(
      input: { currentPassword: $currentPassword, password: $newPassword }
    ) {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserPasswordUpdateMutationFn = ApolloReactCommon.MutationFunction<
  Types.UserPasswordUpdateMutation,
  Types.UserPasswordUpdateMutationVariables
>

/**
 * __useUserPasswordUpdateMutation__
 *
 * To run a mutation, you first call `useUserPasswordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPasswordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPasswordUpdateMutation, { data, loading, error }] = useUserPasswordUpdateMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUserPasswordUpdateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserPasswordUpdateMutation,
    Types.UserPasswordUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserPasswordUpdateMutation,
    Types.UserPasswordUpdateMutationVariables
  >(UserPasswordUpdateDocument, options)
}
export type UserPasswordUpdateMutationHookResult = ReturnType<
  typeof useUserPasswordUpdateMutation
>
export type UserPasswordUpdateMutationResult =
  ApolloReactCommon.MutationResult<Types.UserPasswordUpdateMutation>
export type UserPasswordUpdateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UserPasswordUpdateMutation,
    Types.UserPasswordUpdateMutationVariables
  >
export const UserDeleteDocument = /*#__PURE__*/ gql`
  mutation userDelete($password: String!) {
    userDelete(password: $password) {
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserDeleteMutationFn = ApolloReactCommon.MutationFunction<
  Types.UserDeleteMutation,
  Types.UserDeleteMutationVariables
>

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUserDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserDeleteMutation,
    Types.UserDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserDeleteMutation,
    Types.UserDeleteMutationVariables
  >(UserDeleteDocument, options)
}
export type UserDeleteMutationHookResult = ReturnType<
  typeof useUserDeleteMutation
>
export type UserDeleteMutationResult =
  ApolloReactCommon.MutationResult<Types.UserDeleteMutation>
export type UserDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.UserDeleteMutation,
  Types.UserDeleteMutationVariables
>
export const EmailUpdateDocument = /*#__PURE__*/ gql`
  mutation emailUpdate($email: String!, $password: String!) {
    emailUpdate(email: $email, password: $password) {
      errors {
        ...UserError
      }
      user {
        identifier
        email
        newEmail
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type EmailUpdateMutationFn = ApolloReactCommon.MutationFunction<
  Types.EmailUpdateMutation,
  Types.EmailUpdateMutationVariables
>

/**
 * __useEmailUpdateMutation__
 *
 * To run a mutation, you first call `useEmailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailUpdateMutation, { data, loading, error }] = useEmailUpdateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useEmailUpdateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EmailUpdateMutation,
    Types.EmailUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EmailUpdateMutation,
    Types.EmailUpdateMutationVariables
  >(EmailUpdateDocument, options)
}
export type EmailUpdateMutationHookResult = ReturnType<
  typeof useEmailUpdateMutation
>
export type EmailUpdateMutationResult =
  ApolloReactCommon.MutationResult<Types.EmailUpdateMutation>
export type EmailUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.EmailUpdateMutation,
  Types.EmailUpdateMutationVariables
>
export const EmailResendChangeConfirmationDocument = /*#__PURE__*/ gql`
  mutation emailResendChangeConfirmation {
    emailResendChangeConfirmation {
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type EmailResendChangeConfirmationMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.EmailResendChangeConfirmationMutation,
    Types.EmailResendChangeConfirmationMutationVariables
  >

/**
 * __useEmailResendChangeConfirmationMutation__
 *
 * To run a mutation, you first call `useEmailResendChangeConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailResendChangeConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailResendChangeConfirmationMutation, { data, loading, error }] = useEmailResendChangeConfirmationMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmailResendChangeConfirmationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EmailResendChangeConfirmationMutation,
    Types.EmailResendChangeConfirmationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EmailResendChangeConfirmationMutation,
    Types.EmailResendChangeConfirmationMutationVariables
  >(EmailResendChangeConfirmationDocument, options)
}
export type EmailResendChangeConfirmationMutationHookResult = ReturnType<
  typeof useEmailResendChangeConfirmationMutation
>
export type EmailResendChangeConfirmationMutationResult =
  ApolloReactCommon.MutationResult<Types.EmailResendChangeConfirmationMutation>
export type EmailResendChangeConfirmationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.EmailResendChangeConfirmationMutation,
    Types.EmailResendChangeConfirmationMutationVariables
  >
export const UserRequestPasswordResetDocument = /*#__PURE__*/ gql`
  mutation userRequestPasswordReset($email: String!) {
    userRequestPasswordReset(email: $email) {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserRequestPasswordResetMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UserRequestPasswordResetMutation,
    Types.UserRequestPasswordResetMutationVariables
  >

/**
 * __useUserRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useUserRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRequestPasswordResetMutation, { data, loading, error }] = useUserRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserRequestPasswordResetMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserRequestPasswordResetMutation,
    Types.UserRequestPasswordResetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserRequestPasswordResetMutation,
    Types.UserRequestPasswordResetMutationVariables
  >(UserRequestPasswordResetDocument, options)
}
export type UserRequestPasswordResetMutationHookResult = ReturnType<
  typeof useUserRequestPasswordResetMutation
>
export type UserRequestPasswordResetMutationResult =
  ApolloReactCommon.MutationResult<Types.UserRequestPasswordResetMutation>
export type UserRequestPasswordResetMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UserRequestPasswordResetMutation,
    Types.UserRequestPasswordResetMutationVariables
  >
export const EmailVerifyDocument = /*#__PURE__*/ gql`
  mutation emailVerify($token: String!) {
    emailVerify(token: $token) {
      errors {
        ...UserError
      }
      email
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type EmailVerifyMutationFn = ApolloReactCommon.MutationFunction<
  Types.EmailVerifyMutation,
  Types.EmailVerifyMutationVariables
>

/**
 * __useEmailVerifyMutation__
 *
 * To run a mutation, you first call `useEmailVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVerifyMutation, { data, loading, error }] = useEmailVerifyMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEmailVerifyMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EmailVerifyMutation,
    Types.EmailVerifyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EmailVerifyMutation,
    Types.EmailVerifyMutationVariables
  >(EmailVerifyDocument, options)
}
export type EmailVerifyMutationHookResult = ReturnType<
  typeof useEmailVerifyMutation
>
export type EmailVerifyMutationResult =
  ApolloReactCommon.MutationResult<Types.EmailVerifyMutation>
export type EmailVerifyMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.EmailVerifyMutation,
  Types.EmailVerifyMutationVariables
>
export const ResendVerificationEmailDocument = /*#__PURE__*/ gql`
  mutation resendVerificationEmail {
    resendVerificationEmail {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type ResendVerificationEmailMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.ResendVerificationEmailMutation,
    Types.ResendVerificationEmailMutationVariables
  >

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendVerificationEmailMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ResendVerificationEmailMutation,
    Types.ResendVerificationEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ResendVerificationEmailMutation,
    Types.ResendVerificationEmailMutationVariables
  >(ResendVerificationEmailDocument, options)
}
export type ResendVerificationEmailMutationHookResult = ReturnType<
  typeof useResendVerificationEmailMutation
>
export type ResendVerificationEmailMutationResult =
  ApolloReactCommon.MutationResult<Types.ResendVerificationEmailMutation>
export type ResendVerificationEmailMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ResendVerificationEmailMutation,
    Types.ResendVerificationEmailMutationVariables
  >
export const UserPasswordResetDocument = /*#__PURE__*/ gql`
  mutation userPasswordReset($token: String!, $newPassword: String!) {
    userPasswordReset(input: { token: $token, newPassword: $newPassword }) {
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserPasswordResetMutationFn = ApolloReactCommon.MutationFunction<
  Types.UserPasswordResetMutation,
  Types.UserPasswordResetMutationVariables
>

/**
 * __useUserPasswordResetMutation__
 *
 * To run a mutation, you first call `useUserPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPasswordResetMutation, { data, loading, error }] = useUserPasswordResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUserPasswordResetMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserPasswordResetMutation,
    Types.UserPasswordResetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserPasswordResetMutation,
    Types.UserPasswordResetMutationVariables
  >(UserPasswordResetDocument, options)
}
export type UserPasswordResetMutationHookResult = ReturnType<
  typeof useUserPasswordResetMutation
>
export type UserPasswordResetMutationResult =
  ApolloReactCommon.MutationResult<Types.UserPasswordResetMutation>
export type UserPasswordResetMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UserPasswordResetMutation,
    Types.UserPasswordResetMutationVariables
  >
export const UserUpdateDocument = /*#__PURE__*/ gql`
  mutation userUpdate($input: UserParams) {
    userUpdate(input: $input) {
      errors {
        ...UserError
      }
      successful
      user {
        identifier
        name
        receiveEmailNotifications
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserUpdateMutationFn = ApolloReactCommon.MutationFunction<
  Types.UserUpdateMutation,
  Types.UserUpdateMutationVariables
>

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserUpdateMutation,
    Types.UserUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserUpdateMutation,
    Types.UserUpdateMutationVariables
  >(UserUpdateDocument, options)
}
export type UserUpdateMutationHookResult = ReturnType<
  typeof useUserUpdateMutation
>
export type UserUpdateMutationResult =
  ApolloReactCommon.MutationResult<Types.UserUpdateMutation>
export type UserUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.UserUpdateMutation,
  Types.UserUpdateMutationVariables
>
export const UserAvatarDeleteDocument = /*#__PURE__*/ gql`
  mutation userAvatarDelete {
    userAvatarDelete {
      user {
        identifier
        hasAvatar
        avatar {
          large
          small
        }
      }
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserAvatarDeleteMutationFn = ApolloReactCommon.MutationFunction<
  Types.UserAvatarDeleteMutation,
  Types.UserAvatarDeleteMutationVariables
>

/**
 * __useUserAvatarDeleteMutation__
 *
 * To run a mutation, you first call `useUserAvatarDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAvatarDeleteMutation, { data, loading, error }] = useUserAvatarDeleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useUserAvatarDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserAvatarDeleteMutation,
    Types.UserAvatarDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserAvatarDeleteMutation,
    Types.UserAvatarDeleteMutationVariables
  >(UserAvatarDeleteDocument, options)
}
export type UserAvatarDeleteMutationHookResult = ReturnType<
  typeof useUserAvatarDeleteMutation
>
export type UserAvatarDeleteMutationResult =
  ApolloReactCommon.MutationResult<Types.UserAvatarDeleteMutation>
export type UserAvatarDeleteMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UserAvatarDeleteMutation,
    Types.UserAvatarDeleteMutationVariables
  >
export const UserAvatarCreateDocument = /*#__PURE__*/ gql`
  mutation userAvatarCreate($file: Upload!) {
    userAvatarCreate(file: $file) {
      user {
        identifier
        hasAvatar
        avatar {
          large
          small
        }
      }
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserAvatarCreateMutationFn = ApolloReactCommon.MutationFunction<
  Types.UserAvatarCreateMutation,
  Types.UserAvatarCreateMutationVariables
>

/**
 * __useUserAvatarCreateMutation__
 *
 * To run a mutation, you first call `useUserAvatarCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAvatarCreateMutation, { data, loading, error }] = useUserAvatarCreateMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUserAvatarCreateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserAvatarCreateMutation,
    Types.UserAvatarCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserAvatarCreateMutation,
    Types.UserAvatarCreateMutationVariables
  >(UserAvatarCreateDocument, options)
}
export type UserAvatarCreateMutationHookResult = ReturnType<
  typeof useUserAvatarCreateMutation
>
export type UserAvatarCreateMutationResult =
  ApolloReactCommon.MutationResult<Types.UserAvatarCreateMutation>
export type UserAvatarCreateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UserAvatarCreateMutation,
    Types.UserAvatarCreateMutationVariables
  >
export const SendDownloadSketchEmailDocument = /*#__PURE__*/ gql`
  mutation sendDownloadSketchEmail {
    sendDownloadSketchEmail {
      sent
    }
  }
`
export type SendDownloadSketchEmailMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.SendDownloadSketchEmailMutation,
    Types.SendDownloadSketchEmailMutationVariables
  >

/**
 * __useSendDownloadSketchEmailMutation__
 *
 * To run a mutation, you first call `useSendDownloadSketchEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDownloadSketchEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDownloadSketchEmailMutation, { data, loading, error }] = useSendDownloadSketchEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendDownloadSketchEmailMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SendDownloadSketchEmailMutation,
    Types.SendDownloadSketchEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SendDownloadSketchEmailMutation,
    Types.SendDownloadSketchEmailMutationVariables
  >(SendDownloadSketchEmailDocument, options)
}
export type SendDownloadSketchEmailMutationHookResult = ReturnType<
  typeof useSendDownloadSketchEmailMutation
>
export type SendDownloadSketchEmailMutationResult =
  ApolloReactCommon.MutationResult<Types.SendDownloadSketchEmailMutation>
export type SendDownloadSketchEmailMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.SendDownloadSketchEmailMutation,
    Types.SendDownloadSketchEmailMutationVariables
  >
export const UserAcceptTosAgreementDocument = /*#__PURE__*/ gql`
  mutation userAcceptTosAgreement {
    userAcceptTosAgreement {
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserAcceptTosAgreementMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UserAcceptTosAgreementMutation,
    Types.UserAcceptTosAgreementMutationVariables
  >

/**
 * __useUserAcceptTosAgreementMutation__
 *
 * To run a mutation, you first call `useUserAcceptTosAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAcceptTosAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAcceptTosAgreementMutation, { data, loading, error }] = useUserAcceptTosAgreementMutation({
 *   variables: {
 *   },
 * });
 */
export function useUserAcceptTosAgreementMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserAcceptTosAgreementMutation,
    Types.UserAcceptTosAgreementMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserAcceptTosAgreementMutation,
    Types.UserAcceptTosAgreementMutationVariables
  >(UserAcceptTosAgreementDocument, options)
}
export type UserAcceptTosAgreementMutationHookResult = ReturnType<
  typeof useUserAcceptTosAgreementMutation
>
export type UserAcceptTosAgreementMutationResult =
  ApolloReactCommon.MutationResult<Types.UserAcceptTosAgreementMutation>
export type UserAcceptTosAgreementMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UserAcceptTosAgreementMutation,
    Types.UserAcceptTosAgreementMutationVariables
  >
export const UpdateUserPreferencesDocument = /*#__PURE__*/ gql`
  mutation updateUserPreferences(
    $showOnboardingFirstSteps: Boolean
    $showStorageLimitChanges: Boolean
  ) {
    updateUserPreferences(
      showOnboardingFirstSteps: $showOnboardingFirstSteps
      showStorageLimitChanges: $showStorageLimitChanges
    ) {
      user {
        ...UserPreferences
      }
    }
  }
  ${UserPreferencesFragmentDoc}
`
export type UpdateUserPreferencesMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateUserPreferencesMutation,
    Types.UpdateUserPreferencesMutationVariables
  >

/**
 * __useUpdateUserPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferencesMutation, { data, loading, error }] = useUpdateUserPreferencesMutation({
 *   variables: {
 *      showOnboardingFirstSteps: // value for 'showOnboardingFirstSteps'
 *      showStorageLimitChanges: // value for 'showStorageLimitChanges'
 *   },
 * });
 */
export function useUpdateUserPreferencesMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateUserPreferencesMutation,
    Types.UpdateUserPreferencesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateUserPreferencesMutation,
    Types.UpdateUserPreferencesMutationVariables
  >(UpdateUserPreferencesDocument, options)
}
export type UpdateUserPreferencesMutationHookResult = ReturnType<
  typeof useUpdateUserPreferencesMutation
>
export type UpdateUserPreferencesMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateUserPreferencesMutation>
export type UpdateUserPreferencesMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateUserPreferencesMutation,
    Types.UpdateUserPreferencesMutationVariables
  >
export const GetUserIdDocument = /*#__PURE__*/ gql`
  query getUserId {
    me {
      identifier
    }
  }
`

/**
 * __useGetUserIdQuery__
 *
 * To run a query within a React component, call `useGetUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetUserIdQuery,
    Types.GetUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetUserIdQuery,
    Types.GetUserIdQueryVariables
  >(GetUserIdDocument, options)
}
export function useGetUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetUserIdQuery,
    Types.GetUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetUserIdQuery,
    Types.GetUserIdQueryVariables
  >(GetUserIdDocument, options)
}

export type GetUserIdQueryHookResult = ReturnType<typeof useGetUserIdQuery>
export type GetUserIdLazyQueryHookResult = ReturnType<
  typeof useGetUserIdLazyQuery
>
export type GetUserIdQueryResult = ApolloReactCommon.QueryResult<
  Types.GetUserIdQuery,
  Types.GetUserIdQueryVariables
>
export const GetInitialUserDocument = /*#__PURE__*/ gql`
  query getInitialUser {
    me {
      identifier
      ...InitialUser
    }
  }
  ${InitialUserFragmentDoc}
`

/**
 * __useGetInitialUserQuery__
 *
 * To run a query within a React component, call `useGetInitialUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetInitialUserQuery,
    Types.GetInitialUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetInitialUserQuery,
    Types.GetInitialUserQueryVariables
  >(GetInitialUserDocument, options)
}
export function useGetInitialUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetInitialUserQuery,
    Types.GetInitialUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetInitialUserQuery,
    Types.GetInitialUserQueryVariables
  >(GetInitialUserDocument, options)
}

export type GetInitialUserQueryHookResult = ReturnType<
  typeof useGetInitialUserQuery
>
export type GetInitialUserLazyQueryHookResult = ReturnType<
  typeof useGetInitialUserLazyQuery
>
export type GetInitialUserQueryResult = ApolloReactCommon.QueryResult<
  Types.GetInitialUserQuery,
  Types.GetInitialUserQueryVariables
>
export const GetVerifiedUserDocument = /*#__PURE__*/ gql`
  query getVerifiedUser {
    me {
      identifier
      isVerified
    }
  }
`

/**
 * __useGetVerifiedUserQuery__
 *
 * To run a query within a React component, call `useGetVerifiedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifiedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifiedUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVerifiedUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetVerifiedUserQuery,
    Types.GetVerifiedUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetVerifiedUserQuery,
    Types.GetVerifiedUserQueryVariables
  >(GetVerifiedUserDocument, options)
}
export function useGetVerifiedUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetVerifiedUserQuery,
    Types.GetVerifiedUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetVerifiedUserQuery,
    Types.GetVerifiedUserQueryVariables
  >(GetVerifiedUserDocument, options)
}

export type GetVerifiedUserQueryHookResult = ReturnType<
  typeof useGetVerifiedUserQuery
>
export type GetVerifiedUserLazyQueryHookResult = ReturnType<
  typeof useGetVerifiedUserLazyQuery
>
export type GetVerifiedUserQueryResult = ApolloReactCommon.QueryResult<
  Types.GetVerifiedUserQuery,
  Types.GetVerifiedUserQueryVariables
>
export const GetNotificationStatusDocument = /*#__PURE__*/ gql`
  query getNotificationStatus {
    me {
      ...NotificationStatus
    }
  }
  ${NotificationStatusFragmentDoc}
`

/**
 * __useGetNotificationStatusQuery__
 *
 * To run a query within a React component, call `useGetNotificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetNotificationStatusQuery,
    Types.GetNotificationStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNotificationStatusQuery,
    Types.GetNotificationStatusQueryVariables
  >(GetNotificationStatusDocument, options)
}
export function useGetNotificationStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNotificationStatusQuery,
    Types.GetNotificationStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNotificationStatusQuery,
    Types.GetNotificationStatusQueryVariables
  >(GetNotificationStatusDocument, options)
}

export type GetNotificationStatusQueryHookResult = ReturnType<
  typeof useGetNotificationStatusQuery
>
export type GetNotificationStatusLazyQueryHookResult = ReturnType<
  typeof useGetNotificationStatusLazyQuery
>
export type GetNotificationStatusQueryResult = ApolloReactCommon.QueryResult<
  Types.GetNotificationStatusQuery,
  Types.GetNotificationStatusQueryVariables
>
export const GetUserSettingsDocument = /*#__PURE__*/ gql`
  query getUserSettings($after: String, $limit: Int) {
    me {
      ...User
      identifier
      mfaState
      newEmail
      avatar {
        large
      }
      workspaceMemberships(after: $after, limit: $limit) {
        entries {
          ...UserWorkspaceMembership
        }
        meta {
          after
        }
      }
      activeSessions(limit: 20) {
        entries {
          ...UserActiveSession
        }
      }
    }
  }
  ${UserFragmentDoc}
  ${UserWorkspaceMembershipFragmentDoc}
  ${UserActiveSessionFragmentDoc}
`

/**
 * __useGetUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetUserSettingsQuery,
    Types.GetUserSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetUserSettingsQuery,
    Types.GetUserSettingsQueryVariables
  >(GetUserSettingsDocument, options)
}
export function useGetUserSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetUserSettingsQuery,
    Types.GetUserSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetUserSettingsQuery,
    Types.GetUserSettingsQueryVariables
  >(GetUserSettingsDocument, options)
}

export type GetUserSettingsQueryHookResult = ReturnType<
  typeof useGetUserSettingsQuery
>
export type GetUserSettingsLazyQueryHookResult = ReturnType<
  typeof useGetUserSettingsLazyQuery
>
export type GetUserSettingsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetUserSettingsQuery,
  Types.GetUserSettingsQueryVariables
>
export const GetUserNotificationsCountDocument = /*#__PURE__*/ gql`
  query getUserNotificationsCount {
    me {
      identifier
      ...UserNotificationCount
    }
  }
  ${UserNotificationCountFragmentDoc}
`

/**
 * __useGetUserNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationsCountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetUserNotificationsCountQuery,
    Types.GetUserNotificationsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetUserNotificationsCountQuery,
    Types.GetUserNotificationsCountQueryVariables
  >(GetUserNotificationsCountDocument, options)
}
export function useGetUserNotificationsCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetUserNotificationsCountQuery,
    Types.GetUserNotificationsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetUserNotificationsCountQuery,
    Types.GetUserNotificationsCountQueryVariables
  >(GetUserNotificationsCountDocument, options)
}

export type GetUserNotificationsCountQueryHookResult = ReturnType<
  typeof useGetUserNotificationsCountQuery
>
export type GetUserNotificationsCountLazyQueryHookResult = ReturnType<
  typeof useGetUserNotificationsCountLazyQuery
>
export type GetUserNotificationsCountQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetUserNotificationsCountQuery,
    Types.GetUserNotificationsCountQueryVariables
  >
export const GetShareForDeleteEntityFromCacheDocument = /*#__PURE__*/ gql`
  query getShareForDeleteEntityFromCache($shortId: ShortId!) {
    share(shortId: $shortId) {
      identifier
    }
  }
`

/**
 * __useGetShareForDeleteEntityFromCacheQuery__
 *
 * To run a query within a React component, call `useGetShareForDeleteEntityFromCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareForDeleteEntityFromCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareForDeleteEntityFromCacheQuery({
 *   variables: {
 *      shortId: // value for 'shortId'
 *   },
 * });
 */
export function useGetShareForDeleteEntityFromCacheQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareForDeleteEntityFromCacheQuery,
    Types.GetShareForDeleteEntityFromCacheQueryVariables
  > &
    (
      | {
          variables: Types.GetShareForDeleteEntityFromCacheQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareForDeleteEntityFromCacheQuery,
    Types.GetShareForDeleteEntityFromCacheQueryVariables
  >(GetShareForDeleteEntityFromCacheDocument, options)
}
export function useGetShareForDeleteEntityFromCacheLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareForDeleteEntityFromCacheQuery,
    Types.GetShareForDeleteEntityFromCacheQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareForDeleteEntityFromCacheQuery,
    Types.GetShareForDeleteEntityFromCacheQueryVariables
  >(GetShareForDeleteEntityFromCacheDocument, options)
}

export type GetShareForDeleteEntityFromCacheQueryHookResult = ReturnType<
  typeof useGetShareForDeleteEntityFromCacheQuery
>
export type GetShareForDeleteEntityFromCacheLazyQueryHookResult = ReturnType<
  typeof useGetShareForDeleteEntityFromCacheLazyQuery
>
export type GetShareForDeleteEntityFromCacheQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetShareForDeleteEntityFromCacheQuery,
    Types.GetShareForDeleteEntityFromCacheQueryVariables
  >
export const GetArtboardRevisionsDocument = /*#__PURE__*/ gql`
  query getArtboardRevisions(
    $shareIdentifier: UUID!
    $permanentArtboardIdentifier: ID!
    $after: String
  ) {
    artboardRevisions(
      shareIdentifier: $shareIdentifier
      permanentArtboardId: $permanentArtboardIdentifier
      after: $after
    ) {
      entries {
        ... on Revision {
          order
          ...ArtboardRevision
        }
        ... on RevisionDeleted {
          order
          ...ArtboardRevisionDeleted
        }
        ... on RevisionUnavailable {
          order
          ...ArtboardRevisionUnavailable
        }
      }
      meta {
        after
        totalCount
      }
    }
  }
  ${ArtboardRevisionFragmentDoc}
  ${ArtboardRevisionDeletedFragmentDoc}
  ${ArtboardRevisionUnavailableFragmentDoc}
`

/**
 * __useGetArtboardRevisionsQuery__
 *
 * To run a query within a React component, call `useGetArtboardRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtboardRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtboardRevisionsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      permanentArtboardIdentifier: // value for 'permanentArtboardIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetArtboardRevisionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetArtboardRevisionsQuery,
    Types.GetArtboardRevisionsQueryVariables
  > &
    (
      | { variables: Types.GetArtboardRevisionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetArtboardRevisionsQuery,
    Types.GetArtboardRevisionsQueryVariables
  >(GetArtboardRevisionsDocument, options)
}
export function useGetArtboardRevisionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetArtboardRevisionsQuery,
    Types.GetArtboardRevisionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetArtboardRevisionsQuery,
    Types.GetArtboardRevisionsQueryVariables
  >(GetArtboardRevisionsDocument, options)
}

export type GetArtboardRevisionsQueryHookResult = ReturnType<
  typeof useGetArtboardRevisionsQuery
>
export type GetArtboardRevisionsLazyQueryHookResult = ReturnType<
  typeof useGetArtboardRevisionsLazyQuery
>
export type GetArtboardRevisionsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetArtboardRevisionsQuery,
  Types.GetArtboardRevisionsQueryVariables
>
export const GetFrameRevisionsDocument = /*#__PURE__*/ gql`
  query getFrameRevisions(
    $frameUUID: String!
    $shareIdentifier: UUID!
    $after: String
  ) {
    frame(uuid: $frameUUID, shareIdentifier: $shareIdentifier) {
      identifier
      revisions(after: $after) {
        entries {
          ... on Revision {
            order
            ...FrameGroupRevision
          }
          ... on RevisionDeleted {
            order
            ...FrameGroupRevisionDeleted
          }
          ... on RevisionUnavailable {
            order
            ...FrameGroupRevisionUnavailable
          }
        }
        meta {
          after
          totalCount
        }
      }
    }
  }
  ${FrameGroupRevisionFragmentDoc}
  ${FrameGroupRevisionDeletedFragmentDoc}
  ${FrameGroupRevisionUnavailableFragmentDoc}
`

/**
 * __useGetFrameRevisionsQuery__
 *
 * To run a query within a React component, call `useGetFrameRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrameRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrameRevisionsQuery({
 *   variables: {
 *      frameUUID: // value for 'frameUUID'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetFrameRevisionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFrameRevisionsQuery,
    Types.GetFrameRevisionsQueryVariables
  > &
    (
      | { variables: Types.GetFrameRevisionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFrameRevisionsQuery,
    Types.GetFrameRevisionsQueryVariables
  >(GetFrameRevisionsDocument, options)
}
export function useGetFrameRevisionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFrameRevisionsQuery,
    Types.GetFrameRevisionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFrameRevisionsQuery,
    Types.GetFrameRevisionsQueryVariables
  >(GetFrameRevisionsDocument, options)
}

export type GetFrameRevisionsQueryHookResult = ReturnType<
  typeof useGetFrameRevisionsQuery
>
export type GetFrameRevisionsLazyQueryHookResult = ReturnType<
  typeof useGetFrameRevisionsLazyQuery
>
export type GetFrameRevisionsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetFrameRevisionsQuery,
  Types.GetFrameRevisionsQueryVariables
>
export const VersionDeleteDocument = /*#__PURE__*/ gql`
  mutation versionDelete($versionIdentifier: UUID!) {
    versionDelete(versionIdentifier: $versionIdentifier) {
      successful
      errors {
        ...UserError
      }
      versionDeleted {
        ...VersionDeleted
      }
      share {
        ...ShareInfo
      }
    }
  }
  ${UserErrorFragmentDoc}
  ${VersionDeletedFragmentDoc}
  ${ShareInfoFragmentDoc}
`
export type VersionDeleteMutationFn = ApolloReactCommon.MutationFunction<
  Types.VersionDeleteMutation,
  Types.VersionDeleteMutationVariables
>

/**
 * __useVersionDeleteMutation__
 *
 * To run a mutation, you first call `useVersionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVersionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [versionDeleteMutation, { data, loading, error }] = useVersionDeleteMutation({
 *   variables: {
 *      versionIdentifier: // value for 'versionIdentifier'
 *   },
 * });
 */
export function useVersionDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.VersionDeleteMutation,
    Types.VersionDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.VersionDeleteMutation,
    Types.VersionDeleteMutationVariables
  >(VersionDeleteDocument, options)
}
export type VersionDeleteMutationHookResult = ReturnType<
  typeof useVersionDeleteMutation
>
export type VersionDeleteMutationResult =
  ApolloReactCommon.MutationResult<Types.VersionDeleteMutation>
export type VersionDeleteMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.VersionDeleteMutation,
    Types.VersionDeleteMutationVariables
  >
export const VersionUpdateKindDocument = /*#__PURE__*/ gql`
  mutation versionUpdateKind($versionIdentifier: UUID!, $kind: Kind!) {
    versionUpdateKind(versionIdentifier: $versionIdentifier, kind: $kind) {
      shortId
      kind
    }
  }
`
export type VersionUpdateKindMutationFn = ApolloReactCommon.MutationFunction<
  Types.VersionUpdateKindMutation,
  Types.VersionUpdateKindMutationVariables
>

/**
 * __useVersionUpdateKindMutation__
 *
 * To run a mutation, you first call `useVersionUpdateKindMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVersionUpdateKindMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [versionUpdateKindMutation, { data, loading, error }] = useVersionUpdateKindMutation({
 *   variables: {
 *      versionIdentifier: // value for 'versionIdentifier'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useVersionUpdateKindMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.VersionUpdateKindMutation,
    Types.VersionUpdateKindMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.VersionUpdateKindMutation,
    Types.VersionUpdateKindMutationVariables
  >(VersionUpdateKindDocument, options)
}
export type VersionUpdateKindMutationHookResult = ReturnType<
  typeof useVersionUpdateKindMutation
>
export type VersionUpdateKindMutationResult =
  ApolloReactCommon.MutationResult<Types.VersionUpdateKindMutation>
export type VersionUpdateKindMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.VersionUpdateKindMutation,
    Types.VersionUpdateKindMutationVariables
  >
export const UpdateVersionDescriptionDocument = /*#__PURE__*/ gql`
  mutation updateVersionDescription(
    $versionIdentifier: UUID!
    $shareIdentifier: UUID!
    $description: String!
  ) {
    updateVersionDescription(
      versionIdentifier: $versionIdentifier
      shareIdentifier: $shareIdentifier
      description: $description
    ) {
      shortId
      description
    }
  }
`
export type UpdateVersionDescriptionMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateVersionDescriptionMutation,
    Types.UpdateVersionDescriptionMutationVariables
  >

/**
 * __useUpdateVersionDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateVersionDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVersionDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVersionDescriptionMutation, { data, loading, error }] = useUpdateVersionDescriptionMutation({
 *   variables: {
 *      versionIdentifier: // value for 'versionIdentifier'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateVersionDescriptionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateVersionDescriptionMutation,
    Types.UpdateVersionDescriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateVersionDescriptionMutation,
    Types.UpdateVersionDescriptionMutationVariables
  >(UpdateVersionDescriptionDocument, options)
}
export type UpdateVersionDescriptionMutationHookResult = ReturnType<
  typeof useUpdateVersionDescriptionMutation
>
export type UpdateVersionDescriptionMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateVersionDescriptionMutation>
export type UpdateVersionDescriptionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateVersionDescriptionMutation,
    Types.UpdateVersionDescriptionMutationVariables
  >
export const GetVersionDocument = /*#__PURE__*/ gql`
  query getVersion($shareIdentifier: ShortId!, $versionShortId: ShortId) {
    share(shortId: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        ...Version
      }
    }
  }
  ${VersionFragmentDoc}
`

/**
 * __useGetVersionQuery__
 *
 * To run a query within a React component, call `useGetVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVersionQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetVersionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetVersionQuery,
    Types.GetVersionQueryVariables
  > &
    (
      | { variables: Types.GetVersionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetVersionQuery,
    Types.GetVersionQueryVariables
  >(GetVersionDocument, options)
}
export function useGetVersionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetVersionQuery,
    Types.GetVersionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetVersionQuery,
    Types.GetVersionQueryVariables
  >(GetVersionDocument, options)
}

export type GetVersionQueryHookResult = ReturnType<typeof useGetVersionQuery>
export type GetVersionLazyQueryHookResult = ReturnType<
  typeof useGetVersionLazyQuery
>
export type GetVersionQueryResult = ApolloReactCommon.QueryResult<
  Types.GetVersionQuery,
  Types.GetVersionQueryVariables
>
export const GetLatestStarDocument = /*#__PURE__*/ gql`
  query getLatestStar($shareIdentifier: ShortId) {
    share(shortId: $shareIdentifier) {
      identifier
      version(preferredState: PROCESSED_AND_PUBLISHED) {
        kind
        ...Version
      }
    }
  }
  ${VersionFragmentDoc}
`

/**
 * __useGetLatestStarQuery__
 *
 * To run a query within a React component, call `useGetLatestStarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestStarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestStarQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetLatestStarQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetLatestStarQuery,
    Types.GetLatestStarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetLatestStarQuery,
    Types.GetLatestStarQueryVariables
  >(GetLatestStarDocument, options)
}
export function useGetLatestStarLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetLatestStarQuery,
    Types.GetLatestStarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetLatestStarQuery,
    Types.GetLatestStarQueryVariables
  >(GetLatestStarDocument, options)
}

export type GetLatestStarQueryHookResult = ReturnType<
  typeof useGetLatestStarQuery
>
export type GetLatestStarLazyQueryHookResult = ReturnType<
  typeof useGetLatestStarLazyQuery
>
export type GetLatestStarQueryResult = ApolloReactCommon.QueryResult<
  Types.GetLatestStarQuery,
  Types.GetLatestStarQueryVariables
>
export const VersionUploadProcessedDocument = /*#__PURE__*/ gql`
  subscription versionUploadProcessed(
    $shareIdentifier: UUID
    $preferredState: VersionSubscriptionStateFilter
  ) {
    versionUploadProcessed(
      preferredState: $preferredState
      shareIdentifier: $shareIdentifier
    ) {
      ...ShareInfo
    }
  }
  ${ShareInfoFragmentDoc}
`

/**
 * __useVersionUploadProcessedSubscription__
 *
 * To run a query within a React component, call `useVersionUploadProcessedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVersionUploadProcessedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionUploadProcessedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      preferredState: // value for 'preferredState'
 *   },
 * });
 */
export function useVersionUploadProcessedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.VersionUploadProcessedSubscription,
    Types.VersionUploadProcessedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.VersionUploadProcessedSubscription,
    Types.VersionUploadProcessedSubscriptionVariables
  >(VersionUploadProcessedDocument, options)
}
export type VersionUploadProcessedSubscriptionHookResult = ReturnType<
  typeof useVersionUploadProcessedSubscription
>
export type VersionUploadProcessedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.VersionUploadProcessedSubscription>
export const VersionUploadCompleteDocument = /*#__PURE__*/ gql`
  subscription versionUploadComplete(
    $shareIdentifier: UUID
    $preferredState: VersionSubscriptionStateFilter
    $after: String = null
    $limit: Int = 20
  ) {
    versionUploadComplete(
      preferredState: $preferredState
      shareIdentifier: $shareIdentifier
    ) {
      ...ShareVersionHistory
    }
  }
  ${ShareVersionHistoryFragmentDoc}
`

/**
 * __useVersionUploadCompleteSubscription__
 *
 * To run a query within a React component, call `useVersionUploadCompleteSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVersionUploadCompleteSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionUploadCompleteSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      preferredState: // value for 'preferredState'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useVersionUploadCompleteSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.VersionUploadCompleteSubscription,
    Types.VersionUploadCompleteSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.VersionUploadCompleteSubscription,
    Types.VersionUploadCompleteSubscriptionVariables
  >(VersionUploadCompleteDocument, options)
}
export type VersionUploadCompleteSubscriptionHookResult = ReturnType<
  typeof useVersionUploadCompleteSubscription
>
export type VersionUploadCompleteSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.VersionUploadCompleteSubscription>
export const VersionDeletedDocument = /*#__PURE__*/ gql`
  subscription versionDeleted {
    versionDeleted {
      share {
        ...ShareInfo
        ...ShareLatestStarredVersion
      }
      versionDeleted {
        ...VersionDeleted
      }
    }
  }
  ${ShareInfoFragmentDoc}
  ${ShareLatestStarredVersionFragmentDoc}
  ${VersionDeletedFragmentDoc}
`

/**
 * __useVersionDeletedSubscription__
 *
 * To run a query within a React component, call `useVersionDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVersionDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useVersionDeletedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.VersionDeletedSubscription,
    Types.VersionDeletedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.VersionDeletedSubscription,
    Types.VersionDeletedSubscriptionVariables
  >(VersionDeletedDocument, options)
}
export type VersionDeletedSubscriptionHookResult = ReturnType<
  typeof useVersionDeletedSubscription
>
export type VersionDeletedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.VersionDeletedSubscription>
export const VersionUpdatedDocument = /*#__PURE__*/ gql`
  subscription versionUpdated {
    versionUpdated {
      ...VersionListItem
      share {
        identifier
      }
    }
  }
  ${VersionListItemFragmentDoc}
`

/**
 * __useVersionUpdatedSubscription__
 *
 * To run a query within a React component, call `useVersionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVersionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useVersionUpdatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.VersionUpdatedSubscription,
    Types.VersionUpdatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.VersionUpdatedSubscription,
    Types.VersionUpdatedSubscriptionVariables
  >(VersionUpdatedDocument, options)
}
export type VersionUpdatedSubscriptionHookResult = ReturnType<
  typeof useVersionUpdatedSubscription
>
export type VersionUpdatedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.VersionUpdatedSubscription>
export const GetVersionHistoryDocument = /*#__PURE__*/ gql`
  query getVersionHistory(
    $shareIdentifier: ShortId!
    $after: String = null
    $limit: Int = 20
  ) {
    share(shortId: $shareIdentifier) {
      ...ShareVersionHistory
    }
  }
  ${ShareVersionHistoryFragmentDoc}
`

/**
 * __useGetVersionHistoryQuery__
 *
 * To run a query within a React component, call `useGetVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVersionHistoryQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetVersionHistoryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetVersionHistoryQuery,
    Types.GetVersionHistoryQueryVariables
  > &
    (
      | { variables: Types.GetVersionHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetVersionHistoryQuery,
    Types.GetVersionHistoryQueryVariables
  >(GetVersionHistoryDocument, options)
}
export function useGetVersionHistoryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetVersionHistoryQuery,
    Types.GetVersionHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetVersionHistoryQuery,
    Types.GetVersionHistoryQueryVariables
  >(GetVersionHistoryDocument, options)
}

export type GetVersionHistoryQueryHookResult = ReturnType<
  typeof useGetVersionHistoryQuery
>
export type GetVersionHistoryLazyQueryHookResult = ReturnType<
  typeof useGetVersionHistoryLazyQuery
>
export type GetVersionHistoryQueryResult = ApolloReactCommon.QueryResult<
  Types.GetVersionHistoryQuery,
  Types.GetVersionHistoryQueryVariables
>
export const GetWorkspaceBillingDocument = /*#__PURE__*/ gql`
  query getWorkspaceBilling($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      customer {
        identifier
        billing {
          ...BillingMinimal
        }
      }
    }
  }
  ${BillingMinimalFragmentDoc}
`

/**
 * __useGetWorkspaceBillingQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceBillingQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceBillingQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceBillingQuery,
    Types.GetWorkspaceBillingQueryVariables
  > &
    (
      | { variables: Types.GetWorkspaceBillingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceBillingQuery,
    Types.GetWorkspaceBillingQueryVariables
  >(GetWorkspaceBillingDocument, options)
}
export function useGetWorkspaceBillingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceBillingQuery,
    Types.GetWorkspaceBillingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceBillingQuery,
    Types.GetWorkspaceBillingQueryVariables
  >(GetWorkspaceBillingDocument, options)
}

export type GetWorkspaceBillingQueryHookResult = ReturnType<
  typeof useGetWorkspaceBillingQuery
>
export type GetWorkspaceBillingLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceBillingLazyQuery
>
export type GetWorkspaceBillingQueryResult = ApolloReactCommon.QueryResult<
  Types.GetWorkspaceBillingQuery,
  Types.GetWorkspaceBillingQueryVariables
>
export const GetBillingForWorkspaceNoticeDocument = /*#__PURE__*/ gql`
  query getBillingForWorkspaceNotice($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      customer {
        identifier
        billing {
          ...BillingWorkspaceNotice
        }
      }
    }
  }
  ${BillingWorkspaceNoticeFragmentDoc}
`

/**
 * __useGetBillingForWorkspaceNoticeQuery__
 *
 * To run a query within a React component, call `useGetBillingForWorkspaceNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingForWorkspaceNoticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingForWorkspaceNoticeQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetBillingForWorkspaceNoticeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetBillingForWorkspaceNoticeQuery,
    Types.GetBillingForWorkspaceNoticeQueryVariables
  > &
    (
      | {
          variables: Types.GetBillingForWorkspaceNoticeQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetBillingForWorkspaceNoticeQuery,
    Types.GetBillingForWorkspaceNoticeQueryVariables
  >(GetBillingForWorkspaceNoticeDocument, options)
}
export function useGetBillingForWorkspaceNoticeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetBillingForWorkspaceNoticeQuery,
    Types.GetBillingForWorkspaceNoticeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetBillingForWorkspaceNoticeQuery,
    Types.GetBillingForWorkspaceNoticeQueryVariables
  >(GetBillingForWorkspaceNoticeDocument, options)
}

export type GetBillingForWorkspaceNoticeQueryHookResult = ReturnType<
  typeof useGetBillingForWorkspaceNoticeQuery
>
export type GetBillingForWorkspaceNoticeLazyQueryHookResult = ReturnType<
  typeof useGetBillingForWorkspaceNoticeLazyQuery
>
export type GetBillingForWorkspaceNoticeQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetBillingForWorkspaceNoticeQuery,
    Types.GetBillingForWorkspaceNoticeQueryVariables
  >
export const GetNextBillingCycleDocument = /*#__PURE__*/ gql`
  query getNextBillingCycle($customerId: UUID!) @PaymentQLApi {
    customer(id: $customerId) {
      id
      billingSummary {
        next {
          invoice
          currency
        }
      }
    }
  }
`

/**
 * __useGetNextBillingCycleQuery__
 *
 * To run a query within a React component, call `useGetNextBillingCycleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextBillingCycleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextBillingCycleQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetNextBillingCycleQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetNextBillingCycleQuery,
    Types.GetNextBillingCycleQueryVariables
  > &
    (
      | { variables: Types.GetNextBillingCycleQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNextBillingCycleQuery,
    Types.GetNextBillingCycleQueryVariables
  >(GetNextBillingCycleDocument, options)
}
export function useGetNextBillingCycleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNextBillingCycleQuery,
    Types.GetNextBillingCycleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNextBillingCycleQuery,
    Types.GetNextBillingCycleQueryVariables
  >(GetNextBillingCycleDocument, options)
}

export type GetNextBillingCycleQueryHookResult = ReturnType<
  typeof useGetNextBillingCycleQuery
>
export type GetNextBillingCycleLazyQueryHookResult = ReturnType<
  typeof useGetNextBillingCycleLazyQuery
>
export type GetNextBillingCycleQueryResult = ApolloReactCommon.QueryResult<
  Types.GetNextBillingCycleQuery,
  Types.GetNextBillingCycleQueryVariables
>
export const UpdateBillingDetailsDocument = /*#__PURE__*/ gql`
  mutation updateBillingDetails($input: UpdateBillingDetailsInput!)
  @PaymentQLApi {
    updateBillingDetails(input: $input) {
      customer {
        id
        billingDetails {
          ...BillingDetails
        }
      }
    }
  }
  ${BillingDetailsFragmentDoc}
`
export type UpdateBillingDetailsMutationFn = ApolloReactCommon.MutationFunction<
  Types.UpdateBillingDetailsMutation,
  Types.UpdateBillingDetailsMutationVariables
>

/**
 * __useUpdateBillingDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateBillingDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingDetailsMutation, { data, loading, error }] = useUpdateBillingDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingDetailsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateBillingDetailsMutation,
    Types.UpdateBillingDetailsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateBillingDetailsMutation,
    Types.UpdateBillingDetailsMutationVariables
  >(UpdateBillingDetailsDocument, options)
}
export type UpdateBillingDetailsMutationHookResult = ReturnType<
  typeof useUpdateBillingDetailsMutation
>
export type UpdateBillingDetailsMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateBillingDetailsMutation>
export type UpdateBillingDetailsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateBillingDetailsMutation,
    Types.UpdateBillingDetailsMutationVariables
  >
export const GetBillingHistoryDocument = /*#__PURE__*/ gql`
  query getBillingHistory($customerId: UUID!, $after: String, $limit: Int! = 10)
  @PaymentQLApi {
    customer(id: $customerId) {
      id
      billingHistory(after: $after, limit: $limit) {
        entries {
          ...BillingHistoryEntry
        }
        meta {
          after
          totalCount
        }
      }
    }
  }
  ${BillingHistoryEntryFragmentDoc}
`

/**
 * __useGetBillingHistoryQuery__
 *
 * To run a query within a React component, call `useGetBillingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingHistoryQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBillingHistoryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetBillingHistoryQuery,
    Types.GetBillingHistoryQueryVariables
  > &
    (
      | { variables: Types.GetBillingHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetBillingHistoryQuery,
    Types.GetBillingHistoryQueryVariables
  >(GetBillingHistoryDocument, options)
}
export function useGetBillingHistoryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetBillingHistoryQuery,
    Types.GetBillingHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetBillingHistoryQuery,
    Types.GetBillingHistoryQueryVariables
  >(GetBillingHistoryDocument, options)
}

export type GetBillingHistoryQueryHookResult = ReturnType<
  typeof useGetBillingHistoryQuery
>
export type GetBillingHistoryLazyQueryHookResult = ReturnType<
  typeof useGetBillingHistoryLazyQuery
>
export type GetBillingHistoryQueryResult = ApolloReactCommon.QueryResult<
  Types.GetBillingHistoryQuery,
  Types.GetBillingHistoryQueryVariables
>
export const ChangePlanDocument = /*#__PURE__*/ gql`
  mutation changePlan($input: ChangePlanInput!) @PaymentQLApi {
    changePlan(input: $input) {
      customer {
        id
        paymentDetails {
          ...PaymentDetails
        }
      }
    }
  }
  ${PaymentDetailsFragmentDoc}
`
export type ChangePlanMutationFn = ApolloReactCommon.MutationFunction<
  Types.ChangePlanMutation,
  Types.ChangePlanMutationVariables
>

/**
 * __useChangePlanMutation__
 *
 * To run a mutation, you first call `useChangePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePlanMutation, { data, loading, error }] = useChangePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePlanMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ChangePlanMutation,
    Types.ChangePlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ChangePlanMutation,
    Types.ChangePlanMutationVariables
  >(ChangePlanDocument, options)
}
export type ChangePlanMutationHookResult = ReturnType<
  typeof useChangePlanMutation
>
export type ChangePlanMutationResult =
  ApolloReactCommon.MutationResult<Types.ChangePlanMutation>
export type ChangePlanMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ChangePlanMutation,
  Types.ChangePlanMutationVariables
>
export const GetAvailablePlansDocument = /*#__PURE__*/ gql`
  query getAvailablePlans @PaymentQLApi {
    availablePlans: availableCloudPlans {
      ... on CloudBillingPlan {
        ...CloudBillingPlan
      }
    }
  }
  ${CloudBillingPlanFragmentDoc}
`

/**
 * __useGetAvailablePlansQuery__
 *
 * To run a query within a React component, call `useGetAvailablePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailablePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailablePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailablePlansQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetAvailablePlansQuery,
    Types.GetAvailablePlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAvailablePlansQuery,
    Types.GetAvailablePlansQueryVariables
  >(GetAvailablePlansDocument, options)
}
export function useGetAvailablePlansLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAvailablePlansQuery,
    Types.GetAvailablePlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAvailablePlansQuery,
    Types.GetAvailablePlansQueryVariables
  >(GetAvailablePlansDocument, options)
}

export type GetAvailablePlansQueryHookResult = ReturnType<
  typeof useGetAvailablePlansQuery
>
export type GetAvailablePlansLazyQueryHookResult = ReturnType<
  typeof useGetAvailablePlansLazyQuery
>
export type GetAvailablePlansQueryResult = ApolloReactCommon.QueryResult<
  Types.GetAvailablePlansQuery,
  Types.GetAvailablePlansQueryVariables
>
export const SubscriptionUpdateBillingSimulationDocument = /*#__PURE__*/ gql`
  query subscriptionUpdateBillingSimulation(
    $customerId: UUID!
    $seats: Int!
    $planId: String!
    $promotionCode: String
  ) @PaymentQLApi {
    subscriptionUpdateBillingSimulation(
      customerId: $customerId
      seats: $seats
      planId: $planId
      promotionCode: $promotionCode
    ) {
      price {
        ...BillingPrice
      }
      prorated {
        creditsAmount
        chargeAmount
        price {
          ...Price
        }
        daysRemainingInCycle
        discountForUnusedDays
        couponInfo {
          ...Coupon
        }
      }
      couponInfo {
        ...Coupon
      }
    }
  }
  ${BillingPriceFragmentDoc}
  ${PriceFragmentDoc}
  ${CouponFragmentDoc}
`

/**
 * __useSubscriptionUpdateBillingSimulationQuery__
 *
 * To run a query within a React component, call `useSubscriptionUpdateBillingSimulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionUpdateBillingSimulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionUpdateBillingSimulationQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      seats: // value for 'seats'
 *      planId: // value for 'planId'
 *      promotionCode: // value for 'promotionCode'
 *   },
 * });
 */
export function useSubscriptionUpdateBillingSimulationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.SubscriptionUpdateBillingSimulationQuery,
    Types.SubscriptionUpdateBillingSimulationQueryVariables
  > &
    (
      | {
          variables: Types.SubscriptionUpdateBillingSimulationQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.SubscriptionUpdateBillingSimulationQuery,
    Types.SubscriptionUpdateBillingSimulationQueryVariables
  >(SubscriptionUpdateBillingSimulationDocument, options)
}
export function useSubscriptionUpdateBillingSimulationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.SubscriptionUpdateBillingSimulationQuery,
    Types.SubscriptionUpdateBillingSimulationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.SubscriptionUpdateBillingSimulationQuery,
    Types.SubscriptionUpdateBillingSimulationQueryVariables
  >(SubscriptionUpdateBillingSimulationDocument, options)
}

export type SubscriptionUpdateBillingSimulationQueryHookResult = ReturnType<
  typeof useSubscriptionUpdateBillingSimulationQuery
>
export type SubscriptionUpdateBillingSimulationLazyQueryHookResult = ReturnType<
  typeof useSubscriptionUpdateBillingSimulationLazyQuery
>
export type SubscriptionUpdateBillingSimulationQueryResult =
  ApolloReactCommon.QueryResult<
    Types.SubscriptionUpdateBillingSimulationQuery,
    Types.SubscriptionUpdateBillingSimulationQueryVariables
  >
export const CancelScheduledBillingSeatsDocument = /*#__PURE__*/ gql`
  mutation cancelScheduledBillingSeats($workspaceId: UUID!) {
    cancelScheduledBillingSeats(input: { workspaceIdentifier: $workspaceId }) {
      workspace {
        identifier
        customer {
          identifier
          billing {
            seats {
              ...BillingSeatsInfo
            }
          }
        }
      }
    }
  }
  ${BillingSeatsInfoFragmentDoc}
`
export type CancelScheduledBillingSeatsMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.CancelScheduledBillingSeatsMutation,
    Types.CancelScheduledBillingSeatsMutationVariables
  >

/**
 * __useCancelScheduledBillingSeatsMutation__
 *
 * To run a mutation, you first call `useCancelScheduledBillingSeatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledBillingSeatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledBillingSeatsMutation, { data, loading, error }] = useCancelScheduledBillingSeatsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCancelScheduledBillingSeatsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CancelScheduledBillingSeatsMutation,
    Types.CancelScheduledBillingSeatsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CancelScheduledBillingSeatsMutation,
    Types.CancelScheduledBillingSeatsMutationVariables
  >(CancelScheduledBillingSeatsDocument, options)
}
export type CancelScheduledBillingSeatsMutationHookResult = ReturnType<
  typeof useCancelScheduledBillingSeatsMutation
>
export type CancelScheduledBillingSeatsMutationResult =
  ApolloReactCommon.MutationResult<Types.CancelScheduledBillingSeatsMutation>
export type CancelScheduledBillingSeatsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CancelScheduledBillingSeatsMutation,
    Types.CancelScheduledBillingSeatsMutationVariables
  >
export const UpdateBillingSeatsDocument = /*#__PURE__*/ gql`
  mutation updateBillingSeats($input: UpdateBillingSeatsParams!) {
    updateBillingSeats(input: $input) {
      workspace {
        identifier
        customer {
          identifier
          billing {
            seats {
              ...BillingSeatsInfo
            }
          }
        }
      }
      pendingScaToken
    }
  }
  ${BillingSeatsInfoFragmentDoc}
`
export type UpdateBillingSeatsMutationFn = ApolloReactCommon.MutationFunction<
  Types.UpdateBillingSeatsMutation,
  Types.UpdateBillingSeatsMutationVariables
>

/**
 * __useUpdateBillingSeatsMutation__
 *
 * To run a mutation, you first call `useUpdateBillingSeatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingSeatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingSeatsMutation, { data, loading, error }] = useUpdateBillingSeatsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingSeatsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateBillingSeatsMutation,
    Types.UpdateBillingSeatsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateBillingSeatsMutation,
    Types.UpdateBillingSeatsMutationVariables
  >(UpdateBillingSeatsDocument, options)
}
export type UpdateBillingSeatsMutationHookResult = ReturnType<
  typeof useUpdateBillingSeatsMutation
>
export type UpdateBillingSeatsMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateBillingSeatsMutation>
export type UpdateBillingSeatsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateBillingSeatsMutation,
    Types.UpdateBillingSeatsMutationVariables
  >
export const ApplyCouponDocument = /*#__PURE__*/ gql`
  mutation applyCoupon($promotionCode: String!, $customerId: UUID!)
  @PaymentQLApi {
    applyCoupon(promotionCode: $promotionCode, customerId: $customerId) {
      customer {
        id
        subscriptionInfo {
          status
        }
      }
    }
  }
`
export type ApplyCouponMutationFn = ApolloReactCommon.MutationFunction<
  Types.ApplyCouponMutation,
  Types.ApplyCouponMutationVariables
>

/**
 * __useApplyCouponMutation__
 *
 * To run a mutation, you first call `useApplyCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponMutation, { data, loading, error }] = useApplyCouponMutation({
 *   variables: {
 *      promotionCode: // value for 'promotionCode'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useApplyCouponMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ApplyCouponMutation,
    Types.ApplyCouponMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ApplyCouponMutation,
    Types.ApplyCouponMutationVariables
  >(ApplyCouponDocument, options)
}
export type ApplyCouponMutationHookResult = ReturnType<
  typeof useApplyCouponMutation
>
export type ApplyCouponMutationResult =
  ApolloReactCommon.MutationResult<Types.ApplyCouponMutation>
export type ApplyCouponMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ApplyCouponMutation,
  Types.ApplyCouponMutationVariables
>
export const GetClientCurrencyDocument = /*#__PURE__*/ gql`
  query getClientCurrency($token: String) @PaymentQLApi {
    currencies(token: $token) {
      default
      available
    }
  }
`

/**
 * __useGetClientCurrencyQuery__
 *
 * To run a query within a React component, call `useGetClientCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCurrencyQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetClientCurrencyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetClientCurrencyQuery,
    Types.GetClientCurrencyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetClientCurrencyQuery,
    Types.GetClientCurrencyQueryVariables
  >(GetClientCurrencyDocument, options)
}
export function useGetClientCurrencyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetClientCurrencyQuery,
    Types.GetClientCurrencyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetClientCurrencyQuery,
    Types.GetClientCurrencyQueryVariables
  >(GetClientCurrencyDocument, options)
}

export type GetClientCurrencyQueryHookResult = ReturnType<
  typeof useGetClientCurrencyQuery
>
export type GetClientCurrencyLazyQueryHookResult = ReturnType<
  typeof useGetClientCurrencyLazyQuery
>
export type GetClientCurrencyQueryResult = ApolloReactCommon.QueryResult<
  Types.GetClientCurrencyQuery,
  Types.GetClientCurrencyQueryVariables
>
export const SubscribeCustomerToPlanDocument = /*#__PURE__*/ gql`
  mutation subscribeCustomerToPlan($input: SubscribeCustomerToPlanInput!)
  @PaymentQLApi {
    subscribeCustomerToPlan(input: $input) {
      pendingScaToken
      customer {
        id
        paymentDetails {
          ...PaymentDetails
        }
      }
    }
  }
  ${PaymentDetailsFragmentDoc}
`
export type SubscribeCustomerToPlanMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.SubscribeCustomerToPlanMutation,
    Types.SubscribeCustomerToPlanMutationVariables
  >

/**
 * __useSubscribeCustomerToPlanMutation__
 *
 * To run a mutation, you first call `useSubscribeCustomerToPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeCustomerToPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeCustomerToPlanMutation, { data, loading, error }] = useSubscribeCustomerToPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeCustomerToPlanMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SubscribeCustomerToPlanMutation,
    Types.SubscribeCustomerToPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SubscribeCustomerToPlanMutation,
    Types.SubscribeCustomerToPlanMutationVariables
  >(SubscribeCustomerToPlanDocument, options)
}
export type SubscribeCustomerToPlanMutationHookResult = ReturnType<
  typeof useSubscribeCustomerToPlanMutation
>
export type SubscribeCustomerToPlanMutationResult =
  ApolloReactCommon.MutationResult<Types.SubscribeCustomerToPlanMutation>
export type SubscribeCustomerToPlanMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.SubscribeCustomerToPlanMutation,
    Types.SubscribeCustomerToPlanMutationVariables
  >
export const GetCustomerDocument = /*#__PURE__*/ gql`
  query getCustomer($customerId: UUID!) @PaymentQLApi {
    customer(id: $customerId) {
      id
      creditBalance {
        ...CreditBalance
      }
      subscriptionInfo {
        renewalDate
        ... on CloudSubscription {
          pendingScaToken
        }
        ...SubscriptionInfoPlan
      }
      billingSummary {
        next {
          ...BillingPrice
        }
        current {
          currency
        }
      }
      paymentDetails {
        ...PaymentDetails
      }
      billingDetails {
        ...BillingDetails
      }
    }
  }
  ${CreditBalanceFragmentDoc}
  ${SubscriptionInfoPlanFragmentDoc}
  ${BillingPriceFragmentDoc}
  ${PaymentDetailsFragmentDoc}
  ${BillingDetailsFragmentDoc}
`

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetCustomerQuery,
    Types.GetCustomerQueryVariables
  > &
    (
      | { variables: Types.GetCustomerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCustomerQuery,
    Types.GetCustomerQueryVariables
  >(GetCustomerDocument, options)
}
export function useGetCustomerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCustomerQuery,
    Types.GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCustomerQuery,
    Types.GetCustomerQueryVariables
  >(GetCustomerDocument, options)
}

export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>
export type GetCustomerLazyQueryHookResult = ReturnType<
  typeof useGetCustomerLazyQuery
>
export type GetCustomerQueryResult = ApolloReactCommon.QueryResult<
  Types.GetCustomerQuery,
  Types.GetCustomerQueryVariables
>
export const GetCustomerForPartnerSubscribeDocument = /*#__PURE__*/ gql`
  query getCustomerForPartnerSubscribe($customerId: UUID!) @PaymentQLApi {
    customer(id: $customerId) {
      id
      billingSummary {
        current {
          currency
        }
      }
      subscriptionInfo {
        status
        ... on CloudSubscription {
          trialEnd
          pendingScaToken
          scheduledSeatsTotal
          currentSeatsTotal
        }
        ...SubscriptionInfoPlan
      }
    }
  }
  ${SubscriptionInfoPlanFragmentDoc}
`

/**
 * __useGetCustomerForPartnerSubscribeQuery__
 *
 * To run a query within a React component, call `useGetCustomerForPartnerSubscribeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerForPartnerSubscribeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerForPartnerSubscribeQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerForPartnerSubscribeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetCustomerForPartnerSubscribeQuery,
    Types.GetCustomerForPartnerSubscribeQueryVariables
  > &
    (
      | {
          variables: Types.GetCustomerForPartnerSubscribeQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCustomerForPartnerSubscribeQuery,
    Types.GetCustomerForPartnerSubscribeQueryVariables
  >(GetCustomerForPartnerSubscribeDocument, options)
}
export function useGetCustomerForPartnerSubscribeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCustomerForPartnerSubscribeQuery,
    Types.GetCustomerForPartnerSubscribeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCustomerForPartnerSubscribeQuery,
    Types.GetCustomerForPartnerSubscribeQueryVariables
  >(GetCustomerForPartnerSubscribeDocument, options)
}

export type GetCustomerForPartnerSubscribeQueryHookResult = ReturnType<
  typeof useGetCustomerForPartnerSubscribeQuery
>
export type GetCustomerForPartnerSubscribeLazyQueryHookResult = ReturnType<
  typeof useGetCustomerForPartnerSubscribeLazyQuery
>
export type GetCustomerForPartnerSubscribeQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetCustomerForPartnerSubscribeQuery,
    Types.GetCustomerForPartnerSubscribeQueryVariables
  >
export const GetCustomerProviderDocument = /*#__PURE__*/ gql`
  query getCustomerProvider($customerId: UUID!) @PaymentQLApi {
    customer(id: $customerId) {
      id
      subscriptionInfo {
        status
      }
    }
  }
`

/**
 * __useGetCustomerProviderQuery__
 *
 * To run a query within a React component, call `useGetCustomerProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerProviderQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerProviderQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetCustomerProviderQuery,
    Types.GetCustomerProviderQueryVariables
  > &
    (
      | { variables: Types.GetCustomerProviderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCustomerProviderQuery,
    Types.GetCustomerProviderQueryVariables
  >(GetCustomerProviderDocument, options)
}
export function useGetCustomerProviderLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCustomerProviderQuery,
    Types.GetCustomerProviderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCustomerProviderQuery,
    Types.GetCustomerProviderQueryVariables
  >(GetCustomerProviderDocument, options)
}

export type GetCustomerProviderQueryHookResult = ReturnType<
  typeof useGetCustomerProviderQuery
>
export type GetCustomerProviderLazyQueryHookResult = ReturnType<
  typeof useGetCustomerProviderLazyQuery
>
export type GetCustomerProviderQueryResult = ApolloReactCommon.QueryResult<
  Types.GetCustomerProviderQuery,
  Types.GetCustomerProviderQueryVariables
>
export const GetCustomerSignupSourceDocument = /*#__PURE__*/ gql`
  query getCustomerSignupSource($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      customer {
        identifier
        source
      }
    }
  }
`

/**
 * __useGetCustomerSignupSourceQuery__
 *
 * To run a query within a React component, call `useGetCustomerSignupSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSignupSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSignupSourceQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetCustomerSignupSourceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetCustomerSignupSourceQuery,
    Types.GetCustomerSignupSourceQueryVariables
  > &
    (
      | {
          variables: Types.GetCustomerSignupSourceQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCustomerSignupSourceQuery,
    Types.GetCustomerSignupSourceQueryVariables
  >(GetCustomerSignupSourceDocument, options)
}
export function useGetCustomerSignupSourceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCustomerSignupSourceQuery,
    Types.GetCustomerSignupSourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCustomerSignupSourceQuery,
    Types.GetCustomerSignupSourceQueryVariables
  >(GetCustomerSignupSourceDocument, options)
}

export type GetCustomerSignupSourceQueryHookResult = ReturnType<
  typeof useGetCustomerSignupSourceQuery
>
export type GetCustomerSignupSourceLazyQueryHookResult = ReturnType<
  typeof useGetCustomerSignupSourceLazyQuery
>
export type GetCustomerSignupSourceQueryResult = ApolloReactCommon.QueryResult<
  Types.GetCustomerSignupSourceQuery,
  Types.GetCustomerSignupSourceQueryVariables
>
export const DraftBillingSummaryDocument = /*#__PURE__*/ gql`
  query draftBillingSummary(
    $planId: String!
    $seats: Int!
    $promotionCode: String
    $currency: Currency
  ) @PaymentQLApi {
    draftBillingSummary(
      planID: $planId
      seats: $seats
      promotionCode: $promotionCode
      currency: $currency
    ) {
      memberPrice {
        ...BillingPrice
      }
      price {
        ...BillingPrice
      }
      trialEnd
      couponInfo {
        ...Coupon
      }
    }
  }
  ${BillingPriceFragmentDoc}
  ${CouponFragmentDoc}
`

/**
 * __useDraftBillingSummaryQuery__
 *
 * To run a query within a React component, call `useDraftBillingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftBillingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftBillingSummaryQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *      seats: // value for 'seats'
 *      promotionCode: // value for 'promotionCode'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useDraftBillingSummaryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.DraftBillingSummaryQuery,
    Types.DraftBillingSummaryQueryVariables
  > &
    (
      | { variables: Types.DraftBillingSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.DraftBillingSummaryQuery,
    Types.DraftBillingSummaryQueryVariables
  >(DraftBillingSummaryDocument, options)
}
export function useDraftBillingSummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.DraftBillingSummaryQuery,
    Types.DraftBillingSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.DraftBillingSummaryQuery,
    Types.DraftBillingSummaryQueryVariables
  >(DraftBillingSummaryDocument, options)
}

export type DraftBillingSummaryQueryHookResult = ReturnType<
  typeof useDraftBillingSummaryQuery
>
export type DraftBillingSummaryLazyQueryHookResult = ReturnType<
  typeof useDraftBillingSummaryLazyQuery
>
export type DraftBillingSummaryQueryResult = ApolloReactCommon.QueryResult<
  Types.DraftBillingSummaryQuery,
  Types.DraftBillingSummaryQueryVariables
>
export const UpdatePaymentMethodDocument = /*#__PURE__*/ gql`
  mutation updatePaymentMethod($input: UpdatePaymentMethodInput!)
  @PaymentQLApi {
    updatePaymentMethod(input: $input) {
      customer {
        id
        paymentDetails {
          ...PaymentDetails
        }
        subscriptionInfo {
          ... on CloudSubscription {
            pendingScaToken
          }
        }
      }
    }
  }
  ${PaymentDetailsFragmentDoc}
`
export type UpdatePaymentMethodMutationFn = ApolloReactCommon.MutationFunction<
  Types.UpdatePaymentMethodMutation,
  Types.UpdatePaymentMethodMutationVariables
>

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdatePaymentMethodMutation,
    Types.UpdatePaymentMethodMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdatePaymentMethodMutation,
    Types.UpdatePaymentMethodMutationVariables
  >(UpdatePaymentMethodDocument, options)
}
export type UpdatePaymentMethodMutationHookResult = ReturnType<
  typeof useUpdatePaymentMethodMutation
>
export type UpdatePaymentMethodMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdatePaymentMethodMutation>
export type UpdatePaymentMethodMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdatePaymentMethodMutation,
    Types.UpdatePaymentMethodMutationVariables
  >
export const CreateSetupIntentDocument = /*#__PURE__*/ gql`
  mutation createSetupIntent($input: CreateSetupIntentInput!) @PaymentQLApi {
    createSetupIntent(input: $input) {
      pendingScaToken
    }
  }
`
export type CreateSetupIntentMutationFn = ApolloReactCommon.MutationFunction<
  Types.CreateSetupIntentMutation,
  Types.CreateSetupIntentMutationVariables
>

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSetupIntentMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateSetupIntentMutation,
    Types.CreateSetupIntentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateSetupIntentMutation,
    Types.CreateSetupIntentMutationVariables
  >(CreateSetupIntentDocument, options)
}
export type CreateSetupIntentMutationHookResult = ReturnType<
  typeof useCreateSetupIntentMutation
>
export type CreateSetupIntentMutationResult =
  ApolloReactCommon.MutationResult<Types.CreateSetupIntentMutation>
export type CreateSetupIntentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreateSetupIntentMutation,
    Types.CreateSetupIntentMutationVariables
  >
export const GetPaymentDetailsDocument = /*#__PURE__*/ gql`
  query getPaymentDetails($customerId: UUID!) @PaymentQLApi {
    customer(id: $customerId) {
      id
      paymentDetails {
        ...PaymentDetails
      }
    }
  }
  ${PaymentDetailsFragmentDoc}
`

/**
 * __useGetPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentDetailsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPaymentDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPaymentDetailsQuery,
    Types.GetPaymentDetailsQueryVariables
  > &
    (
      | { variables: Types.GetPaymentDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPaymentDetailsQuery,
    Types.GetPaymentDetailsQueryVariables
  >(GetPaymentDetailsDocument, options)
}
export function useGetPaymentDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPaymentDetailsQuery,
    Types.GetPaymentDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPaymentDetailsQuery,
    Types.GetPaymentDetailsQueryVariables
  >(GetPaymentDetailsDocument, options)
}

export type GetPaymentDetailsQueryHookResult = ReturnType<
  typeof useGetPaymentDetailsQuery
>
export type GetPaymentDetailsLazyQueryHookResult = ReturnType<
  typeof useGetPaymentDetailsLazyQuery
>
export type GetPaymentDetailsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPaymentDetailsQuery,
  Types.GetPaymentDetailsQueryVariables
>
export const GetSeatsUpdateBillingSimulationDocument = /*#__PURE__*/ gql`
  query getSeatsUpdateBillingSimulation($customerId: UUID!, $totalSeats: Int!)
  @PaymentQLApi {
    seatsUpdateBillingSimulation(customerId: $customerId, seats: $totalSeats) {
      price {
        ...BillingPrice
      }
      extraSeatsPrice {
        ...BillingPrice
      }
      prorated {
        price {
          ...Price
        }
        creditsAmount
        chargeAmount
        daysElapsedInCycle
        discountForUnusedDays
      }
      couponInfo {
        ...Coupon
      }
    }
  }
  ${BillingPriceFragmentDoc}
  ${PriceFragmentDoc}
  ${CouponFragmentDoc}
`

/**
 * __useGetSeatsUpdateBillingSimulationQuery__
 *
 * To run a query within a React component, call `useGetSeatsUpdateBillingSimulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeatsUpdateBillingSimulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeatsUpdateBillingSimulationQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      totalSeats: // value for 'totalSeats'
 *   },
 * });
 */
export function useGetSeatsUpdateBillingSimulationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSeatsUpdateBillingSimulationQuery,
    Types.GetSeatsUpdateBillingSimulationQueryVariables
  > &
    (
      | {
          variables: Types.GetSeatsUpdateBillingSimulationQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSeatsUpdateBillingSimulationQuery,
    Types.GetSeatsUpdateBillingSimulationQueryVariables
  >(GetSeatsUpdateBillingSimulationDocument, options)
}
export function useGetSeatsUpdateBillingSimulationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSeatsUpdateBillingSimulationQuery,
    Types.GetSeatsUpdateBillingSimulationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSeatsUpdateBillingSimulationQuery,
    Types.GetSeatsUpdateBillingSimulationQueryVariables
  >(GetSeatsUpdateBillingSimulationDocument, options)
}

export type GetSeatsUpdateBillingSimulationQueryHookResult = ReturnType<
  typeof useGetSeatsUpdateBillingSimulationQuery
>
export type GetSeatsUpdateBillingSimulationLazyQueryHookResult = ReturnType<
  typeof useGetSeatsUpdateBillingSimulationLazyQuery
>
export type GetSeatsUpdateBillingSimulationQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetSeatsUpdateBillingSimulationQuery,
    Types.GetSeatsUpdateBillingSimulationQueryVariables
  >
export const CancelSubscriptionDocument = /*#__PURE__*/ gql`
  mutation cancelSubscription($customerId: UUID!) @PaymentQLApi {
    cancelSubscription(customerId: $customerId) {
      customer {
        id
        subscriptionInfo {
          subscriptionEnd
          renewalDate
        }
      }
    }
  }
`
export type CancelSubscriptionMutationFn = ApolloReactCommon.MutationFunction<
  Types.CancelSubscriptionMutation,
  Types.CancelSubscriptionMutationVariables
>

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CancelSubscriptionMutation,
    Types.CancelSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CancelSubscriptionMutation,
    Types.CancelSubscriptionMutationVariables
  >(CancelSubscriptionDocument, options)
}
export type CancelSubscriptionMutationHookResult = ReturnType<
  typeof useCancelSubscriptionMutation
>
export type CancelSubscriptionMutationResult =
  ApolloReactCommon.MutationResult<Types.CancelSubscriptionMutation>
export type CancelSubscriptionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CancelSubscriptionMutation,
    Types.CancelSubscriptionMutationVariables
  >
export const UndoScheduledSubscriptionCancellationDocument = /*#__PURE__*/ gql`
  mutation undoScheduledSubscriptionCancellation($customerId: UUID!)
  @PaymentQLApi {
    undoScheduledSubscriptionCancellation(customerId: $customerId) {
      customer {
        id
        subscriptionInfo {
          subscriptionEnd
          renewalDate
        }
      }
    }
  }
`
export type UndoScheduledSubscriptionCancellationMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UndoScheduledSubscriptionCancellationMutation,
    Types.UndoScheduledSubscriptionCancellationMutationVariables
  >

/**
 * __useUndoScheduledSubscriptionCancellationMutation__
 *
 * To run a mutation, you first call `useUndoScheduledSubscriptionCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoScheduledSubscriptionCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoScheduledSubscriptionCancellationMutation, { data, loading, error }] = useUndoScheduledSubscriptionCancellationMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useUndoScheduledSubscriptionCancellationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UndoScheduledSubscriptionCancellationMutation,
    Types.UndoScheduledSubscriptionCancellationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UndoScheduledSubscriptionCancellationMutation,
    Types.UndoScheduledSubscriptionCancellationMutationVariables
  >(UndoScheduledSubscriptionCancellationDocument, options)
}
export type UndoScheduledSubscriptionCancellationMutationHookResult =
  ReturnType<typeof useUndoScheduledSubscriptionCancellationMutation>
export type UndoScheduledSubscriptionCancellationMutationResult =
  ApolloReactCommon.MutationResult<Types.UndoScheduledSubscriptionCancellationMutation>
export type UndoScheduledSubscriptionCancellationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UndoScheduledSubscriptionCancellationMutation,
    Types.UndoScheduledSubscriptionCancellationMutationVariables
  >
export const ReactivateSubscriptionDocument = /*#__PURE__*/ gql`
  mutation ReactivateSubscription($customerId: UUID!) @PaymentQLApi {
    reactivateSubscription(customerId: $customerId) {
      customer {
        id
      }
    }
  }
`
export type ReactivateSubscriptionMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.ReactivateSubscriptionMutation,
    Types.ReactivateSubscriptionMutationVariables
  >

/**
 * __useReactivateSubscriptionMutation__
 *
 * To run a mutation, you first call `useReactivateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateSubscriptionMutation, { data, loading, error }] = useReactivateSubscriptionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useReactivateSubscriptionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ReactivateSubscriptionMutation,
    Types.ReactivateSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ReactivateSubscriptionMutation,
    Types.ReactivateSubscriptionMutationVariables
  >(ReactivateSubscriptionDocument, options)
}
export type ReactivateSubscriptionMutationHookResult = ReturnType<
  typeof useReactivateSubscriptionMutation
>
export type ReactivateSubscriptionMutationResult =
  ApolloReactCommon.MutationResult<Types.ReactivateSubscriptionMutation>
export type ReactivateSubscriptionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ReactivateSubscriptionMutation,
    Types.ReactivateSubscriptionMutationVariables
  >
export const GetTaxableCountriesDocument = /*#__PURE__*/ gql`
  query getTaxableCountries @PaymentQLApi {
    taxableCountries {
      code
    }
  }
`

/**
 * __useGetTaxableCountriesQuery__
 *
 * To run a query within a React component, call `useGetTaxableCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxableCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxableCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxableCountriesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetTaxableCountriesQuery,
    Types.GetTaxableCountriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetTaxableCountriesQuery,
    Types.GetTaxableCountriesQueryVariables
  >(GetTaxableCountriesDocument, options)
}
export function useGetTaxableCountriesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetTaxableCountriesQuery,
    Types.GetTaxableCountriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetTaxableCountriesQuery,
    Types.GetTaxableCountriesQueryVariables
  >(GetTaxableCountriesDocument, options)
}

export type GetTaxableCountriesQueryHookResult = ReturnType<
  typeof useGetTaxableCountriesQuery
>
export type GetTaxableCountriesLazyQueryHookResult = ReturnType<
  typeof useGetTaxableCountriesLazyQuery
>
export type GetTaxableCountriesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetTaxableCountriesQuery,
  Types.GetTaxableCountriesQueryVariables
>
export const CreateWorkspaceDocument = /*#__PURE__*/ gql`
  mutation createWorkspace($input: CreateWorkspaceParams!) {
    createWorkspace(input: $input) {
      pendingScaToken
      workspace {
        ...WorkspaceMinimal
        memberships {
          list(limit: 1) {
            entries {
              identifier
              role
            }
          }
        }
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
`
export type CreateWorkspaceMutationFn = ApolloReactCommon.MutationFunction<
  Types.CreateWorkspaceMutation,
  Types.CreateWorkspaceMutationVariables
>

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateWorkspaceMutation,
    Types.CreateWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateWorkspaceMutation,
    Types.CreateWorkspaceMutationVariables
  >(CreateWorkspaceDocument, options)
}
export type CreateWorkspaceMutationHookResult = ReturnType<
  typeof useCreateWorkspaceMutation
>
export type CreateWorkspaceMutationResult =
  ApolloReactCommon.MutationResult<Types.CreateWorkspaceMutation>
export type CreateWorkspaceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreateWorkspaceMutation,
    Types.CreateWorkspaceMutationVariables
  >
export const UpgradePersonalWorkspaceDocument = /*#__PURE__*/ gql`
  mutation upgradePersonalWorkspace($input: UpgradePersonalWorkspaceParams!) {
    upgradePersonalWorkspace(input: $input) {
      workspace {
        ...WorkspaceMinimal
        memberships {
          list(limit: 1) {
            entries {
              identifier
              role
            }
          }
        }
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
`
export type UpgradePersonalWorkspaceMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpgradePersonalWorkspaceMutation,
    Types.UpgradePersonalWorkspaceMutationVariables
  >

/**
 * __useUpgradePersonalWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpgradePersonalWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradePersonalWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradePersonalWorkspaceMutation, { data, loading, error }] = useUpgradePersonalWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpgradePersonalWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpgradePersonalWorkspaceMutation,
    Types.UpgradePersonalWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpgradePersonalWorkspaceMutation,
    Types.UpgradePersonalWorkspaceMutationVariables
  >(UpgradePersonalWorkspaceDocument, options)
}
export type UpgradePersonalWorkspaceMutationHookResult = ReturnType<
  typeof useUpgradePersonalWorkspaceMutation
>
export type UpgradePersonalWorkspaceMutationResult =
  ApolloReactCommon.MutationResult<Types.UpgradePersonalWorkspaceMutation>
export type UpgradePersonalWorkspaceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpgradePersonalWorkspaceMutation,
    Types.UpgradePersonalWorkspaceMutationVariables
  >
export const AcceptWorkspaceInviteDocument = /*#__PURE__*/ gql`
  mutation acceptWorkspaceInvite($membershipToken: String!) {
    acceptWorkspaceInvite(membershipToken: $membershipToken) {
      membership {
        identifier
        inviter {
          identifier
          name
        }
        workspace {
          identifier
          name
        }
      }
    }
  }
`
export type AcceptWorkspaceInviteMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AcceptWorkspaceInviteMutation,
    Types.AcceptWorkspaceInviteMutationVariables
  >

/**
 * __useAcceptWorkspaceInviteMutation__
 *
 * To run a mutation, you first call `useAcceptWorkspaceInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptWorkspaceInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptWorkspaceInviteMutation, { data, loading, error }] = useAcceptWorkspaceInviteMutation({
 *   variables: {
 *      membershipToken: // value for 'membershipToken'
 *   },
 * });
 */
export function useAcceptWorkspaceInviteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AcceptWorkspaceInviteMutation,
    Types.AcceptWorkspaceInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AcceptWorkspaceInviteMutation,
    Types.AcceptWorkspaceInviteMutationVariables
  >(AcceptWorkspaceInviteDocument, options)
}
export type AcceptWorkspaceInviteMutationHookResult = ReturnType<
  typeof useAcceptWorkspaceInviteMutation
>
export type AcceptWorkspaceInviteMutationResult =
  ApolloReactCommon.MutationResult<Types.AcceptWorkspaceInviteMutation>
export type AcceptWorkspaceInviteMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AcceptWorkspaceInviteMutation,
    Types.AcceptWorkspaceInviteMutationVariables
  >
export const UpdateWorkspaceDocument = /*#__PURE__*/ gql`
  mutation updateWorkspace($input: UpdateWorkspaceParams!) {
    updateWorkspace(input: $input) {
      workspace {
        identifier
        name
        avatar {
          large
          small
        }
      }
    }
  }
`
export type UpdateWorkspaceMutationFn = ApolloReactCommon.MutationFunction<
  Types.UpdateWorkspaceMutation,
  Types.UpdateWorkspaceMutationVariables
>

/**
 * __useUpdateWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMutation, { data, loading, error }] = useUpdateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceMutation,
    Types.UpdateWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceMutation,
    Types.UpdateWorkspaceMutationVariables
  >(UpdateWorkspaceDocument, options)
}
export type UpdateWorkspaceMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceMutation
>
export type UpdateWorkspaceMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateWorkspaceMutation>
export type UpdateWorkspaceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateWorkspaceMutation,
    Types.UpdateWorkspaceMutationVariables
  >
export const DeleteWorkspaceAvatarDocument = /*#__PURE__*/ gql`
  mutation deleteWorkspaceAvatar($workspaceId: UUID!) {
    deleteWorkspaceAvatar(identifier: $workspaceId) {
      workspace {
        identifier
        avatar {
          small
          large
        }
      }
    }
  }
`
export type DeleteWorkspaceAvatarMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.DeleteWorkspaceAvatarMutation,
    Types.DeleteWorkspaceAvatarMutationVariables
  >

/**
 * __useDeleteWorkspaceAvatarMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceAvatarMutation, { data, loading, error }] = useDeleteWorkspaceAvatarMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteWorkspaceAvatarMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteWorkspaceAvatarMutation,
    Types.DeleteWorkspaceAvatarMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteWorkspaceAvatarMutation,
    Types.DeleteWorkspaceAvatarMutationVariables
  >(DeleteWorkspaceAvatarDocument, options)
}
export type DeleteWorkspaceAvatarMutationHookResult = ReturnType<
  typeof useDeleteWorkspaceAvatarMutation
>
export type DeleteWorkspaceAvatarMutationResult =
  ApolloReactCommon.MutationResult<Types.DeleteWorkspaceAvatarMutation>
export type DeleteWorkspaceAvatarMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DeleteWorkspaceAvatarMutation,
    Types.DeleteWorkspaceAvatarMutationVariables
  >
export const DeleteWorkspaceDocument = /*#__PURE__*/ gql`
  mutation deleteWorkspace($workspaceId: UUID!, $password: String) {
    deleteWorkspace(identifier: $workspaceId, password: $password) {
      deletedWorkspace {
        identifier
      }
    }
  }
`
export type DeleteWorkspaceMutationFn = ApolloReactCommon.MutationFunction<
  Types.DeleteWorkspaceMutation,
  Types.DeleteWorkspaceMutationVariables
>

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteWorkspaceMutation,
    Types.DeleteWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteWorkspaceMutation,
    Types.DeleteWorkspaceMutationVariables
  >(DeleteWorkspaceDocument, options)
}
export type DeleteWorkspaceMutationHookResult = ReturnType<
  typeof useDeleteWorkspaceMutation
>
export type DeleteWorkspaceMutationResult =
  ApolloReactCommon.MutationResult<Types.DeleteWorkspaceMutation>
export type DeleteWorkspaceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DeleteWorkspaceMutation,
    Types.DeleteWorkspaceMutationVariables
  >
export const AgreeToWorkspaceCustomerTermsOfServiceDocument = /*#__PURE__*/ gql`
  mutation agreeToWorkspaceCustomerTermsOfService(
    $customerId: UUID!
    $tosAgreed: Boolean!
  ) {
    agreeToWorkspaceCustomerTermsOfService(
      customerIdentifier: $customerId
      agreed: $tosAgreed
    ) {
      customer {
        identifier
        tosAgreed
      }
    }
  }
`
export type AgreeToWorkspaceCustomerTermsOfServiceMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutation,
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutationVariables
  >

/**
 * __useAgreeToWorkspaceCustomerTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAgreeToWorkspaceCustomerTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeToWorkspaceCustomerTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeToWorkspaceCustomerTermsOfServiceMutation, { data, loading, error }] = useAgreeToWorkspaceCustomerTermsOfServiceMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      tosAgreed: // value for 'tosAgreed'
 *   },
 * });
 */
export function useAgreeToWorkspaceCustomerTermsOfServiceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutation,
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutation,
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutationVariables
  >(AgreeToWorkspaceCustomerTermsOfServiceDocument, options)
}
export type AgreeToWorkspaceCustomerTermsOfServiceMutationHookResult =
  ReturnType<typeof useAgreeToWorkspaceCustomerTermsOfServiceMutation>
export type AgreeToWorkspaceCustomerTermsOfServiceMutationResult =
  ApolloReactCommon.MutationResult<Types.AgreeToWorkspaceCustomerTermsOfServiceMutation>
export type AgreeToWorkspaceCustomerTermsOfServiceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutation,
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutationVariables
  >
export const UpdateRestrictedUploadsStateDocument = /*#__PURE__*/ gql`
  mutation updateRestrictedUploadsState(
    $workspaceId: UUID!
    $enableRestrictedUploads: Boolean!
  ) {
    updateRestrictedUploadsState(
      input: {
        identifier: $workspaceId
        restrictedUploads: $enableRestrictedUploads
      }
    ) {
      workspace {
        identifier
        uploadsRestrictedFor
      }
    }
  }
`
export type UpdateRestrictedUploadsStateMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateRestrictedUploadsStateMutation,
    Types.UpdateRestrictedUploadsStateMutationVariables
  >

/**
 * __useUpdateRestrictedUploadsStateMutation__
 *
 * To run a mutation, you first call `useUpdateRestrictedUploadsStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestrictedUploadsStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestrictedUploadsStateMutation, { data, loading, error }] = useUpdateRestrictedUploadsStateMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      enableRestrictedUploads: // value for 'enableRestrictedUploads'
 *   },
 * });
 */
export function useUpdateRestrictedUploadsStateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateRestrictedUploadsStateMutation,
    Types.UpdateRestrictedUploadsStateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateRestrictedUploadsStateMutation,
    Types.UpdateRestrictedUploadsStateMutationVariables
  >(UpdateRestrictedUploadsStateDocument, options)
}
export type UpdateRestrictedUploadsStateMutationHookResult = ReturnType<
  typeof useUpdateRestrictedUploadsStateMutation
>
export type UpdateRestrictedUploadsStateMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateRestrictedUploadsStateMutation>
export type UpdateRestrictedUploadsStateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateRestrictedUploadsStateMutation,
    Types.UpdateRestrictedUploadsStateMutationVariables
  >
export const UpdateRestrictedPublicLinksDocument = /*#__PURE__*/ gql`
  mutation updateRestrictedPublicLinks(
    $workspaceId: UUID!
    $enabled: Boolean!
  ) {
    updateRestrictedPublicLinks(
      input: { workspaceIdentifier: $workspaceId, enabled: $enabled }
    ) {
      workspace {
        identifier
        features {
          restrictedPublicLinks
        }
      }
    }
  }
`
export type UpdateRestrictedPublicLinksMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateRestrictedPublicLinksMutation,
    Types.UpdateRestrictedPublicLinksMutationVariables
  >

/**
 * __useUpdateRestrictedPublicLinksMutation__
 *
 * To run a mutation, you first call `useUpdateRestrictedPublicLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestrictedPublicLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestrictedPublicLinksMutation, { data, loading, error }] = useUpdateRestrictedPublicLinksMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateRestrictedPublicLinksMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateRestrictedPublicLinksMutation,
    Types.UpdateRestrictedPublicLinksMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateRestrictedPublicLinksMutation,
    Types.UpdateRestrictedPublicLinksMutationVariables
  >(UpdateRestrictedPublicLinksDocument, options)
}
export type UpdateRestrictedPublicLinksMutationHookResult = ReturnType<
  typeof useUpdateRestrictedPublicLinksMutation
>
export type UpdateRestrictedPublicLinksMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateRestrictedPublicLinksMutation>
export type UpdateRestrictedPublicLinksMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateRestrictedPublicLinksMutation,
    Types.UpdateRestrictedPublicLinksMutationVariables
  >
export const EnableSupportAccessDocument = /*#__PURE__*/ gql`
  mutation enableSupportAccess($identifier: UUID!) {
    enableSupportAccess(identifier: $identifier) {
      workspace {
        supportAccessGrantedUntil
      }
    }
  }
`
export type EnableSupportAccessMutationFn = ApolloReactCommon.MutationFunction<
  Types.EnableSupportAccessMutation,
  Types.EnableSupportAccessMutationVariables
>

/**
 * __useEnableSupportAccessMutation__
 *
 * To run a mutation, you first call `useEnableSupportAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableSupportAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableSupportAccessMutation, { data, loading, error }] = useEnableSupportAccessMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useEnableSupportAccessMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EnableSupportAccessMutation,
    Types.EnableSupportAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EnableSupportAccessMutation,
    Types.EnableSupportAccessMutationVariables
  >(EnableSupportAccessDocument, options)
}
export type EnableSupportAccessMutationHookResult = ReturnType<
  typeof useEnableSupportAccessMutation
>
export type EnableSupportAccessMutationResult =
  ApolloReactCommon.MutationResult<Types.EnableSupportAccessMutation>
export type EnableSupportAccessMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.EnableSupportAccessMutation,
    Types.EnableSupportAccessMutationVariables
  >
export const DisableSupportAccessDocument = /*#__PURE__*/ gql`
  mutation disableSupportAccess($identifier: UUID!) {
    disableSupportAccess(identifier: $identifier) {
      workspace {
        supportAccessGrantedUntil
      }
    }
  }
`
export type DisableSupportAccessMutationFn = ApolloReactCommon.MutationFunction<
  Types.DisableSupportAccessMutation,
  Types.DisableSupportAccessMutationVariables
>

/**
 * __useDisableSupportAccessMutation__
 *
 * To run a mutation, you first call `useDisableSupportAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSupportAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSupportAccessMutation, { data, loading, error }] = useDisableSupportAccessMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDisableSupportAccessMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DisableSupportAccessMutation,
    Types.DisableSupportAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DisableSupportAccessMutation,
    Types.DisableSupportAccessMutationVariables
  >(DisableSupportAccessDocument, options)
}
export type DisableSupportAccessMutationHookResult = ReturnType<
  typeof useDisableSupportAccessMutation
>
export type DisableSupportAccessMutationResult =
  ApolloReactCommon.MutationResult<Types.DisableSupportAccessMutation>
export type DisableSupportAccessMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DisableSupportAccessMutation,
    Types.DisableSupportAccessMutationVariables
  >
export const WorkspaceMembersReportDocument = /*#__PURE__*/ gql`
  mutation workspaceMembersReport($workspaceIdentifier: UUID!) {
    workspaceMembersReport(workspaceIdentifier: $workspaceIdentifier) {
      downloadUrl
    }
  }
`
export type WorkspaceMembersReportMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.WorkspaceMembersReportMutation,
    Types.WorkspaceMembersReportMutationVariables
  >

/**
 * __useWorkspaceMembersReportMutation__
 *
 * To run a mutation, you first call `useWorkspaceMembersReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMembersReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspaceMembersReportMutation, { data, loading, error }] = useWorkspaceMembersReportMutation({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *   },
 * });
 */
export function useWorkspaceMembersReportMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.WorkspaceMembersReportMutation,
    Types.WorkspaceMembersReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.WorkspaceMembersReportMutation,
    Types.WorkspaceMembersReportMutationVariables
  >(WorkspaceMembersReportDocument, options)
}
export type WorkspaceMembersReportMutationHookResult = ReturnType<
  typeof useWorkspaceMembersReportMutation
>
export type WorkspaceMembersReportMutationResult =
  ApolloReactCommon.MutationResult<Types.WorkspaceMembersReportMutation>
export type WorkspaceMembersReportMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.WorkspaceMembersReportMutation,
    Types.WorkspaceMembersReportMutationVariables
  >
export const GetWorkspacesDocument = /*#__PURE__*/ gql`
  query getWorkspaces {
    me {
      identifier
      personalWorkspace {
        ...WorkspaceMinimal
      }
      workspaces {
        ...WorkspaceMinimalWithBillingStatus
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
  ${WorkspaceMinimalWithBillingStatusFragmentDoc}
`

/**
 * __useGetWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspacesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacesQuery,
    Types.GetWorkspacesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacesQuery,
    Types.GetWorkspacesQueryVariables
  >(GetWorkspacesDocument, options)
}
export function useGetWorkspacesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacesQuery,
    Types.GetWorkspacesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacesQuery,
    Types.GetWorkspacesQueryVariables
  >(GetWorkspacesDocument, options)
}

export type GetWorkspacesQueryHookResult = ReturnType<
  typeof useGetWorkspacesQuery
>
export type GetWorkspacesLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacesLazyQuery
>
export type GetWorkspacesQueryResult = ApolloReactCommon.QueryResult<
  Types.GetWorkspacesQuery,
  Types.GetWorkspacesQueryVariables
>
export const GetWorkspacesForDuplicationDocument = /*#__PURE__*/ gql`
  query getWorkspacesForDuplication {
    me {
      identifier
      workspaces {
        ...DuplicationWorkspace
      }
    }
  }
  ${DuplicationWorkspaceFragmentDoc}
`

/**
 * __useGetWorkspacesForDuplicationQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesForDuplicationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspacesForDuplicationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacesForDuplicationQuery,
    Types.GetWorkspacesForDuplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacesForDuplicationQuery,
    Types.GetWorkspacesForDuplicationQueryVariables
  >(GetWorkspacesForDuplicationDocument, options)
}
export function useGetWorkspacesForDuplicationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacesForDuplicationQuery,
    Types.GetWorkspacesForDuplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacesForDuplicationQuery,
    Types.GetWorkspacesForDuplicationQueryVariables
  >(GetWorkspacesForDuplicationDocument, options)
}

export type GetWorkspacesForDuplicationQueryHookResult = ReturnType<
  typeof useGetWorkspacesForDuplicationQuery
>
export type GetWorkspacesForDuplicationLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacesForDuplicationLazyQuery
>
export type GetWorkspacesForDuplicationQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspacesForDuplicationQuery,
    Types.GetWorkspacesForDuplicationQueryVariables
  >
export const GetWorkspaceDocument = /*#__PURE__*/ gql`
  query getWorkspace($identifier: UUID!) {
    workspace(identifier: $identifier) {
      ...WorkspaceMinimalWithBillingStatus
    }
  }
  ${WorkspaceMinimalWithBillingStatusFragmentDoc}
`

/**
 * __useGetWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceQuery,
    Types.GetWorkspaceQueryVariables
  > &
    (
      | { variables: Types.GetWorkspaceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceQuery,
    Types.GetWorkspaceQueryVariables
  >(GetWorkspaceDocument, options)
}
export function useGetWorkspaceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceQuery,
    Types.GetWorkspaceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceQuery,
    Types.GetWorkspaceQueryVariables
  >(GetWorkspaceDocument, options)
}

export type GetWorkspaceQueryHookResult = ReturnType<
  typeof useGetWorkspaceQuery
>
export type GetWorkspaceLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceLazyQuery
>
export type GetWorkspaceQueryResult = ApolloReactCommon.QueryResult<
  Types.GetWorkspaceQuery,
  Types.GetWorkspaceQueryVariables
>
export const GetPublicWorkspaceDocument = /*#__PURE__*/ gql`
  query getPublicWorkspace($identifier: UUID!) {
    publicWorkspace(identifier: $identifier) {
      ...PublicWorkspaceMinimal
    }
  }
  ${PublicWorkspaceMinimalFragmentDoc}
`

/**
 * __useGetPublicWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetPublicWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicWorkspaceQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetPublicWorkspaceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicWorkspaceQuery,
    Types.GetPublicWorkspaceQueryVariables
  > &
    (
      | { variables: Types.GetPublicWorkspaceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicWorkspaceQuery,
    Types.GetPublicWorkspaceQueryVariables
  >(GetPublicWorkspaceDocument, options)
}
export function useGetPublicWorkspaceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicWorkspaceQuery,
    Types.GetPublicWorkspaceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicWorkspaceQuery,
    Types.GetPublicWorkspaceQueryVariables
  >(GetPublicWorkspaceDocument, options)
}

export type GetPublicWorkspaceQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceQuery
>
export type GetPublicWorkspaceLazyQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceLazyQuery
>
export type GetPublicWorkspaceQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPublicWorkspaceQuery,
  Types.GetPublicWorkspaceQueryVariables
>
export const GetWorkspaceSettingsDocument = /*#__PURE__*/ gql`
  query getWorkspaceSettings(
    $identifier: UUID!
    $includeShares: Boolean = true
  ) {
    workspace(identifier: $identifier) {
      ...WorkspaceMinimal
      identifier
      canUseRestrictedUploads
      uploadsRestrictedFor
      scimEnabled
      customer {
        identifier
        source
        billing {
          status
          seats {
            ...BillingSeatsInfo
          }
          trialEnd
          subscriptionEnd
          subscriptionSetUp
        }
        ssoEnabled
        ssoShortName
      }
      features {
        ssoEnabled
        userDirectoryEnabled
      }
      shares @include(if: $includeShares) {
        meta {
          totalCount
        }
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
  ${BillingSeatsInfoFragmentDoc}
`

/**
 * __useGetWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSettingsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      includeShares: // value for 'includeShares'
 *   },
 * });
 */
export function useGetWorkspaceSettingsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSettingsQuery,
    Types.GetWorkspaceSettingsQueryVariables
  > &
    (
      | { variables: Types.GetWorkspaceSettingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSettingsQuery,
    Types.GetWorkspaceSettingsQueryVariables
  >(GetWorkspaceSettingsDocument, options)
}
export function useGetWorkspaceSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSettingsQuery,
    Types.GetWorkspaceSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSettingsQuery,
    Types.GetWorkspaceSettingsQueryVariables
  >(GetWorkspaceSettingsDocument, options)
}

export type GetWorkspaceSettingsQueryHookResult = ReturnType<
  typeof useGetWorkspaceSettingsQuery
>
export type GetWorkspaceSettingsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSettingsLazyQuery
>
export type GetWorkspaceSettingsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetWorkspaceSettingsQuery,
  Types.GetWorkspaceSettingsQueryVariables
>
export const GetWorkspaceSsoSettingsDocument = /*#__PURE__*/ gql`
  query getWorkspaceSsoSettings($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      customer {
        identifier
        ssoConfig {
          ...WorkspaceSsoConfig
        }
      }
    }
  }
  ${WorkspaceSsoConfigFragmentDoc}
`

/**
 * __useGetWorkspaceSsoSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSsoSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSsoSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSsoSettingsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceSsoSettingsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSsoSettingsQuery,
    Types.GetWorkspaceSsoSettingsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceSsoSettingsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSsoSettingsQuery,
    Types.GetWorkspaceSsoSettingsQueryVariables
  >(GetWorkspaceSsoSettingsDocument, options)
}
export function useGetWorkspaceSsoSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSsoSettingsQuery,
    Types.GetWorkspaceSsoSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSsoSettingsQuery,
    Types.GetWorkspaceSsoSettingsQueryVariables
  >(GetWorkspaceSsoSettingsDocument, options)
}

export type GetWorkspaceSsoSettingsQueryHookResult = ReturnType<
  typeof useGetWorkspaceSsoSettingsQuery
>
export type GetWorkspaceSsoSettingsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSsoSettingsLazyQuery
>
export type GetWorkspaceSsoSettingsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetWorkspaceSsoSettingsQuery,
  Types.GetWorkspaceSsoSettingsQueryVariables
>
export const GetWorkspaceSubscribeInformationDocument = /*#__PURE__*/ gql`
  query getWorkspaceSubscribeInformation($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      customer {
        identifier
        billing {
          trialEnd
          seats {
            ...BillingSeatsInfo
          }
        }
      }
      memberships {
        list {
          meta {
            totalCount
          }
        }
      }
    }
  }
  ${BillingSeatsInfoFragmentDoc}
`

/**
 * __useGetWorkspaceSubscribeInformationQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSubscribeInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSubscribeInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSubscribeInformationQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceSubscribeInformationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSubscribeInformationQuery,
    Types.GetWorkspaceSubscribeInformationQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceSubscribeInformationQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSubscribeInformationQuery,
    Types.GetWorkspaceSubscribeInformationQueryVariables
  >(GetWorkspaceSubscribeInformationDocument, options)
}
export function useGetWorkspaceSubscribeInformationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSubscribeInformationQuery,
    Types.GetWorkspaceSubscribeInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSubscribeInformationQuery,
    Types.GetWorkspaceSubscribeInformationQueryVariables
  >(GetWorkspaceSubscribeInformationDocument, options)
}

export type GetWorkspaceSubscribeInformationQueryHookResult = ReturnType<
  typeof useGetWorkspaceSubscribeInformationQuery
>
export type GetWorkspaceSubscribeInformationLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSubscribeInformationLazyQuery
>
export type GetWorkspaceSubscribeInformationQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspaceSubscribeInformationQuery,
    Types.GetWorkspaceSubscribeInformationQueryVariables
  >
export const GetPublicWorkspaceFromTokenDocument = /*#__PURE__*/ gql`
  query getPublicWorkspaceFromToken($inviteToken: String!) {
    getPublicWorkspaceFromToken(membershipToken: $inviteToken) {
      identifier
      name
      avatar {
        small
      }
    }
  }
`

/**
 * __useGetPublicWorkspaceFromTokenQuery__
 *
 * To run a query within a React component, call `useGetPublicWorkspaceFromTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicWorkspaceFromTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicWorkspaceFromTokenQuery({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useGetPublicWorkspaceFromTokenQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicWorkspaceFromTokenQuery,
    Types.GetPublicWorkspaceFromTokenQueryVariables
  > &
    (
      | {
          variables: Types.GetPublicWorkspaceFromTokenQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicWorkspaceFromTokenQuery,
    Types.GetPublicWorkspaceFromTokenQueryVariables
  >(GetPublicWorkspaceFromTokenDocument, options)
}
export function useGetPublicWorkspaceFromTokenLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicWorkspaceFromTokenQuery,
    Types.GetPublicWorkspaceFromTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicWorkspaceFromTokenQuery,
    Types.GetPublicWorkspaceFromTokenQueryVariables
  >(GetPublicWorkspaceFromTokenDocument, options)
}

export type GetPublicWorkspaceFromTokenQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceFromTokenQuery
>
export type GetPublicWorkspaceFromTokenLazyQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceFromTokenLazyQuery
>
export type GetPublicWorkspaceFromTokenQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetPublicWorkspaceFromTokenQuery,
    Types.GetPublicWorkspaceFromTokenQueryVariables
  >
export const GetWorkspaceUploadsRestrictedForDocument = /*#__PURE__*/ gql`
  query getWorkspaceUploadsRestrictedFor($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      uploadsRestrictedFor
    }
  }
`

/**
 * __useGetWorkspaceUploadsRestrictedForQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceUploadsRestrictedForQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceUploadsRestrictedForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceUploadsRestrictedForQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceUploadsRestrictedForQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceUploadsRestrictedForQuery,
    Types.GetWorkspaceUploadsRestrictedForQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceUploadsRestrictedForQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceUploadsRestrictedForQuery,
    Types.GetWorkspaceUploadsRestrictedForQueryVariables
  >(GetWorkspaceUploadsRestrictedForDocument, options)
}
export function useGetWorkspaceUploadsRestrictedForLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceUploadsRestrictedForQuery,
    Types.GetWorkspaceUploadsRestrictedForQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceUploadsRestrictedForQuery,
    Types.GetWorkspaceUploadsRestrictedForQueryVariables
  >(GetWorkspaceUploadsRestrictedForDocument, options)
}

export type GetWorkspaceUploadsRestrictedForQueryHookResult = ReturnType<
  typeof useGetWorkspaceUploadsRestrictedForQuery
>
export type GetWorkspaceUploadsRestrictedForLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceUploadsRestrictedForLazyQuery
>
export type GetWorkspaceUploadsRestrictedForQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspaceUploadsRestrictedForQuery,
    Types.GetWorkspaceUploadsRestrictedForQueryVariables
  >
export const GetWorkspaceProfileIdentifierDocument = /*#__PURE__*/ gql`
  query getWorkspaceProfileIdentifier($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      profile {
        identifier
      }
    }
  }
`

/**
 * __useGetWorkspaceProfileIdentifierQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceProfileIdentifierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceProfileIdentifierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceProfileIdentifierQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceProfileIdentifierQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceProfileIdentifierQuery,
    Types.GetWorkspaceProfileIdentifierQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceProfileIdentifierQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceProfileIdentifierQuery,
    Types.GetWorkspaceProfileIdentifierQueryVariables
  >(GetWorkspaceProfileIdentifierDocument, options)
}
export function useGetWorkspaceProfileIdentifierLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceProfileIdentifierQuery,
    Types.GetWorkspaceProfileIdentifierQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceProfileIdentifierQuery,
    Types.GetWorkspaceProfileIdentifierQueryVariables
  >(GetWorkspaceProfileIdentifierDocument, options)
}

export type GetWorkspaceProfileIdentifierQueryHookResult = ReturnType<
  typeof useGetWorkspaceProfileIdentifierQuery
>
export type GetWorkspaceProfileIdentifierLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceProfileIdentifierLazyQuery
>
export type GetWorkspaceProfileIdentifierQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspaceProfileIdentifierQuery,
    Types.GetWorkspaceProfileIdentifierQueryVariables
  >
export const GetWorkspaceSupportAccessDocument = /*#__PURE__*/ gql`
  query getWorkspaceSupportAccess($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      supportAccessGrantedUntil
    }
  }
`

/**
 * __useGetWorkspaceSupportAccessQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSupportAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSupportAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSupportAccessQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceSupportAccessQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSupportAccessQuery,
    Types.GetWorkspaceSupportAccessQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceSupportAccessQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSupportAccessQuery,
    Types.GetWorkspaceSupportAccessQueryVariables
  >(GetWorkspaceSupportAccessDocument, options)
}
export function useGetWorkspaceSupportAccessLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSupportAccessQuery,
    Types.GetWorkspaceSupportAccessQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSupportAccessQuery,
    Types.GetWorkspaceSupportAccessQueryVariables
  >(GetWorkspaceSupportAccessDocument, options)
}

export type GetWorkspaceSupportAccessQueryHookResult = ReturnType<
  typeof useGetWorkspaceSupportAccessQuery
>
export type GetWorkspaceSupportAccessLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSupportAccessLazyQuery
>
export type GetWorkspaceSupportAccessQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspaceSupportAccessQuery,
    Types.GetWorkspaceSupportAccessQueryVariables
  >
export const GetWorkspaceHeaviestSharesDocument = /*#__PURE__*/ gql`
  query getWorkspaceHeaviestShares($identifier: UUID!) {
    workspaceHeaviestShares(identifier: $identifier) {
      ...ShareWithSize
    }
  }
  ${ShareWithSizeFragmentDoc}
`

/**
 * __useGetWorkspaceHeaviestSharesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceHeaviestSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceHeaviestSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceHeaviestSharesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceHeaviestSharesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceHeaviestSharesQuery,
    Types.GetWorkspaceHeaviestSharesQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceHeaviestSharesQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceHeaviestSharesQuery,
    Types.GetWorkspaceHeaviestSharesQueryVariables
  >(GetWorkspaceHeaviestSharesDocument, options)
}
export function useGetWorkspaceHeaviestSharesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceHeaviestSharesQuery,
    Types.GetWorkspaceHeaviestSharesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceHeaviestSharesQuery,
    Types.GetWorkspaceHeaviestSharesQueryVariables
  >(GetWorkspaceHeaviestSharesDocument, options)
}

export type GetWorkspaceHeaviestSharesQueryHookResult = ReturnType<
  typeof useGetWorkspaceHeaviestSharesQuery
>
export type GetWorkspaceHeaviestSharesLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceHeaviestSharesLazyQuery
>
export type GetWorkspaceHeaviestSharesQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspaceHeaviestSharesQuery,
    Types.GetWorkspaceHeaviestSharesQueryVariables
  >
export const WorkspaceMembershipUpdatedDocument = /*#__PURE__*/ gql`
  subscription workspaceMembershipUpdated {
    workspaceMembershipUpdated {
      status
      workspaceIdentifier
    }
  }
`

/**
 * __useWorkspaceMembershipUpdatedSubscription__
 *
 * To run a query within a React component, call `useWorkspaceMembershipUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMembershipUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceMembershipUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceMembershipUpdatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.WorkspaceMembershipUpdatedSubscription,
    Types.WorkspaceMembershipUpdatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.WorkspaceMembershipUpdatedSubscription,
    Types.WorkspaceMembershipUpdatedSubscriptionVariables
  >(WorkspaceMembershipUpdatedDocument, options)
}
export type WorkspaceMembershipUpdatedSubscriptionHookResult = ReturnType<
  typeof useWorkspaceMembershipUpdatedSubscription
>
export type WorkspaceMembershipUpdatedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Types.WorkspaceMembershipUpdatedSubscription>
export const GetWorkspaceCustomerDocument = /*#__PURE__*/ gql`
  query getWorkspaceCustomer($identifier: UUID!) {
    workspaceCustomer(identifier: $identifier) {
      workspaces {
        entries {
          ...WorkspaceMinimal
        }
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
`

/**
 * __useGetWorkspaceCustomerQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceCustomerQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceCustomerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceCustomerQuery,
    Types.GetWorkspaceCustomerQueryVariables
  > &
    (
      | { variables: Types.GetWorkspaceCustomerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceCustomerQuery,
    Types.GetWorkspaceCustomerQueryVariables
  >(GetWorkspaceCustomerDocument, options)
}
export function useGetWorkspaceCustomerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceCustomerQuery,
    Types.GetWorkspaceCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceCustomerQuery,
    Types.GetWorkspaceCustomerQueryVariables
  >(GetWorkspaceCustomerDocument, options)
}

export type GetWorkspaceCustomerQueryHookResult = ReturnType<
  typeof useGetWorkspaceCustomerQuery
>
export type GetWorkspaceCustomerLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceCustomerLazyQuery
>
export type GetWorkspaceCustomerQueryResult = ApolloReactCommon.QueryResult<
  Types.GetWorkspaceCustomerQuery,
  Types.GetWorkspaceCustomerQueryVariables
>
export const InviteWorkspaceMembersDocument = /*#__PURE__*/ gql`
  mutation inviteWorkspaceMembers($input: InviteWorkspaceMembersParams!) {
    inviteWorkspaceMembers(input: $input) {
      workspace {
        identifier
        customer {
          identifier
          billing {
            seats {
              ...BillingSeatsInfo
            }
          }
        }
      }
      pendingScaToken
    }
  }
  ${BillingSeatsInfoFragmentDoc}
`
export type InviteWorkspaceMembersMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.InviteWorkspaceMembersMutation,
    Types.InviteWorkspaceMembersMutationVariables
  >

/**
 * __useInviteWorkspaceMembersMutation__
 *
 * To run a mutation, you first call `useInviteWorkspaceMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteWorkspaceMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteWorkspaceMembersMutation, { data, loading, error }] = useInviteWorkspaceMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteWorkspaceMembersMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.InviteWorkspaceMembersMutation,
    Types.InviteWorkspaceMembersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.InviteWorkspaceMembersMutation,
    Types.InviteWorkspaceMembersMutationVariables
  >(InviteWorkspaceMembersDocument, options)
}
export type InviteWorkspaceMembersMutationHookResult = ReturnType<
  typeof useInviteWorkspaceMembersMutation
>
export type InviteWorkspaceMembersMutationResult =
  ApolloReactCommon.MutationResult<Types.InviteWorkspaceMembersMutation>
export type InviteWorkspaceMembersMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.InviteWorkspaceMembersMutation,
    Types.InviteWorkspaceMembersMutationVariables
  >
export const UpdateWorkspaceMemberDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceMember($input: UpdateWorkspaceMemberParams!) {
    updateWorkspaceMember(input: $input) {
      membership {
        ...WorkspaceMembership
        identifier
        role
        isEditor
        workspace {
          identifier
          customer {
            identifier
            billing {
              seats {
                ...BillingSeatsInfo
              }
            }
          }
        }
      }
      pendingScaToken
    }
  }
  ${WorkspaceMembershipFragmentDoc}
  ${BillingSeatsInfoFragmentDoc}
`
export type UpdateWorkspaceMemberMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateWorkspaceMemberMutation,
    Types.UpdateWorkspaceMemberMutationVariables
  >

/**
 * __useUpdateWorkspaceMemberMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMemberMutation, { data, loading, error }] = useUpdateWorkspaceMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceMemberMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceMemberMutation,
    Types.UpdateWorkspaceMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceMemberMutation,
    Types.UpdateWorkspaceMemberMutationVariables
  >(UpdateWorkspaceMemberDocument, options)
}
export type UpdateWorkspaceMemberMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceMemberMutation
>
export type UpdateWorkspaceMemberMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateWorkspaceMemberMutation>
export type UpdateWorkspaceMemberMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateWorkspaceMemberMutation,
    Types.UpdateWorkspaceMemberMutationVariables
  >
export const RemoveWorkspaceMemberDocument = /*#__PURE__*/ gql`
  mutation removeWorkspaceMember($membershipId: UUID!) {
    removeWorkspaceMember(membershipIdentifier: $membershipId) {
      workspace {
        identifier
        memberships {
          userCanAccess
          totalMemberships: list {
            meta {
              totalCount
            }
          }
        }
        customer {
          identifier
          billing {
            seats {
              ...BillingSeatsInfo
            }
          }
        }
      }
    }
  }
  ${BillingSeatsInfoFragmentDoc}
`
export type RemoveWorkspaceMemberMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.RemoveWorkspaceMemberMutation,
    Types.RemoveWorkspaceMemberMutationVariables
  >

/**
 * __useRemoveWorkspaceMemberMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspaceMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspaceMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspaceMemberMutation, { data, loading, error }] = useRemoveWorkspaceMemberMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useRemoveWorkspaceMemberMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemoveWorkspaceMemberMutation,
    Types.RemoveWorkspaceMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemoveWorkspaceMemberMutation,
    Types.RemoveWorkspaceMemberMutationVariables
  >(RemoveWorkspaceMemberDocument, options)
}
export type RemoveWorkspaceMemberMutationHookResult = ReturnType<
  typeof useRemoveWorkspaceMemberMutation
>
export type RemoveWorkspaceMemberMutationResult =
  ApolloReactCommon.MutationResult<Types.RemoveWorkspaceMemberMutation>
export type RemoveWorkspaceMemberMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RemoveWorkspaceMemberMutation,
    Types.RemoveWorkspaceMemberMutationVariables
  >
export const ResendWorkspaceInviteDocument = /*#__PURE__*/ gql`
  mutation resendWorkspaceInvite($membershipId: UUID!) {
    resendWorkspaceInvite(identifier: $membershipId) {
      membership {
        identifier
      }
    }
  }
`
export type ResendWorkspaceInviteMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.ResendWorkspaceInviteMutation,
    Types.ResendWorkspaceInviteMutationVariables
  >

/**
 * __useResendWorkspaceInviteMutation__
 *
 * To run a mutation, you first call `useResendWorkspaceInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendWorkspaceInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendWorkspaceInviteMutation, { data, loading, error }] = useResendWorkspaceInviteMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useResendWorkspaceInviteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ResendWorkspaceInviteMutation,
    Types.ResendWorkspaceInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ResendWorkspaceInviteMutation,
    Types.ResendWorkspaceInviteMutationVariables
  >(ResendWorkspaceInviteDocument, options)
}
export type ResendWorkspaceInviteMutationHookResult = ReturnType<
  typeof useResendWorkspaceInviteMutation
>
export type ResendWorkspaceInviteMutationResult =
  ApolloReactCommon.MutationResult<Types.ResendWorkspaceInviteMutation>
export type ResendWorkspaceInviteMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.ResendWorkspaceInviteMutation,
    Types.ResendWorkspaceInviteMutationVariables
  >
export const LeaveWorkspaceDocument = /*#__PURE__*/ gql`
  mutation leaveWorkspace($membershipId: UUID!) {
    removeWorkspaceMember(membershipIdentifier: $membershipId) {
      workspace {
        identifier
      }
    }
  }
`
export type LeaveWorkspaceMutationFn = ApolloReactCommon.MutationFunction<
  Types.LeaveWorkspaceMutation,
  Types.LeaveWorkspaceMutationVariables
>

/**
 * __useLeaveWorkspaceMutation__
 *
 * To run a mutation, you first call `useLeaveWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveWorkspaceMutation, { data, loading, error }] = useLeaveWorkspaceMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useLeaveWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.LeaveWorkspaceMutation,
    Types.LeaveWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.LeaveWorkspaceMutation,
    Types.LeaveWorkspaceMutationVariables
  >(LeaveWorkspaceDocument, options)
}
export type LeaveWorkspaceMutationHookResult = ReturnType<
  typeof useLeaveWorkspaceMutation
>
export type LeaveWorkspaceMutationResult =
  ApolloReactCommon.MutationResult<Types.LeaveWorkspaceMutation>
export type LeaveWorkspaceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.LeaveWorkspaceMutation,
    Types.LeaveWorkspaceMutationVariables
  >
export const GetPendingWorkspaceMembershipDocument = /*#__PURE__*/ gql`
  query getPendingWorkspaceMembership(
    $membershipToken: String!
    $includeCustomer: Boolean! = false
  ) {
    pendingWorkspaceMembership(membershipToken: $membershipToken) {
      identifier
      isEditor
      role
      user {
        identifier
        name
        email
        avatar {
          small
        }
      }
      workspace {
        identifier
        name
        userRole
        avatar {
          small
          large
        }
        customer @include(if: $includeCustomer) {
          identifier
          ssoStartUrl
          ssoEnabled
        }
      }
      invite {
        identifier
        email
      }
      inviter {
        identifier
        name
      }
    }
    me {
      ...UserEmail
      personalIdentityEmail
    }
  }
  ${UserEmailFragmentDoc}
`

/**
 * __useGetPendingWorkspaceMembershipQuery__
 *
 * To run a query within a React component, call `useGetPendingWorkspaceMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingWorkspaceMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingWorkspaceMembershipQuery({
 *   variables: {
 *      membershipToken: // value for 'membershipToken'
 *      includeCustomer: // value for 'includeCustomer'
 *   },
 * });
 */
export function useGetPendingWorkspaceMembershipQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPendingWorkspaceMembershipQuery,
    Types.GetPendingWorkspaceMembershipQueryVariables
  > &
    (
      | {
          variables: Types.GetPendingWorkspaceMembershipQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPendingWorkspaceMembershipQuery,
    Types.GetPendingWorkspaceMembershipQueryVariables
  >(GetPendingWorkspaceMembershipDocument, options)
}
export function useGetPendingWorkspaceMembershipLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPendingWorkspaceMembershipQuery,
    Types.GetPendingWorkspaceMembershipQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPendingWorkspaceMembershipQuery,
    Types.GetPendingWorkspaceMembershipQueryVariables
  >(GetPendingWorkspaceMembershipDocument, options)
}

export type GetPendingWorkspaceMembershipQueryHookResult = ReturnType<
  typeof useGetPendingWorkspaceMembershipQuery
>
export type GetPendingWorkspaceMembershipLazyQueryHookResult = ReturnType<
  typeof useGetPendingWorkspaceMembershipLazyQuery
>
export type GetPendingWorkspaceMembershipQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetPendingWorkspaceMembershipQuery,
    Types.GetPendingWorkspaceMembershipQueryVariables
  >
export const GetWorkspaceMembershipsDocument = /*#__PURE__*/ gql`
  query getWorkspaceMemberships(
    $workspaceId: UUID!
    $after: String
    $filter: String
    $limit: Int = 20
    $role: WorkspaceMembershipRole
    $accessLevel: WorkspaceMemberAccessLevel
    $excludeRoles: [WorkspaceMembershipRole]
    $activityStatus: UserActivityStatus
    $order: WorkspaceMembershipOrderType
    $orderDirection: OrderDirection
  ) {
    workspace(identifier: $workspaceId) {
      identifier
      memberships {
        userCanAccess
        totalMemberships: list {
          meta {
            totalCount
          }
        }
        totalGuests: list(role: GUEST) {
          meta {
            totalCount
          }
        }
        totalMembers: list(excludeRoles: GUEST) {
          meta {
            totalCount
          }
        }
        list(
          after: $after
          search: $filter
          limit: $limit
          role: $role
          accessLevel: $accessLevel
          excludeRoles: $excludeRoles
          activityStatus: $activityStatus
          order: $order
          orderDirection: $orderDirection
        ) {
          entries {
            ...WorkspaceMembership
          }
          meta {
            after
            totalCount
          }
        }
      }
    }
  }
  ${WorkspaceMembershipFragmentDoc}
`

/**
 * __useGetWorkspaceMembershipsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMembershipsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      role: // value for 'role'
 *      accessLevel: // value for 'accessLevel'
 *      excludeRoles: // value for 'excludeRoles'
 *      activityStatus: // value for 'activityStatus'
 *      order: // value for 'order'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useGetWorkspaceMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceMembershipsQuery,
    Types.GetWorkspaceMembershipsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceMembershipsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceMembershipsQuery,
    Types.GetWorkspaceMembershipsQueryVariables
  >(GetWorkspaceMembershipsDocument, options)
}
export function useGetWorkspaceMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceMembershipsQuery,
    Types.GetWorkspaceMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceMembershipsQuery,
    Types.GetWorkspaceMembershipsQueryVariables
  >(GetWorkspaceMembershipsDocument, options)
}

export type GetWorkspaceMembershipsQueryHookResult = ReturnType<
  typeof useGetWorkspaceMembershipsQuery
>
export type GetWorkspaceMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceMembershipsLazyQuery
>
export type GetWorkspaceMembershipsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetWorkspaceMembershipsQuery,
  Types.GetWorkspaceMembershipsQueryVariables
>
export const GetWorkspaceMembershipsCountDocument = /*#__PURE__*/ gql`
  query getWorkspaceMembershipsCount($workspaceId: UUID!) {
    workspace(identifier: $workspaceId) {
      identifier
      memberships {
        totalMemberships: list {
          meta {
            totalCount
          }
        }
        totalGuests: list(role: GUEST) {
          meta {
            totalCount
          }
        }
        totalMembers: list(excludeRoles: GUEST) {
          meta {
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useGetWorkspaceMembershipsCountQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMembershipsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMembershipsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMembershipsCountQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceMembershipsCountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceMembershipsCountQuery,
    Types.GetWorkspaceMembershipsCountQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceMembershipsCountQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceMembershipsCountQuery,
    Types.GetWorkspaceMembershipsCountQueryVariables
  >(GetWorkspaceMembershipsCountDocument, options)
}
export function useGetWorkspaceMembershipsCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceMembershipsCountQuery,
    Types.GetWorkspaceMembershipsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceMembershipsCountQuery,
    Types.GetWorkspaceMembershipsCountQueryVariables
  >(GetWorkspaceMembershipsCountDocument, options)
}

export type GetWorkspaceMembershipsCountQueryHookResult = ReturnType<
  typeof useGetWorkspaceMembershipsCountQuery
>
export type GetWorkspaceMembershipsCountLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceMembershipsCountLazyQuery
>
export type GetWorkspaceMembershipsCountQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspaceMembershipsCountQuery,
    Types.GetWorkspaceMembershipsCountQueryVariables
  >
export const GetWorkspaceMembersCountWithCustomerDocument = /*#__PURE__*/ gql`
  query getWorkspaceMembersCountWithCustomer($workspaceId: UUID!) {
    workspace(identifier: $workspaceId) {
      identifier
      memberships {
        totalMemberships: list {
          meta {
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useGetWorkspaceMembersCountWithCustomerQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMembersCountWithCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMembersCountWithCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMembersCountWithCustomerQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceMembersCountWithCustomerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceMembersCountWithCustomerQuery,
    Types.GetWorkspaceMembersCountWithCustomerQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceMembersCountWithCustomerQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceMembersCountWithCustomerQuery,
    Types.GetWorkspaceMembersCountWithCustomerQueryVariables
  >(GetWorkspaceMembersCountWithCustomerDocument, options)
}
export function useGetWorkspaceMembersCountWithCustomerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceMembersCountWithCustomerQuery,
    Types.GetWorkspaceMembersCountWithCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceMembersCountWithCustomerQuery,
    Types.GetWorkspaceMembersCountWithCustomerQueryVariables
  >(GetWorkspaceMembersCountWithCustomerDocument, options)
}

export type GetWorkspaceMembersCountWithCustomerQueryHookResult = ReturnType<
  typeof useGetWorkspaceMembersCountWithCustomerQuery
>
export type GetWorkspaceMembersCountWithCustomerLazyQueryHookResult =
  ReturnType<typeof useGetWorkspaceMembersCountWithCustomerLazyQuery>
export type GetWorkspaceMembersCountWithCustomerQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspaceMembersCountWithCustomerQuery,
    Types.GetWorkspaceMembersCountWithCustomerQueryVariables
  >
export const GetInvitableUsersDocument = /*#__PURE__*/ gql`
  query getInvitableUsers(
    $workspaceIdentifier: UUID!
    $shareIdentifier: UUID
    $projectIdentifier: UUID
    $search: String
  ) {
    invitableUsers(
      shareIdentifier: $shareIdentifier
      workspaceIdentifier: $workspaceIdentifier
      projectIdentifier: $projectIdentifier
      search: $search
      limit: 5
    ) {
      entries {
        ...InvitableUser
      }
    }
  }
  ${InvitableUserFragmentDoc}
`

/**
 * __useGetInvitableUsersQuery__
 *
 * To run a query within a React component, call `useGetInvitableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitableUsersQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      projectIdentifier: // value for 'projectIdentifier'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetInvitableUsersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetInvitableUsersQuery,
    Types.GetInvitableUsersQueryVariables
  > &
    (
      | { variables: Types.GetInvitableUsersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetInvitableUsersQuery,
    Types.GetInvitableUsersQueryVariables
  >(GetInvitableUsersDocument, options)
}
export function useGetInvitableUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetInvitableUsersQuery,
    Types.GetInvitableUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetInvitableUsersQuery,
    Types.GetInvitableUsersQueryVariables
  >(GetInvitableUsersDocument, options)
}

export type GetInvitableUsersQueryHookResult = ReturnType<
  typeof useGetInvitableUsersQuery
>
export type GetInvitableUsersLazyQueryHookResult = ReturnType<
  typeof useGetInvitableUsersLazyQuery
>
export type GetInvitableUsersQueryResult = ApolloReactCommon.QueryResult<
  Types.GetInvitableUsersQuery,
  Types.GetInvitableUsersQueryVariables
>
export const GetInvitableUsersAndGroupsDocument = /*#__PURE__*/ gql`
  query getInvitableUsersAndGroups(
    $workspaceIdentifier: UUID!
    $shareIdentifier: UUID
    $projectIdentifier: UUID
    $search: String
  ) {
    invitableUsersAndGroups(
      shareIdentifier: $shareIdentifier
      workspaceIdentifier: $workspaceIdentifier
      projectIdentifier: $projectIdentifier
      search: $search
      limit: 5
    ) {
      ... on WorkspaceMembership {
        ...InvitableUser
      }
      ... on PermissionGroup {
        ...WorkspacePermissionGroup
      }
    }
  }
  ${InvitableUserFragmentDoc}
  ${WorkspacePermissionGroupFragmentDoc}
`

/**
 * __useGetInvitableUsersAndGroupsQuery__
 *
 * To run a query within a React component, call `useGetInvitableUsersAndGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitableUsersAndGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitableUsersAndGroupsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      projectIdentifier: // value for 'projectIdentifier'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetInvitableUsersAndGroupsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetInvitableUsersAndGroupsQuery,
    Types.GetInvitableUsersAndGroupsQueryVariables
  > &
    (
      | {
          variables: Types.GetInvitableUsersAndGroupsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetInvitableUsersAndGroupsQuery,
    Types.GetInvitableUsersAndGroupsQueryVariables
  >(GetInvitableUsersAndGroupsDocument, options)
}
export function useGetInvitableUsersAndGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetInvitableUsersAndGroupsQuery,
    Types.GetInvitableUsersAndGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetInvitableUsersAndGroupsQuery,
    Types.GetInvitableUsersAndGroupsQueryVariables
  >(GetInvitableUsersAndGroupsDocument, options)
}

export type GetInvitableUsersAndGroupsQueryHookResult = ReturnType<
  typeof useGetInvitableUsersAndGroupsQuery
>
export type GetInvitableUsersAndGroupsLazyQueryHookResult = ReturnType<
  typeof useGetInvitableUsersAndGroupsLazyQuery
>
export type GetInvitableUsersAndGroupsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetInvitableUsersAndGroupsQuery,
    Types.GetInvitableUsersAndGroupsQueryVariables
  >
export const GetInvitableEmailUsersDocument = /*#__PURE__*/ gql`
  query getInvitableEmailUsers(
    $workspaceIdentifier: UUID!
    $shareIdentifier: UUID
    $projectIdentifier: UUID
    $search: String
  ) {
    invitableUsers(
      shareIdentifier: $shareIdentifier
      workspaceIdentifier: $workspaceIdentifier
      projectIdentifier: $projectIdentifier
      search: $search
      limit: 5
    ) {
      entries {
        ...InvitableUserEmail
      }
    }
  }
  ${InvitableUserEmailFragmentDoc}
`

/**
 * __useGetInvitableEmailUsersQuery__
 *
 * To run a query within a React component, call `useGetInvitableEmailUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitableEmailUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitableEmailUsersQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      projectIdentifier: // value for 'projectIdentifier'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetInvitableEmailUsersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetInvitableEmailUsersQuery,
    Types.GetInvitableEmailUsersQueryVariables
  > &
    (
      | {
          variables: Types.GetInvitableEmailUsersQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetInvitableEmailUsersQuery,
    Types.GetInvitableEmailUsersQueryVariables
  >(GetInvitableEmailUsersDocument, options)
}
export function useGetInvitableEmailUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetInvitableEmailUsersQuery,
    Types.GetInvitableEmailUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetInvitableEmailUsersQuery,
    Types.GetInvitableEmailUsersQueryVariables
  >(GetInvitableEmailUsersDocument, options)
}

export type GetInvitableEmailUsersQueryHookResult = ReturnType<
  typeof useGetInvitableEmailUsersQuery
>
export type GetInvitableEmailUsersLazyQueryHookResult = ReturnType<
  typeof useGetInvitableEmailUsersLazyQuery
>
export type GetInvitableEmailUsersQueryResult = ApolloReactCommon.QueryResult<
  Types.GetInvitableEmailUsersQuery,
  Types.GetInvitableEmailUsersQueryVariables
>
export const GetAccessShareMembershipsDocument = /*#__PURE__*/ gql`
  query getAccessShareMemberships(
    $workspaceIdentifier: UUID!
    $workspaceMembershipIdentifier: UUID!
    $shareSearch: ShareMemberAccessSearchParams
    $after: String
    $limit: Int = 10
  ) {
    workspace(identifier: $workspaceIdentifier) {
      identifier
      workspaceMembership(identifier: $workspaceMembershipIdentifier) {
        shareMemberships(search: $shareSearch, after: $after, limit: $limit) {
          entries {
            ...UserAccessShareMembership
          }
          meta {
            after
            limit
            totalCount
          }
        }
      }
    }
  }
  ${UserAccessShareMembershipFragmentDoc}
`

/**
 * __useGetAccessShareMembershipsQuery__
 *
 * To run a query within a React component, call `useGetAccessShareMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessShareMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessShareMembershipsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      workspaceMembershipIdentifier: // value for 'workspaceMembershipIdentifier'
 *      shareSearch: // value for 'shareSearch'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAccessShareMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAccessShareMembershipsQuery,
    Types.GetAccessShareMembershipsQueryVariables
  > &
    (
      | {
          variables: Types.GetAccessShareMembershipsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAccessShareMembershipsQuery,
    Types.GetAccessShareMembershipsQueryVariables
  >(GetAccessShareMembershipsDocument, options)
}
export function useGetAccessShareMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAccessShareMembershipsQuery,
    Types.GetAccessShareMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAccessShareMembershipsQuery,
    Types.GetAccessShareMembershipsQueryVariables
  >(GetAccessShareMembershipsDocument, options)
}

export type GetAccessShareMembershipsQueryHookResult = ReturnType<
  typeof useGetAccessShareMembershipsQuery
>
export type GetAccessShareMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetAccessShareMembershipsLazyQuery
>
export type GetAccessShareMembershipsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetAccessShareMembershipsQuery,
    Types.GetAccessShareMembershipsQueryVariables
  >
export const GetAccessProjectMembershipsDocument = /*#__PURE__*/ gql`
  query getAccessProjectMemberships(
    $workspaceIdentifier: UUID!
    $workspaceMembershipIdentifier: UUID!
    $projectSearch: ProjectMemberAccessSearchParams
    $after: String
    $limit: Int = 10
  ) {
    workspace(identifier: $workspaceIdentifier) {
      identifier
      workspaceMembership(identifier: $workspaceMembershipIdentifier) {
        projectMemberships(
          search: $projectSearch
          after: $after
          limit: $limit
        ) {
          entries {
            ...UserAccessProjectMembership
          }
          meta {
            after
            limit
            totalCount
          }
        }
      }
    }
  }
  ${UserAccessProjectMembershipFragmentDoc}
`

/**
 * __useGetAccessProjectMembershipsQuery__
 *
 * To run a query within a React component, call `useGetAccessProjectMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessProjectMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessProjectMembershipsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      workspaceMembershipIdentifier: // value for 'workspaceMembershipIdentifier'
 *      projectSearch: // value for 'projectSearch'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAccessProjectMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAccessProjectMembershipsQuery,
    Types.GetAccessProjectMembershipsQueryVariables
  > &
    (
      | {
          variables: Types.GetAccessProjectMembershipsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAccessProjectMembershipsQuery,
    Types.GetAccessProjectMembershipsQueryVariables
  >(GetAccessProjectMembershipsDocument, options)
}
export function useGetAccessProjectMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAccessProjectMembershipsQuery,
    Types.GetAccessProjectMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAccessProjectMembershipsQuery,
    Types.GetAccessProjectMembershipsQueryVariables
  >(GetAccessProjectMembershipsDocument, options)
}

export type GetAccessProjectMembershipsQueryHookResult = ReturnType<
  typeof useGetAccessProjectMembershipsQuery
>
export type GetAccessProjectMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetAccessProjectMembershipsLazyQuery
>
export type GetAccessProjectMembershipsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetAccessProjectMembershipsQuery,
    Types.GetAccessProjectMembershipsQueryVariables
  >
export const GetAccessPermissionGroupMembershipsDocument = /*#__PURE__*/ gql`
  query getAccessPermissionGroupMemberships(
    $workspaceIdentifier: UUID!
    $workspaceMembershipIdentifier: UUID!
    $permissionGroupSearch: String
    $after: String
    $limit: Int = 10
  ) {
    workspace(identifier: $workspaceIdentifier) {
      identifier
      workspaceMembership(identifier: $workspaceMembershipIdentifier) {
        permissionGroupMemberships(
          search: $permissionGroupSearch
          after: $after
          limit: $limit
        ) {
          entries {
            identifier
            permissionGroup {
              identifier
              ...WorkspacePermissionGroup
            }
          }
          meta {
            after
            limit
            totalCount
          }
        }
      }
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`

/**
 * __useGetAccessPermissionGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useGetAccessPermissionGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessPermissionGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessPermissionGroupMembershipsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      workspaceMembershipIdentifier: // value for 'workspaceMembershipIdentifier'
 *      permissionGroupSearch: // value for 'permissionGroupSearch'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAccessPermissionGroupMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAccessPermissionGroupMembershipsQuery,
    Types.GetAccessPermissionGroupMembershipsQueryVariables
  > &
    (
      | {
          variables: Types.GetAccessPermissionGroupMembershipsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAccessPermissionGroupMembershipsQuery,
    Types.GetAccessPermissionGroupMembershipsQueryVariables
  >(GetAccessPermissionGroupMembershipsDocument, options)
}
export function useGetAccessPermissionGroupMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAccessPermissionGroupMembershipsQuery,
    Types.GetAccessPermissionGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAccessPermissionGroupMembershipsQuery,
    Types.GetAccessPermissionGroupMembershipsQueryVariables
  >(GetAccessPermissionGroupMembershipsDocument, options)
}

export type GetAccessPermissionGroupMembershipsQueryHookResult = ReturnType<
  typeof useGetAccessPermissionGroupMembershipsQuery
>
export type GetAccessPermissionGroupMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetAccessPermissionGroupMembershipsLazyQuery
>
export type GetAccessPermissionGroupMembershipsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetAccessPermissionGroupMembershipsQuery,
    Types.GetAccessPermissionGroupMembershipsQueryVariables
  >
export const InviteWorkspacePartnerDocument = /*#__PURE__*/ gql`
  mutation inviteWorkspacePartner($input: InviteWorkspacePartnerParams!) {
    inviteWorkspacePartner(input: $input) {
      identifier
      name
    }
  }
`
export type InviteWorkspacePartnerMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.InviteWorkspacePartnerMutation,
    Types.InviteWorkspacePartnerMutationVariables
  >

/**
 * __useInviteWorkspacePartnerMutation__
 *
 * To run a mutation, you first call `useInviteWorkspacePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteWorkspacePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteWorkspacePartnerMutation, { data, loading, error }] = useInviteWorkspacePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteWorkspacePartnerMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.InviteWorkspacePartnerMutation,
    Types.InviteWorkspacePartnerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.InviteWorkspacePartnerMutation,
    Types.InviteWorkspacePartnerMutationVariables
  >(InviteWorkspacePartnerDocument, options)
}
export type InviteWorkspacePartnerMutationHookResult = ReturnType<
  typeof useInviteWorkspacePartnerMutation
>
export type InviteWorkspacePartnerMutationResult =
  ApolloReactCommon.MutationResult<Types.InviteWorkspacePartnerMutation>
export type InviteWorkspacePartnerMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.InviteWorkspacePartnerMutation,
    Types.InviteWorkspacePartnerMutationVariables
  >
export const AcceptPartnershipInviteDocument = /*#__PURE__*/ gql`
  mutation acceptPartnershipInvite(
    $membershipToken: String!
    $seats: Int!
    $tosAgreed: Boolean!
    $shipping: ShippingDetailsInput
  ) {
    acceptPartnershipInvite(
      membershipToken: $membershipToken
      seats: $seats
      tosAgreed: $tosAgreed
      shipping: $shipping
    ) {
      membership {
        identifier
      }
    }
  }
`
export type AcceptPartnershipInviteMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AcceptPartnershipInviteMutation,
    Types.AcceptPartnershipInviteMutationVariables
  >

/**
 * __useAcceptPartnershipInviteMutation__
 *
 * To run a mutation, you first call `useAcceptPartnershipInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPartnershipInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPartnershipInviteMutation, { data, loading, error }] = useAcceptPartnershipInviteMutation({
 *   variables: {
 *      membershipToken: // value for 'membershipToken'
 *      seats: // value for 'seats'
 *      tosAgreed: // value for 'tosAgreed'
 *      shipping: // value for 'shipping'
 *   },
 * });
 */
export function useAcceptPartnershipInviteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AcceptPartnershipInviteMutation,
    Types.AcceptPartnershipInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AcceptPartnershipInviteMutation,
    Types.AcceptPartnershipInviteMutationVariables
  >(AcceptPartnershipInviteDocument, options)
}
export type AcceptPartnershipInviteMutationHookResult = ReturnType<
  typeof useAcceptPartnershipInviteMutation
>
export type AcceptPartnershipInviteMutationResult =
  ApolloReactCommon.MutationResult<Types.AcceptPartnershipInviteMutation>
export type AcceptPartnershipInviteMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AcceptPartnershipInviteMutation,
    Types.AcceptPartnershipInviteMutationVariables
  >
export const CreatePartnerWorkspaceDocument = /*#__PURE__*/ gql`
  mutation createPartnerWorkspace($input: CreatePartnerWorkspaceParams!) {
    createPartnerWorkspace(input: $input) {
      workspace {
        identifier
      }
    }
  }
`
export type CreatePartnerWorkspaceMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.CreatePartnerWorkspaceMutation,
    Types.CreatePartnerWorkspaceMutationVariables
  >

/**
 * __useCreatePartnerWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreatePartnerWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerWorkspaceMutation, { data, loading, error }] = useCreatePartnerWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePartnerWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreatePartnerWorkspaceMutation,
    Types.CreatePartnerWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreatePartnerWorkspaceMutation,
    Types.CreatePartnerWorkspaceMutationVariables
  >(CreatePartnerWorkspaceDocument, options)
}
export type CreatePartnerWorkspaceMutationHookResult = ReturnType<
  typeof useCreatePartnerWorkspaceMutation
>
export type CreatePartnerWorkspaceMutationResult =
  ApolloReactCommon.MutationResult<Types.CreatePartnerWorkspaceMutation>
export type CreatePartnerWorkspaceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreatePartnerWorkspaceMutation,
    Types.CreatePartnerWorkspaceMutationVariables
  >
export const GetPartnerDocument = /*#__PURE__*/ gql`
  query getPartner($email: String!) {
    partner(email: $email) {
      identifier
      name
      email
      avatar {
        small
      }
    }
  }
`

/**
 * __useGetPartnerQuery__
 *
 * To run a query within a React component, call `useGetPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetPartnerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPartnerQuery,
    Types.GetPartnerQueryVariables
  > &
    (
      | { variables: Types.GetPartnerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPartnerQuery,
    Types.GetPartnerQueryVariables
  >(GetPartnerDocument, options)
}
export function useGetPartnerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPartnerQuery,
    Types.GetPartnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPartnerQuery,
    Types.GetPartnerQueryVariables
  >(GetPartnerDocument, options)
}

export type GetPartnerQueryHookResult = ReturnType<typeof useGetPartnerQuery>
export type GetPartnerLazyQueryHookResult = ReturnType<
  typeof useGetPartnerLazyQuery
>
export type GetPartnerQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPartnerQuery,
  Types.GetPartnerQueryVariables
>
export const GetPartnerBillingDetailsDocument = /*#__PURE__*/ gql`
  query getPartnerBillingDetails @PaymentQLApi {
    partnerBillingDetails {
      name
      email
      address {
        line1
        city
        state
        country
        postalCode
      }
      taxId
    }
  }
`

/**
 * __useGetPartnerBillingDetailsQuery__
 *
 * To run a query within a React component, call `useGetPartnerBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerBillingDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerBillingDetailsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetPartnerBillingDetailsQuery,
    Types.GetPartnerBillingDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPartnerBillingDetailsQuery,
    Types.GetPartnerBillingDetailsQueryVariables
  >(GetPartnerBillingDetailsDocument, options)
}
export function useGetPartnerBillingDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPartnerBillingDetailsQuery,
    Types.GetPartnerBillingDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPartnerBillingDetailsQuery,
    Types.GetPartnerBillingDetailsQueryVariables
  >(GetPartnerBillingDetailsDocument, options)
}

export type GetPartnerBillingDetailsQueryHookResult = ReturnType<
  typeof useGetPartnerBillingDetailsQuery
>
export type GetPartnerBillingDetailsLazyQueryHookResult = ReturnType<
  typeof useGetPartnerBillingDetailsLazyQuery
>
export type GetPartnerBillingDetailsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetPartnerBillingDetailsQuery,
  Types.GetPartnerBillingDetailsQueryVariables
>
export const CreatePermissionGroupDocument = /*#__PURE__*/ gql`
  mutation createPermissionGroup($input: CreatePermissionGroupParams!) {
    createPermissionGroup(input: $input) {
      permissionGroup {
        identifier
        ...WorkspacePermissionGroup
      }
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`
export type CreatePermissionGroupMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.CreatePermissionGroupMutation,
    Types.CreatePermissionGroupMutationVariables
  >

/**
 * __useCreatePermissionGroupMutation__
 *
 * To run a mutation, you first call `useCreatePermissionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionGroupMutation, { data, loading, error }] = useCreatePermissionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePermissionGroupMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreatePermissionGroupMutation,
    Types.CreatePermissionGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreatePermissionGroupMutation,
    Types.CreatePermissionGroupMutationVariables
  >(CreatePermissionGroupDocument, options)
}
export type CreatePermissionGroupMutationHookResult = ReturnType<
  typeof useCreatePermissionGroupMutation
>
export type CreatePermissionGroupMutationResult =
  ApolloReactCommon.MutationResult<Types.CreatePermissionGroupMutation>
export type CreatePermissionGroupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreatePermissionGroupMutation,
    Types.CreatePermissionGroupMutationVariables
  >
export const UpdatePermissionGroupNameDocument = /*#__PURE__*/ gql`
  mutation updatePermissionGroupName($input: UpdatePermissionGroupParams!) {
    updatePermissionGroup(input: $input) {
      permissionGroup {
        identifier
        name
      }
    }
  }
`
export type UpdatePermissionGroupNameMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdatePermissionGroupNameMutation,
    Types.UpdatePermissionGroupNameMutationVariables
  >

/**
 * __useUpdatePermissionGroupNameMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionGroupNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionGroupNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionGroupNameMutation, { data, loading, error }] = useUpdatePermissionGroupNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePermissionGroupNameMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdatePermissionGroupNameMutation,
    Types.UpdatePermissionGroupNameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdatePermissionGroupNameMutation,
    Types.UpdatePermissionGroupNameMutationVariables
  >(UpdatePermissionGroupNameDocument, options)
}
export type UpdatePermissionGroupNameMutationHookResult = ReturnType<
  typeof useUpdatePermissionGroupNameMutation
>
export type UpdatePermissionGroupNameMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdatePermissionGroupNameMutation>
export type UpdatePermissionGroupNameMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdatePermissionGroupNameMutation,
    Types.UpdatePermissionGroupNameMutationVariables
  >
export const AddMemberToPermissionGroupDocument = /*#__PURE__*/ gql`
  mutation addMemberToPermissionGroup(
    $input: AddPermissionGroupMembersParams!
  ) {
    addPermissionGroupMembers(input: $input) {
      permissionGroup {
        ...WorkspacePermissionGroup
      }
      members {
        identifier
        workspaceMember {
          ...WorkspaceMembership
        }
      }
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
  ${WorkspaceMembershipFragmentDoc}
`
export type AddMemberToPermissionGroupMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AddMemberToPermissionGroupMutation,
    Types.AddMemberToPermissionGroupMutationVariables
  >

/**
 * __useAddMemberToPermissionGroupMutation__
 *
 * To run a mutation, you first call `useAddMemberToPermissionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberToPermissionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberToPermissionGroupMutation, { data, loading, error }] = useAddMemberToPermissionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberToPermissionGroupMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddMemberToPermissionGroupMutation,
    Types.AddMemberToPermissionGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddMemberToPermissionGroupMutation,
    Types.AddMemberToPermissionGroupMutationVariables
  >(AddMemberToPermissionGroupDocument, options)
}
export type AddMemberToPermissionGroupMutationHookResult = ReturnType<
  typeof useAddMemberToPermissionGroupMutation
>
export type AddMemberToPermissionGroupMutationResult =
  ApolloReactCommon.MutationResult<Types.AddMemberToPermissionGroupMutation>
export type AddMemberToPermissionGroupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AddMemberToPermissionGroupMutation,
    Types.AddMemberToPermissionGroupMutationVariables
  >
export const RemovePermissionGroupMemberDocument = /*#__PURE__*/ gql`
  mutation removePermissionGroupMember(
    $input: RemovePermissionGroupMemberParams!
  ) {
    removePermissionGroupMember(input: $input) {
      permissionGroup {
        ...WorkspacePermissionGroup
      }
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`
export type RemovePermissionGroupMemberMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.RemovePermissionGroupMemberMutation,
    Types.RemovePermissionGroupMemberMutationVariables
  >

/**
 * __useRemovePermissionGroupMemberMutation__
 *
 * To run a mutation, you first call `useRemovePermissionGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePermissionGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePermissionGroupMemberMutation, { data, loading, error }] = useRemovePermissionGroupMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePermissionGroupMemberMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemovePermissionGroupMemberMutation,
    Types.RemovePermissionGroupMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemovePermissionGroupMemberMutation,
    Types.RemovePermissionGroupMemberMutationVariables
  >(RemovePermissionGroupMemberDocument, options)
}
export type RemovePermissionGroupMemberMutationHookResult = ReturnType<
  typeof useRemovePermissionGroupMemberMutation
>
export type RemovePermissionGroupMemberMutationResult =
  ApolloReactCommon.MutationResult<Types.RemovePermissionGroupMemberMutation>
export type RemovePermissionGroupMemberMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RemovePermissionGroupMemberMutation,
    Types.RemovePermissionGroupMemberMutationVariables
  >
export const DeletePermissionGroupDocument = /*#__PURE__*/ gql`
  mutation deletePermissionGroup($input: DeletePermissionGroupParams!) {
    deletePermissionGroup(input: $input) {
      permissionGroupIdentifier
    }
  }
`
export type DeletePermissionGroupMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.DeletePermissionGroupMutation,
    Types.DeletePermissionGroupMutationVariables
  >

/**
 * __useDeletePermissionGroupMutation__
 *
 * To run a mutation, you first call `useDeletePermissionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermissionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePermissionGroupMutation, { data, loading, error }] = useDeletePermissionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePermissionGroupMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeletePermissionGroupMutation,
    Types.DeletePermissionGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeletePermissionGroupMutation,
    Types.DeletePermissionGroupMutationVariables
  >(DeletePermissionGroupDocument, options)
}
export type DeletePermissionGroupMutationHookResult = ReturnType<
  typeof useDeletePermissionGroupMutation
>
export type DeletePermissionGroupMutationResult =
  ApolloReactCommon.MutationResult<Types.DeletePermissionGroupMutation>
export type DeletePermissionGroupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.DeletePermissionGroupMutation,
    Types.DeletePermissionGroupMutationVariables
  >
export const AddSharePermissionGroupRelationDocument = /*#__PURE__*/ gql`
  mutation addSharePermissionGroupRelation(
    $accessLevel: PrivateAccessLevel!
    $permissionGroupIdentifier: UUID!
    $shareIdentifier: UUID!
  ) {
    addSharePermissionGroupRelation(
      accessLevel: $accessLevel
      permissionGroupIdentifier: $permissionGroupIdentifier
      shareIdentifier: $shareIdentifier
    ) {
      relation {
        identifier
      }
    }
  }
`
export type AddSharePermissionGroupRelationMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AddSharePermissionGroupRelationMutation,
    Types.AddSharePermissionGroupRelationMutationVariables
  >

/**
 * __useAddSharePermissionGroupRelationMutation__
 *
 * To run a mutation, you first call `useAddSharePermissionGroupRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSharePermissionGroupRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSharePermissionGroupRelationMutation, { data, loading, error }] = useAddSharePermissionGroupRelationMutation({
 *   variables: {
 *      accessLevel: // value for 'accessLevel'
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useAddSharePermissionGroupRelationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddSharePermissionGroupRelationMutation,
    Types.AddSharePermissionGroupRelationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddSharePermissionGroupRelationMutation,
    Types.AddSharePermissionGroupRelationMutationVariables
  >(AddSharePermissionGroupRelationDocument, options)
}
export type AddSharePermissionGroupRelationMutationHookResult = ReturnType<
  typeof useAddSharePermissionGroupRelationMutation
>
export type AddSharePermissionGroupRelationMutationResult =
  ApolloReactCommon.MutationResult<Types.AddSharePermissionGroupRelationMutation>
export type AddSharePermissionGroupRelationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AddSharePermissionGroupRelationMutation,
    Types.AddSharePermissionGroupRelationMutationVariables
  >
export const AddProjectPermissionGroupRelationDocument = /*#__PURE__*/ gql`
  mutation addProjectPermissionGroupRelation(
    $permissionGroupIdentifier: UUID!
    $projectIdentifier: UUID!
  ) {
    addProjectPermissionGroupRelation(
      permissionGroupIdentifier: $permissionGroupIdentifier
      projectIdentifier: $projectIdentifier
    ) {
      relation {
        identifier
      }
    }
  }
`
export type AddProjectPermissionGroupRelationMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.AddProjectPermissionGroupRelationMutation,
    Types.AddProjectPermissionGroupRelationMutationVariables
  >

/**
 * __useAddProjectPermissionGroupRelationMutation__
 *
 * To run a mutation, you first call `useAddProjectPermissionGroupRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectPermissionGroupRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectPermissionGroupRelationMutation, { data, loading, error }] = useAddProjectPermissionGroupRelationMutation({
 *   variables: {
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useAddProjectPermissionGroupRelationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddProjectPermissionGroupRelationMutation,
    Types.AddProjectPermissionGroupRelationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddProjectPermissionGroupRelationMutation,
    Types.AddProjectPermissionGroupRelationMutationVariables
  >(AddProjectPermissionGroupRelationDocument, options)
}
export type AddProjectPermissionGroupRelationMutationHookResult = ReturnType<
  typeof useAddProjectPermissionGroupRelationMutation
>
export type AddProjectPermissionGroupRelationMutationResult =
  ApolloReactCommon.MutationResult<Types.AddProjectPermissionGroupRelationMutation>
export type AddProjectPermissionGroupRelationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.AddProjectPermissionGroupRelationMutation,
    Types.AddProjectPermissionGroupRelationMutationVariables
  >
export const RemovePermissionGroupToShareProjectDocument = /*#__PURE__*/ gql`
  mutation removePermissionGroupToShareProject(
    $input: RemovePermissionGroupRelationParams!
  ) {
    removePermissionGroupRelation(input: $input) {
      permissionGroup {
        identifier
      }
      share {
        identifier
      }
      project {
        identifier
      }
    }
  }
`
export type RemovePermissionGroupToShareProjectMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.RemovePermissionGroupToShareProjectMutation,
    Types.RemovePermissionGroupToShareProjectMutationVariables
  >

/**
 * __useRemovePermissionGroupToShareProjectMutation__
 *
 * To run a mutation, you first call `useRemovePermissionGroupToShareProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePermissionGroupToShareProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePermissionGroupToShareProjectMutation, { data, loading, error }] = useRemovePermissionGroupToShareProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePermissionGroupToShareProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemovePermissionGroupToShareProjectMutation,
    Types.RemovePermissionGroupToShareProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemovePermissionGroupToShareProjectMutation,
    Types.RemovePermissionGroupToShareProjectMutationVariables
  >(RemovePermissionGroupToShareProjectDocument, options)
}
export type RemovePermissionGroupToShareProjectMutationHookResult = ReturnType<
  typeof useRemovePermissionGroupToShareProjectMutation
>
export type RemovePermissionGroupToShareProjectMutationResult =
  ApolloReactCommon.MutationResult<Types.RemovePermissionGroupToShareProjectMutation>
export type RemovePermissionGroupToShareProjectMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.RemovePermissionGroupToShareProjectMutation,
    Types.RemovePermissionGroupToShareProjectMutationVariables
  >
export const UpdateSharePermissionGroupRelationDocument = /*#__PURE__*/ gql`
  mutation updateSharePermissionGroupRelation(
    $accessLevel: PrivateAccessLevel!
    $relationIdentifier: UUID!
  ) {
    updateSharePermissionGroupRelation(
      accessLevel: $accessLevel
      relationIdentifier: $relationIdentifier
    ) {
      relation {
        identifier
        accessLevel
      }
    }
  }
`
export type UpdateSharePermissionGroupRelationMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateSharePermissionGroupRelationMutation,
    Types.UpdateSharePermissionGroupRelationMutationVariables
  >

/**
 * __useUpdateSharePermissionGroupRelationMutation__
 *
 * To run a mutation, you first call `useUpdateSharePermissionGroupRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharePermissionGroupRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharePermissionGroupRelationMutation, { data, loading, error }] = useUpdateSharePermissionGroupRelationMutation({
 *   variables: {
 *      accessLevel: // value for 'accessLevel'
 *      relationIdentifier: // value for 'relationIdentifier'
 *   },
 * });
 */
export function useUpdateSharePermissionGroupRelationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateSharePermissionGroupRelationMutation,
    Types.UpdateSharePermissionGroupRelationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateSharePermissionGroupRelationMutation,
    Types.UpdateSharePermissionGroupRelationMutationVariables
  >(UpdateSharePermissionGroupRelationDocument, options)
}
export type UpdateSharePermissionGroupRelationMutationHookResult = ReturnType<
  typeof useUpdateSharePermissionGroupRelationMutation
>
export type UpdateSharePermissionGroupRelationMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateSharePermissionGroupRelationMutation>
export type UpdateSharePermissionGroupRelationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateSharePermissionGroupRelationMutation,
    Types.UpdateSharePermissionGroupRelationMutationVariables
  >
export const GetWorkspacePermissionGroupsDocument = /*#__PURE__*/ gql`
  query getWorkspacePermissionGroups(
    $workspaceIdentifier: UUID!
    $search: String
    $after: String
  ) {
    workspace(identifier: $workspaceIdentifier) {
      identifier
      permissionGroups(search: $search, after: $after) {
        entries {
          ...WorkspacePermissionGroup
        }
        meta {
          after
          totalCount
        }
      }
      totalWorkspacePermissionGroups: permissionGroups {
        meta {
          totalCount
        }
      }
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`

/**
 * __useGetWorkspacePermissionGroupsQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePermissionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePermissionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePermissionGroupsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetWorkspacePermissionGroupsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacePermissionGroupsQuery,
    Types.GetWorkspacePermissionGroupsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspacePermissionGroupsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacePermissionGroupsQuery,
    Types.GetWorkspacePermissionGroupsQueryVariables
  >(GetWorkspacePermissionGroupsDocument, options)
}
export function useGetWorkspacePermissionGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacePermissionGroupsQuery,
    Types.GetWorkspacePermissionGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacePermissionGroupsQuery,
    Types.GetWorkspacePermissionGroupsQueryVariables
  >(GetWorkspacePermissionGroupsDocument, options)
}

export type GetWorkspacePermissionGroupsQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupsQuery
>
export type GetWorkspacePermissionGroupsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupsLazyQuery
>
export type GetWorkspacePermissionGroupsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspacePermissionGroupsQuery,
    Types.GetWorkspacePermissionGroupsQueryVariables
  >
export const GetWorkspacePermissionGroupMembersDocument = /*#__PURE__*/ gql`
  query getWorkspacePermissionGroupMembers(
    $permissionGroupIdentifier: UUID!
    $after: String
  ) {
    permissionGroup(identifier: $permissionGroupIdentifier) {
      identifier
      members(after: $after) {
        entries {
          identifier
          workspaceMember {
            ...WorkspaceMembership
          }
        }
        meta {
          totalCount
          after
        }
      }
    }
  }
  ${WorkspaceMembershipFragmentDoc}
`

/**
 * __useGetWorkspacePermissionGroupMembersQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePermissionGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePermissionGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePermissionGroupMembersQuery({
 *   variables: {
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetWorkspacePermissionGroupMembersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacePermissionGroupMembersQuery,
    Types.GetWorkspacePermissionGroupMembersQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspacePermissionGroupMembersQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacePermissionGroupMembersQuery,
    Types.GetWorkspacePermissionGroupMembersQueryVariables
  >(GetWorkspacePermissionGroupMembersDocument, options)
}
export function useGetWorkspacePermissionGroupMembersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacePermissionGroupMembersQuery,
    Types.GetWorkspacePermissionGroupMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacePermissionGroupMembersQuery,
    Types.GetWorkspacePermissionGroupMembersQueryVariables
  >(GetWorkspacePermissionGroupMembersDocument, options)
}

export type GetWorkspacePermissionGroupMembersQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupMembersQuery
>
export type GetWorkspacePermissionGroupMembersLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupMembersLazyQuery
>
export type GetWorkspacePermissionGroupMembersQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspacePermissionGroupMembersQuery,
    Types.GetWorkspacePermissionGroupMembersQueryVariables
  >
export const GetWorkspacePermissionGroupSharesDocument = /*#__PURE__*/ gql`
  query getWorkspacePermissionGroupShares(
    $permissionGroupIdentifier: UUID!
    $after: String
    $search: String
  ) {
    permissionGroup(identifier: $permissionGroupIdentifier) {
      identifier
      shares(search: $search, after: $after) {
        entries {
          identifier
          share {
            identifier
            name
            updatedAt
            version(preferredState: PROCESSED) {
              ...Version
              document {
                identifier
                previewFile {
                  ...ShareThumbnails
                }
              }
            }
          }
        }
        meta {
          after
          totalCount
        }
      }
      projects(search: $search) {
        meta {
          totalCount
        }
      }
    }
  }
  ${VersionFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
`

/**
 * __useGetWorkspacePermissionGroupSharesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePermissionGroupSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePermissionGroupSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePermissionGroupSharesQuery({
 *   variables: {
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkspacePermissionGroupSharesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacePermissionGroupSharesQuery,
    Types.GetWorkspacePermissionGroupSharesQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspacePermissionGroupSharesQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacePermissionGroupSharesQuery,
    Types.GetWorkspacePermissionGroupSharesQueryVariables
  >(GetWorkspacePermissionGroupSharesDocument, options)
}
export function useGetWorkspacePermissionGroupSharesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacePermissionGroupSharesQuery,
    Types.GetWorkspacePermissionGroupSharesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacePermissionGroupSharesQuery,
    Types.GetWorkspacePermissionGroupSharesQueryVariables
  >(GetWorkspacePermissionGroupSharesDocument, options)
}

export type GetWorkspacePermissionGroupSharesQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupSharesQuery
>
export type GetWorkspacePermissionGroupSharesLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupSharesLazyQuery
>
export type GetWorkspacePermissionGroupSharesQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspacePermissionGroupSharesQuery,
    Types.GetWorkspacePermissionGroupSharesQueryVariables
  >
export const GetWorkspacePermissionGroupProjectsDocument = /*#__PURE__*/ gql`
  query getWorkspacePermissionGroupProjects(
    $permissionGroupIdentifier: UUID!
    $after: String
    $search: String
  ) {
    permissionGroup(identifier: $permissionGroupIdentifier) {
      identifier
      projects(search: $search, after: $after) {
        entries {
          identifier
          project {
            identifier
            ...Project
          }
        }
        meta {
          after
          totalCount
        }
      }
      shares(search: $search) {
        meta {
          totalCount
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useGetWorkspacePermissionGroupProjectsQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePermissionGroupProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePermissionGroupProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePermissionGroupProjectsQuery({
 *   variables: {
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkspacePermissionGroupProjectsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacePermissionGroupProjectsQuery,
    Types.GetWorkspacePermissionGroupProjectsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspacePermissionGroupProjectsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacePermissionGroupProjectsQuery,
    Types.GetWorkspacePermissionGroupProjectsQueryVariables
  >(GetWorkspacePermissionGroupProjectsDocument, options)
}
export function useGetWorkspacePermissionGroupProjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacePermissionGroupProjectsQuery,
    Types.GetWorkspacePermissionGroupProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacePermissionGroupProjectsQuery,
    Types.GetWorkspacePermissionGroupProjectsQueryVariables
  >(GetWorkspacePermissionGroupProjectsDocument, options)
}

export type GetWorkspacePermissionGroupProjectsQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupProjectsQuery
>
export type GetWorkspacePermissionGroupProjectsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupProjectsLazyQuery
>
export type GetWorkspacePermissionGroupProjectsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspacePermissionGroupProjectsQuery,
    Types.GetWorkspacePermissionGroupProjectsQueryVariables
  >
export const GetInvitableUsersForPermissionGroupDocument = /*#__PURE__*/ gql`
  query getInvitableUsersForPermissionGroup(
    $workspaceIdentifier: UUID!
    $permissionGroupIdentifier: UUID
    $search: String
  ) {
    invitableUsersForPermissionGroup(
      workspaceIdentifier: $workspaceIdentifier
      permissionGroupIdentifier: $permissionGroupIdentifier
      search: $search
    ) {
      entries {
        identifier
        ...WorkspaceMembership
      }
    }
  }
  ${WorkspaceMembershipFragmentDoc}
`

/**
 * __useGetInvitableUsersForPermissionGroupQuery__
 *
 * To run a query within a React component, call `useGetInvitableUsersForPermissionGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitableUsersForPermissionGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitableUsersForPermissionGroupQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetInvitableUsersForPermissionGroupQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetInvitableUsersForPermissionGroupQuery,
    Types.GetInvitableUsersForPermissionGroupQueryVariables
  > &
    (
      | {
          variables: Types.GetInvitableUsersForPermissionGroupQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetInvitableUsersForPermissionGroupQuery,
    Types.GetInvitableUsersForPermissionGroupQueryVariables
  >(GetInvitableUsersForPermissionGroupDocument, options)
}
export function useGetInvitableUsersForPermissionGroupLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetInvitableUsersForPermissionGroupQuery,
    Types.GetInvitableUsersForPermissionGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetInvitableUsersForPermissionGroupQuery,
    Types.GetInvitableUsersForPermissionGroupQueryVariables
  >(GetInvitableUsersForPermissionGroupDocument, options)
}

export type GetInvitableUsersForPermissionGroupQueryHookResult = ReturnType<
  typeof useGetInvitableUsersForPermissionGroupQuery
>
export type GetInvitableUsersForPermissionGroupLazyQueryHookResult = ReturnType<
  typeof useGetInvitableUsersForPermissionGroupLazyQuery
>
export type GetInvitableUsersForPermissionGroupQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetInvitableUsersForPermissionGroupQuery,
    Types.GetInvitableUsersForPermissionGroupQueryVariables
  >
export const GetWorkspaceStorageDetailsDocument = /*#__PURE__*/ gql`
  query getWorkspaceStorageDetails($identifier: UUID!) {
    workspaceStorage(identifier: $identifier) {
      used
      limit
      shareCount
    }
  }
`

/**
 * __useGetWorkspaceStorageDetailsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceStorageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceStorageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceStorageDetailsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceStorageDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceStorageDetailsQuery,
    Types.GetWorkspaceStorageDetailsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceStorageDetailsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceStorageDetailsQuery,
    Types.GetWorkspaceStorageDetailsQueryVariables
  >(GetWorkspaceStorageDetailsDocument, options)
}
export function useGetWorkspaceStorageDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceStorageDetailsQuery,
    Types.GetWorkspaceStorageDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceStorageDetailsQuery,
    Types.GetWorkspaceStorageDetailsQueryVariables
  >(GetWorkspaceStorageDetailsDocument, options)
}

export type GetWorkspaceStorageDetailsQueryHookResult = ReturnType<
  typeof useGetWorkspaceStorageDetailsQuery
>
export type GetWorkspaceStorageDetailsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceStorageDetailsLazyQuery
>
export type GetWorkspaceStorageDetailsQueryResult =
  ApolloReactCommon.QueryResult<
    Types.GetWorkspaceStorageDetailsQuery,
    Types.GetWorkspaceStorageDetailsQueryVariables
  >
export const CreateWorkspaceProfileDocument = /*#__PURE__*/ gql`
  mutation createWorkspaceProfile(
    $workspaceIdentifier: UUID!
    $input: CreateWorkspaceProfileParams
  ) {
    createWorkspaceProfile(
      workspaceIdentifier: $workspaceIdentifier
      input: $input
    ) {
      workspaceProfile {
        identifier
      }
    }
  }
`
export type CreateWorkspaceProfileMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.CreateWorkspaceProfileMutation,
    Types.CreateWorkspaceProfileMutationVariables
  >

/**
 * __useCreateWorkspaceProfileMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceProfileMutation, { data, loading, error }] = useCreateWorkspaceProfileMutation({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceProfileMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateWorkspaceProfileMutation,
    Types.CreateWorkspaceProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateWorkspaceProfileMutation,
    Types.CreateWorkspaceProfileMutationVariables
  >(CreateWorkspaceProfileDocument, options)
}
export type CreateWorkspaceProfileMutationHookResult = ReturnType<
  typeof useCreateWorkspaceProfileMutation
>
export type CreateWorkspaceProfileMutationResult =
  ApolloReactCommon.MutationResult<Types.CreateWorkspaceProfileMutation>
export type CreateWorkspaceProfileMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CreateWorkspaceProfileMutation,
    Types.CreateWorkspaceProfileMutationVariables
  >
export const UpdateWorkspaceProfileDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceProfile($input: UpdateWorkspaceProfileParams!) {
    updateWorkspaceProfile(input: $input) {
      workspaceProfile {
        identifier
        ...WorkspaceProfile
      }
    }
  }
  ${WorkspaceProfileFragmentDoc}
`
export type UpdateWorkspaceProfileMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateWorkspaceProfileMutation,
    Types.UpdateWorkspaceProfileMutationVariables
  >

/**
 * __useUpdateWorkspaceProfileMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceProfileMutation, { data, loading, error }] = useUpdateWorkspaceProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceProfileMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceProfileMutation,
    Types.UpdateWorkspaceProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceProfileMutation,
    Types.UpdateWorkspaceProfileMutationVariables
  >(UpdateWorkspaceProfileDocument, options)
}
export type UpdateWorkspaceProfileMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceProfileMutation
>
export type UpdateWorkspaceProfileMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateWorkspaceProfileMutation>
export type UpdateWorkspaceProfileMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateWorkspaceProfileMutation,
    Types.UpdateWorkspaceProfileMutationVariables
  >
export const CheckWorkspaceProfileShortUrlDocument = /*#__PURE__*/ gql`
  mutation checkWorkspaceProfileShortUrl($shortUrlName: String!) {
    checkWorkspaceProfileShortUrl(shortUrlName: $shortUrlName) {
      available
    }
  }
`
export type CheckWorkspaceProfileShortUrlMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.CheckWorkspaceProfileShortUrlMutation,
    Types.CheckWorkspaceProfileShortUrlMutationVariables
  >

/**
 * __useCheckWorkspaceProfileShortUrlMutation__
 *
 * To run a mutation, you first call `useCheckWorkspaceProfileShortUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckWorkspaceProfileShortUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkWorkspaceProfileShortUrlMutation, { data, loading, error }] = useCheckWorkspaceProfileShortUrlMutation({
 *   variables: {
 *      shortUrlName: // value for 'shortUrlName'
 *   },
 * });
 */
export function useCheckWorkspaceProfileShortUrlMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CheckWorkspaceProfileShortUrlMutation,
    Types.CheckWorkspaceProfileShortUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CheckWorkspaceProfileShortUrlMutation,
    Types.CheckWorkspaceProfileShortUrlMutationVariables
  >(CheckWorkspaceProfileShortUrlDocument, options)
}
export type CheckWorkspaceProfileShortUrlMutationHookResult = ReturnType<
  typeof useCheckWorkspaceProfileShortUrlMutation
>
export type CheckWorkspaceProfileShortUrlMutationResult =
  ApolloReactCommon.MutationResult<Types.CheckWorkspaceProfileShortUrlMutation>
export type CheckWorkspaceProfileShortUrlMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.CheckWorkspaceProfileShortUrlMutation,
    Types.CheckWorkspaceProfileShortUrlMutationVariables
  >
export const UpdateWorkspaceProfileShortUrlDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceProfileShortUrl(
    $input: UpdateWorkspaceProfileShortUrlParams!
  ) {
    updateWorkspaceProfileShortUrl(input: $input) {
      workspaceProfile {
        ...WorkspaceProfile
      }
    }
  }
  ${WorkspaceProfileFragmentDoc}
`
export type UpdateWorkspaceProfileShortUrlMutationFn =
  ApolloReactCommon.MutationFunction<
    Types.UpdateWorkspaceProfileShortUrlMutation,
    Types.UpdateWorkspaceProfileShortUrlMutationVariables
  >

/**
 * __useUpdateWorkspaceProfileShortUrlMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceProfileShortUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceProfileShortUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceProfileShortUrlMutation, { data, loading, error }] = useUpdateWorkspaceProfileShortUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceProfileShortUrlMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceProfileShortUrlMutation,
    Types.UpdateWorkspaceProfileShortUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceProfileShortUrlMutation,
    Types.UpdateWorkspaceProfileShortUrlMutationVariables
  >(UpdateWorkspaceProfileShortUrlDocument, options)
}
export type UpdateWorkspaceProfileShortUrlMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceProfileShortUrlMutation
>
export type UpdateWorkspaceProfileShortUrlMutationResult =
  ApolloReactCommon.MutationResult<Types.UpdateWorkspaceProfileShortUrlMutation>
export type UpdateWorkspaceProfileShortUrlMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Types.UpdateWorkspaceProfileShortUrlMutation,
    Types.UpdateWorkspaceProfileShortUrlMutationVariables
  >
export const GetWorkspaceProfileDocument = /*#__PURE__*/ gql`
  query getWorkspaceProfile($workspaceIdentifier: UUID, $shortUrlName: String) {
    workspaceProfile(
      workspaceIdentifier: $workspaceIdentifier
      shortUrlName: $shortUrlName
    ) {
      ...WorkspaceProfile
    }
  }
  ${WorkspaceProfileFragmentDoc}
`

/**
 * __useGetWorkspaceProfileQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceProfileQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      shortUrlName: // value for 'shortUrlName'
 *   },
 * });
 */
export function useGetWorkspaceProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceProfileQuery,
    Types.GetWorkspaceProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceProfileQuery,
    Types.GetWorkspaceProfileQueryVariables
  >(GetWorkspaceProfileDocument, options)
}
export function useGetWorkspaceProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceProfileQuery,
    Types.GetWorkspaceProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceProfileQuery,
    Types.GetWorkspaceProfileQueryVariables
  >(GetWorkspaceProfileDocument, options)
}

export type GetWorkspaceProfileQueryHookResult = ReturnType<
  typeof useGetWorkspaceProfileQuery
>
export type GetWorkspaceProfileLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceProfileLazyQuery
>
export type GetWorkspaceProfileQueryResult = ApolloReactCommon.QueryResult<
  Types.GetWorkspaceProfileQuery,
  Types.GetWorkspaceProfileQueryVariables
>
export const GetProfilePublicationsDocument = /*#__PURE__*/ gql`
  query getProfilePublications($workspaceIdentifier: UUID!, $after: String) {
    workspaceProfile(workspaceIdentifier: $workspaceIdentifier) {
      identifier
      publications(after: $after) {
        entries {
          ...PublicationItem
        }
        meta {
          after
          totalCount
        }
      }
    }
  }
  ${PublicationItemFragmentDoc}
`

/**
 * __useGetProfilePublicationsQuery__
 *
 * To run a query within a React component, call `useGetProfilePublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePublicationsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetProfilePublicationsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProfilePublicationsQuery,
    Types.GetProfilePublicationsQueryVariables
  > &
    (
      | {
          variables: Types.GetProfilePublicationsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProfilePublicationsQuery,
    Types.GetProfilePublicationsQueryVariables
  >(GetProfilePublicationsDocument, options)
}
export function useGetProfilePublicationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProfilePublicationsQuery,
    Types.GetProfilePublicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProfilePublicationsQuery,
    Types.GetProfilePublicationsQueryVariables
  >(GetProfilePublicationsDocument, options)
}

export type GetProfilePublicationsQueryHookResult = ReturnType<
  typeof useGetProfilePublicationsQuery
>
export type GetProfilePublicationsLazyQueryHookResult = ReturnType<
  typeof useGetProfilePublicationsLazyQuery
>
export type GetProfilePublicationsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetProfilePublicationsQuery,
  Types.GetProfilePublicationsQueryVariables
>
export const GetRandomPublicationsDocument = /*#__PURE__*/ gql`
  query getRandomPublications(
    $workspaceIdentifier: UUID!
    $exclude: [UUID!]
    $limit: Int = 2
  ) {
    workspaceProfile(workspaceIdentifier: $workspaceIdentifier) {
      identifier
      shortUrlName
      publications(sortOrder: RANDOM, exclude: $exclude, limit: $limit) {
        entries {
          ...PublicationItem
        }
      }
    }
  }
  ${PublicationItemFragmentDoc}
`

/**
 * __useGetRandomPublicationsQuery__
 *
 * To run a query within a React component, call `useGetRandomPublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRandomPublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRandomPublicationsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      exclude: // value for 'exclude'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRandomPublicationsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetRandomPublicationsQuery,
    Types.GetRandomPublicationsQueryVariables
  > &
    (
      | { variables: Types.GetRandomPublicationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetRandomPublicationsQuery,
    Types.GetRandomPublicationsQueryVariables
  >(GetRandomPublicationsDocument, options)
}
export function useGetRandomPublicationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetRandomPublicationsQuery,
    Types.GetRandomPublicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetRandomPublicationsQuery,
    Types.GetRandomPublicationsQueryVariables
  >(GetRandomPublicationsDocument, options)
}

export type GetRandomPublicationsQueryHookResult = ReturnType<
  typeof useGetRandomPublicationsQuery
>
export type GetRandomPublicationsLazyQueryHookResult = ReturnType<
  typeof useGetRandomPublicationsLazyQuery
>
export type GetRandomPublicationsQueryResult = ApolloReactCommon.QueryResult<
  Types.GetRandomPublicationsQuery,
  Types.GetRandomPublicationsQueryVariables
>
